import React from "react";

function CreatePhrase(params) {
  return (
    <div>
      <div
        className="wrapper d-flex flex-column flex-row-fluid"
        id="kt_wrapper"
      >
        {/*begin::Header*/}
        <div id="kt_header" style={{}} className="header align-items-stretch">
          {/*begin::Container*/}
          <div className="container-fluid d-flex align-items-stretch justify-content-between">
            {/*begin::Aside mobile toggle*/}
            <div
              className="d-flex align-items-center d-lg-none ms-n2 me-2"
              title="Show aside menu"
            >
              <div
                className="btn btn-icon btn-active-light-primary w-30px h-30px w-md-40px h-md-40px"
                id="kt_aside_mobile_toggle"
              >
                {/*begin::Svg Icon | path: icons/duotune/abstract/abs015.svg*/}
                <span className="svg-icon svg-icon-1">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M21 7H3C2.4 7 2 6.6 2 6V4C2 3.4 2.4 3 3 3H21C21.6 3 22 3.4 22 4V6C22 6.6 21.6 7 21 7Z"
                      fill="currentColor"
                    />
                    <path
                      opacity="0.3"
                      d="M21 14H3C2.4 14 2 13.6 2 13V11C2 10.4 2.4 10 3 10H21C21.6 10 22 10.4 22 11V13C22 13.6 21.6 14 21 14ZM22 20V18C22 17.4 21.6 17 21 17H3C2.4 17 2 17.4 2 18V20C2 20.6 2.4 21 3 21H21C21.6 21 22 20.6 22 20Z"
                      fill="currentColor"
                    />
                  </svg>
                </span>
                {/*end::Svg Icon*/}
              </div>
            </div>
            {/*end::Aside mobile toggle*/}
            {/*begin::Mobile logo*/}
            <div className="d-flex align-items-center flex-grow-1 flex-lg-grow-0">
              <a
                href="/metronic8/demo1/../demo1/index.html"
                className="d-lg-none"
              >
                <img
                  alt="Logo"
                  src="/metronic8/demo1/assets/media/logos/logo-2.svg"
                  className="h-30px"
                />
              </a>
            </div>
            {/*end::Mobile logo*/}
            {/*begin::Wrapper*/}
            <div className="d-flex align-items-stretch justify-content-between flex-lg-grow-1">
              {/*begin::Navbar*/}
              <div className="d-flex align-items-stretch" id="kt_header_nav">
                {/*begin::Menu wrapper*/}
                <div
                  className="header-menu align-items-stretch"
                  data-kt-drawer="true"
                  data-kt-drawer-name="header-menu"
                  data-kt-drawer-activate="{default: true, lg: false}"
                  data-kt-drawer-overlay="true"
                  data-kt-drawer-width="{default:'200px', '300px': '250px'}"
                  data-kt-drawer-direction="end"
                  data-kt-drawer-toggle="#kt_header_menu_mobile_toggle"
                  data-kt-swapper="true"
                  data-kt-swapper-mode="prepend"
                  data-kt-swapper-parent="{default: '#kt_body', lg: '#kt_header_nav'}"
                >
                  {/*begin::Menu*/}
                  <div
                    className="menu menu-lg-rounded menu-column menu-lg-row menu-state-bg menu-title-gray-700 menu-state-title-primary menu-state-icon-primary menu-state-bullet-primary menu-arrow-gray-400 fw-bold my-5 my-lg-0 align-items-stretch"
                    id="#kt_header_menu"
                    data-kt-menu="true"
                  >
                    <div
                      data-kt-menu-trigger="click"
                      data-kt-menu-placement="bottom-start"
                      className="menu-item here show menu-lg-down-accordion me-lg-1"
                    >
                      <span className="menu-link py-3">
                        <span className="menu-title">Dashboards</span>
                        <span className="menu-arrow d-lg-none" />
                      </span>
                      <div className="menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-rounded-0 py-lg-4 w-lg-225px">
                        <div className="menu-item">
                          <a
                            className="menu-link active py-3"
                            href="/metronic8/demo1/../demo1/index.html"
                          >
                            <span className="menu-bullet">
                              <span className="bullet bullet-dot" />
                            </span>
                            <span className="menu-title">Multipurpose</span>
                          </a>
                        </div>
                        <div className="menu-item">
                          <a
                            className="menu-link py-3"
                            href="/metronic8/demo1/../demo1/dashboards/ecommerce.html"
                          >
                            <span className="menu-bullet">
                              <span className="bullet bullet-dot" />
                            </span>
                            <span className="menu-title">eCommerce</span>
                          </a>
                        </div>
                        <div className="menu-item">
                          <a
                            className="menu-link py-3"
                            href="/metronic8/demo1/../demo1/dashboards/projects.html"
                          >
                            <span className="menu-bullet">
                              <span className="bullet bullet-dot" />
                            </span>
                            <span className="menu-title">Projects</span>
                          </a>
                        </div>
                        <div className="menu-item">
                          <a
                            className="menu-link py-3"
                            href="/metronic8/demo1/../demo1/dashboards/online-courses.html"
                          >
                            <span className="menu-bullet">
                              <span className="bullet bullet-dot" />
                            </span>
                            <span className="menu-title">Online Courses</span>
                          </a>
                        </div>
                        <div className="menu-item">
                          <a
                            className="menu-link py-3"
                            href="/metronic8/demo1/../demo1/dashboards/marketing.html"
                          >
                            <span className="menu-bullet">
                              <span className="bullet bullet-dot" />
                            </span>
                            <span className="menu-title">Marketing</span>
                          </a>
                        </div>
                        <div className="menu-item">
                          <a
                            className="menu-link py-3"
                            href="/metronic8/demo1/../demo1/dashboards/bidding.html"
                          >
                            <span className="menu-bullet">
                              <span className="bullet bullet-dot" />
                            </span>
                            <span className="menu-title">Bidding</span>
                          </a>
                        </div>
                        <div
                          className="menu-inner flex-column collapse"
                          id="kt_aside_menu_collapse_2"
                        >
                          <div className="menu-item">
                            <a
                              className="menu-link py-3"
                              href="/metronic8/demo1/../demo1/dashboards/logistics.html"
                            >
                              <span className="menu-bullet">
                                <span className="bullet bullet-dot" />
                              </span>
                              <span className="menu-title">Logistics</span>
                            </a>
                          </div>
                          <div className="menu-item">
                            <a
                              className="menu-link py-3"
                              href="/metronic8/demo1/../demo1/dashboards/delivery.html"
                            >
                              <span className="menu-bullet">
                                <span className="bullet bullet-dot" />
                              </span>
                              <span className="menu-title">Delivery</span>
                            </a>
                          </div>
                          <div className="menu-item">
                            <a
                              className="menu-link py-3"
                              href="/metronic8/demo1/../demo1/dashboards/website-analytics.html"
                            >
                              <span className="menu-bullet">
                                <span className="bullet bullet-dot" />
                              </span>
                              <span className="menu-title">
                                Website Analytics
                              </span>
                            </a>
                          </div>
                          <div className="menu-item">
                            <a
                              className="menu-link py-3"
                              href="/metronic8/demo1/../demo1/dashboards/finance-performance.html"
                            >
                              <span className="menu-bullet">
                                <span className="bullet bullet-dot" />
                              </span>
                              <span className="menu-title">
                                Finance Performance
                              </span>
                            </a>
                          </div>
                          <div className="menu-item">
                            <a
                              className="menu-link py-3"
                              href="/metronic8/demo1/../demo1/dashboards/store-analytics.html"
                            >
                              <span className="menu-bullet">
                                <span className="bullet bullet-dot" />
                              </span>
                              <span className="menu-title">
                                Store Analytics
                              </span>
                            </a>
                          </div>
                          <div className="menu-item">
                            <a
                              className="menu-link py-3"
                              href="/metronic8/demo1/../demo1/dashboards/social.html"
                            >
                              <span className="menu-bullet">
                                <span className="bullet bullet-dot" />
                              </span>
                              <span className="menu-title">Social</span>
                            </a>
                          </div>
                          <div className="menu-item">
                            <a
                              className="menu-link py-3"
                              href="/metronic8/demo1/../demo1/dashboards/crypto.html"
                            >
                              <span className="menu-bullet">
                                <span className="bullet bullet-dot" />
                              </span>
                              <span className="menu-title">Crypto</span>
                            </a>
                          </div>
                          <div className="menu-item">
                            <a
                              className="menu-link py-3"
                              href="/metronic8/demo1/../demo1/dashboards/school.html"
                            >
                              <span className="menu-bullet">
                                <span className="bullet bullet-dot" />
                              </span>
                              <span className="menu-title">School</span>
                            </a>
                          </div>
                          <div className="menu-item">
                            <a
                              className="menu-link py-3"
                              href="/metronic8/demo1/../demo1/dashboards/podcast.html"
                            >
                              <span className="menu-bullet">
                                <span className="bullet bullet-dot" />
                              </span>
                              <span className="menu-title">Podcast</span>
                            </a>
                          </div>
                          <div className="menu-item">
                            <a
                              className="menu-link py-3"
                              href="/metronic8/demo1/../demo1/landing.html"
                            >
                              <span className="menu-bullet">
                                <span className="bullet bullet-dot" />
                              </span>
                              <span className="menu-title">Landing</span>
                            </a>
                          </div>
                        </div>
                        <div className="menu-item">
                          <div className="menu-content">
                            <a
                              className="btn btn-flex btn-color-success fs-base p-0 ms-2 mb-2 collapsible collapsed rotate"
                              data-bs-toggle="collapse"
                              href="#kt_aside_menu_collapse_2"
                              data-kt-toggle-text="Show Less"
                            >
                              <span data-kt-toggle-text-target="true">
                                Show 10 More
                              </span>
                              {/*begin::Svg Icon | path: icons/duotune/arrows/arr082.svg*/}
                              <span className="svg-icon ms-2 svg-icon-3 rotate-180">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width={24}
                                  height={24}
                                  viewBox="0 0 24 24"
                                  fill="none"
                                >
                                  <path
                                    opacity="0.5"
                                    d="M12.5657 9.63427L16.75 5.44995C17.1642 5.03574 17.8358 5.03574 18.25 5.44995C18.6642 5.86416 18.6642 6.53574 18.25 6.94995L12.7071 12.4928C12.3166 12.8834 11.6834 12.8834 11.2929 12.4928L5.75 6.94995C5.33579 6.53574 5.33579 5.86416 5.75 5.44995C6.16421 5.03574 6.83579 5.03574 7.25 5.44995L11.4343 9.63427C11.7467 9.94669 12.2533 9.94668 12.5657 9.63427Z"
                                    fill="currentColor"
                                  />
                                  <path
                                    d="M12.5657 15.6343L16.75 11.45C17.1642 11.0357 17.8358 11.0357 18.25 11.45C18.6642 11.8642 18.6642 12.5357 18.25 12.95L12.7071 18.4928C12.3166 18.8834 11.6834 18.8834 11.2929 18.4928L5.75 12.95C5.33579 12.5357 5.33579 11.8642 5.75 11.45C6.16421 11.0357 6.83579 11.0357 7.25 11.45L11.4343 15.6343C11.7467 15.9467 12.2533 15.9467 12.5657 15.6343Z"
                                    fill="currentColor"
                                  />
                                </svg>
                              </span>
                              {/*end::Svg Icon*/}
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      data-kt-menu-trigger="click"
                      data-kt-menu-placement="bottom-start"
                      className="menu-item menu-lg-down-accordion me-lg-1"
                    >
                      <span className="menu-link py-3">
                        <span className="menu-title">Crafted</span>
                        <span className="menu-arrow d-lg-none" />
                      </span>
                      <div className="menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-rounded-0 py-lg-4 w-lg-225px">
                        <div
                          data-kt-menu-trigger="{default:'click', lg: 'hover'}"
                          data-kt-menu-placement="right-start"
                          className="menu-item menu-lg-down-accordion"
                        >
                          <span className="menu-link py-3">
                            <span className="menu-icon">
                              {/*begin::Svg Icon | path: icons/duotune/ecommerce/ecm007.svg*/}
                              <span className="svg-icon svg-icon-2">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width={24}
                                  height={24}
                                  viewBox="0 0 24 24"
                                  fill="none"
                                >
                                  <path
                                    d="M21 9V11C21 11.6 20.6 12 20 12H14V8H20C20.6 8 21 8.4 21 9ZM10 8H4C3.4 8 3 8.4 3 9V11C3 11.6 3.4 12 4 12H10V8Z"
                                    fill="currentColor"
                                  />
                                  <path
                                    d="M15 2C13.3 2 12 3.3 12 5V8H15C16.7 8 18 6.7 18 5C18 3.3 16.7 2 15 2Z"
                                    fill="currentColor"
                                  />
                                  <path
                                    opacity="0.3"
                                    d="M9 2C10.7 2 12 3.3 12 5V8H9C7.3 8 6 6.7 6 5C6 3.3 7.3 2 9 2ZM4 12V21C4 21.6 4.4 22 5 22H10V12H4ZM20 12V21C20 21.6 19.6 22 19 22H14V12H20Z"
                                    fill="currentColor"
                                  />
                                </svg>
                              </span>
                              {/*end::Svg Icon*/}
                            </span>
                            <span className="menu-title">Pages</span>
                            <span className="menu-arrow" />
                          </span>
                          <div className="menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-active-bg py-lg-4 w-lg-225px">
                            <div
                              data-kt-menu-trigger="{default:'click', lg: 'hover'}"
                              data-kt-menu-placement="right-start"
                              className="menu-item menu-lg-down-accordion"
                            >
                              <span className="menu-link py-3">
                                <span className="menu-bullet">
                                  <span className="bullet bullet-dot" />
                                </span>
                                <span className="menu-title">Profile</span>
                                <span className="menu-arrow" />
                              </span>
                              <div className="menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-active-bg py-lg-4 w-lg-225px">
                                <div className="menu-item">
                                  <a
                                    className="menu-link py-3"
                                    href="/metronic8/demo1/../demo1/pages/user-profile/overview.html"
                                  >
                                    <span className="menu-bullet">
                                      <span className="bullet bullet-dot" />
                                    </span>
                                    <span className="menu-title">Overview</span>
                                  </a>
                                </div>
                                <div className="menu-item">
                                  <a
                                    className="menu-link py-3"
                                    href="/metronic8/demo1/../demo1/pages/user-profile/projects.html"
                                  >
                                    <span className="menu-bullet">
                                      <span className="bullet bullet-dot" />
                                    </span>
                                    <span className="menu-title">Projects</span>
                                  </a>
                                </div>
                                <div className="menu-item">
                                  <a
                                    className="menu-link py-3"
                                    href="/metronic8/demo1/../demo1/pages/user-profile/campaigns.html"
                                  >
                                    <span className="menu-bullet">
                                      <span className="bullet bullet-dot" />
                                    </span>
                                    <span className="menu-title">
                                      Campaigns
                                    </span>
                                  </a>
                                </div>
                                <div className="menu-item">
                                  <a
                                    className="menu-link py-3"
                                    href="/metronic8/demo1/../demo1/pages/user-profile/documents.html"
                                  >
                                    <span className="menu-bullet">
                                      <span className="bullet bullet-dot" />
                                    </span>
                                    <span className="menu-title">
                                      Documents
                                    </span>
                                  </a>
                                </div>
                                <div className="menu-item">
                                  <a
                                    className="menu-link py-3"
                                    href="/metronic8/demo1/../demo1/pages/user-profile/followers.html"
                                  >
                                    <span className="menu-bullet">
                                      <span className="bullet bullet-dot" />
                                    </span>
                                    <span className="menu-title">
                                      Followers
                                    </span>
                                  </a>
                                </div>
                                <div className="menu-item">
                                  <a
                                    className="menu-link py-3"
                                    href="/metronic8/demo1/../demo1/pages/user-profile/activity.html"
                                  >
                                    <span className="menu-bullet">
                                      <span className="bullet bullet-dot" />
                                    </span>
                                    <span className="menu-title">Activity</span>
                                  </a>
                                </div>
                              </div>
                            </div>
                            <div
                              data-kt-menu-trigger="{default:'click', lg: 'hover'}"
                              data-kt-menu-placement="right-start"
                              className="menu-item menu-lg-down-accordion"
                            >
                              <span className="menu-link py-3">
                                <span className="menu-bullet">
                                  <span className="bullet bullet-dot" />
                                </span>
                                <span className="menu-title">Blog</span>
                                <span className="menu-arrow" />
                              </span>
                              <div className="menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-active-bg py-lg-4 w-lg-225px">
                                <div className="menu-item">
                                  <a
                                    className="menu-link py-3"
                                    href="/metronic8/demo1/../demo1/pages/blog/home.html"
                                  >
                                    <span className="menu-bullet">
                                      <span className="bullet bullet-dot" />
                                    </span>
                                    <span className="menu-title">
                                      Blog Home
                                    </span>
                                  </a>
                                </div>
                                <div className="menu-item">
                                  <a
                                    className="menu-link py-3"
                                    href="/metronic8/demo1/../demo1/pages/blog/post.html"
                                  >
                                    <span className="menu-bullet">
                                      <span className="bullet bullet-dot" />
                                    </span>
                                    <span className="menu-title">
                                      Blog Post
                                    </span>
                                  </a>
                                </div>
                              </div>
                            </div>
                            <div
                              data-kt-menu-trigger="{default:'click', lg: 'hover'}"
                              data-kt-menu-placement="right-start"
                              className="menu-item menu-lg-down-accordion"
                            >
                              <span className="menu-link py-3">
                                <span className="menu-bullet">
                                  <span className="bullet bullet-dot" />
                                </span>
                                <span className="menu-title">Pricing</span>
                                <span className="menu-arrow" />
                              </span>
                              <div className="menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-active-bg py-lg-4 w-lg-225px">
                                <div className="menu-item">
                                  <a
                                    className="menu-link py-3"
                                    href="/metronic8/demo1/../demo1/pages/pricing/pricing-1.html"
                                  >
                                    <span className="menu-bullet">
                                      <span className="bullet bullet-dot" />
                                    </span>
                                    <span className="menu-title">
                                      Pricing 1
                                    </span>
                                  </a>
                                </div>
                                <div className="menu-item">
                                  <a
                                    className="menu-link py-3"
                                    href="/metronic8/demo1/../demo1/pages/pricing/pricing-2.html"
                                  >
                                    <span className="menu-bullet">
                                      <span className="bullet bullet-dot" />
                                    </span>
                                    <span className="menu-title">
                                      Pricing 2
                                    </span>
                                  </a>
                                </div>
                              </div>
                            </div>
                            <div
                              data-kt-menu-trigger="{default:'click', lg: 'hover'}"
                              data-kt-menu-placement="right-start"
                              className="menu-item menu-lg-down-accordion"
                            >
                              <span className="menu-link py-3">
                                <span className="menu-bullet">
                                  <span className="bullet bullet-dot" />
                                </span>
                                <span className="menu-title">Careers</span>
                                <span className="menu-arrow" />
                              </span>
                              <div className="menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-active-bg py-lg-4 w-lg-225px">
                                <div className="menu-item">
                                  <a
                                    className="menu-link py-3"
                                    href="/metronic8/demo1/../demo1/pages/careers/list.html"
                                  >
                                    <span className="menu-bullet">
                                      <span className="bullet bullet-dot" />
                                    </span>
                                    <span className="menu-title">
                                      Careers List
                                    </span>
                                  </a>
                                </div>
                                <div className="menu-item">
                                  <a
                                    className="menu-link py-3"
                                    href="/metronic8/demo1/../demo1/pages/careers/apply.html"
                                  >
                                    <span className="menu-bullet">
                                      <span className="bullet bullet-dot" />
                                    </span>
                                    <span className="menu-title">
                                      Careers Apply
                                    </span>
                                  </a>
                                </div>
                              </div>
                            </div>
                            <div
                              data-kt-menu-trigger="{default:'click', lg: 'hover'}"
                              data-kt-menu-placement="right-start"
                              className="menu-item menu-lg-down-accordion"
                            >
                              <span className="menu-link py-3">
                                <span className="menu-bullet">
                                  <span className="bullet bullet-dot" />
                                </span>
                                <span className="menu-title">FAQ</span>
                                <span className="menu-arrow" />
                              </span>
                              <div className="menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-active-bg py-lg-4 w-lg-225px">
                                <div className="menu-item">
                                  <a
                                    className="menu-link py-3"
                                    href="/metronic8/demo1/../demo1/pages/faq/classic.html"
                                  >
                                    <span className="menu-bullet">
                                      <span className="bullet bullet-dot" />
                                    </span>
                                    <span className="menu-title">Classic</span>
                                  </a>
                                </div>
                                <div className="menu-item">
                                  <a
                                    className="menu-link py-3"
                                    href="/metronic8/demo1/../demo1/pages/faq/extended.html"
                                  >
                                    <span className="menu-bullet">
                                      <span className="bullet bullet-dot" />
                                    </span>
                                    <span className="menu-title">Extended</span>
                                  </a>
                                </div>
                              </div>
                            </div>
                            <div className="menu-item">
                              <a
                                className="menu-link py-3"
                                href="/metronic8/demo1/../demo1/pages/about.html"
                              >
                                <span className="menu-bullet">
                                  <span className="bullet bullet-dot" />
                                </span>
                                <span className="menu-title">About Us</span>
                              </a>
                            </div>
                            <div className="menu-item">
                              <a
                                className="menu-link py-3"
                                href="/metronic8/demo1/../demo1/pages/contact.html"
                              >
                                <span className="menu-bullet">
                                  <span className="bullet bullet-dot" />
                                </span>
                                <span className="menu-title">Contact Us</span>
                              </a>
                            </div>
                            <div className="menu-item">
                              <a
                                className="menu-link py-3"
                                href="/metronic8/demo1/../demo1/pages/team.html"
                              >
                                <span className="menu-bullet">
                                  <span className="bullet bullet-dot" />
                                </span>
                                <span className="menu-title">Our Team</span>
                              </a>
                            </div>
                            <div className="menu-item">
                              <a
                                className="menu-link py-3"
                                href="/metronic8/demo1/../demo1/pages/licenses.html"
                              >
                                <span className="menu-bullet">
                                  <span className="bullet bullet-dot" />
                                </span>
                                <span className="menu-title">Licenses</span>
                              </a>
                            </div>
                            <div className="menu-item">
                              <a
                                className="menu-link py-3"
                                href="/metronic8/demo1/../demo1/pages/sitemap.html"
                              >
                                <span className="menu-bullet">
                                  <span className="bullet bullet-dot" />
                                </span>
                                <span className="menu-title">Sitemap</span>
                              </a>
                            </div>
                          </div>
                        </div>
                        <div
                          data-kt-menu-trigger="{default:'click', lg: 'hover'}"
                          data-kt-menu-placement="right-start"
                          className="menu-item menu-lg-down-accordion"
                        >
                          <span className="menu-link py-3">
                            <span className="menu-icon">
                              {/*begin::Svg Icon | path: icons/duotune/communication/com013.svg*/}
                              <span className="svg-icon svg-icon-2">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width={24}
                                  height={24}
                                  viewBox="0 0 24 24"
                                  fill="none"
                                >
                                  <path
                                    d="M6.28548 15.0861C7.34369 13.1814 9.35142 12 11.5304 12H12.4696C14.6486 12 16.6563 13.1814 17.7145 15.0861L19.3493 18.0287C20.0899 19.3618 19.1259 21 17.601 21H6.39903C4.87406 21 3.91012 19.3618 4.65071 18.0287L6.28548 15.0861Z"
                                    fill="currentColor"
                                  />
                                  <rect
                                    opacity="0.3"
                                    x={8}
                                    y={3}
                                    width={8}
                                    height={8}
                                    rx={4}
                                    fill="currentColor"
                                  />
                                </svg>
                              </span>
                              {/*end::Svg Icon*/}
                            </span>
                            <span className="menu-title">Account</span>
                            <span className="menu-arrow" />
                          </span>
                          <div className="menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-active-bg py-lg-4 w-lg-225px">
                            <div className="menu-item">
                              <a
                                className="menu-link py-3"
                                href="/metronic8/demo1/../demo1/account/overview.html"
                              >
                                <span className="menu-bullet">
                                  <span className="bullet bullet-dot" />
                                </span>
                                <span className="menu-title">Overview</span>
                              </a>
                            </div>
                            <div className="menu-item">
                              <a
                                className="menu-link py-3"
                                href="/metronic8/demo1/../demo1/account/settings.html"
                              >
                                <span className="menu-bullet">
                                  <span className="bullet bullet-dot" />
                                </span>
                                <span className="menu-title">Settings</span>
                              </a>
                            </div>
                            <div className="menu-item">
                              <a
                                className="menu-link py-3"
                                href="/metronic8/demo1/../demo1/account/security.html"
                              >
                                <span className="menu-bullet">
                                  <span className="bullet bullet-dot" />
                                </span>
                                <span className="menu-title">Security</span>
                              </a>
                            </div>
                            <div className="menu-item">
                              <a
                                className="menu-link py-3"
                                href="/metronic8/demo1/../demo1/account/billing.html"
                              >
                                <span className="menu-bullet">
                                  <span className="bullet bullet-dot" />
                                </span>
                                <span className="menu-title">Billing</span>
                              </a>
                            </div>
                            <div className="menu-item">
                              <a
                                className="menu-link py-3"
                                href="/metronic8/demo1/../demo1/account/statements.html"
                              >
                                <span className="menu-bullet">
                                  <span className="bullet bullet-dot" />
                                </span>
                                <span className="menu-title">Statements</span>
                              </a>
                            </div>
                            <div className="menu-item">
                              <a
                                className="menu-link py-3"
                                href="/metronic8/demo1/../demo1/account/referrals.html"
                              >
                                <span className="menu-bullet">
                                  <span className="bullet bullet-dot" />
                                </span>
                                <span className="menu-title">Referrals</span>
                              </a>
                            </div>
                            <div className="menu-item">
                              <a
                                className="menu-link py-3"
                                href="/metronic8/demo1/../demo1/account/api-keys.html"
                              >
                                <span className="menu-bullet">
                                  <span className="bullet bullet-dot" />
                                </span>
                                <span className="menu-title">API Keys</span>
                              </a>
                            </div>
                            <div className="menu-item">
                              <a
                                className="menu-link py-3"
                                href="/metronic8/demo1/../demo1/account/logs.html"
                              >
                                <span className="menu-bullet">
                                  <span className="bullet bullet-dot" />
                                </span>
                                <span className="menu-title">Logs</span>
                              </a>
                            </div>
                          </div>
                        </div>
                        <div
                          data-kt-menu-trigger="{default:'click', lg: 'hover'}"
                          data-kt-menu-placement="right-start"
                          className="menu-item menu-lg-down-accordion"
                        >
                          <span className="menu-link py-3">
                            <span className="menu-icon">
                              {/*begin::Svg Icon | path: icons/duotune/technology/teh004.svg*/}
                              <span className="svg-icon svg-icon-2">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width={24}
                                  height={24}
                                  viewBox="0 0 24 24"
                                  fill="none"
                                >
                                  <path
                                    opacity="0.3"
                                    d="M21 10.7192H3C2.4 10.7192 2 11.1192 2 11.7192C2 12.3192 2.4 12.7192 3 12.7192H6V14.7192C6 18.0192 8.7 20.7192 12 20.7192C15.3 20.7192 18 18.0192 18 14.7192V12.7192H21C21.6 12.7192 22 12.3192 22 11.7192C22 11.1192 21.6 10.7192 21 10.7192Z"
                                    fill="currentColor"
                                  />
                                  <path
                                    d="M11.6 21.9192C11.4 21.9192 11.2 21.8192 11 21.7192C10.6 21.4192 10.5 20.7191 10.8 20.3191C11.7 19.1191 12.3 17.8191 12.7 16.3191C12.8 15.8191 13.4 15.4192 13.9 15.6192C14.4 15.7192 14.8 16.3191 14.6 16.8191C14.2 18.5191 13.4 20.1192 12.4 21.5192C12.2 21.7192 11.9 21.9192 11.6 21.9192ZM8.7 19.7192C10.2 18.1192 11 15.9192 11 13.7192V8.71917C11 8.11917 11.4 7.71917 12 7.71917C12.6 7.71917 13 8.11917 13 8.71917V13.0192C13 13.6192 13.4 14.0192 14 14.0192C14.6 14.0192 15 13.6192 15 13.0192V8.71917C15 7.01917 13.7 5.71917 12 5.71917C10.3 5.71917 9 7.01917 9 8.71917V13.7192C9 15.4192 8.4 17.1191 7.2 18.3191C6.8 18.7191 6.9 19.3192 7.3 19.7192C7.5 19.9192 7.7 20.0192 8 20.0192C8.3 20.0192 8.5 19.9192 8.7 19.7192ZM6 16.7192C6.5 16.7192 7 16.2192 7 15.7192V8.71917C7 8.11917 7.1 7.51918 7.3 6.91918C7.5 6.41918 7.2 5.8192 6.7 5.6192C6.2 5.4192 5.59999 5.71917 5.39999 6.21917C5.09999 7.01917 5 7.81917 5 8.71917V15.7192V15.8191C5 16.3191 5.5 16.7192 6 16.7192ZM9 4.71917C9.5 4.31917 10.1 4.11918 10.7 3.91918C11.2 3.81918 11.5 3.21917 11.4 2.71917C11.3 2.21917 10.7 1.91916 10.2 2.01916C9.4 2.21916 8.59999 2.6192 7.89999 3.1192C7.49999 3.4192 7.4 4.11916 7.7 4.51916C7.9 4.81916 8.2 4.91918 8.5 4.91918C8.6 4.91918 8.8 4.81917 9 4.71917ZM18.2 18.9192C18.7 17.2192 19 15.5192 19 13.7192V8.71917C19 5.71917 17.1 3.1192 14.3 2.1192C13.8 1.9192 13.2 2.21917 13 2.71917C12.8 3.21917 13.1 3.81916 13.6 4.01916C15.6 4.71916 17 6.61917 17 8.71917V13.7192C17 15.3192 16.8 16.8191 16.3 18.3191C16.1 18.8191 16.4 19.4192 16.9 19.6192C17 19.6192 17.1 19.6192 17.2 19.6192C17.7 19.6192 18 19.3192 18.2 18.9192Z"
                                    fill="currentColor"
                                  />
                                </svg>
                              </span>
                              {/*end::Svg Icon*/}
                            </span>
                            <span className="menu-title">Authentication</span>
                            <span className="menu-arrow" />
                          </span>
                          <div className="menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-active-bg py-lg-4 w-lg-225px">
                            <div
                              data-kt-menu-trigger="{default:'click', lg: 'hover'}"
                              data-kt-menu-placement="right-start"
                              className="menu-item menu-lg-down-accordion"
                            >
                              <span className="menu-link py-3">
                                <span className="menu-bullet">
                                  <span className="bullet bullet-dot" />
                                </span>
                                <span className="menu-title">Basic Layout</span>
                                <span className="menu-arrow" />
                              </span>
                              <div className="menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-active-bg py-lg-4 w-lg-225px">
                                <div className="menu-item">
                                  <a
                                    className="menu-link py-3"
                                    href="/metronic8/demo1/../demo1/authentication/layouts/basic/sign-in.html"
                                  >
                                    <span className="menu-bullet">
                                      <span className="bullet bullet-dot" />
                                    </span>
                                    <span className="menu-title">Sign-in</span>
                                  </a>
                                </div>
                                <div className="menu-item">
                                  <a
                                    className="menu-link py-3"
                                    href="/metronic8/demo1/../demo1/authentication/layouts/basic/sign-up.html"
                                  >
                                    <span className="menu-bullet">
                                      <span className="bullet bullet-dot" />
                                    </span>
                                    <span className="menu-title">Sign-up</span>
                                  </a>
                                </div>
                                <div className="menu-item">
                                  <a
                                    className="menu-link py-3"
                                    href="/metronic8/demo1/../demo1/authentication/layouts/basic/two-steps.html"
                                  >
                                    <span className="menu-bullet">
                                      <span className="bullet bullet-dot" />
                                    </span>
                                    <span className="menu-title">
                                      Two-steps
                                    </span>
                                  </a>
                                </div>
                                <div className="menu-item">
                                  <a
                                    className="menu-link py-3"
                                    href="/metronic8/demo1/../demo1/authentication/layouts/basic/password-reset.html"
                                  >
                                    <span className="menu-bullet">
                                      <span className="bullet bullet-dot" />
                                    </span>
                                    <span className="menu-title">
                                      Password Reset
                                    </span>
                                  </a>
                                </div>
                                <div className="menu-item">
                                  <a
                                    className="menu-link py-3"
                                    href="/metronic8/demo1/../demo1/authentication/layouts/basic/new-password.html"
                                  >
                                    <span className="menu-bullet">
                                      <span className="bullet bullet-dot" />
                                    </span>
                                    <span className="menu-title">
                                      New Password
                                    </span>
                                  </a>
                                </div>
                              </div>
                            </div>
                            <div
                              data-kt-menu-trigger="{default:'click', lg: 'hover'}"
                              data-kt-menu-placement="right-start"
                              className="menu-item menu-lg-down-accordion"
                            >
                              <span className="menu-link py-3">
                                <span className="menu-bullet">
                                  <span className="bullet bullet-dot" />
                                </span>
                                <span className="menu-title">Aside Layout</span>
                                <span className="menu-arrow" />
                              </span>
                              <div className="menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-active-bg py-lg-4 w-lg-225px">
                                <div className="menu-item">
                                  <a
                                    className="menu-link py-3"
                                    href="/metronic8/demo1/../demo1/authentication/layouts/aside/sign-in.html"
                                  >
                                    <span className="menu-bullet">
                                      <span className="bullet bullet-dot" />
                                    </span>
                                    <span className="menu-title">Sign-in</span>
                                  </a>
                                </div>
                                <div className="menu-item">
                                  <a
                                    className="menu-link py-3"
                                    href="/metronic8/demo1/../demo1/authentication/layouts/aside/sign-up.html"
                                  >
                                    <span className="menu-bullet">
                                      <span className="bullet bullet-dot" />
                                    </span>
                                    <span className="menu-title">Sign-up</span>
                                  </a>
                                </div>
                                <div className="menu-item">
                                  <a
                                    className="menu-link py-3"
                                    href="/metronic8/demo1/../demo1/authentication/layouts/aside/two-steps.html"
                                  >
                                    <span className="menu-bullet">
                                      <span className="bullet bullet-dot" />
                                    </span>
                                    <span className="menu-title">
                                      Two-steps
                                    </span>
                                  </a>
                                </div>
                                <div className="menu-item">
                                  <a
                                    className="menu-link py-3"
                                    href="/metronic8/demo1/../demo1/authentication/layouts/aside/password-reset.html"
                                  >
                                    <span className="menu-bullet">
                                      <span className="bullet bullet-dot" />
                                    </span>
                                    <span className="menu-title">
                                      Password Reset
                                    </span>
                                  </a>
                                </div>
                                <div className="menu-item">
                                  <a
                                    className="menu-link py-3"
                                    href="/metronic8/demo1/../demo1/authentication/layouts/aside/new-password.html"
                                  >
                                    <span className="menu-bullet">
                                      <span className="bullet bullet-dot" />
                                    </span>
                                    <span className="menu-title">
                                      New Password
                                    </span>
                                  </a>
                                </div>
                              </div>
                            </div>
                            <div
                              data-kt-menu-trigger="{default:'click', lg: 'hover'}"
                              data-kt-menu-placement="right-start"
                              className="menu-item menu-lg-down-accordion"
                            >
                              <span className="menu-link py-3">
                                <span className="menu-bullet">
                                  <span className="bullet bullet-dot" />
                                </span>
                                <span className="menu-title">Dark Layout</span>
                                <span className="menu-arrow" />
                              </span>
                              <div className="menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-active-bg py-lg-4 w-lg-225px">
                                <div className="menu-item">
                                  <a
                                    className="menu-link py-3"
                                    href="/metronic8/demo1/../demo1/authentication/layouts/dark/sign-in.html"
                                  >
                                    <span className="menu-bullet">
                                      <span className="bullet bullet-dot" />
                                    </span>
                                    <span className="menu-title">Sign-in</span>
                                  </a>
                                </div>
                                <div className="menu-item">
                                  <a
                                    className="menu-link py-3"
                                    href="/metronic8/demo1/../demo1/authentication/layouts/dark/sign-up.html"
                                  >
                                    <span className="menu-bullet">
                                      <span className="bullet bullet-dot" />
                                    </span>
                                    <span className="menu-title">Sign-up</span>
                                  </a>
                                </div>
                                <div className="menu-item">
                                  <a
                                    className="menu-link py-3"
                                    href="/metronic8/demo1/../demo1/authentication/layouts/dark/two-steps.html"
                                  >
                                    <span className="menu-bullet">
                                      <span className="bullet bullet-dot" />
                                    </span>
                                    <span className="menu-title">
                                      Two-steps
                                    </span>
                                  </a>
                                </div>
                                <div className="menu-item">
                                  <a
                                    className="menu-link py-3"
                                    href="/metronic8/demo1/../demo1/authentication/layouts/dark/password-reset.html"
                                  >
                                    <span className="menu-bullet">
                                      <span className="bullet bullet-dot" />
                                    </span>
                                    <span className="menu-title">
                                      Password Reset
                                    </span>
                                  </a>
                                </div>
                                <div className="menu-item">
                                  <a
                                    className="menu-link py-3"
                                    href="/metronic8/demo1/../demo1/authentication/layouts/dark/new-password.html"
                                  >
                                    <span className="menu-bullet">
                                      <span className="bullet bullet-dot" />
                                    </span>
                                    <span className="menu-title">
                                      New Password
                                    </span>
                                  </a>
                                </div>
                              </div>
                            </div>
                            <div
                              data-kt-menu-trigger="{default:'click', lg: 'hover'}"
                              data-kt-menu-placement="right-start"
                              className="menu-item menu-lg-down-accordion"
                            >
                              <span className="menu-link py-3">
                                <span className="menu-bullet">
                                  <span className="bullet bullet-dot" />
                                </span>
                                <span className="menu-title">Extended</span>
                                <span className="menu-arrow" />
                              </span>
                              <div className="menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-active-bg py-lg-4 w-lg-225px">
                                <div className="menu-item">
                                  <a
                                    className="menu-link py-3"
                                    href="/metronic8/demo1/../demo1/authentication/extended/two-factor-authentication.html"
                                  >
                                    <span className="menu-bullet">
                                      <span className="bullet bullet-dot" />
                                    </span>
                                    <span className="menu-title">
                                      Two Factor Auth
                                    </span>
                                  </a>
                                </div>
                                <div className="menu-item">
                                  <a
                                    className="menu-link py-3"
                                    href="/metronic8/demo1/../demo1/authentication/extended/multi-steps-sign-up.html"
                                  >
                                    <span className="menu-bullet">
                                      <span className="bullet bullet-dot" />
                                    </span>
                                    <span className="menu-title">
                                      Multi-steps Sign-up
                                    </span>
                                  </a>
                                </div>
                                <div className="menu-item">
                                  <a
                                    className="menu-link py-3"
                                    href="/metronic8/demo1/../demo1/authentication/extended/free-trial-sign-up.html"
                                  >
                                    <span className="menu-bullet">
                                      <span className="bullet bullet-dot" />
                                    </span>
                                    <span className="menu-title">
                                      Free Trial Sign-up
                                    </span>
                                  </a>
                                </div>
                                <div className="menu-item">
                                  <a
                                    className="menu-link py-3"
                                    href="/metronic8/demo1/../demo1/authentication/extended/coming-soon.html"
                                  >
                                    <span className="menu-bullet">
                                      <span className="bullet bullet-dot" />
                                    </span>
                                    <span className="menu-title">
                                      Coming Soon
                                    </span>
                                  </a>
                                </div>
                                <div className="menu-item">
                                  <a
                                    className="menu-link py-3"
                                    href="/metronic8/demo1/../demo1/authentication/general/welcome.html"
                                  >
                                    <span className="menu-bullet">
                                      <span className="bullet bullet-dot" />
                                    </span>
                                    <span className="menu-title">
                                      Welcome Message
                                    </span>
                                  </a>
                                </div>
                                <div className="menu-item">
                                  <a
                                    className="menu-link py-3"
                                    href="/metronic8/demo1/../demo1/authentication/general/verify-email.html"
                                  >
                                    <span className="menu-bullet">
                                      <span className="bullet bullet-dot" />
                                    </span>
                                    <span className="menu-title">
                                      Verify Email
                                    </span>
                                  </a>
                                </div>
                                <div className="menu-item">
                                  <a
                                    className="menu-link py-3"
                                    href="/metronic8/demo1/../demo1/authentication/general/password-confirmation.html"
                                  >
                                    <span className="menu-bullet">
                                      <span className="bullet bullet-dot" />
                                    </span>
                                    <span className="menu-title">
                                      Password Confirmation
                                    </span>
                                  </a>
                                </div>
                                <div className="menu-item">
                                  <a
                                    className="menu-link py-3"
                                    href="/metronic8/demo1/../demo1/authentication/general/deactivation.html"
                                  >
                                    <span className="menu-bullet">
                                      <span className="bullet bullet-dot" />
                                    </span>
                                    <span className="menu-title">
                                      Account Deactivation
                                    </span>
                                  </a>
                                </div>
                                <div className="menu-item">
                                  <a
                                    className="menu-link py-3"
                                    href="/metronic8/demo1/../demo1/authentication/general/error-404.html"
                                  >
                                    <span className="menu-bullet">
                                      <span className="bullet bullet-dot" />
                                    </span>
                                    <span className="menu-title">
                                      Error 404
                                    </span>
                                  </a>
                                </div>
                                <div className="menu-item">
                                  <a
                                    className="menu-link py-3"
                                    href="/metronic8/demo1/../demo1/authentication/general/error-500.html"
                                  >
                                    <span className="menu-bullet">
                                      <span className="bullet bullet-dot" />
                                    </span>
                                    <span className="menu-title">
                                      Error 500
                                    </span>
                                  </a>
                                </div>
                              </div>
                            </div>
                            <div
                              data-kt-menu-trigger="{default:'click', lg: 'hover'}"
                              data-kt-menu-placement="right-start"
                              className="menu-item menu-lg-down-accordion"
                            >
                              <span className="menu-link py-3">
                                <span className="menu-bullet">
                                  <span className="bullet bullet-dot" />
                                </span>
                                <span className="menu-title">
                                  Email Templates
                                </span>
                                <span className="menu-arrow" />
                              </span>
                              <div className="menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-active-bg py-lg-4 w-lg-225px">
                                <div className="menu-item">
                                  <a
                                    className="menu-link py-3"
                                    href="/metronic8/demo1/../demo1/authentication/email/verify-email.html"
                                    target="blank"
                                  >
                                    <span className="menu-bullet">
                                      <span className="bullet bullet-dot" />
                                    </span>
                                    <span className="menu-title">
                                      Verify Email
                                    </span>
                                  </a>
                                </div>
                                <div className="menu-item">
                                  <a
                                    className="menu-link py-3"
                                    href="/metronic8/demo1/../demo1/authentication/email/invitation.html"
                                    target="blank"
                                  >
                                    <span className="menu-bullet">
                                      <span className="bullet bullet-dot" />
                                    </span>
                                    <span className="menu-title">
                                      Account Invitation
                                    </span>
                                  </a>
                                </div>
                                <div className="menu-item">
                                  <a
                                    className="menu-link py-3"
                                    href="/metronic8/demo1/../demo1/authentication/email/password-reset.html"
                                    target="blank"
                                  >
                                    <span className="menu-bullet">
                                      <span className="bullet bullet-dot" />
                                    </span>
                                    <span className="menu-title">
                                      Password Reset
                                    </span>
                                  </a>
                                </div>
                                <div className="menu-item">
                                  <a
                                    className="menu-link py-3"
                                    href="/metronic8/demo1/../demo1/authentication/email/password-change.html"
                                    target="blank"
                                  >
                                    <span className="menu-bullet">
                                      <span className="bullet bullet-dot" />
                                    </span>
                                    <span className="menu-title">
                                      Password Changed
                                    </span>
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          data-kt-menu-trigger="{default:'click', lg: 'hover'}"
                          data-kt-menu-placement="right-start"
                          className="menu-item menu-lg-down-accordion"
                        >
                          <span className="menu-link py-3">
                            <span className="menu-icon">
                              {/*begin::Svg Icon | path: icons/duotune/art/art009.svg*/}
                              <span className="svg-icon svg-icon-2">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width={24}
                                  height={24}
                                  viewBox="0 0 24 24"
                                  fill="none"
                                >
                                  <path
                                    opacity="0.3"
                                    d="M21 18.3V4H20H5C4.4 4 4 4.4 4 5V20C10.9 20 16.7 15.6 19 9.5V18.3C18.4 18.6 18 19.3 18 20C18 21.1 18.9 22 20 22C21.1 22 22 21.1 22 20C22 19.3 21.6 18.6 21 18.3Z"
                                    fill="currentColor"
                                  />
                                  <path
                                    d="M22 4C22 2.9 21.1 2 20 2C18.9 2 18 2.9 18 4C18 4.7 18.4 5.29995 18.9 5.69995C18.1 12.6 12.6 18.2 5.70001 18.9C5.30001 18.4 4.7 18 4 18C2.9 18 2 18.9 2 20C2 21.1 2.9 22 4 22C4.8 22 5.39999 21.6 5.79999 20.9C13.8 20.1 20.1 13.7 20.9 5.80005C21.6 5.40005 22 4.8 22 4Z"
                                    fill="currentColor"
                                  />
                                </svg>
                              </span>
                              {/*end::Svg Icon*/}
                            </span>
                            <span className="menu-title">Utilities</span>
                            <span className="menu-arrow" />
                          </span>
                          <div className="menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-active-bg py-lg-4 w-lg-225px">
                            <div
                              data-kt-menu-trigger="{default:'click', lg: 'hover'}"
                              data-kt-menu-placement="right-start"
                              className="menu-item menu-lg-down-accordion"
                            >
                              <span className="menu-link py-3">
                                <span className="menu-bullet">
                                  <span className="bullet bullet-dot" />
                                </span>
                                <span className="menu-title">Modals</span>
                                <span className="menu-arrow" />
                              </span>
                              <div className="menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-active-bg py-lg-4 w-lg-225px">
                                <div
                                  data-kt-menu-trigger="{default:'click', lg: 'hover'}"
                                  data-kt-menu-placement="right-start"
                                  className="menu-item menu-lg-down-accordion"
                                >
                                  <span className="menu-link py-3">
                                    <span className="menu-bullet">
                                      <span className="bullet bullet-dot" />
                                    </span>
                                    <span className="menu-title">General</span>
                                    <span className="menu-arrow" />
                                  </span>
                                  <div className="menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-active-bg py-lg-4 w-lg-225px">
                                    <div className="menu-item">
                                      <a
                                        className="menu-link py-3"
                                        href="/metronic8/demo1/../demo1/utilities/modals/general/invite-friends.html"
                                      >
                                        <span className="menu-bullet">
                                          <span className="bullet bullet-dot" />
                                        </span>
                                        <span className="menu-title">
                                          Invite Friends
                                        </span>
                                      </a>
                                    </div>
                                    <div className="menu-item">
                                      <a
                                        className="menu-link py-3"
                                        href="/metronic8/demo1/../demo1/utilities/modals/general/view-users.html"
                                      >
                                        <span className="menu-bullet">
                                          <span className="bullet bullet-dot" />
                                        </span>
                                        <span className="menu-title">
                                          View Users
                                        </span>
                                      </a>
                                    </div>
                                    <div className="menu-item">
                                      <a
                                        className="menu-link py-3"
                                        href="/metronic8/demo1/../demo1/utilities/modals/general/upgrade-plan.html"
                                      >
                                        <span className="menu-bullet">
                                          <span className="bullet bullet-dot" />
                                        </span>
                                        <span className="menu-title">
                                          Upgrade Plan
                                        </span>
                                      </a>
                                    </div>
                                    <div className="menu-item">
                                      <a
                                        className="menu-link py-3"
                                        href="/metronic8/demo1/../demo1/utilities/modals/general/share-earn.html"
                                      >
                                        <span className="menu-bullet">
                                          <span className="bullet bullet-dot" />
                                        </span>
                                        <span className="menu-title">
                                          Share &amp; Earn
                                        </span>
                                      </a>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  data-kt-menu-trigger="{default:'click', lg: 'hover'}"
                                  data-kt-menu-placement="right-start"
                                  className="menu-item menu-lg-down-accordion"
                                >
                                  <span className="menu-link py-3">
                                    <span className="menu-bullet">
                                      <span className="bullet bullet-dot" />
                                    </span>
                                    <span className="menu-title">Forms</span>
                                    <span className="menu-arrow" />
                                  </span>
                                  <div className="menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-active-bg py-lg-4 w-lg-225px">
                                    <div className="menu-item">
                                      <a
                                        className="menu-link py-3"
                                        href="/metronic8/demo1/../demo1/utilities/modals/forms/new-target.html"
                                      >
                                        <span className="menu-bullet">
                                          <span className="bullet bullet-dot" />
                                        </span>
                                        <span className="menu-title">
                                          New Target
                                        </span>
                                      </a>
                                    </div>
                                    <div className="menu-item">
                                      <a
                                        className="menu-link py-3"
                                        href="/metronic8/demo1/../demo1/utilities/modals/forms/new-card.html"
                                      >
                                        <span className="menu-bullet">
                                          <span className="bullet bullet-dot" />
                                        </span>
                                        <span className="menu-title">
                                          New Card
                                        </span>
                                      </a>
                                    </div>
                                    <div className="menu-item">
                                      <a
                                        className="menu-link py-3"
                                        href="/metronic8/demo1/../demo1/utilities/modals/forms/new-address.html"
                                      >
                                        <span className="menu-bullet">
                                          <span className="bullet bullet-dot" />
                                        </span>
                                        <span className="menu-title">
                                          New Address
                                        </span>
                                      </a>
                                    </div>
                                    <div className="menu-item">
                                      <a
                                        className="menu-link py-3"
                                        href="/metronic8/demo1/../demo1/utilities/modals/forms/create-api-key.html"
                                      >
                                        <span className="menu-bullet">
                                          <span className="bullet bullet-dot" />
                                        </span>
                                        <span className="menu-title">
                                          Create API Key
                                        </span>
                                      </a>
                                    </div>
                                    <div className="menu-item">
                                      <a
                                        className="menu-link py-3"
                                        href="/metronic8/demo1/../demo1/utilities/modals/forms/bidding.html"
                                      >
                                        <span className="menu-bullet">
                                          <span className="bullet bullet-dot" />
                                        </span>
                                        <span className="menu-title">
                                          Bidding
                                        </span>
                                      </a>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  data-kt-menu-trigger="{default:'click', lg: 'hover'}"
                                  data-kt-menu-placement="right-start"
                                  className="menu-item menu-lg-down-accordion"
                                >
                                  <span className="menu-link py-3">
                                    <span className="menu-bullet">
                                      <span className="bullet bullet-dot" />
                                    </span>
                                    <span className="menu-title">Wizards</span>
                                    <span className="menu-arrow" />
                                  </span>
                                  <div className="menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-active-bg py-lg-4 w-lg-225px">
                                    <div className="menu-item">
                                      <a
                                        className="menu-link py-3"
                                        href="/metronic8/demo1/../demo1/utilities/modals/wizards/two-factor-authentication.html"
                                      >
                                        <span className="menu-bullet">
                                          <span className="bullet bullet-dot" />
                                        </span>
                                        <span className="menu-title">
                                          Two Factor Auth
                                        </span>
                                      </a>
                                    </div>
                                    <div className="menu-item">
                                      <a
                                        className="menu-link py-3"
                                        href="/metronic8/demo1/../demo1/utilities/modals/wizards/create-app.html"
                                      >
                                        <span className="menu-bullet">
                                          <span className="bullet bullet-dot" />
                                        </span>
                                        <span className="menu-title">
                                          Create App
                                        </span>
                                      </a>
                                    </div>
                                    <div className="menu-item">
                                      <a
                                        className="menu-link py-3"
                                        href="/metronic8/demo1/../demo1/utilities/modals/wizards/create-campaign.html"
                                      >
                                        <span className="menu-bullet">
                                          <span className="bullet bullet-dot" />
                                        </span>
                                        <span className="menu-title">
                                          Create Campaign
                                        </span>
                                      </a>
                                    </div>
                                    <div className="menu-item">
                                      <a
                                        className="menu-link py-3"
                                        href="/metronic8/demo1/../demo1/utilities/modals/wizards/create-account.html"
                                      >
                                        <span className="menu-bullet">
                                          <span className="bullet bullet-dot" />
                                        </span>
                                        <span className="menu-title">
                                          Create Account
                                        </span>
                                      </a>
                                    </div>
                                    <div className="menu-item">
                                      <a
                                        className="menu-link py-3"
                                        href="/metronic8/demo1/../demo1/utilities/modals/wizards/create-project.html"
                                      >
                                        <span className="menu-bullet">
                                          <span className="bullet bullet-dot" />
                                        </span>
                                        <span className="menu-title">
                                          Create Project
                                        </span>
                                      </a>
                                    </div>
                                    <div className="menu-item">
                                      <a
                                        className="menu-link py-3"
                                        href="/metronic8/demo1/../demo1/utilities/modals/wizards/offer-a-deal.html"
                                      >
                                        <span className="menu-bullet">
                                          <span className="bullet bullet-dot" />
                                        </span>
                                        <span className="menu-title">
                                          Offer a Deal
                                        </span>
                                      </a>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  data-kt-menu-trigger="{default:'click', lg: 'hover'}"
                                  data-kt-menu-placement="right-start"
                                  className="menu-item menu-lg-down-accordion"
                                >
                                  <span className="menu-link py-3">
                                    <span className="menu-bullet">
                                      <span className="bullet bullet-dot" />
                                    </span>
                                    <span className="menu-title">Search</span>
                                    <span className="menu-arrow" />
                                  </span>
                                  <div className="menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-active-bg py-lg-4 w-lg-225px">
                                    <div className="menu-item">
                                      <a
                                        className="menu-link py-3"
                                        href="/metronic8/demo1/../demo1/utilities/modals/search/users.html"
                                      >
                                        <span className="menu-bullet">
                                          <span className="bullet bullet-dot" />
                                        </span>
                                        <span className="menu-title">
                                          Users
                                        </span>
                                      </a>
                                    </div>
                                    <div className="menu-item">
                                      <a
                                        className="menu-link py-3"
                                        href="/metronic8/demo1/../demo1/utilities/modals/search/select-location.html"
                                      >
                                        <span className="menu-bullet">
                                          <span className="bullet bullet-dot" />
                                        </span>
                                        <span className="menu-title">
                                          Select Location
                                        </span>
                                      </a>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              data-kt-menu-trigger="{default:'click', lg: 'hover'}"
                              data-kt-menu-placement="right-start"
                              className="menu-item menu-lg-down-accordion"
                            >
                              <span className="menu-link py-3">
                                <span className="menu-bullet">
                                  <span className="bullet bullet-dot" />
                                </span>
                                <span className="menu-title">Search</span>
                                <span className="menu-arrow" />
                              </span>
                              <div className="menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-active-bg py-lg-4 w-lg-225px">
                                <div className="menu-item">
                                  <a
                                    className="menu-link py-3"
                                    href="/metronic8/demo1/../demo1/utilities/search/horizontal.html"
                                  >
                                    <span className="menu-bullet">
                                      <span className="bullet bullet-dot" />
                                    </span>
                                    <span className="menu-title">
                                      Horizontal
                                    </span>
                                  </a>
                                </div>
                                <div className="menu-item">
                                  <a
                                    className="menu-link py-3"
                                    href="/metronic8/demo1/../demo1/utilities/search/vertical.html"
                                  >
                                    <span className="menu-bullet">
                                      <span className="bullet bullet-dot" />
                                    </span>
                                    <span className="menu-title">Vertical</span>
                                  </a>
                                </div>
                                <div className="menu-item">
                                  <a
                                    className="menu-link py-3"
                                    href="/metronic8/demo1/../demo1/utilities/search/users.html"
                                  >
                                    <span className="menu-bullet">
                                      <span className="bullet bullet-dot" />
                                    </span>
                                    <span className="menu-title">Users</span>
                                  </a>
                                </div>
                                <div className="menu-item">
                                  <a
                                    className="menu-link py-3"
                                    href="/metronic8/demo1/../demo1/utilities/search/select-location.html"
                                  >
                                    <span className="menu-bullet">
                                      <span className="bullet bullet-dot" />
                                    </span>
                                    <span className="menu-title">Location</span>
                                  </a>
                                </div>
                              </div>
                            </div>
                            <div
                              data-kt-menu-trigger="{default:'click', lg: 'hover'}"
                              data-kt-menu-placement="right-start"
                              className="menu-item menu-lg-down-accordion"
                            >
                              <span className="menu-link py-3">
                                <span className="menu-bullet">
                                  <span className="bullet bullet-dot" />
                                </span>
                                <span className="menu-title">Wizards</span>
                                <span className="menu-arrow" />
                              </span>
                              <div className="menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-active-bg py-lg-4 w-lg-225px">
                                <div className="menu-item">
                                  <a
                                    className="menu-link py-3"
                                    href="/metronic8/demo1/../demo1/utilities/wizards/horizontal.html"
                                  >
                                    <span className="menu-bullet">
                                      <span className="bullet bullet-dot" />
                                    </span>
                                    <span className="menu-title">
                                      Horizontal
                                    </span>
                                  </a>
                                </div>
                                <div className="menu-item">
                                  <a
                                    className="menu-link py-3"
                                    href="/metronic8/demo1/../demo1/utilities/wizards/vertical.html"
                                  >
                                    <span className="menu-bullet">
                                      <span className="bullet bullet-dot" />
                                    </span>
                                    <span className="menu-title">Vertical</span>
                                  </a>
                                </div>
                                <div className="menu-item">
                                  <a
                                    className="menu-link py-3"
                                    href="/metronic8/demo1/../demo1/utilities/wizards/two-factor-authentication.html"
                                  >
                                    <span className="menu-bullet">
                                      <span className="bullet bullet-dot" />
                                    </span>
                                    <span className="menu-title">
                                      Two Factor Auth
                                    </span>
                                  </a>
                                </div>
                                <div className="menu-item">
                                  <a
                                    className="menu-link py-3"
                                    href="/metronic8/demo1/../demo1/utilities/wizards/create-app.html"
                                  >
                                    <span className="menu-bullet">
                                      <span className="bullet bullet-dot" />
                                    </span>
                                    <span className="menu-title">
                                      Create App
                                    </span>
                                  </a>
                                </div>
                                <div className="menu-item">
                                  <a
                                    className="menu-link py-3"
                                    href="/metronic8/demo1/../demo1/utilities/wizards/create-campaign.html"
                                  >
                                    <span className="menu-bullet">
                                      <span className="bullet bullet-dot" />
                                    </span>
                                    <span className="menu-title">
                                      Create Campaign
                                    </span>
                                  </a>
                                </div>
                                <div className="menu-item">
                                  <a
                                    className="menu-link py-3"
                                    href="/metronic8/demo1/../demo1/utilities/wizards/create-account.html"
                                  >
                                    <span className="menu-bullet">
                                      <span className="bullet bullet-dot" />
                                    </span>
                                    <span className="menu-title">
                                      Create Account
                                    </span>
                                  </a>
                                </div>
                                <div className="menu-item">
                                  <a
                                    className="menu-link py-3"
                                    href="/metronic8/demo1/../demo1/utilities/wizards/create-project.html"
                                  >
                                    <span className="menu-bullet">
                                      <span className="bullet bullet-dot" />
                                    </span>
                                    <span className="menu-title">
                                      Create Project
                                    </span>
                                  </a>
                                </div>
                                <div className="menu-item">
                                  <a
                                    className="menu-link py-3"
                                    href="/metronic8/demo1/../demo1/utilities/wizards/offer-a-deal.html"
                                  >
                                    <span className="menu-bullet">
                                      <span className="bullet bullet-dot" />
                                    </span>
                                    <span className="menu-title">
                                      Offer a Deal
                                    </span>
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          data-kt-menu-trigger="{default:'click', lg: 'hover'}"
                          data-kt-menu-placement="right-start"
                          className="menu-item menu-lg-down-accordion"
                        >
                          <span className="menu-link py-3">
                            <span className="menu-icon">
                              {/*begin::Svg Icon | path: icons/duotune/general/gen022.svg*/}
                              <span className="svg-icon svg-icon-2">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width={24}
                                  height={24}
                                  viewBox="0 0 24 24"
                                  fill="none"
                                >
                                  <path
                                    d="M11.2929 2.70711C11.6834 2.31658 12.3166 2.31658 12.7071 2.70711L15.2929 5.29289C15.6834 5.68342 15.6834 6.31658 15.2929 6.70711L12.7071 9.29289C12.3166 9.68342 11.6834 9.68342 11.2929 9.29289L8.70711 6.70711C8.31658 6.31658 8.31658 5.68342 8.70711 5.29289L11.2929 2.70711Z"
                                    fill="currentColor"
                                  />
                                  <path
                                    d="M11.2929 14.7071C11.6834 14.3166 12.3166 14.3166 12.7071 14.7071L15.2929 17.2929C15.6834 17.6834 15.6834 18.3166 15.2929 18.7071L12.7071 21.2929C12.3166 21.6834 11.6834 21.6834 11.2929 21.2929L8.70711 18.7071C8.31658 18.3166 8.31658 17.6834 8.70711 17.2929L11.2929 14.7071Z"
                                    fill="currentColor"
                                  />
                                  <path
                                    opacity="0.3"
                                    d="M5.29289 8.70711C5.68342 8.31658 6.31658 8.31658 6.70711 8.70711L9.29289 11.2929C9.68342 11.6834 9.68342 12.3166 9.29289 12.7071L6.70711 15.2929C6.31658 15.6834 5.68342 15.6834 5.29289 15.2929L2.70711 12.7071C2.31658 12.3166 2.31658 11.6834 2.70711 11.2929L5.29289 8.70711Z"
                                    fill="currentColor"
                                  />
                                  <path
                                    opacity="0.3"
                                    d="M17.2929 8.70711C17.6834 8.31658 18.3166 8.31658 18.7071 8.70711L21.2929 11.2929C21.6834 11.6834 21.6834 12.3166 21.2929 12.7071L18.7071 15.2929C18.3166 15.6834 17.6834 15.6834 17.2929 15.2929L14.7071 12.7071C14.3166 12.3166 14.3166 11.6834 14.7071 11.2929L17.2929 8.70711Z"
                                    fill="currentColor"
                                  />
                                </svg>
                              </span>
                              {/*end::Svg Icon*/}
                            </span>
                            <span className="menu-title">Widgets</span>
                            <span className="menu-arrow" />
                          </span>
                          <div className="menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-active-bg py-lg-4 w-lg-225px">
                            <div className="menu-item">
                              <a
                                className="menu-link py-3"
                                href="/metronic8/demo1/../demo1/widgets/lists.html"
                              >
                                <span className="menu-bullet">
                                  <span className="bullet bullet-dot" />
                                </span>
                                <span className="menu-title">Lists</span>
                              </a>
                            </div>
                            <div className="menu-item">
                              <a
                                className="menu-link py-3"
                                href="/metronic8/demo1/../demo1/widgets/statistics.html"
                              >
                                <span className="menu-bullet">
                                  <span className="bullet bullet-dot" />
                                </span>
                                <span className="menu-title">Statistics</span>
                              </a>
                            </div>
                            <div className="menu-item">
                              <a
                                className="menu-link py-3"
                                href="/metronic8/demo1/../demo1/widgets/charts.html"
                              >
                                <span className="menu-bullet">
                                  <span className="bullet bullet-dot" />
                                </span>
                                <span className="menu-title">Charts</span>
                              </a>
                            </div>
                            <div className="menu-item">
                              <a
                                className="menu-link py-3"
                                href="/metronic8/demo1/../demo1/widgets/mixed.html"
                              >
                                <span className="menu-bullet">
                                  <span className="bullet bullet-dot" />
                                </span>
                                <span className="menu-title">Mixed</span>
                              </a>
                            </div>
                            <div className="menu-item">
                              <a
                                className="menu-link py-3"
                                href="/metronic8/demo1/../demo1/widgets/tables.html"
                              >
                                <span className="menu-bullet">
                                  <span className="bullet bullet-dot" />
                                </span>
                                <span className="menu-title">Tables</span>
                              </a>
                            </div>
                            <div className="menu-item">
                              <a
                                className="menu-link py-3"
                                href="/metronic8/demo1/../demo1/widgets/feeds.html"
                              >
                                <span className="menu-bullet">
                                  <span className="bullet bullet-dot" />
                                </span>
                                <span className="menu-title">Feeds</span>
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      data-kt-menu-trigger="click"
                      data-kt-menu-placement="bottom-start"
                      className="menu-item menu-lg-down-accordion me-lg-1"
                    >
                      <span className="menu-link py-3">
                        <span className="menu-title">Apps</span>
                        <span className="menu-arrow d-lg-none" />
                      </span>
                      <div className="menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-rounded-0 py-lg-4 w-lg-225px">
                        <div
                          data-kt-menu-trigger="{default:'click', lg: 'hover'}"
                          data-kt-menu-placement="right-start"
                          className="menu-item menu-lg-down-accordion"
                        >
                          <span className="menu-link py-3">
                            <span className="menu-icon">
                              {/*begin::Svg Icon | path: icons/duotune/general/gen002.svg*/}
                              <span className="svg-icon svg-icon-2">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width={24}
                                  height={24}
                                  viewBox="0 0 24 24"
                                  fill="none"
                                >
                                  <path
                                    opacity="0.3"
                                    d="M4.05424 15.1982C8.34524 7.76818 13.5782 3.26318 20.9282 2.01418C21.0729 1.98837 21.2216 1.99789 21.3618 2.04193C21.502 2.08597 21.6294 2.16323 21.7333 2.26712C21.8372 2.37101 21.9144 2.49846 21.9585 2.63863C22.0025 2.7788 22.012 2.92754 21.9862 3.07218C20.7372 10.4222 16.2322 15.6552 8.80224 19.9462L4.05424 15.1982ZM3.81924 17.3372L2.63324 20.4482C2.58427 20.5765 2.5735 20.7163 2.6022 20.8507C2.63091 20.9851 2.69788 21.1082 2.79503 21.2054C2.89218 21.3025 3.01536 21.3695 3.14972 21.3982C3.28408 21.4269 3.42387 21.4161 3.55224 21.3672L6.66524 20.1802L3.81924 17.3372ZM16.5002 5.99818C16.2036 5.99818 15.9136 6.08615 15.6669 6.25097C15.4202 6.41579 15.228 6.65006 15.1144 6.92415C15.0009 7.19824 14.9712 7.49984 15.0291 7.79081C15.0869 8.08178 15.2298 8.34906 15.4396 8.55884C15.6494 8.76862 15.9166 8.91148 16.2076 8.96935C16.4986 9.02723 16.8002 8.99753 17.0743 8.884C17.3484 8.77046 17.5826 8.5782 17.7474 8.33153C17.9123 8.08486 18.0002 7.79485 18.0002 7.49818C18.0002 7.10035 17.8422 6.71882 17.5609 6.43752C17.2796 6.15621 16.8981 5.99818 16.5002 5.99818Z"
                                    fill="currentColor"
                                  />
                                  <path
                                    d="M4.05423 15.1982L2.24723 13.3912C2.15505 13.299 2.08547 13.1867 2.04395 13.0632C2.00243 12.9396 1.9901 12.8081 2.00793 12.679C2.02575 12.5498 2.07325 12.4266 2.14669 12.3189C2.22013 12.2112 2.31752 12.1219 2.43123 12.0582L9.15323 8.28918C7.17353 10.3717 5.4607 12.6926 4.05423 15.1982ZM8.80023 19.9442L10.6072 21.7512C10.6994 21.8434 10.8117 21.9129 10.9352 21.9545C11.0588 21.996 11.1903 22.0083 11.3195 21.9905C11.4486 21.9727 11.5718 21.9252 11.6795 21.8517C11.7872 21.7783 11.8765 21.6809 11.9402 21.5672L15.7092 14.8442C13.6269 16.8245 11.3061 18.5377 8.80023 19.9442ZM7.04023 18.1832L12.5832 12.6402C12.7381 12.4759 12.8228 12.2577 12.8195 12.032C12.8161 11.8063 12.725 11.5907 12.5653 11.4311C12.4057 11.2714 12.1901 11.1803 11.9644 11.1769C11.7387 11.1736 11.5205 11.2583 11.3562 11.4132L5.81323 16.9562L7.04023 18.1832Z"
                                    fill="currentColor"
                                  />
                                </svg>
                              </span>
                              {/*end::Svg Icon*/}
                            </span>
                            <span className="menu-title">Projects</span>
                            <span className="menu-arrow" />
                          </span>
                          <div className="menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-active-bg py-lg-4 w-lg-225px">
                            <div className="menu-item">
                              <a
                                className="menu-link py-3"
                                href="/metronic8/demo1/../demo1/apps/projects/list.html"
                              >
                                <span className="menu-bullet">
                                  <span className="bullet bullet-dot" />
                                </span>
                                <span className="menu-title">My Projects</span>
                              </a>
                            </div>
                            <div className="menu-item">
                              <a
                                className="menu-link py-3"
                                href="/metronic8/demo1/../demo1/apps/projects/project.html"
                              >
                                <span className="menu-bullet">
                                  <span className="bullet bullet-dot" />
                                </span>
                                <span className="menu-title">View Project</span>
                              </a>
                            </div>
                            <div className="menu-item">
                              <a
                                className="menu-link py-3"
                                href="/metronic8/demo1/../demo1/apps/projects/targets.html"
                              >
                                <span className="menu-bullet">
                                  <span className="bullet bullet-dot" />
                                </span>
                                <span className="menu-title">Targets</span>
                              </a>
                            </div>
                            <div className="menu-item">
                              <a
                                className="menu-link py-3"
                                href="/metronic8/demo1/../demo1/apps/projects/budget.html"
                              >
                                <span className="menu-bullet">
                                  <span className="bullet bullet-dot" />
                                </span>
                                <span className="menu-title">Budget</span>
                              </a>
                            </div>
                            <div className="menu-item">
                              <a
                                className="menu-link py-3"
                                href="/metronic8/demo1/../demo1/apps/projects/users.html"
                              >
                                <span className="menu-bullet">
                                  <span className="bullet bullet-dot" />
                                </span>
                                <span className="menu-title">Users</span>
                              </a>
                            </div>
                            <div className="menu-item">
                              <a
                                className="menu-link py-3"
                                href="/metronic8/demo1/../demo1/apps/projects/files.html"
                              >
                                <span className="menu-bullet">
                                  <span className="bullet bullet-dot" />
                                </span>
                                <span className="menu-title">Files</span>
                              </a>
                            </div>
                            <div className="menu-item">
                              <a
                                className="menu-link py-3"
                                href="/metronic8/demo1/../demo1/apps/projects/activity.html"
                              >
                                <span className="menu-bullet">
                                  <span className="bullet bullet-dot" />
                                </span>
                                <span className="menu-title">Activity</span>
                              </a>
                            </div>
                            <div className="menu-item">
                              <a
                                className="menu-link py-3"
                                href="/metronic8/demo1/../demo1/apps/projects/settings.html"
                              >
                                <span className="menu-bullet">
                                  <span className="bullet bullet-dot" />
                                </span>
                                <span className="menu-title">Settings</span>
                              </a>
                            </div>
                          </div>
                        </div>
                        <div
                          data-kt-menu-trigger="{default:'click', lg: 'hover'}"
                          data-kt-menu-placement="right-start"
                          className="menu-item menu-lg-down-accordion"
                        >
                          <span className="menu-link py-3">
                            <span className="menu-icon">
                              {/*begin::Svg Icon | path: icons/duotune/ecommerce/ecm001.svg*/}
                              <span className="svg-icon svg-icon-2">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width={24}
                                  height={24}
                                  viewBox="0 0 24 24"
                                  fill="none"
                                >
                                  <path
                                    opacity="0.3"
                                    d="M18.041 22.041C18.5932 22.041 19.041 21.5932 19.041 21.041C19.041 20.4887 18.5932 20.041 18.041 20.041C17.4887 20.041 17.041 20.4887 17.041 21.041C17.041 21.5932 17.4887 22.041 18.041 22.041Z"
                                    fill="currentColor"
                                  />
                                  <path
                                    opacity="0.3"
                                    d="M6.04095 22.041C6.59324 22.041 7.04095 21.5932 7.04095 21.041C7.04095 20.4887 6.59324 20.041 6.04095 20.041C5.48867 20.041 5.04095 20.4887 5.04095 21.041C5.04095 21.5932 5.48867 22.041 6.04095 22.041Z"
                                    fill="currentColor"
                                  />
                                  <path
                                    opacity="0.3"
                                    d="M7.04095 16.041L19.1409 15.1409C19.7409 15.1409 20.141 14.7409 20.341 14.1409L21.7409 8.34094C21.9409 7.64094 21.4409 7.04095 20.7409 7.04095H5.44095L7.04095 16.041Z"
                                    fill="currentColor"
                                  />
                                  <path
                                    d="M19.041 20.041H5.04096C4.74096 20.041 4.34095 19.841 4.14095 19.541C3.94095 19.241 3.94095 18.841 4.14095 18.541L6.04096 14.841L4.14095 4.64095L2.54096 3.84096C2.04096 3.64096 1.84095 3.04097 2.14095 2.54097C2.34095 2.04097 2.94096 1.84095 3.44096 2.14095L5.44096 3.14095C5.74096 3.24095 5.94096 3.54096 5.94096 3.84096L7.94096 14.841C7.94096 15.041 7.94095 15.241 7.84095 15.441L6.54096 18.041H19.041C19.641 18.041 20.041 18.441 20.041 19.041C20.041 19.641 19.641 20.041 19.041 20.041Z"
                                    fill="currentColor"
                                  />
                                </svg>
                              </span>
                              {/*end::Svg Icon*/}
                            </span>
                            <span className="menu-title">eCommerce</span>
                            <span className="menu-arrow" />
                          </span>
                          <div className="menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-active-bg py-lg-4 w-lg-225px">
                            <div
                              data-kt-menu-trigger="{default:'click', lg: 'hover'}"
                              data-kt-menu-placement="right-start"
                              className="menu-item menu-lg-down-accordion"
                            >
                              <span className="menu-link py-3">
                                <span className="menu-bullet">
                                  <span className="bullet bullet-dot" />
                                </span>
                                <span className="menu-title">Catalog</span>
                                <span className="menu-arrow" />
                              </span>
                              <div className="menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-active-bg py-lg-4 w-lg-225px">
                                <div className="menu-item">
                                  <a
                                    className="menu-link py-3"
                                    href="/metronic8/demo1/../demo1/apps/ecommerce/catalog/products.html"
                                  >
                                    <span className="menu-bullet">
                                      <span className="bullet bullet-dot" />
                                    </span>
                                    <span className="menu-title">Products</span>
                                  </a>
                                </div>
                                <div className="menu-item">
                                  <a
                                    className="menu-link py-3"
                                    href="/metronic8/demo1/../demo1/apps/ecommerce/catalog/categories.html"
                                  >
                                    <span className="menu-bullet">
                                      <span className="bullet bullet-dot" />
                                    </span>
                                    <span className="menu-title">
                                      Categories
                                    </span>
                                  </a>
                                </div>
                                <div className="menu-item">
                                  <a
                                    className="menu-link py-3"
                                    href="/metronic8/demo1/../demo1/apps/ecommerce/catalog/add-product.html"
                                  >
                                    <span className="menu-bullet">
                                      <span className="bullet bullet-dot" />
                                    </span>
                                    <span className="menu-title">
                                      Add Product
                                    </span>
                                  </a>
                                </div>
                                <div className="menu-item">
                                  <a
                                    className="menu-link py-3"
                                    href="/metronic8/demo1/../demo1/apps/ecommerce/catalog/edit-product.html"
                                  >
                                    <span className="menu-bullet">
                                      <span className="bullet bullet-dot" />
                                    </span>
                                    <span className="menu-title">
                                      Edit Product
                                    </span>
                                  </a>
                                </div>
                                <div className="menu-item">
                                  <a
                                    className="menu-link py-3"
                                    href="/metronic8/demo1/../demo1/apps/ecommerce/catalog/add-category.html"
                                  >
                                    <span className="menu-bullet">
                                      <span className="bullet bullet-dot" />
                                    </span>
                                    <span className="menu-title">
                                      Add Category
                                    </span>
                                  </a>
                                </div>
                                <div className="menu-item">
                                  <a
                                    className="menu-link py-3"
                                    href="/metronic8/demo1/../demo1/apps/ecommerce/catalog/edit-category.html"
                                  >
                                    <span className="menu-bullet">
                                      <span className="bullet bullet-dot" />
                                    </span>
                                    <span className="menu-title">
                                      Edit Category
                                    </span>
                                  </a>
                                </div>
                              </div>
                            </div>
                            <div
                              data-kt-menu-trigger="click"
                              className="menu-item menu-accordion"
                            >
                              <span className="menu-link py-3">
                                <span className="menu-bullet">
                                  <span className="bullet bullet-dot" />
                                </span>
                                <span className="menu-title">Sales</span>
                                <span className="menu-arrow" />
                              </span>
                              <div className="menu-sub menu-sub-accordion">
                                <div className="menu-item">
                                  <a
                                    className="menu-link py-3"
                                    href="/metronic8/demo1/../demo1/apps/ecommerce/sales/listing.html"
                                  >
                                    <span className="menu-bullet">
                                      <span className="bullet bullet-dot" />
                                    </span>
                                    <span className="menu-title">
                                      Orders Listing
                                    </span>
                                  </a>
                                </div>
                                <div className="menu-item">
                                  <a
                                    className="menu-link py-3"
                                    href="/metronic8/demo1/../demo1/apps/ecommerce/sales/details.html"
                                  >
                                    <span className="menu-bullet">
                                      <span className="bullet bullet-dot" />
                                    </span>
                                    <span className="menu-title">
                                      Order Details
                                    </span>
                                  </a>
                                </div>
                                <div className="menu-item">
                                  <a
                                    className="menu-link py-3"
                                    href="/metronic8/demo1/../demo1/apps/ecommerce/sales/add-order.html"
                                  >
                                    <span className="menu-bullet">
                                      <span className="bullet bullet-dot" />
                                    </span>
                                    <span className="menu-title">
                                      Add Order
                                    </span>
                                  </a>
                                </div>
                                <div className="menu-item">
                                  <a
                                    className="menu-link py-3"
                                    href="/metronic8/demo1/../demo1/apps/ecommerce/sales/edit-order.html"
                                  >
                                    <span className="menu-bullet">
                                      <span className="bullet bullet-dot" />
                                    </span>
                                    <span className="menu-title">
                                      Edit Order
                                    </span>
                                  </a>
                                </div>
                              </div>
                            </div>
                            <div
                              data-kt-menu-trigger="click"
                              className="menu-item menu-accordion"
                            >
                              <span className="menu-link py-3">
                                <span className="menu-bullet">
                                  <span className="bullet bullet-dot" />
                                </span>
                                <span className="menu-title">Customers</span>
                                <span className="menu-arrow" />
                              </span>
                              <div className="menu-sub menu-sub-accordion">
                                <div className="menu-item">
                                  <a
                                    className="menu-link py-3"
                                    href="/metronic8/demo1/../demo1/apps/ecommerce/customers/listing.html"
                                  >
                                    <span className="menu-bullet">
                                      <span className="bullet bullet-dot" />
                                    </span>
                                    <span className="menu-title">
                                      Customers Listing
                                    </span>
                                  </a>
                                </div>
                                <div className="menu-item">
                                  <a
                                    className="menu-link py-3"
                                    href="/metronic8/demo1/../demo1/apps/ecommerce/customers/details.html"
                                  >
                                    <span className="menu-bullet">
                                      <span className="bullet bullet-dot" />
                                    </span>
                                    <span className="menu-title">
                                      Customers Details
                                    </span>
                                  </a>
                                </div>
                              </div>
                            </div>
                            <div
                              data-kt-menu-trigger="click"
                              className="menu-item menu-accordion"
                            >
                              <span className="menu-link py-3">
                                <span className="menu-bullet">
                                  <span className="bullet bullet-dot" />
                                </span>
                                <span className="menu-title">Reports</span>
                                <span className="menu-arrow" />
                              </span>
                              <div className="menu-sub menu-sub-accordion">
                                <div className="menu-item">
                                  <a
                                    className="menu-link py-3"
                                    href="/metronic8/demo1/../demo1/apps/ecommerce/reports/view.html"
                                  >
                                    <span className="menu-bullet">
                                      <span className="bullet bullet-dot" />
                                    </span>
                                    <span className="menu-title">
                                      Products Viewed
                                    </span>
                                  </a>
                                </div>
                                <div className="menu-item">
                                  <a
                                    className="menu-link py-3"
                                    href="/metronic8/demo1/../demo1/apps/ecommerce/reports/sales.html"
                                  >
                                    <span className="menu-bullet">
                                      <span className="bullet bullet-dot" />
                                    </span>
                                    <span className="menu-title">Sales</span>
                                  </a>
                                </div>
                                <div className="menu-item">
                                  <a
                                    className="menu-link py-3"
                                    href="/metronic8/demo1/../demo1/apps/ecommerce/reports/returns.html"
                                  >
                                    <span className="menu-bullet">
                                      <span className="bullet bullet-dot" />
                                    </span>
                                    <span className="menu-title">Returns</span>
                                  </a>
                                </div>
                                <div className="menu-item">
                                  <a
                                    className="menu-link py-3"
                                    href="/metronic8/demo1/../demo1/apps/ecommerce/reports/customer-orders.html"
                                  >
                                    <span className="menu-bullet">
                                      <span className="bullet bullet-dot" />
                                    </span>
                                    <span className="menu-title">
                                      Customer Orders
                                    </span>
                                  </a>
                                </div>
                                <div className="menu-item">
                                  <a
                                    className="menu-link py-3"
                                    href="/metronic8/demo1/../demo1/apps/ecommerce/reports/shipping.html"
                                  >
                                    <span className="menu-bullet">
                                      <span className="bullet bullet-dot" />
                                    </span>
                                    <span className="menu-title">Shipping</span>
                                  </a>
                                </div>
                              </div>
                            </div>
                            <div className="menu-item">
                              <a
                                className="menu-link py-3"
                                href="/metronic8/demo1/../demo1/apps/ecommerce/settings.html"
                              >
                                <span className="menu-bullet">
                                  <span className="bullet bullet-dot" />
                                </span>
                                <span className="menu-title">Settings</span>
                              </a>
                            </div>
                          </div>
                        </div>
                        <div
                          data-kt-menu-trigger="{default:'click', lg: 'hover'}"
                          data-kt-menu-placement="right-start"
                          className="menu-item menu-lg-down-accordion"
                        >
                          <span className="menu-link py-3">
                            <span className="menu-icon">
                              {/*begin::Svg Icon | path: icons/duotune/graphs/gra006.svg*/}
                              <span className="svg-icon svg-icon-2">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width={24}
                                  height={24}
                                  viewBox="0 0 24 24"
                                  fill="none"
                                >
                                  <path
                                    d="M13 5.91517C15.8 6.41517 18 8.81519 18 11.8152C18 12.5152 17.9 13.2152 17.6 13.9152L20.1 15.3152C20.6 15.6152 21.4 15.4152 21.6 14.8152C21.9 13.9152 22.1 12.9152 22.1 11.8152C22.1 7.01519 18.8 3.11521 14.3 2.01521C13.7 1.91521 13.1 2.31521 13.1 3.01521V5.91517H13Z"
                                    fill="currentColor"
                                  />
                                  <path
                                    opacity="0.3"
                                    d="M19.1 17.0152C19.7 17.3152 19.8 18.1152 19.3 18.5152C17.5 20.5152 14.9 21.7152 12 21.7152C9.1 21.7152 6.50001 20.5152 4.70001 18.5152C4.30001 18.0152 4.39999 17.3152 4.89999 17.0152L7.39999 15.6152C8.49999 16.9152 10.2 17.8152 12 17.8152C13.8 17.8152 15.5 17.0152 16.6 15.6152L19.1 17.0152ZM6.39999 13.9151C6.19999 13.2151 6 12.5152 6 11.8152C6 8.81517 8.2 6.41515 11 5.91515V3.01519C11 2.41519 10.4 1.91519 9.79999 2.01519C5.29999 3.01519 2 7.01517 2 11.8152C2 12.8152 2.2 13.8152 2.5 14.8152C2.7 15.4152 3.4 15.7152 4 15.3152L6.39999 13.9151Z"
                                    fill="currentColor"
                                  />
                                </svg>
                              </span>
                              {/*end::Svg Icon*/}
                            </span>
                            <span className="menu-title">Support Center</span>
                            <span className="menu-arrow" />
                          </span>
                          <div className="menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-active-bg py-lg-4 w-lg-225px">
                            <div className="menu-item">
                              <a
                                className="menu-link py-3"
                                href="/metronic8/demo1/../demo1/apps/support-center/overview.html"
                              >
                                <span className="menu-bullet">
                                  <span className="bullet bullet-dot" />
                                </span>
                                <span className="menu-title">Overview</span>
                              </a>
                            </div>
                            <div
                              data-kt-menu-trigger="{default:'click', lg: 'hover'}"
                              data-kt-menu-placement="right-start"
                              className="menu-item menu-lg-down-accordion"
                            >
                              <span className="menu-link py-3">
                                <span className="menu-bullet">
                                  <span className="bullet bullet-dot" />
                                </span>
                                <span className="menu-title">Tickets</span>
                                <span className="menu-arrow" />
                              </span>
                              <div className="menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-active-bg py-lg-4 w-lg-225px">
                                <div className="menu-item">
                                  <a
                                    className="menu-link py-3"
                                    href="/metronic8/demo1/../demo1/apps/support-center/tickets/list.html"
                                  >
                                    <span className="menu-bullet">
                                      <span className="bullet bullet-dot" />
                                    </span>
                                    <span className="menu-title">
                                      Ticket List
                                    </span>
                                  </a>
                                </div>
                                <div className="menu-item">
                                  <a
                                    className="menu-link py-3"
                                    href="/metronic8/demo1/../demo1/apps/support-center/tickets/view.html"
                                  >
                                    <span className="menu-bullet">
                                      <span className="bullet bullet-dot" />
                                    </span>
                                    <span className="menu-title">
                                      Ticket View
                                    </span>
                                  </a>
                                </div>
                              </div>
                            </div>
                            <div
                              data-kt-menu-trigger="{default:'click', lg: 'hover'}"
                              data-kt-menu-placement="right-start"
                              className="menu-item menu-lg-down-accordion"
                            >
                              <span className="menu-link py-3">
                                <span className="menu-bullet">
                                  <span className="bullet bullet-dot" />
                                </span>
                                <span className="menu-title">Tutorials</span>
                                <span className="menu-arrow" />
                              </span>
                              <div className="menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-active-bg py-lg-4 w-lg-225px">
                                <div className="menu-item">
                                  <a
                                    className="menu-link py-3"
                                    href="/metronic8/demo1/../demo1/apps/support-center/tutorials/list.html"
                                  >
                                    <span className="menu-bullet">
                                      <span className="bullet bullet-dot" />
                                    </span>
                                    <span className="menu-title">
                                      Tutorials List
                                    </span>
                                  </a>
                                </div>
                                <div className="menu-item">
                                  <a
                                    className="menu-link py-3"
                                    href="/metronic8/demo1/../demo1/apps/support-center/tutorials/post.html"
                                  >
                                    <span className="menu-bullet">
                                      <span className="bullet bullet-dot" />
                                    </span>
                                    <span className="menu-title">
                                      Tutorials Post
                                    </span>
                                  </a>
                                </div>
                              </div>
                            </div>
                            <div className="menu-item">
                              <a
                                className="menu-link py-3"
                                href="/metronic8/demo1/../demo1/apps/support-center/faq.html"
                              >
                                <span className="menu-bullet">
                                  <span className="bullet bullet-dot" />
                                </span>
                                <span className="menu-title">FAQ</span>
                              </a>
                            </div>
                            <div className="menu-item">
                              <a
                                className="menu-link py-3"
                                href="/metronic8/demo1/../demo1/apps/support-center/licenses.html"
                              >
                                <span className="menu-bullet">
                                  <span className="bullet bullet-dot" />
                                </span>
                                <span className="menu-title">Licenses</span>
                              </a>
                            </div>
                            <div className="menu-item">
                              <a
                                className="menu-link py-3"
                                href="/metronic8/demo1/../demo1/apps/support-center/contact.html"
                              >
                                <span className="menu-bullet">
                                  <span className="bullet bullet-dot" />
                                </span>
                                <span className="menu-title">Contact Us</span>
                              </a>
                            </div>
                          </div>
                        </div>
                        <div
                          data-kt-menu-trigger="{default:'click', lg: 'hover'}"
                          data-kt-menu-placement="right-start"
                          className="menu-item menu-lg-down-accordion"
                        >
                          <span className="menu-link py-3">
                            <span className="menu-icon">
                              {/*begin::Svg Icon | path: icons/duotune/general/gen051.svg*/}
                              <span className="svg-icon svg-icon-2">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width={24}
                                  height={24}
                                  viewBox="0 0 24 24"
                                  fill="none"
                                >
                                  <path
                                    opacity="0.3"
                                    d="M20.5543 4.37824L12.1798 2.02473C12.0626 1.99176 11.9376 1.99176 11.8203 2.02473L3.44572 4.37824C3.18118 4.45258 3 4.6807 3 4.93945V13.569C3 14.6914 3.48509 15.8404 4.4417 16.984C5.17231 17.8575 6.18314 18.7345 7.446 19.5909C9.56752 21.0295 11.6566 21.912 11.7445 21.9488C11.8258 21.9829 11.9129 22 12.0001 22C12.0872 22 12.1744 21.983 12.2557 21.9488C12.3435 21.912 14.4326 21.0295 16.5541 19.5909C17.8169 18.7345 18.8277 17.8575 19.5584 16.984C20.515 15.8404 21 14.6914 21 13.569V4.93945C21 4.6807 20.8189 4.45258 20.5543 4.37824Z"
                                    fill="currentColor"
                                  />
                                  <path
                                    d="M14.854 11.321C14.7568 11.2282 14.6388 11.1818 14.4998 11.1818H14.3333V10.2272C14.3333 9.61741 14.1041 9.09378 13.6458 8.65628C13.1875 8.21876 12.639 8 12 8C11.361 8 10.8124 8.21876 10.3541 8.65626C9.89574 9.09378 9.66663 9.61739 9.66663 10.2272V11.1818H9.49999C9.36115 11.1818 9.24306 11.2282 9.14583 11.321C9.0486 11.4138 9 11.5265 9 11.6591V14.5227C9 14.6553 9.04862 14.768 9.14583 14.8609C9.24306 14.9536 9.36115 15 9.49999 15H14.5C14.6389 15 14.7569 14.9536 14.8542 14.8609C14.9513 14.768 15 14.6553 15 14.5227V11.6591C15.0001 11.5265 14.9513 11.4138 14.854 11.321ZM13.3333 11.1818H10.6666V10.2272C10.6666 9.87594 10.7969 9.57597 11.0573 9.32743C11.3177 9.07886 11.6319 8.9546 12 8.9546C12.3681 8.9546 12.6823 9.07884 12.9427 9.32743C13.2031 9.57595 13.3333 9.87594 13.3333 10.2272V11.1818Z"
                                    fill="currentColor"
                                  />
                                </svg>
                              </span>
                              {/*end::Svg Icon*/}
                            </span>
                            <span className="menu-title">User Management</span>
                            <span className="menu-arrow" />
                          </span>
                          <div className="menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-active-bg py-lg-4 w-lg-225px">
                            <div
                              data-kt-menu-trigger="{default:'click', lg: 'hover'}"
                              data-kt-menu-placement="right-start"
                              className="menu-item menu-lg-down-accordion"
                            >
                              <span className="menu-link py-3">
                                <span className="menu-bullet">
                                  <span className="bullet bullet-dot" />
                                </span>
                                <span className="menu-title">Users</span>
                                <span className="menu-arrow" />
                              </span>
                              <div className="menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-active-bg py-lg-4 w-lg-225px">
                                <div className="menu-item">
                                  <a
                                    className="menu-link py-3"
                                    href="/metronic8/demo1/../demo1/apps/user-management/users/list.html"
                                  >
                                    <span className="menu-bullet">
                                      <span className="bullet bullet-dot" />
                                    </span>
                                    <span className="menu-title">
                                      Users List
                                    </span>
                                  </a>
                                </div>
                                <div className="menu-item">
                                  <a
                                    className="menu-link py-3"
                                    href="/metronic8/demo1/../demo1/apps/user-management/users/view.html"
                                  >
                                    <span className="menu-bullet">
                                      <span className="bullet bullet-dot" />
                                    </span>
                                    <span className="menu-title">
                                      View User
                                    </span>
                                  </a>
                                </div>
                              </div>
                            </div>
                            <div
                              data-kt-menu-trigger="{default:'click', lg: 'hover'}"
                              data-kt-menu-placement="right-start"
                              className="menu-item menu-lg-down-accordion"
                            >
                              <span className="menu-link py-3">
                                <span className="menu-bullet">
                                  <span className="bullet bullet-dot" />
                                </span>
                                <span className="menu-title">Roles</span>
                                <span className="menu-arrow" />
                              </span>
                              <div className="menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-active-bg py-lg-4 w-lg-225px">
                                <div className="menu-item">
                                  <a
                                    className="menu-link py-3"
                                    href="/metronic8/demo1/../demo1/apps/user-management/roles/list.html"
                                  >
                                    <span className="menu-bullet">
                                      <span className="bullet bullet-dot" />
                                    </span>
                                    <span className="menu-title">
                                      Roles List
                                    </span>
                                  </a>
                                </div>
                                <div className="menu-item">
                                  <a
                                    className="menu-link py-3"
                                    href="/metronic8/demo1/../demo1/apps/user-management/roles/view.html"
                                  >
                                    <span className="menu-bullet">
                                      <span className="bullet bullet-dot" />
                                    </span>
                                    <span className="menu-title">
                                      View Roles
                                    </span>
                                  </a>
                                </div>
                              </div>
                            </div>
                            <div className="menu-item">
                              <a
                                className="menu-link py-3"
                                href="/metronic8/demo1/../demo1/apps/user-management/permissions.html"
                              >
                                <span className="menu-bullet">
                                  <span className="bullet bullet-dot" />
                                </span>
                                <span className="menu-title">Permissions</span>
                              </a>
                            </div>
                          </div>
                        </div>
                        <div
                          data-kt-menu-trigger="{default:'click', lg: 'hover'}"
                          data-kt-menu-placement="right-start"
                          className="menu-item menu-lg-down-accordion"
                        >
                          <span className="menu-link py-3">
                            <span className="menu-icon">
                              {/*begin::Svg Icon | path: icons/duotune/electronics/elc002.svg*/}
                              <span className="svg-icon svg-icon-2">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width={24}
                                  height={24}
                                  viewBox="0 0 24 24"
                                  fill="none"
                                >
                                  <path
                                    d="M6 21C6 21.6 6.4 22 7 22H17C17.6 22 18 21.6 18 21V20H6V21Z"
                                    fill="currentColor"
                                  />
                                  <path
                                    opacity="0.3"
                                    d="M17 2H7C6.4 2 6 2.4 6 3V20H18V3C18 2.4 17.6 2 17 2Z"
                                    fill="currentColor"
                                  />
                                  <path
                                    d="M12 4C11.4 4 11 3.6 11 3V2H13V3C13 3.6 12.6 4 12 4Z"
                                    fill="currentColor"
                                  />
                                </svg>
                              </span>
                              {/*end::Svg Icon*/}
                            </span>
                            <span className="menu-title">Contacts</span>
                            <span className="menu-arrow" />
                          </span>
                          <div className="menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-active-bg py-lg-4 w-lg-225px">
                            <div className="menu-item">
                              <a
                                className="menu-link py-3"
                                href="/metronic8/demo1/../demo1/apps/contacts/getting-started.html"
                              >
                                <span className="menu-bullet">
                                  <span className="bullet bullet-dot" />
                                </span>
                                <span className="menu-title">
                                  Getting Started
                                </span>
                              </a>
                            </div>
                            <div className="menu-item">
                              <a
                                className="menu-link py-3"
                                href="/metronic8/demo1/../demo1/apps/contacts/add-contact.html"
                              >
                                <span className="menu-bullet">
                                  <span className="bullet bullet-dot" />
                                </span>
                                <span className="menu-title">Add Contact</span>
                              </a>
                            </div>
                            <div className="menu-item">
                              <a
                                className="menu-link py-3"
                                href="/metronic8/demo1/../demo1/apps/contacts/edit-contact.html"
                              >
                                <span className="menu-bullet">
                                  <span className="bullet bullet-dot" />
                                </span>
                                <span className="menu-title">Edit Contact</span>
                              </a>
                            </div>
                            <div className="menu-item">
                              <a
                                className="menu-link py-3"
                                href="/metronic8/demo1/../demo1/apps/contacts/view-contact.html"
                              >
                                <span className="menu-bullet">
                                  <span className="bullet bullet-dot" />
                                </span>
                                <span className="menu-title">View Contact</span>
                              </a>
                            </div>
                          </div>
                        </div>
                        <div
                          data-kt-menu-trigger="{default:'click', lg: 'hover'}"
                          data-kt-menu-placement="right-start"
                          className="menu-item menu-lg-down-accordion"
                        >
                          <span className="menu-link py-3">
                            <span className="menu-icon">
                              {/*begin::Svg Icon | path: icons/duotune/ecommerce/ecm002.svg*/}
                              <span className="svg-icon svg-icon-2">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width={24}
                                  height={24}
                                  viewBox="0 0 24 24"
                                  fill="none"
                                >
                                  <path
                                    d="M21 10H13V11C13 11.6 12.6 12 12 12C11.4 12 11 11.6 11 11V10H3C2.4 10 2 10.4 2 11V13H22V11C22 10.4 21.6 10 21 10Z"
                                    fill="currentColor"
                                  />
                                  <path
                                    opacity="0.3"
                                    d="M12 12C11.4 12 11 11.6 11 11V3C11 2.4 11.4 2 12 2C12.6 2 13 2.4 13 3V11C13 11.6 12.6 12 12 12Z"
                                    fill="currentColor"
                                  />
                                  <path
                                    opacity="0.3"
                                    d="M18.1 21H5.9C5.4 21 4.9 20.6 4.8 20.1L3 13H21L19.2 20.1C19.1 20.6 18.6 21 18.1 21ZM13 18V15C13 14.4 12.6 14 12 14C11.4 14 11 14.4 11 15V18C11 18.6 11.4 19 12 19C12.6 19 13 18.6 13 18ZM17 18V15C17 14.4 16.6 14 16 14C15.4 14 15 14.4 15 15V18C15 18.6 15.4 19 16 19C16.6 19 17 18.6 17 18ZM9 18V15C9 14.4 8.6 14 8 14C7.4 14 7 14.4 7 15V18C7 18.6 7.4 19 8 19C8.6 19 9 18.6 9 18Z"
                                    fill="currentColor"
                                  />
                                </svg>
                              </span>
                              {/*end::Svg Icon*/}
                            </span>
                            <span className="menu-title">Subscriptions</span>
                            <span className="menu-arrow" />
                          </span>
                          <div className="menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-active-bg py-lg-4 w-lg-225px">
                            <div className="menu-item">
                              <a
                                className="menu-link py-3"
                                href="/metronic8/demo1/../demo1/apps/subscriptions/getting-started.html"
                              >
                                <span className="menu-bullet">
                                  <span className="bullet bullet-dot" />
                                </span>
                                <span className="menu-title">
                                  Getting Started
                                </span>
                              </a>
                            </div>
                            <div className="menu-item">
                              <a
                                className="menu-link py-3"
                                href="/metronic8/demo1/../demo1/apps/subscriptions/list.html"
                              >
                                <span className="menu-bullet">
                                  <span className="bullet bullet-dot" />
                                </span>
                                <span className="menu-title">
                                  Subscription List
                                </span>
                              </a>
                            </div>
                            <div className="menu-item">
                              <a
                                className="menu-link py-3"
                                href="/metronic8/demo1/../demo1/apps/subscriptions/add.html"
                              >
                                <span className="menu-bullet">
                                  <span className="bullet bullet-dot" />
                                </span>
                                <span className="menu-title">
                                  Add Subscription
                                </span>
                              </a>
                            </div>
                            <div className="menu-item">
                              <a
                                className="menu-link py-3"
                                href="/metronic8/demo1/../demo1/apps/subscriptions/view.html"
                              >
                                <span className="menu-bullet">
                                  <span className="bullet bullet-dot" />
                                </span>
                                <span className="menu-title">
                                  View Subscription
                                </span>
                              </a>
                            </div>
                          </div>
                        </div>
                        <div
                          data-kt-menu-trigger="{default:'click', lg: 'hover'}"
                          data-kt-menu-placement="right-start"
                          className="menu-item menu-lg-down-accordion"
                        >
                          <span className="menu-link py-3">
                            <span className="menu-icon">
                              {/*begin::Svg Icon | path: icons/duotune/finance/fin006.svg*/}
                              <span className="svg-icon svg-icon-2">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width={24}
                                  height={24}
                                  viewBox="0 0 24 24"
                                  fill="none"
                                >
                                  <path
                                    opacity="0.3"
                                    d="M20 15H4C2.9 15 2 14.1 2 13V7C2 6.4 2.4 6 3 6H21C21.6 6 22 6.4 22 7V13C22 14.1 21.1 15 20 15ZM13 12H11C10.5 12 10 12.4 10 13V16C10 16.5 10.4 17 11 17H13C13.6 17 14 16.6 14 16V13C14 12.4 13.6 12 13 12Z"
                                    fill="currentColor"
                                  />
                                  <path
                                    d="M14 6V5H10V6H8V5C8 3.9 8.9 3 10 3H14C15.1 3 16 3.9 16 5V6H14ZM20 15H14V16C14 16.6 13.5 17 13 17H11C10.5 17 10 16.6 10 16V15H4C3.6 15 3.3 14.9 3 14.7V18C3 19.1 3.9 20 5 20H19C20.1 20 21 19.1 21 18V14.7C20.7 14.9 20.4 15 20 15Z"
                                    fill="currentColor"
                                  />
                                </svg>
                              </span>
                              {/*end::Svg Icon*/}
                            </span>
                            <span className="menu-title">Customers</span>
                            <span className="menu-arrow" />
                          </span>
                          <div className="menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-active-bg py-lg-4 w-lg-225px">
                            <div className="menu-item">
                              <a
                                className="menu-link py-3"
                                href="/metronic8/demo1/../demo1/apps/customers/getting-started.html"
                              >
                                <span className="menu-bullet">
                                  <span className="bullet bullet-dot" />
                                </span>
                                <span className="menu-title">
                                  Getting Started
                                </span>
                              </a>
                            </div>
                            <div className="menu-item">
                              <a
                                className="menu-link py-3"
                                href="/metronic8/demo1/../demo1/apps/customers/list.html"
                              >
                                <span className="menu-bullet">
                                  <span className="bullet bullet-dot" />
                                </span>
                                <span className="menu-title">
                                  Customer Listing
                                </span>
                              </a>
                            </div>
                            <div className="menu-item">
                              <a
                                className="menu-link py-3"
                                href="/metronic8/demo1/../demo1/apps/customers/view.html"
                              >
                                <span className="menu-bullet">
                                  <span className="bullet bullet-dot" />
                                </span>
                                <span className="menu-title">
                                  Customer Details
                                </span>
                              </a>
                            </div>
                          </div>
                        </div>
                        <div
                          data-kt-menu-trigger="{default:'click', lg: 'hover'}"
                          data-kt-menu-placement="right-start"
                          className="menu-item menu-lg-down-accordion"
                        >
                          <span className="menu-link py-3">
                            <span className="menu-icon">
                              {/*begin::Svg Icon | path: icons/duotune/finance/fin002.svg*/}
                              <span className="svg-icon svg-icon-2">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width={24}
                                  height={24}
                                  viewBox="0 0 24 24"
                                  fill="none"
                                >
                                  <path
                                    d="M22 7H2V11H22V7Z"
                                    fill="currentColor"
                                  />
                                  <path
                                    opacity="0.3"
                                    d="M21 19H3C2.4 19 2 18.6 2 18V6C2 5.4 2.4 5 3 5H21C21.6 5 22 5.4 22 6V18C22 18.6 21.6 19 21 19ZM14 14C14 13.4 13.6 13 13 13H5C4.4 13 4 13.4 4 14C4 14.6 4.4 15 5 15H13C13.6 15 14 14.6 14 14ZM16 15.5C16 16.3 16.7 17 17.5 17H18.5C19.3 17 20 16.3 20 15.5C20 14.7 19.3 14 18.5 14H17.5C16.7 14 16 14.7 16 15.5Z"
                                    fill="currentColor"
                                  />
                                </svg>
                              </span>
                              {/*end::Svg Icon*/}
                            </span>
                            <span className="menu-title">
                              Invoice Management
                            </span>
                            <span className="menu-arrow" />
                          </span>
                          <div className="menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-active-bg py-lg-4 w-lg-225px">
                            <div
                              data-kt-menu-trigger="{default:'click', lg: 'hover'}"
                              data-kt-menu-placement="right-start"
                              className="menu-item menu-lg-down-accordion"
                            >
                              <span className="menu-link py-3">
                                <span className="menu-bullet">
                                  <span className="bullet bullet-dot" />
                                </span>
                                <span className="menu-title">Profile</span>
                                <span className="menu-arrow" />
                              </span>
                              <div className="menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-active-bg py-lg-4 w-lg-225px">
                                <div className="menu-item">
                                  <a
                                    className="menu-link py-3"
                                    href="/metronic8/demo1/../demo1/apps/invoices/view/invoice-1.html"
                                  >
                                    <span className="menu-bullet">
                                      <span className="bullet bullet-dot" />
                                    </span>
                                    <span className="menu-title">
                                      Invoice 1
                                    </span>
                                  </a>
                                </div>
                                <div className="menu-item">
                                  <a
                                    className="menu-link py-3"
                                    href="/metronic8/demo1/../demo1/apps/invoices/view/invoice-2.html"
                                  >
                                    <span className="menu-bullet">
                                      <span className="bullet bullet-dot" />
                                    </span>
                                    <span className="menu-title">
                                      Invoice 2
                                    </span>
                                  </a>
                                </div>
                                <div className="menu-item">
                                  <a
                                    className="menu-link py-3"
                                    href="/metronic8/demo1/../demo1/apps/invoices/view/invoice-3.html"
                                  >
                                    <span className="menu-bullet">
                                      <span className="bullet bullet-dot" />
                                    </span>
                                    <span className="menu-title">
                                      Invoice 3
                                    </span>
                                  </a>
                                </div>
                              </div>
                            </div>
                            <div className="menu-item">
                              <a
                                className="menu-link py-3"
                                href="/metronic8/demo1/../demo1/apps/invoices/create.html"
                              >
                                <span className="menu-bullet">
                                  <span className="bullet bullet-dot" />
                                </span>
                                <span className="menu-title">
                                  Create Invoice
                                </span>
                              </a>
                            </div>
                          </div>
                        </div>
                        <div
                          data-kt-menu-trigger="{default:'click', lg: 'hover'}"
                          data-kt-menu-placement="right-start"
                          className="menu-item menu-lg-down-accordion"
                        >
                          <span className="menu-link py-3">
                            <span className="menu-icon">
                              {/*begin::Svg Icon | path: icons/duotune/files/fil025.svg*/}
                              <span className="svg-icon svg-icon-2">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width={24}
                                  height={24}
                                  viewBox="0 0 24 24"
                                  fill="none"
                                >
                                  <path
                                    opacity="0.3"
                                    d="M14 2H6C4.89543 2 4 2.89543 4 4V20C4 21.1046 4.89543 22 6 22H18C19.1046 22 20 21.1046 20 20V8L14 2Z"
                                    fill="currentColor"
                                  />
                                  <path
                                    d="M20 8L14 2V6C14 7.10457 14.8954 8 16 8H20Z"
                                    fill="currentColor"
                                  />
                                  <path
                                    d="M10.3629 14.0084L8.92108 12.6429C8.57518 12.3153 8.03352 12.3153 7.68761 12.6429C7.31405 12.9967 7.31405 13.5915 7.68761 13.9453L10.2254 16.3488C10.6111 16.714 11.215 16.714 11.6007 16.3488L16.3124 11.8865C16.6859 11.5327 16.6859 10.9379 16.3124 10.5841C15.9665 10.2565 15.4248 10.2565 15.0789 10.5841L11.4631 14.0084C11.1546 14.3006 10.6715 14.3006 10.3629 14.0084Z"
                                    fill="currentColor"
                                  />
                                </svg>
                              </span>
                              {/*end::Svg Icon*/}
                            </span>
                            <span className="menu-title">File Manager</span>
                            <span className="menu-arrow" />
                          </span>
                          <div className="menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-active-bg py-lg-4 w-lg-225px">
                            <div className="menu-item">
                              <a
                                className="menu-link py-3"
                                href="/metronic8/demo1/../demo1/apps/file-manager/folders.html"
                              >
                                <span className="menu-bullet">
                                  <span className="bullet bullet-dot" />
                                </span>
                                <span className="menu-title">Folders</span>
                              </a>
                            </div>
                            <div className="menu-item">
                              <a
                                className="menu-link py-3"
                                href="/metronic8/demo1/../demo1/apps/file-manager/files.html"
                              >
                                <span className="menu-bullet">
                                  <span className="bullet bullet-dot" />
                                </span>
                                <span className="menu-title">Files</span>
                              </a>
                            </div>
                            <div className="menu-item">
                              <a
                                className="menu-link py-3"
                                href="/metronic8/demo1/../demo1/apps/file-manager/blank.html"
                              >
                                <span className="menu-bullet">
                                  <span className="bullet bullet-dot" />
                                </span>
                                <span className="menu-title">
                                  Blank Directory
                                </span>
                              </a>
                            </div>
                            <div className="menu-item">
                              <a
                                className="menu-link py-3"
                                href="/metronic8/demo1/../demo1/apps/file-manager/settings.html"
                              >
                                <span className="menu-bullet">
                                  <span className="bullet bullet-dot" />
                                </span>
                                <span className="menu-title">Settings</span>
                              </a>
                            </div>
                          </div>
                        </div>
                        <div
                          data-kt-menu-trigger="{default:'click', lg: 'hover'}"
                          data-kt-menu-placement="right-start"
                          className="menu-item menu-lg-down-accordion"
                        >
                          <span className="menu-link py-3">
                            <span className="menu-icon">
                              {/*begin::Svg Icon | path: icons/duotune/communication/com011.svg*/}
                              <span className="svg-icon svg-icon-2">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width={24}
                                  height={24}
                                  viewBox="0 0 24 24"
                                  fill="none"
                                >
                                  <path
                                    opacity="0.3"
                                    d="M21 19H3C2.4 19 2 18.6 2 18V6C2 5.4 2.4 5 3 5H21C21.6 5 22 5.4 22 6V18C22 18.6 21.6 19 21 19Z"
                                    fill="currentColor"
                                  />
                                  <path
                                    d="M21 5H2.99999C2.69999 5 2.49999 5.10005 2.29999 5.30005L11.2 13.3C11.7 13.7 12.4 13.7 12.8 13.3L21.7 5.30005C21.5 5.10005 21.3 5 21 5Z"
                                    fill="currentColor"
                                  />
                                </svg>
                              </span>
                              {/*end::Svg Icon*/}
                            </span>
                            <span className="menu-title">Inbox</span>
                            <span className="menu-arrow" />
                          </span>
                          <div className="menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-active-bg py-lg-4 w-lg-225px">
                            <div className="menu-item">
                              <a
                                className="menu-link py-3"
                                href="/metronic8/demo1/../demo1/apps/inbox/listing.html"
                              >
                                <span className="menu-bullet">
                                  <span className="bullet bullet-dot" />
                                </span>
                                <span className="menu-title">Messages</span>
                              </a>
                            </div>
                            <div className="menu-item">
                              <a
                                className="menu-link py-3"
                                href="/metronic8/demo1/../demo1/apps/inbox/compose.html"
                              >
                                <span className="menu-bullet">
                                  <span className="bullet bullet-dot" />
                                </span>
                                <span className="menu-title">Compose</span>
                              </a>
                            </div>
                            <div className="menu-item">
                              <a
                                className="menu-link py-3"
                                href="/metronic8/demo1/../demo1/apps/inbox/reply.html"
                              >
                                <span className="menu-bullet">
                                  <span className="bullet bullet-dot" />
                                </span>
                                <span className="menu-title">
                                  View &amp; Reply
                                </span>
                              </a>
                            </div>
                          </div>
                        </div>
                        <div
                          data-kt-menu-trigger="{default:'click', lg: 'hover'}"
                          data-kt-menu-placement="right-start"
                          className="menu-item menu-lg-down-accordion"
                        >
                          <span className="menu-link py-3">
                            <span className="menu-icon">
                              {/*begin::Svg Icon | path: icons/duotune/communication/com012.svg*/}
                              <span className="svg-icon svg-icon-2">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width={24}
                                  height={24}
                                  viewBox="0 0 24 24"
                                  fill="none"
                                >
                                  <path
                                    opacity="0.3"
                                    d="M20 3H4C2.89543 3 2 3.89543 2 5V16C2 17.1046 2.89543 18 4 18H4.5C5.05228 18 5.5 18.4477 5.5 19V21.5052C5.5 22.1441 6.21212 22.5253 6.74376 22.1708L11.4885 19.0077C12.4741 18.3506 13.6321 18 14.8167 18H20C21.1046 18 22 17.1046 22 16V5C22 3.89543 21.1046 3 20 3Z"
                                    fill="currentColor"
                                  />
                                  <rect
                                    x={6}
                                    y={12}
                                    width={7}
                                    height={2}
                                    rx={1}
                                    fill="currentColor"
                                  />
                                  <rect
                                    x={6}
                                    y={7}
                                    width={12}
                                    height={2}
                                    rx={1}
                                    fill="currentColor"
                                  />
                                </svg>
                              </span>
                              {/*end::Svg Icon*/}
                            </span>
                            <span className="menu-title">Chat</span>
                            <span className="menu-arrow" />
                          </span>
                          <div className="menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-active-bg py-lg-4 w-lg-225px">
                            <div className="menu-item">
                              <a
                                className="menu-link py-3"
                                href="/metronic8/demo1/../demo1/apps/chat/private.html"
                              >
                                <span className="menu-bullet">
                                  <span className="bullet bullet-dot" />
                                </span>
                                <span className="menu-title">Private Chat</span>
                              </a>
                            </div>
                            <div className="menu-item">
                              <a
                                className="menu-link py-3"
                                href="/metronic8/demo1/../demo1/apps/chat/group.html"
                              >
                                <span className="menu-bullet">
                                  <span className="bullet bullet-dot" />
                                </span>
                                <span className="menu-title">Group Chat</span>
                              </a>
                            </div>
                            <div className="menu-item">
                              <a
                                className="menu-link py-3"
                                href="/metronic8/demo1/../demo1/apps/chat/drawer.html"
                              >
                                <span className="menu-bullet">
                                  <span className="bullet bullet-dot" />
                                </span>
                                <span className="menu-title">Drawer Chat</span>
                              </a>
                            </div>
                          </div>
                        </div>
                        <div className="menu-item">
                          <a
                            className="menu-link py-3"
                            href="/metronic8/demo1/../demo1/apps/calendar.html"
                          >
                            <span className="menu-icon">
                              {/*begin::Svg Icon | path: icons/duotune/general/gen014.svg*/}
                              <span className="svg-icon svg-icon-2">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width={24}
                                  height={24}
                                  viewBox="0 0 24 24"
                                  fill="none"
                                >
                                  <path
                                    opacity="0.3"
                                    d="M21 22H3C2.4 22 2 21.6 2 21V5C2 4.4 2.4 4 3 4H21C21.6 4 22 4.4 22 5V21C22 21.6 21.6 22 21 22Z"
                                    fill="currentColor"
                                  />
                                  <path
                                    d="M6 6C5.4 6 5 5.6 5 5V3C5 2.4 5.4 2 6 2C6.6 2 7 2.4 7 3V5C7 5.6 6.6 6 6 6ZM11 5V3C11 2.4 10.6 2 10 2C9.4 2 9 2.4 9 3V5C9 5.6 9.4 6 10 6C10.6 6 11 5.6 11 5ZM15 5V3C15 2.4 14.6 2 14 2C13.4 2 13 2.4 13 3V5C13 5.6 13.4 6 14 6C14.6 6 15 5.6 15 5ZM19 5V3C19 2.4 18.6 2 18 2C17.4 2 17 2.4 17 3V5C17 5.6 17.4 6 18 6C18.6 6 19 5.6 19 5Z"
                                    fill="currentColor"
                                  />
                                  <path
                                    d="M8.8 13.1C9.2 13.1 9.5 13 9.7 12.8C9.9 12.6 10.1 12.3 10.1 11.9C10.1 11.6 10 11.3 9.8 11.1C9.6 10.9 9.3 10.8 9 10.8C8.8 10.8 8.59999 10.8 8.39999 10.9C8.19999 11 8.1 11.1 8 11.2C7.9 11.3 7.8 11.4 7.7 11.6C7.6 11.8 7.5 11.9 7.5 12.1C7.5 12.2 7.4 12.2 7.3 12.3C7.2 12.4 7.09999 12.4 6.89999 12.4C6.69999 12.4 6.6 12.3 6.5 12.2C6.4 12.1 6.3 11.9 6.3 11.7C6.3 11.5 6.4 11.3 6.5 11.1C6.6 10.9 6.8 10.7 7 10.5C7.2 10.3 7.49999 10.1 7.89999 10C8.29999 9.90003 8.60001 9.80003 9.10001 9.80003C9.50001 9.80003 9.80001 9.90003 10.1 10C10.4 10.1 10.7 10.3 10.9 10.4C11.1 10.5 11.3 10.8 11.4 11.1C11.5 11.4 11.6 11.6 11.6 11.9C11.6 12.3 11.5 12.6 11.3 12.9C11.1 13.2 10.9 13.5 10.6 13.7C10.9 13.9 11.2 14.1 11.4 14.3C11.6 14.5 11.8 14.7 11.9 15C12 15.3 12.1 15.5 12.1 15.8C12.1 16.2 12 16.5 11.9 16.8C11.8 17.1 11.5 17.4 11.3 17.7C11.1 18 10.7 18.2 10.3 18.3C9.9 18.4 9.5 18.5 9 18.5C8.5 18.5 8.1 18.4 7.7 18.2C7.3 18 7 17.8 6.8 17.6C6.6 17.4 6.4 17.1 6.3 16.8C6.2 16.5 6.10001 16.3 6.10001 16.1C6.10001 15.9 6.2 15.7 6.3 15.6C6.4 15.5 6.6 15.4 6.8 15.4C6.9 15.4 7.00001 15.4 7.10001 15.5C7.20001 15.6 7.3 15.6 7.3 15.7C7.5 16.2 7.7 16.6 8 16.9C8.3 17.2 8.6 17.3 9 17.3C9.2 17.3 9.5 17.2 9.7 17.1C9.9 17 10.1 16.8 10.3 16.6C10.5 16.4 10.5 16.1 10.5 15.8C10.5 15.3 10.4 15 10.1 14.7C9.80001 14.4 9.50001 14.3 9.10001 14.3C9.00001 14.3 8.9 14.3 8.7 14.3C8.5 14.3 8.39999 14.3 8.39999 14.3C8.19999 14.3 7.99999 14.2 7.89999 14.1C7.79999 14 7.7 13.8 7.7 13.7C7.7 13.5 7.79999 13.4 7.89999 13.2C7.99999 13 8.2 13 8.5 13H8.8V13.1ZM15.3 17.5V12.2C14.3 13 13.6 13.3 13.3 13.3C13.1 13.3 13 13.2 12.9 13.1C12.8 13 12.7 12.8 12.7 12.6C12.7 12.4 12.8 12.3 12.9 12.2C13 12.1 13.2 12 13.6 11.8C14.1 11.6 14.5 11.3 14.7 11.1C14.9 10.9 15.2 10.6 15.5 10.3C15.8 10 15.9 9.80003 15.9 9.70003C15.9 9.60003 16.1 9.60004 16.3 9.60004C16.5 9.60004 16.7 9.70003 16.8 9.80003C16.9 9.90003 17 10.2 17 10.5V17.2C17 18 16.7 18.4 16.2 18.4C16 18.4 15.8 18.3 15.6 18.2C15.4 18.1 15.3 17.8 15.3 17.5Z"
                                    fill="currentColor"
                                  />
                                </svg>
                              </span>
                              {/*end::Svg Icon*/}
                            </span>
                            <span className="menu-title">Calendar</span>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div
                      data-kt-menu-trigger="click"
                      data-kt-menu-placement="bottom-start"
                      className="menu-item menu-lg-down-accordion me-lg-1"
                    >
                      <span className="menu-link py-3">
                        <span className="menu-title">Layouts</span>
                        <span className="menu-arrow d-lg-none" />
                      </span>
                      <div className="menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-rounded-0 py-lg-4 w-lg-225px">
                        <div
                          data-kt-menu-trigger="{default:'click', lg: 'hover'}"
                          data-kt-menu-placement="right-start"
                          className="menu-item menu-lg-down-accordion"
                        >
                          <span className="menu-link py-3">
                            <span className="menu-icon">
                              {/*begin::Svg Icon | path: icons/duotune/abstract/abs042.svg*/}
                              <span className="svg-icon svg-icon-2">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width={24}
                                  height={24}
                                  viewBox="0 0 24 24"
                                  fill="none"
                                >
                                  <path
                                    d="M18 21.6C16.6 20.4 9.1 20.3 6.3 21.2C5.7 21.4 5.1 21.2 4.7 20.8L2 18C4.2 15.8 10.8 15.1 15.8 15.8C16.2 18.3 17 20.5 18 21.6ZM18.8 2.8C18.4 2.4 17.8 2.20001 17.2 2.40001C14.4 3.30001 6.9 3.2 5.5 2C6.8 3.3 7.4 5.5 7.7 7.7C9 7.9 10.3 8 11.7 8C15.8 8 19.8 7.2 21.5 5.5L18.8 2.8Z"
                                    fill="currentColor"
                                  />
                                  <path
                                    opacity="0.3"
                                    d="M21.2 17.3C21.4 17.9 21.2 18.5 20.8 18.9L18 21.6C15.8 19.4 15.1 12.8 15.8 7.8C18.3 7.4 20.4 6.70001 21.5 5.60001C20.4 7.00001 20.2 14.5 21.2 17.3ZM8 11.7C8 9 7.7 4.2 5.5 2L2.8 4.8C2.4 5.2 2.2 5.80001 2.4 6.40001C2.7 7.40001 3.00001 9.2 3.10001 11.7C3.10001 15.5 2.40001 17.6 2.10001 18C3.20001 16.9 5.3 16.2 7.8 15.8C8 14.2 8 12.7 8 11.7Z"
                                    fill="currentColor"
                                  />
                                </svg>
                              </span>
                              {/*end::Svg Icon*/}
                            </span>
                            <span className="menu-title">Toolbars</span>
                            <span className="menu-arrow" />
                          </span>
                          <div className="menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-active-bg py-lg-4 w-lg-225px">
                            <div className="menu-item">
                              <a
                                className="menu-link py-3"
                                href="/metronic8/demo1/../demo1/layouts/toolbars/toolbar-1.html"
                              >
                                <span className="menu-bullet">
                                  <span className="bullet bullet-dot" />
                                </span>
                                <span className="menu-title">Toolbar 1</span>
                              </a>
                            </div>
                            <div className="menu-item">
                              <a
                                className="menu-link py-3"
                                href="/metronic8/demo1/../demo1/layouts/toolbars/toolbar-2.html"
                              >
                                <span className="menu-bullet">
                                  <span className="bullet bullet-dot" />
                                </span>
                                <span className="menu-title">Toolbar 2</span>
                              </a>
                            </div>
                            <div className="menu-item">
                              <a
                                className="menu-link py-3"
                                href="/metronic8/demo1/../demo1/layouts/toolbars/toolbar-3.html"
                              >
                                <span className="menu-bullet">
                                  <span className="bullet bullet-dot" />
                                </span>
                                <span className="menu-title">Toolbar 3</span>
                              </a>
                            </div>
                            <div className="menu-item">
                              <a
                                className="menu-link py-3"
                                href="/metronic8/demo1/../demo1/layouts/toolbars/toolbar-4.html"
                              >
                                <span className="menu-bullet">
                                  <span className="bullet bullet-dot" />
                                </span>
                                <span className="menu-title">Toolbar 4</span>
                              </a>
                            </div>
                            <div className="menu-item">
                              <a
                                className="menu-link py-3"
                                href="/metronic8/demo1/../demo1/layouts/toolbars/toolbar-5.html"
                              >
                                <span className="menu-bullet">
                                  <span className="bullet bullet-dot" />
                                </span>
                                <span className="menu-title">Toolbar 5</span>
                              </a>
                            </div>
                            <div className="menu-item">
                              <a
                                className="menu-link py-3"
                                href="/metronic8/demo1/../demo1/layouts/toolbars/no-toolbar.html"
                              >
                                <span className="menu-bullet">
                                  <span className="bullet bullet-dot" />
                                </span>
                                <span className="menu-title">No Toolbar</span>
                              </a>
                            </div>
                          </div>
                        </div>
                        <div
                          data-kt-menu-trigger="{default:'click', lg: 'hover'}"
                          data-kt-menu-placement="right-start"
                          className="menu-item menu-lg-dropdown"
                        >
                          <span className="menu-link py-3">
                            <span className="menu-icon">
                              {/*begin::Svg Icon | path: icons/duotune/general/gen009.svg*/}
                              <span className="svg-icon svg-icon-2">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width={24}
                                  height={24}
                                  viewBox="0 0 24 24"
                                  fill="none"
                                >
                                  <path
                                    opacity="0.3"
                                    d="M21 22H14C13.4 22 13 21.6 13 21V3C13 2.4 13.4 2 14 2H21C21.6 2 22 2.4 22 3V21C22 21.6 21.6 22 21 22Z"
                                    fill="currentColor"
                                  />
                                  <path
                                    d="M10 22H3C2.4 22 2 21.6 2 21V3C2 2.4 2.4 2 3 2H10C10.6 2 11 2.4 11 3V21C11 21.6 10.6 22 10 22Z"
                                    fill="currentColor"
                                  />
                                </svg>
                              </span>
                              {/*end::Svg Icon*/}
                            </span>
                            <span className="menu-title">Aside</span>
                            <span className="menu-arrow" />
                          </span>
                          <div className="menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-active-bg py-lg-4 w-lg-225px">
                            <div className="menu-item">
                              <a
                                className="menu-link py-3"
                                href="/metronic8/demo1/../demo1/layouts/aside/light.html"
                              >
                                <span className="menu-bullet">
                                  <span className="bullet bullet-dot" />
                                </span>
                                <span className="menu-title">Light Skin</span>
                              </a>
                            </div>
                            <div className="menu-item">
                              <a
                                className="menu-link py-3"
                                href="/metronic8/demo1/../demo1/layouts/aside/font-icons.html"
                              >
                                <span className="menu-bullet">
                                  <span className="bullet bullet-dot" />
                                </span>
                                <span className="menu-title">Font Icons</span>
                              </a>
                            </div>
                            <div className="menu-item">
                              <a
                                className="menu-link py-3"
                                href="/metronic8/demo1/../demo1/layouts/aside/minimized.html"
                              >
                                <span className="menu-bullet">
                                  <span className="bullet bullet-dot" />
                                </span>
                                <span className="menu-title">Minimized</span>
                              </a>
                            </div>
                            <div className="menu-item">
                              <a
                                className="menu-link py-3"
                                href="/metronic8/demo1/../demo1/layouts/aside/only-header.html"
                              >
                                <span className="menu-bullet">
                                  <span className="bullet bullet-dot" />
                                </span>
                                <span className="menu-title">Only Header</span>
                              </a>
                            </div>
                          </div>
                        </div>
                        <div className="menu-item">
                          <a
                            className="menu-link py-3"
                            href="/metronic8/demo1/../demo1/layout-builder.html"
                            title
                            data-bs-toggle="tooltip"
                            data-bs-trigger="hover"
                            data-bs-dismiss="click"
                            data-bs-placement="right"
                            data-bs-original-title="Build your layout, preview and export HTML for server side integration"
                          >
                            <span className="menu-icon">
                              {/*begin::Svg Icon | path: icons/duotune/general/gen019.svg*/}
                              <span className="svg-icon svg-icon-2">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width={24}
                                  height={24}
                                  viewBox="0 0 24 24"
                                  fill="none"
                                >
                                  <path
                                    d="M17.5 11H6.5C4 11 2 9 2 6.5C2 4 4 2 6.5 2H17.5C20 2 22 4 22 6.5C22 9 20 11 17.5 11ZM15 6.5C15 7.9 16.1 9 17.5 9C18.9 9 20 7.9 20 6.5C20 5.1 18.9 4 17.5 4C16.1 4 15 5.1 15 6.5Z"
                                    fill="currentColor"
                                  />
                                  <path
                                    opacity="0.3"
                                    d="M17.5 22H6.5C4 22 2 20 2 17.5C2 15 4 13 6.5 13H17.5C20 13 22 15 22 17.5C22 20 20 22 17.5 22ZM4 17.5C4 18.9 5.1 20 6.5 20C7.9 20 9 18.9 9 17.5C9 16.1 7.9 15 6.5 15C5.1 15 4 16.1 4 17.5Z"
                                    fill="currentColor"
                                  />
                                </svg>
                              </span>
                              {/*end::Svg Icon*/}
                            </span>
                            <span className="menu-title">Layout Builder</span>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div
                      data-kt-menu-trigger="click"
                      data-kt-menu-placement="bottom-start"
                      className="menu-item menu-lg-down-accordion me-lg-1"
                    >
                      <span className="menu-link py-3">
                        <span className="menu-title">Resources</span>
                        <span className="menu-arrow d-lg-none" />
                      </span>
                      <div className="menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown menu-rounded-0 py-lg-4 w-lg-225px">
                        <div className="menu-item">
                          <a
                            className="menu-link py-3"
                            href="/metronic8/demo1/../demo1/documentation/base/utilities.html"
                            title
                            data-bs-toggle="tooltip"
                            data-bs-trigger="hover"
                            data-bs-dismiss="click"
                            data-bs-placement="right"
                            data-bs-original-title="Check out over 200 in-house components, plugins and ready for use solutions"
                          >
                            <span className="menu-icon">
                              {/*begin::Svg Icon | path: /icons/duotune/general/gen002.svg*/}
                              <span className="svg-icon svg-icon-2">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width={24}
                                  height={24}
                                  viewBox="0 0 24 24"
                                  fill="none"
                                >
                                  <path
                                    opacity="0.3"
                                    d="M4.05424 15.1982C8.34524 7.76818 13.5782 3.26318 20.9282 2.01418C21.0729 1.98837 21.2216 1.99789 21.3618 2.04193C21.502 2.08597 21.6294 2.16323 21.7333 2.26712C21.8372 2.37101 21.9144 2.49846 21.9585 2.63863C22.0025 2.7788 22.012 2.92754 21.9862 3.07218C20.7372 10.4222 16.2322 15.6552 8.80224 19.9462L4.05424 15.1982ZM3.81924 17.3372L2.63324 20.4482C2.58427 20.5765 2.5735 20.7163 2.6022 20.8507C2.63091 20.9851 2.69788 21.1082 2.79503 21.2054C2.89218 21.3025 3.01536 21.3695 3.14972 21.3982C3.28408 21.4269 3.42387 21.4161 3.55224 21.3672L6.66524 20.1802L3.81924 17.3372ZM16.5002 5.99818C16.2036 5.99818 15.9136 6.08615 15.6669 6.25097C15.4202 6.41579 15.228 6.65006 15.1144 6.92415C15.0009 7.19824 14.9712 7.49984 15.0291 7.79081C15.0869 8.08178 15.2298 8.34906 15.4396 8.55884C15.6494 8.76862 15.9166 8.91148 16.2076 8.96935C16.4986 9.02723 16.8002 8.99753 17.0743 8.884C17.3484 8.77046 17.5826 8.5782 17.7474 8.33153C17.9123 8.08486 18.0002 7.79485 18.0002 7.49818C18.0002 7.10035 17.8422 6.71882 17.5609 6.43752C17.2796 6.15621 16.8981 5.99818 16.5002 5.99818Z"
                                    fill="currentColor"
                                  />
                                  <path
                                    d="M4.05423 15.1982L2.24723 13.3912C2.15505 13.299 2.08547 13.1867 2.04395 13.0632C2.00243 12.9396 1.9901 12.8081 2.00793 12.679C2.02575 12.5498 2.07325 12.4266 2.14669 12.3189C2.22013 12.2112 2.31752 12.1219 2.43123 12.0582L9.15323 8.28918C7.17353 10.3717 5.4607 12.6926 4.05423 15.1982ZM8.80023 19.9442L10.6072 21.7512C10.6994 21.8434 10.8117 21.9129 10.9352 21.9545C11.0588 21.996 11.1903 22.0083 11.3195 21.9905C11.4486 21.9727 11.5718 21.9252 11.6795 21.8517C11.7872 21.7783 11.8765 21.6809 11.9402 21.5672L15.7092 14.8442C13.6269 16.8245 11.3061 18.5377 8.80023 19.9442ZM7.04023 18.1832L12.5832 12.6402C12.7381 12.4759 12.8228 12.2577 12.8195 12.032C12.8161 11.8063 12.725 11.5907 12.5653 11.4311C12.4057 11.2714 12.1901 11.1803 11.9644 11.1769C11.7387 11.1736 11.5205 11.2583 11.3562 11.4132L5.81323 16.9562L7.04023 18.1832Z"
                                    fill="currentColor"
                                  />
                                </svg>
                              </span>
                              {/*end::Svg Icon*/}
                            </span>
                            <span className="menu-title">Components</span>
                          </a>
                        </div>
                        <div className="menu-item">
                          <a
                            className="menu-link py-3"
                            href="/metronic8/demo1/../demo1/layout-builder.html"
                            title
                            data-bs-toggle="tooltip"
                            data-bs-trigger="hover"
                            data-bs-dismiss="click"
                            data-bs-placement="right"
                            data-bs-original-title="Build your layout, preview and export HTML for server side integration"
                          >
                            <span className="menu-icon">
                              {/*begin::Svg Icon | path: icons/duotune/general/gen019.svg*/}
                              <span className="svg-icon svg-icon-2">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width={24}
                                  height={24}
                                  viewBox="0 0 24 24"
                                  fill="none"
                                >
                                  <path
                                    d="M17.5 11H6.5C4 11 2 9 2 6.5C2 4 4 2 6.5 2H17.5C20 2 22 4 22 6.5C22 9 20 11 17.5 11ZM15 6.5C15 7.9 16.1 9 17.5 9C18.9 9 20 7.9 20 6.5C20 5.1 18.9 4 17.5 4C16.1 4 15 5.1 15 6.5Z"
                                    fill="currentColor"
                                  />
                                  <path
                                    opacity="0.3"
                                    d="M17.5 22H6.5C4 22 2 20 2 17.5C2 15 4 13 6.5 13H17.5C20 13 22 15 22 17.5C22 20 20 22 17.5 22ZM4 17.5C4 18.9 5.1 20 6.5 20C7.9 20 9 18.9 9 17.5C9 16.1 7.9 15 6.5 15C5.1 15 4 16.1 4 17.5Z"
                                    fill="currentColor"
                                  />
                                </svg>
                              </span>
                              {/*end::Svg Icon*/}
                            </span>
                            <span className="menu-title">Layout Builder</span>
                          </a>
                        </div>
                        <div className="menu-item">
                          <a
                            className="menu-link py-3"
                            href="/metronic8/demo1/../demo1/documentation/getting-started.html"
                            title
                            data-bs-toggle="tooltip"
                            data-bs-trigger="hover"
                            data-bs-dismiss="click"
                            data-bs-placement="right"
                            data-bs-original-title="Check out the complete documentation"
                          >
                            <span className="menu-icon">
                              {/*begin::Svg Icon | path: icons/duotune/abstract/abs027.svg*/}
                              <span className="svg-icon svg-icon-2">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width={24}
                                  height={24}
                                  viewBox="0 0 24 24"
                                  fill="none"
                                >
                                  <path
                                    opacity="0.3"
                                    d="M21.25 18.525L13.05 21.825C12.35 22.125 11.65 22.125 10.95 21.825L2.75 18.525C1.75 18.125 1.75 16.725 2.75 16.325L4.04999 15.825L10.25 18.325C10.85 18.525 11.45 18.625 12.05 18.625C12.65 18.625 13.25 18.525 13.85 18.325L20.05 15.825L21.35 16.325C22.35 16.725 22.35 18.125 21.25 18.525ZM13.05 16.425L21.25 13.125C22.25 12.725 22.25 11.325 21.25 10.925L13.05 7.62502C12.35 7.32502 11.65 7.32502 10.95 7.62502L2.75 10.925C1.75 11.325 1.75 12.725 2.75 13.125L10.95 16.425C11.65 16.725 12.45 16.725 13.05 16.425Z"
                                    fill="currentColor"
                                  />
                                  <path
                                    d="M11.05 11.025L2.84998 7.725C1.84998 7.325 1.84998 5.925 2.84998 5.525L11.05 2.225C11.75 1.925 12.45 1.925 13.15 2.225L21.35 5.525C22.35 5.925 22.35 7.325 21.35 7.725L13.05 11.025C12.45 11.325 11.65 11.325 11.05 11.025Z"
                                    fill="currentColor"
                                  />
                                </svg>
                              </span>
                              {/*end::Svg Icon*/}
                            </span>
                            <span className="menu-title">Documentation</span>
                          </a>
                        </div>
                        <div className="menu-item">
                          <a
                            className="menu-link py-3"
                            href="/metronic8/demo1/../demo1/documentation/getting-started/changelog.html"
                          >
                            <span className="menu-icon">
                              {/*begin::Svg Icon | path: icons/duotune/coding/cod003.svg*/}
                              <span className="svg-icon svg-icon-2">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width={24}
                                  height={24}
                                  viewBox="0 0 24 24"
                                  fill="none"
                                >
                                  <path
                                    d="M16.95 18.9688C16.75 18.9688 16.55 18.8688 16.35 18.7688C15.85 18.4688 15.75 17.8688 16.05 17.3688L19.65 11.9688L16.05 6.56876C15.75 6.06876 15.85 5.46873 16.35 5.16873C16.85 4.86873 17.45 4.96878 17.75 5.46878L21.75 11.4688C21.95 11.7688 21.95 12.2688 21.75 12.5688L17.75 18.5688C17.55 18.7688 17.25 18.9688 16.95 18.9688ZM7.55001 18.7688C8.05001 18.4688 8.15 17.8688 7.85 17.3688L4.25001 11.9688L7.85 6.56876C8.15 6.06876 8.05001 5.46873 7.55001 5.16873C7.05001 4.86873 6.45 4.96878 6.15 5.46878L2.15 11.4688C1.95 11.7688 1.95 12.2688 2.15 12.5688L6.15 18.5688C6.35 18.8688 6.65 18.9688 6.95 18.9688C7.15 18.9688 7.35001 18.8688 7.55001 18.7688Z"
                                    fill="currentColor"
                                  />
                                  <path
                                    opacity="0.3"
                                    d="M10.45 18.9687C10.35 18.9687 10.25 18.9687 10.25 18.9687C9.75 18.8687 9.35 18.2688 9.55 17.7688L12.55 5.76878C12.65 5.26878 13.25 4.8687 13.75 5.0687C14.25 5.1687 14.65 5.76878 14.45 6.26878L11.45 18.2688C11.35 18.6688 10.85 18.9687 10.45 18.9687Z"
                                    fill="currentColor"
                                  />
                                </svg>
                              </span>
                              {/*end::Svg Icon*/}
                            </span>
                            <span className="menu-title">
                              Changelog v8.0.38
                            </span>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div
                      data-kt-menu-trigger="click"
                      data-kt-menu-placement="bottom-start"
                      className="menu-item menu-lg-down-accordion me-lg-1"
                    >
                      <span className="menu-link py-3">
                        <span className="menu-title">Mega Menu</span>
                        <span className="menu-arrow d-lg-none" />
                      </span>
                      <div className="menu-sub menu-sub-lg-down-accordion menu-sub-lg-dropdown w-100 w-lg-600px p-5 p-lg-5">
                        {/*begin:Row*/}
                        <div className="row" data-kt-menu-dismiss="true">
                          {/*begin:Col*/}
                          <div className="col-lg-4 border-left-lg-1">
                            <div className="menu-inline menu-column menu-active-bg">
                              <div className="menu-item">
                                <a href="#" className="menu-link">
                                  <span className="menu-bullet">
                                    <span className="bullet bullet-dot" />
                                  </span>
                                  <span className="menu-title">
                                    Example link
                                  </span>
                                </a>
                              </div>
                              <div className="menu-item">
                                <a href="#" className="menu-link">
                                  <span className="menu-bullet">
                                    <span className="bullet bullet-dot" />
                                  </span>
                                  <span className="menu-title">
                                    Example link
                                  </span>
                                </a>
                              </div>
                              <div className="menu-item">
                                <a href="#" className="menu-link">
                                  <span className="menu-bullet">
                                    <span className="bullet bullet-dot" />
                                  </span>
                                  <span className="menu-title">
                                    Example link
                                  </span>
                                </a>
                              </div>
                              <div className="menu-item">
                                <a href="#" className="menu-link">
                                  <span className="menu-bullet">
                                    <span className="bullet bullet-dot" />
                                  </span>
                                  <span className="menu-title">
                                    Example link
                                  </span>
                                </a>
                              </div>
                              <div className="menu-item">
                                <a href="#" className="menu-link">
                                  <span className="menu-bullet">
                                    <span className="bullet bullet-dot" />
                                  </span>
                                  <span className="menu-title">
                                    Example link
                                  </span>
                                </a>
                              </div>
                            </div>
                          </div>
                          {/*end:Col*/}
                          {/*begin:Col*/}
                          <div className="col-lg-4 border-left-lg-1">
                            <div className="menu-inline menu-column menu-active-bg">
                              <div className="menu-item">
                                <a href="#" className="menu-link">
                                  <span className="menu-bullet">
                                    <span className="bullet bullet-dot" />
                                  </span>
                                  <span className="menu-title">
                                    Example link
                                  </span>
                                </a>
                              </div>
                              <div className="menu-item">
                                <a href="#" className="menu-link">
                                  <span className="menu-bullet">
                                    <span className="bullet bullet-dot" />
                                  </span>
                                  <span className="menu-title">
                                    Example link
                                  </span>
                                </a>
                              </div>
                              <div className="menu-item">
                                <a href="#" className="menu-link">
                                  <span className="menu-bullet">
                                    <span className="bullet bullet-dot" />
                                  </span>
                                  <span className="menu-title">
                                    Example link
                                  </span>
                                </a>
                              </div>
                              <div className="menu-item">
                                <a href="#" className="menu-link">
                                  <span className="menu-bullet">
                                    <span className="bullet bullet-dot" />
                                  </span>
                                  <span className="menu-title">
                                    Example link
                                  </span>
                                </a>
                              </div>
                              <div className="menu-item">
                                <a href="#" className="menu-link">
                                  <span className="menu-bullet">
                                    <span className="bullet bullet-dot" />
                                  </span>
                                  <span className="menu-title">
                                    Example link
                                  </span>
                                </a>
                              </div>
                            </div>
                          </div>
                          {/*end:Col*/}
                          {/*begin:Col*/}
                          <div className="col-lg-4 border-left-lg-1">
                            <div className="menu-inline menu-column menu-active-bg">
                              <div className="menu-item">
                                <a href="#" className="menu-link">
                                  <span className="menu-bullet">
                                    <span className="bullet bullet-dot" />
                                  </span>
                                  <span className="menu-title">
                                    Example link
                                  </span>
                                </a>
                              </div>
                              <div className="menu-item">
                                <a href="#" className="menu-link">
                                  <span className="menu-bullet">
                                    <span className="bullet bullet-dot" />
                                  </span>
                                  <span className="menu-title">
                                    Example link
                                  </span>
                                </a>
                              </div>
                              <div className="menu-item">
                                <a href="#" className="menu-link">
                                  <span className="menu-bullet">
                                    <span className="bullet bullet-dot" />
                                  </span>
                                  <span className="menu-title">
                                    Example link
                                  </span>
                                </a>
                              </div>
                              <div className="menu-item">
                                <a href="#" className="menu-link">
                                  <span className="menu-bullet">
                                    <span className="bullet bullet-dot" />
                                  </span>
                                  <span className="menu-title">
                                    Example link
                                  </span>
                                </a>
                              </div>
                              <div className="menu-item">
                                <a href="#" className="menu-link">
                                  <span className="menu-bullet">
                                    <span className="bullet bullet-dot" />
                                  </span>
                                  <span className="menu-title">
                                    Example link
                                  </span>
                                </a>
                              </div>
                            </div>
                          </div>
                          {/*end:Col*/}
                        </div>
                        {/*end:Row*/}
                      </div>
                    </div>
                  </div>
                  {/*end::Menu*/}
                </div>
                {/*end::Menu wrapper*/}
              </div>
              {/*end::Navbar*/}
              {/*begin::Toolbar wrapper*/}
              <div className="d-flex align-items-stretch flex-shrink-0">
                {/*begin::Search*/}
                <div className="d-flex align-items-stretch ms-1 ms-lg-3">
                  {/*begin::Search*/}
                  <div
                    id="kt_header_search"
                    className="header-search d-flex align-items-stretch"
                    data-kt-search-keypress="true"
                    data-kt-search-min-length={2}
                    data-kt-search-enter="enter"
                    data-kt-search-layout="menu"
                    data-kt-menu-trigger="auto"
                    data-kt-menu-overflow="false"
                    data-kt-menu-permanent="true"
                    data-kt-menu-placement="bottom-end"
                    data-kt-search="true"
                  >
                    {/*begin::Search toggle*/}
                    <div
                      className="d-flex align-items-center"
                      data-kt-search-element="toggle"
                      id="kt_header_search_toggle"
                    >
                      <div className="btn btn-icon btn-icon-muted btn-active-light btn-active-color-primary w-30px h-30px w-md-40px h-md-40px">
                        {/*begin::Svg Icon | path: icons/duotune/general/gen021.svg*/}
                        <span className="svg-icon svg-icon-1">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width={24}
                            height={24}
                            viewBox="0 0 24 24"
                            fill="none"
                          >
                            <rect
                              opacity="0.5"
                              x="17.0365"
                              y="15.1223"
                              width="8.15546"
                              height={2}
                              rx={1}
                              transform="rotate(45 17.0365 15.1223)"
                              fill="currentColor"
                            />
                            <path
                              d="M11 19C6.55556 19 3 15.4444 3 11C3 6.55556 6.55556 3 11 3C15.4444 3 19 6.55556 19 11C19 15.4444 15.4444 19 11 19ZM11 5C7.53333 5 5 7.53333 5 11C5 14.4667 7.53333 17 11 17C14.4667 17 17 14.4667 17 11C17 7.53333 14.4667 5 11 5Z"
                              fill="currentColor"
                            />
                          </svg>
                        </span>
                        {/*end::Svg Icon*/}
                      </div>
                    </div>
                    {/*end::Search toggle*/}
                    {/*begin::Menu*/}
                    <div
                      data-kt-search-element="content"
                      className="menu menu-sub menu-sub-dropdown p-7 w-325px w-md-375px"
                      data-kt-menu="true"
                    >
                      {/*begin::Wrapper*/}
                      <div data-kt-search-element="wrapper">
                        {/*begin::Form*/}
                        <form
                          data-kt-search-element="form"
                          className="w-100 position-relative mb-3"
                          autoComplete="off"
                        >
                          {/*begin::Icon*/}
                          {/*begin::Svg Icon | path: icons/duotune/general/gen021.svg*/}
                          <span className="svg-icon svg-icon-2 svg-icon-lg-1 svg-icon-gray-500 position-absolute top-50 translate-middle-y ms-0">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width={24}
                              height={24}
                              viewBox="0 0 24 24"
                              fill="none"
                            >
                              <rect
                                opacity="0.5"
                                x="17.0365"
                                y="15.1223"
                                width="8.15546"
                                height={2}
                                rx={1}
                                transform="rotate(45 17.0365 15.1223)"
                                fill="currentColor"
                              />
                              <path
                                d="M11 19C6.55556 19 3 15.4444 3 11C3 6.55556 6.55556 3 11 3C15.4444 3 19 6.55556 19 11C19 15.4444 15.4444 19 11 19ZM11 5C7.53333 5 5 7.53333 5 11C5 14.4667 7.53333 17 11 17C14.4667 17 17 14.4667 17 11C17 7.53333 14.4667 5 11 5Z"
                                fill="currentColor"
                              />
                            </svg>
                          </span>
                          {/*end::Svg Icon*/}
                          {/*end::Icon*/}
                          {/*begin::Input*/}
                          <input
                            type="text"
                            className="search-input form-control form-control-flush ps-10"
                            name="search"
                            defaultValue
                            placeholder="Search..."
                            data-kt-search-element="input"
                          />
                          {/*end::Input*/}
                          {/*begin::Spinner*/}
                          <span
                            className="position-absolute top-50 end-0 translate-middle-y lh-0 d-none me-1"
                            data-kt-search-element="spinner"
                          >
                            <span className="spinner-border h-15px w-15px align-middle text-gray-400" />
                          </span>
                          {/*end::Spinner*/}
                          {/*begin::Reset*/}
                          <span
                            className="btn btn-flush btn-active-color-primary position-absolute top-50 end-0 translate-middle-y lh-0 d-none"
                            data-kt-search-element="clear"
                          >
                            {/*begin::Svg Icon | path: icons/duotune/arrows/arr061.svg*/}
                            <span className="svg-icon svg-icon-2 svg-icon-lg-1 me-0">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={24}
                                height={24}
                                viewBox="0 0 24 24"
                                fill="none"
                              >
                                <rect
                                  opacity="0.5"
                                  x={6}
                                  y="17.3137"
                                  width={16}
                                  height={2}
                                  rx={1}
                                  transform="rotate(-45 6 17.3137)"
                                  fill="currentColor"
                                />
                                <rect
                                  x="7.41422"
                                  y={6}
                                  width={16}
                                  height={2}
                                  rx={1}
                                  transform="rotate(45 7.41422 6)"
                                  fill="currentColor"
                                />
                              </svg>
                            </span>
                            {/*end::Svg Icon*/}
                          </span>
                          {/*end::Reset*/}
                          {/*begin::Toolbar*/}
                          <div
                            className="position-absolute top-50 end-0 translate-middle-y"
                            data-kt-search-element="toolbar"
                          >
                            {/*begin::Preferences toggle*/}
                            <div
                              data-kt-search-element="preferences-show"
                              className="btn btn-icon w-20px btn-sm btn-active-color-primary me-1"
                              data-bs-toggle="tooltip"
                              title
                              data-bs-original-title="Show search preferences"
                            >
                              {/*begin::Svg Icon | path: icons/duotune/coding/cod001.svg*/}
                              <span className="svg-icon svg-icon-1">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width={24}
                                  height={24}
                                  viewBox="0 0 24 24"
                                  fill="none"
                                >
                                  <path
                                    opacity="0.3"
                                    d="M22.1 11.5V12.6C22.1 13.2 21.7 13.6 21.2 13.7L19.9 13.9C19.7 14.7 19.4 15.5 18.9 16.2L19.7 17.2999C20 17.6999 20 18.3999 19.6 18.7999L18.8 19.6C18.4 20 17.8 20 17.3 19.7L16.2 18.9C15.5 19.3 14.7 19.7 13.9 19.9L13.7 21.2C13.6 21.7 13.1 22.1 12.6 22.1H11.5C10.9 22.1 10.5 21.7 10.4 21.2L10.2 19.9C9.4 19.7 8.6 19.4 7.9 18.9L6.8 19.7C6.4 20 5.7 20 5.3 19.6L4.5 18.7999C4.1 18.3999 4.1 17.7999 4.4 17.2999L5.2 16.2C4.8 15.5 4.4 14.7 4.2 13.9L2.9 13.7C2.4 13.6 2 13.1 2 12.6V11.5C2 10.9 2.4 10.5 2.9 10.4L4.2 10.2C4.4 9.39995 4.7 8.60002 5.2 7.90002L4.4 6.79993C4.1 6.39993 4.1 5.69993 4.5 5.29993L5.3 4.5C5.7 4.1 6.3 4.10002 6.8 4.40002L7.9 5.19995C8.6 4.79995 9.4 4.39995 10.2 4.19995L10.4 2.90002C10.5 2.40002 11 2 11.5 2H12.6C13.2 2 13.6 2.40002 13.7 2.90002L13.9 4.19995C14.7 4.39995 15.5 4.69995 16.2 5.19995L17.3 4.40002C17.7 4.10002 18.4 4.1 18.8 4.5L19.6 5.29993C20 5.69993 20 6.29993 19.7 6.79993L18.9 7.90002C19.3 8.60002 19.7 9.39995 19.9 10.2L21.2 10.4C21.7 10.5 22.1 11 22.1 11.5ZM12.1 8.59998C10.2 8.59998 8.6 10.2 8.6 12.1C8.6 14 10.2 15.6 12.1 15.6C14 15.6 15.6 14 15.6 12.1C15.6 10.2 14 8.59998 12.1 8.59998Z"
                                    fill="currentColor"
                                  />
                                  <path
                                    d="M17.1 12.1C17.1 14.9 14.9 17.1 12.1 17.1C9.30001 17.1 7.10001 14.9 7.10001 12.1C7.10001 9.29998 9.30001 7.09998 12.1 7.09998C14.9 7.09998 17.1 9.29998 17.1 12.1ZM12.1 10.1C11 10.1 10.1 11 10.1 12.1C10.1 13.2 11 14.1 12.1 14.1C13.2 14.1 14.1 13.2 14.1 12.1C14.1 11 13.2 10.1 12.1 10.1Z"
                                    fill="currentColor"
                                  />
                                </svg>
                              </span>
                              {/*end::Svg Icon*/}
                            </div>
                            {/*end::Preferences toggle*/}
                            {/*begin::Advanced search toggle*/}
                            <div
                              data-kt-search-element="advanced-options-form-show"
                              className="btn btn-icon w-20px btn-sm btn-active-color-primary"
                              data-bs-toggle="tooltip"
                              title
                              data-bs-original-title="Show more search options"
                            >
                              {/*begin::Svg Icon | path: icons/duotune/arrows/arr072.svg*/}
                              <span className="svg-icon svg-icon-2">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width={24}
                                  height={24}
                                  viewBox="0 0 24 24"
                                  fill="none"
                                >
                                  <path
                                    d="M11.4343 12.7344L7.25 8.55005C6.83579 8.13583 6.16421 8.13584 5.75 8.55005C5.33579 8.96426 5.33579 9.63583 5.75 10.05L11.2929 15.5929C11.6834 15.9835 12.3166 15.9835 12.7071 15.5929L18.25 10.05C18.6642 9.63584 18.6642 8.96426 18.25 8.55005C17.8358 8.13584 17.1642 8.13584 16.75 8.55005L12.5657 12.7344C12.2533 13.0468 11.7467 13.0468 11.4343 12.7344Z"
                                    fill="currentColor"
                                  />
                                </svg>
                              </span>
                              {/*end::Svg Icon*/}
                            </div>
                            {/*end::Advanced search toggle*/}
                          </div>
                          {/*end::Toolbar*/}
                        </form>
                        {/*end::Form*/}
                        {/*begin::Separator*/}
                        <div className="separator border-gray-200 mb-6" />
                        {/*end::Separator*/}
                        {/*begin::Recently viewed*/}
                        <div
                          data-kt-search-element="results"
                          className="d-none"
                        >
                          {/*begin::Items*/}
                          <div className="scroll-y mh-200px mh-lg-350px">
                            {/*begin::Category title*/}
                            <h3
                              className="fs-5 text-muted m-0 pb-5"
                              data-kt-search-element="category-title"
                            >
                              Users
                            </h3>
                            {/*end::Category title*/}
                            {/*begin::Item*/}
                            <a
                              href="#"
                              className="d-flex text-dark text-hover-primary align-items-center mb-5"
                            >
                              {/*begin::Symbol*/}
                              <div className="symbol symbol-40px me-4">
                                <img
                                  src="/metronic8/demo1/assets/media/avatars/300-6.jpg"
                                  alt=""
                                />
                              </div>
                              {/*end::Symbol*/}
                              {/*begin::Title*/}
                              <div className="d-flex flex-column justify-content-start fw-bold">
                                <span className="fs-6 fw-bold">
                                  Karina Clark
                                </span>
                                <span className="fs-7 fw-bold text-muted">
                                  Marketing Manager
                                </span>
                              </div>
                              {/*end::Title*/}
                            </a>
                            {/*end::Item*/}
                            {/*begin::Item*/}
                            <a
                              href="#"
                              className="d-flex text-dark text-hover-primary align-items-center mb-5"
                            >
                              {/*begin::Symbol*/}
                              <div className="symbol symbol-40px me-4">
                                <img
                                  src="/metronic8/demo1/assets/media/avatars/300-2.jpg"
                                  alt=""
                                />
                              </div>
                              {/*end::Symbol*/}
                              {/*begin::Title*/}
                              <div className="d-flex flex-column justify-content-start fw-bold">
                                <span className="fs-6 fw-bold">
                                  Olivia Bold
                                </span>
                                <span className="fs-7 fw-bold text-muted">
                                  Software Engineer
                                </span>
                              </div>
                              {/*end::Title*/}
                            </a>
                            {/*end::Item*/}
                            {/*begin::Item*/}
                            <a
                              href="#"
                              className="d-flex text-dark text-hover-primary align-items-center mb-5"
                            >
                              {/*begin::Symbol*/}
                              <div className="symbol symbol-40px me-4">
                                <img
                                  src="/metronic8/demo1/assets/media/avatars/300-9.jpg"
                                  alt=""
                                />
                              </div>
                              {/*end::Symbol*/}
                              {/*begin::Title*/}
                              <div className="d-flex flex-column justify-content-start fw-bold">
                                <span className="fs-6 fw-bold">Ana Clark</span>
                                <span className="fs-7 fw-bold text-muted">
                                  UI/UX Designer
                                </span>
                              </div>
                              {/*end::Title*/}
                            </a>
                            {/*end::Item*/}
                            {/*begin::Item*/}
                            <a
                              href="#"
                              className="d-flex text-dark text-hover-primary align-items-center mb-5"
                            >
                              {/*begin::Symbol*/}
                              <div className="symbol symbol-40px me-4">
                                <img
                                  src="/metronic8/demo1/assets/media/avatars/300-14.jpg"
                                  alt=""
                                />
                              </div>
                              {/*end::Symbol*/}
                              {/*begin::Title*/}
                              <div className="d-flex flex-column justify-content-start fw-bold">
                                <span className="fs-6 fw-bold">
                                  Nick Pitola
                                </span>
                                <span className="fs-7 fw-bold text-muted">
                                  Art Director
                                </span>
                              </div>
                              {/*end::Title*/}
                            </a>
                            {/*end::Item*/}
                            {/*begin::Item*/}
                            <a
                              href="#"
                              className="d-flex text-dark text-hover-primary align-items-center mb-5"
                            >
                              {/*begin::Symbol*/}
                              <div className="symbol symbol-40px me-4">
                                <img
                                  src="/metronic8/demo1/assets/media/avatars/300-11.jpg"
                                  alt=""
                                />
                              </div>
                              {/*end::Symbol*/}
                              {/*begin::Title*/}
                              <div className="d-flex flex-column justify-content-start fw-bold">
                                <span className="fs-6 fw-bold">
                                  Edward Kulnic
                                </span>
                                <span className="fs-7 fw-bold text-muted">
                                  System Administrator
                                </span>
                              </div>
                              {/*end::Title*/}
                            </a>
                            {/*end::Item*/}
                            {/*begin::Category title*/}
                            <h3
                              className="fs-5 text-muted m-0 pt-5 pb-5"
                              data-kt-search-element="category-title"
                            >
                              Customers
                            </h3>
                            {/*end::Category title*/}
                            {/*begin::Item*/}
                            <a
                              href="#"
                              className="d-flex text-dark text-hover-primary align-items-center mb-5"
                            >
                              {/*begin::Symbol*/}
                              <div className="symbol symbol-40px me-4">
                                <span className="symbol-label bg-light">
                                  <img
                                    className="w-20px h-20px"
                                    src="/metronic8/demo1/assets/media/svg/brand-logos/volicity-9.svg"
                                    alt=""
                                  />
                                </span>
                              </div>
                              {/*end::Symbol*/}
                              {/*begin::Title*/}
                              <div className="d-flex flex-column justify-content-start fw-bold">
                                <span className="fs-6 fw-bold">
                                  Company Rbranding
                                </span>
                                <span className="fs-7 fw-bold text-muted">
                                  UI Design
                                </span>
                              </div>
                              {/*end::Title*/}
                            </a>
                            {/*end::Item*/}
                            {/*begin::Item*/}
                            <a
                              href="#"
                              className="d-flex text-dark text-hover-primary align-items-center mb-5"
                            >
                              {/*begin::Symbol*/}
                              <div className="symbol symbol-40px me-4">
                                <span className="symbol-label bg-light">
                                  <img
                                    className="w-20px h-20px"
                                    src="/metronic8/demo1/assets/media/svg/brand-logos/tvit.svg"
                                    alt=""
                                  />
                                </span>
                              </div>
                              {/*end::Symbol*/}
                              {/*begin::Title*/}
                              <div className="d-flex flex-column justify-content-start fw-bold">
                                <span className="fs-6 fw-bold">
                                  Company Re-branding
                                </span>
                                <span className="fs-7 fw-bold text-muted">
                                  Web Development
                                </span>
                              </div>
                              {/*end::Title*/}
                            </a>
                            {/*end::Item*/}
                            {/*begin::Item*/}
                            <a
                              href="#"
                              className="d-flex text-dark text-hover-primary align-items-center mb-5"
                            >
                              {/*begin::Symbol*/}
                              <div className="symbol symbol-40px me-4">
                                <span className="symbol-label bg-light">
                                  <img
                                    className="w-20px h-20px"
                                    src="/metronic8/demo1/assets/media/svg/misc/infography.svg"
                                    alt=""
                                  />
                                </span>
                              </div>
                              {/*end::Symbol*/}
                              {/*begin::Title*/}
                              <div className="d-flex flex-column justify-content-start fw-bold">
                                <span className="fs-6 fw-bold">
                                  Business Analytics App
                                </span>
                                <span className="fs-7 fw-bold text-muted">
                                  Administration
                                </span>
                              </div>
                              {/*end::Title*/}
                            </a>
                            {/*end::Item*/}
                            {/*begin::Item*/}
                            <a
                              href="#"
                              className="d-flex text-dark text-hover-primary align-items-center mb-5"
                            >
                              {/*begin::Symbol*/}
                              <div className="symbol symbol-40px me-4">
                                <span className="symbol-label bg-light">
                                  <img
                                    className="w-20px h-20px"
                                    src="/metronic8/demo1/assets/media/svg/brand-logos/leaf.svg"
                                    alt=""
                                  />
                                </span>
                              </div>
                              {/*end::Symbol*/}
                              {/*begin::Title*/}
                              <div className="d-flex flex-column justify-content-start fw-bold">
                                <span className="fs-6 fw-bold">
                                  EcoLeaf App Launch
                                </span>
                                <span className="fs-7 fw-bold text-muted">
                                  Marketing
                                </span>
                              </div>
                              {/*end::Title*/}
                            </a>
                            {/*end::Item*/}
                            {/*begin::Item*/}
                            <a
                              href="#"
                              className="d-flex text-dark text-hover-primary align-items-center mb-5"
                            >
                              {/*begin::Symbol*/}
                              <div className="symbol symbol-40px me-4">
                                <span className="symbol-label bg-light">
                                  <img
                                    className="w-20px h-20px"
                                    src="/metronic8/demo1/assets/media/svg/brand-logos/tower.svg"
                                    alt=""
                                  />
                                </span>
                              </div>
                              {/*end::Symbol*/}
                              {/*begin::Title*/}
                              <div className="d-flex flex-column justify-content-start fw-bold">
                                <span className="fs-6 fw-bold">
                                  Tower Group Website
                                </span>
                                <span className="fs-7 fw-bold text-muted">
                                  Google Adwords
                                </span>
                              </div>
                              {/*end::Title*/}
                            </a>
                            {/*end::Item*/}
                            {/*begin::Category title*/}
                            <h3
                              className="fs-5 text-muted m-0 pt-5 pb-5"
                              data-kt-search-element="category-title"
                            >
                              Projects
                            </h3>
                            {/*end::Category title*/}
                            {/*begin::Item*/}
                            <a
                              href="#"
                              className="d-flex text-dark text-hover-primary align-items-center mb-5"
                            >
                              {/*begin::Symbol*/}
                              <div className="symbol symbol-40px me-4">
                                <span className="symbol-label bg-light">
                                  {/*begin::Svg Icon | path: icons/duotune/general/gen005.svg*/}
                                  <span className="svg-icon svg-icon-2 svg-icon-primary">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                    >
                                      <path
                                        opacity="0.3"
                                        d="M19 22H5C4.4 22 4 21.6 4 21V3C4 2.4 4.4 2 5 2H14L20 8V21C20 21.6 19.6 22 19 22ZM12.5 18C12.5 17.4 12.6 17.5 12 17.5H8.5C7.9 17.5 8 17.4 8 18C8 18.6 7.9 18.5 8.5 18.5L12 18C12.6 18 12.5 18.6 12.5 18ZM16.5 13C16.5 12.4 16.6 12.5 16 12.5H8.5C7.9 12.5 8 12.4 8 13C8 13.6 7.9 13.5 8.5 13.5H15.5C16.1 13.5 16.5 13.6 16.5 13ZM12.5 8C12.5 7.4 12.6 7.5 12 7.5H8C7.4 7.5 7.5 7.4 7.5 8C7.5 8.6 7.4 8.5 8 8.5H12C12.6 8.5 12.5 8.6 12.5 8Z"
                                        fill="currentColor"
                                      />
                                      <rect
                                        x={7}
                                        y={17}
                                        width={6}
                                        height={2}
                                        rx={1}
                                        fill="currentColor"
                                      />
                                      <rect
                                        x={7}
                                        y={12}
                                        width={10}
                                        height={2}
                                        rx={1}
                                        fill="currentColor"
                                      />
                                      <rect
                                        x={7}
                                        y={7}
                                        width={6}
                                        height={2}
                                        rx={1}
                                        fill="currentColor"
                                      />
                                      <path
                                        d="M15 8H20L14 2V7C14 7.6 14.4 8 15 8Z"
                                        fill="currentColor"
                                      />
                                    </svg>
                                  </span>
                                  {/*end::Svg Icon*/}
                                </span>
                              </div>
                              {/*end::Symbol*/}
                              {/*begin::Title*/}
                              <div className="d-flex flex-column">
                                <span className="fs-6 fw-bold">
                                  Si-Fi Project by AU Themes
                                </span>
                                <span className="fs-7 fw-bold text-muted">
                                  #45670
                                </span>
                              </div>
                              {/*end::Title*/}
                            </a>
                            {/*end::Item*/}
                            {/*begin::Item*/}
                            <a
                              href="#"
                              className="d-flex text-dark text-hover-primary align-items-center mb-5"
                            >
                              {/*begin::Symbol*/}
                              <div className="symbol symbol-40px me-4">
                                <span className="symbol-label bg-light">
                                  {/*begin::Svg Icon | path: icons/duotune/general/gen032.svg*/}
                                  <span className="svg-icon svg-icon-2 svg-icon-primary">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                    >
                                      <rect
                                        x={8}
                                        y={9}
                                        width={3}
                                        height={10}
                                        rx="1.5"
                                        fill="currentColor"
                                      />
                                      <rect
                                        opacity="0.5"
                                        x={13}
                                        y={5}
                                        width={3}
                                        height={14}
                                        rx="1.5"
                                        fill="currentColor"
                                      />
                                      <rect
                                        x={18}
                                        y={11}
                                        width={3}
                                        height={8}
                                        rx="1.5"
                                        fill="currentColor"
                                      />
                                      <rect
                                        x={3}
                                        y={13}
                                        width={3}
                                        height={6}
                                        rx="1.5"
                                        fill="currentColor"
                                      />
                                    </svg>
                                  </span>
                                  {/*end::Svg Icon*/}
                                </span>
                              </div>
                              {/*end::Symbol*/}
                              {/*begin::Title*/}
                              <div className="d-flex flex-column">
                                <span className="fs-6 fw-bold">
                                  Shopix Mobile App Planning
                                </span>
                                <span className="fs-7 fw-bold text-muted">
                                  #45690
                                </span>
                              </div>
                              {/*end::Title*/}
                            </a>
                            {/*end::Item*/}
                            {/*begin::Item*/}
                            <a
                              href="#"
                              className="d-flex text-dark text-hover-primary align-items-center mb-5"
                            >
                              {/*begin::Symbol*/}
                              <div className="symbol symbol-40px me-4">
                                <span className="symbol-label bg-light">
                                  {/*begin::Svg Icon | path: icons/duotune/communication/com012.svg*/}
                                  <span className="svg-icon svg-icon-2 svg-icon-primary">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                    >
                                      <path
                                        opacity="0.3"
                                        d="M20 3H4C2.89543 3 2 3.89543 2 5V16C2 17.1046 2.89543 18 4 18H4.5C5.05228 18 5.5 18.4477 5.5 19V21.5052C5.5 22.1441 6.21212 22.5253 6.74376 22.1708L11.4885 19.0077C12.4741 18.3506 13.6321 18 14.8167 18H20C21.1046 18 22 17.1046 22 16V5C22 3.89543 21.1046 3 20 3Z"
                                        fill="currentColor"
                                      />
                                      <rect
                                        x={6}
                                        y={12}
                                        width={7}
                                        height={2}
                                        rx={1}
                                        fill="currentColor"
                                      />
                                      <rect
                                        x={6}
                                        y={7}
                                        width={12}
                                        height={2}
                                        rx={1}
                                        fill="currentColor"
                                      />
                                    </svg>
                                  </span>
                                  {/*end::Svg Icon*/}
                                </span>
                              </div>
                              {/*end::Symbol*/}
                              {/*begin::Title*/}
                              <div className="d-flex flex-column">
                                <span className="fs-6 fw-bold">
                                  Finance Monitoring SAAS Discussion
                                </span>
                                <span className="fs-7 fw-bold text-muted">
                                  #21090
                                </span>
                              </div>
                              {/*end::Title*/}
                            </a>
                            {/*end::Item*/}
                            {/*begin::Item*/}
                            <a
                              href="#"
                              className="d-flex text-dark text-hover-primary align-items-center mb-5"
                            >
                              {/*begin::Symbol*/}
                              <div className="symbol symbol-40px me-4">
                                <span className="symbol-label bg-light">
                                  {/*begin::Svg Icon | path: icons/duotune/communication/com006.svg*/}
                                  <span className="svg-icon svg-icon-2 svg-icon-primary">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                    >
                                      <path
                                        opacity="0.3"
                                        d="M22 12C22 17.5 17.5 22 12 22C6.5 22 2 17.5 2 12C2 6.5 6.5 2 12 2C17.5 2 22 6.5 22 12ZM12 7C10.3 7 9 8.3 9 10C9 11.7 10.3 13 12 13C13.7 13 15 11.7 15 10C15 8.3 13.7 7 12 7Z"
                                        fill="currentColor"
                                      />
                                      <path
                                        d="M12 22C14.6 22 17 21 18.7 19.4C17.9 16.9 15.2 15 12 15C8.8 15 6.09999 16.9 5.29999 19.4C6.99999 21 9.4 22 12 22Z"
                                        fill="currentColor"
                                      />
                                    </svg>
                                  </span>
                                  {/*end::Svg Icon*/}
                                </span>
                              </div>
                              {/*end::Symbol*/}
                              {/*begin::Title*/}
                              <div className="d-flex flex-column">
                                <span className="fs-6 fw-bold">
                                  Dashboard Analitics Launch
                                </span>
                                <span className="fs-7 fw-bold text-muted">
                                  #34560
                                </span>
                              </div>
                              {/*end::Title*/}
                            </a>
                            {/*end::Item*/}
                          </div>
                          {/*end::Items*/}
                        </div>
                        {/*end::Recently viewed*/}
                        {/*begin::Recently viewed*/}
                        <div className="mb-5" data-kt-search-element="main">
                          {/*begin::Heading*/}
                          <div className="d-flex flex-stack fw-bold mb-4">
                            {/*begin::Label*/}
                            <span className="text-muted fs-6 me-2">
                              Recently Searched:
                            </span>
                            {/*end::Label*/}
                          </div>
                          {/*end::Heading*/}
                          {/*begin::Items*/}
                          <div className="scroll-y mh-200px mh-lg-325px">
                            {/*begin::Item*/}
                            <div className="d-flex align-items-center mb-5">
                              {/*begin::Symbol*/}
                              <div className="symbol symbol-40px me-4">
                                <span className="symbol-label bg-light">
                                  {/*begin::Svg Icon | path: icons/duotune/electronics/elc004.svg*/}
                                  <span className="svg-icon svg-icon-2 svg-icon-primary">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                    >
                                      <path
                                        d="M2 16C2 16.6 2.4 17 3 17H21C21.6 17 22 16.6 22 16V15H2V16Z"
                                        fill="currentColor"
                                      />
                                      <path
                                        opacity="0.3"
                                        d="M21 3H3C2.4 3 2 3.4 2 4V15H22V4C22 3.4 21.6 3 21 3Z"
                                        fill="currentColor"
                                      />
                                      <path
                                        opacity="0.3"
                                        d="M15 17H9V20H15V17Z"
                                        fill="currentColor"
                                      />
                                    </svg>
                                  </span>
                                  {/*end::Svg Icon*/}
                                </span>
                              </div>
                              {/*end::Symbol*/}
                              {/*begin::Title*/}
                              <div className="d-flex flex-column">
                                <a
                                  href="#"
                                  className="fs-6 text-gray-800 text-hover-primary fw-bold"
                                >
                                  BoomApp by Keenthemes
                                </a>
                                <span className="fs-7 text-muted fw-bold">
                                  #45789
                                </span>
                              </div>
                              {/*end::Title*/}
                            </div>
                            {/*end::Item*/}
                            {/*begin::Item*/}
                            <div className="d-flex align-items-center mb-5">
                              {/*begin::Symbol*/}
                              <div className="symbol symbol-40px me-4">
                                <span className="symbol-label bg-light">
                                  {/*begin::Svg Icon | path: icons/duotune/graphs/gra001.svg*/}
                                  <span className="svg-icon svg-icon-2 svg-icon-primary">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                    >
                                      <path
                                        opacity="0.3"
                                        d="M14 3V21H10V3C10 2.4 10.4 2 11 2H13C13.6 2 14 2.4 14 3ZM7 14H5C4.4 14 4 14.4 4 15V21H8V15C8 14.4 7.6 14 7 14Z"
                                        fill="currentColor"
                                      />
                                      <path
                                        d="M21 20H20V8C20 7.4 19.6 7 19 7H17C16.4 7 16 7.4 16 8V20H3C2.4 20 2 20.4 2 21C2 21.6 2.4 22 3 22H21C21.6 22 22 21.6 22 21C22 20.4 21.6 20 21 20Z"
                                        fill="currentColor"
                                      />
                                    </svg>
                                  </span>
                                  {/*end::Svg Icon*/}
                                </span>
                              </div>
                              {/*end::Symbol*/}
                              {/*begin::Title*/}
                              <div className="d-flex flex-column">
                                <a
                                  href="#"
                                  className="fs-6 text-gray-800 text-hover-primary fw-bold"
                                >
                                  "Kept API Project Meeting
                                </a>
                                <span className="fs-7 text-muted fw-bold">
                                  #84050
                                </span>
                              </div>
                              {/*end::Title*/}
                            </div>
                            {/*end::Item*/}
                            {/*begin::Item*/}
                            <div className="d-flex align-items-center mb-5">
                              {/*begin::Symbol*/}
                              <div className="symbol symbol-40px me-4">
                                <span className="symbol-label bg-light">
                                  {/*begin::Svg Icon | path: icons/duotune/graphs/gra006.svg*/}
                                  <span className="svg-icon svg-icon-2 svg-icon-primary">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                    >
                                      <path
                                        d="M13 5.91517C15.8 6.41517 18 8.81519 18 11.8152C18 12.5152 17.9 13.2152 17.6 13.9152L20.1 15.3152C20.6 15.6152 21.4 15.4152 21.6 14.8152C21.9 13.9152 22.1 12.9152 22.1 11.8152C22.1 7.01519 18.8 3.11521 14.3 2.01521C13.7 1.91521 13.1 2.31521 13.1 3.01521V5.91517H13Z"
                                        fill="currentColor"
                                      />
                                      <path
                                        opacity="0.3"
                                        d="M19.1 17.0152C19.7 17.3152 19.8 18.1152 19.3 18.5152C17.5 20.5152 14.9 21.7152 12 21.7152C9.1 21.7152 6.50001 20.5152 4.70001 18.5152C4.30001 18.0152 4.39999 17.3152 4.89999 17.0152L7.39999 15.6152C8.49999 16.9152 10.2 17.8152 12 17.8152C13.8 17.8152 15.5 17.0152 16.6 15.6152L19.1 17.0152ZM6.39999 13.9151C6.19999 13.2151 6 12.5152 6 11.8152C6 8.81517 8.2 6.41515 11 5.91515V3.01519C11 2.41519 10.4 1.91519 9.79999 2.01519C5.29999 3.01519 2 7.01517 2 11.8152C2 12.8152 2.2 13.8152 2.5 14.8152C2.7 15.4152 3.4 15.7152 4 15.3152L6.39999 13.9151Z"
                                        fill="currentColor"
                                      />
                                    </svg>
                                  </span>
                                  {/*end::Svg Icon*/}
                                </span>
                              </div>
                              {/*end::Symbol*/}
                              {/*begin::Title*/}
                              <div className="d-flex flex-column">
                                <a
                                  href="#"
                                  className="fs-6 text-gray-800 text-hover-primary fw-bold"
                                >
                                  "KPI Monitoring App Launch
                                </a>
                                <span className="fs-7 text-muted fw-bold">
                                  #84250
                                </span>
                              </div>
                              {/*end::Title*/}
                            </div>
                            {/*end::Item*/}
                            {/*begin::Item*/}
                            <div className="d-flex align-items-center mb-5">
                              {/*begin::Symbol*/}
                              <div className="symbol symbol-40px me-4">
                                <span className="symbol-label bg-light">
                                  {/*begin::Svg Icon | path: icons/duotune/graphs/gra002.svg*/}
                                  <span className="svg-icon svg-icon-2 svg-icon-primary">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                    >
                                      <path
                                        opacity="0.3"
                                        d="M20 8L12.5 5L5 14V19H20V8Z"
                                        fill="currentColor"
                                      />
                                      <path
                                        d="M21 18H6V3C6 2.4 5.6 2 5 2C4.4 2 4 2.4 4 3V18H3C2.4 18 2 18.4 2 19C2 19.6 2.4 20 3 20H4V21C4 21.6 4.4 22 5 22C5.6 22 6 21.6 6 21V20H21C21.6 20 22 19.6 22 19C22 18.4 21.6 18 21 18Z"
                                        fill="currentColor"
                                      />
                                    </svg>
                                  </span>
                                  {/*end::Svg Icon*/}
                                </span>
                              </div>
                              {/*end::Symbol*/}
                              {/*begin::Title*/}
                              <div className="d-flex flex-column">
                                <a
                                  href="#"
                                  className="fs-6 text-gray-800 text-hover-primary fw-bold"
                                >
                                  Project Reference FAQ
                                </a>
                                <span className="fs-7 text-muted fw-bold">
                                  #67945
                                </span>
                              </div>
                              {/*end::Title*/}
                            </div>
                            {/*end::Item*/}
                            {/*begin::Item*/}
                            <div className="d-flex align-items-center mb-5">
                              {/*begin::Symbol*/}
                              <div className="symbol symbol-40px me-4">
                                <span className="symbol-label bg-light">
                                  {/*begin::Svg Icon | path: icons/duotune/communication/com010.svg*/}
                                  <span className="svg-icon svg-icon-2 svg-icon-primary">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                    >
                                      <path
                                        d="M6 8.725C6 8.125 6.4 7.725 7 7.725H14L18 11.725V12.925L22 9.725L12.6 2.225C12.2 1.925 11.7 1.925 11.4 2.225L2 9.725L6 12.925V8.725Z"
                                        fill="currentColor"
                                      />
                                      <path
                                        opacity="0.3"
                                        d="M22 9.72498V20.725C22 21.325 21.6 21.725 21 21.725H3C2.4 21.725 2 21.325 2 20.725V9.72498L11.4 17.225C11.8 17.525 12.3 17.525 12.6 17.225L22 9.72498ZM15 11.725H18L14 7.72498V10.725C14 11.325 14.4 11.725 15 11.725Z"
                                        fill="currentColor"
                                      />
                                    </svg>
                                  </span>
                                  {/*end::Svg Icon*/}
                                </span>
                              </div>
                              {/*end::Symbol*/}
                              {/*begin::Title*/}
                              <div className="d-flex flex-column">
                                <a
                                  href="#"
                                  className="fs-6 text-gray-800 text-hover-primary fw-bold"
                                >
                                  "FitPro App Development
                                </a>
                                <span className="fs-7 text-muted fw-bold">
                                  #84250
                                </span>
                              </div>
                              {/*end::Title*/}
                            </div>
                            {/*end::Item*/}
                            {/*begin::Item*/}
                            <div className="d-flex align-items-center mb-5">
                              {/*begin::Symbol*/}
                              <div className="symbol symbol-40px me-4">
                                <span className="symbol-label bg-light">
                                  {/*begin::Svg Icon | path: icons/duotune/finance/fin001.svg*/}
                                  <span className="svg-icon svg-icon-2 svg-icon-primary">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                    >
                                      <path
                                        d="M20 19.725V18.725C20 18.125 19.6 17.725 19 17.725H5C4.4 17.725 4 18.125 4 18.725V19.725H3C2.4 19.725 2 20.125 2 20.725V21.725H22V20.725C22 20.125 21.6 19.725 21 19.725H20Z"
                                        fill="currentColor"
                                      />
                                      <path
                                        opacity="0.3"
                                        d="M22 6.725V7.725C22 8.325 21.6 8.725 21 8.725H18C18.6 8.725 19 9.125 19 9.725C19 10.325 18.6 10.725 18 10.725V15.725C18.6 15.725 19 16.125 19 16.725V17.725H15V16.725C15 16.125 15.4 15.725 16 15.725V10.725C15.4 10.725 15 10.325 15 9.725C15 9.125 15.4 8.725 16 8.725H13C13.6 8.725 14 9.125 14 9.725C14 10.325 13.6 10.725 13 10.725V15.725C13.6 15.725 14 16.125 14 16.725V17.725H10V16.725C10 16.125 10.4 15.725 11 15.725V10.725C10.4 10.725 10 10.325 10 9.725C10 9.125 10.4 8.725 11 8.725H8C8.6 8.725 9 9.125 9 9.725C9 10.325 8.6 10.725 8 10.725V15.725C8.6 15.725 9 16.125 9 16.725V17.725H5V16.725C5 16.125 5.4 15.725 6 15.725V10.725C5.4 10.725 5 10.325 5 9.725C5 9.125 5.4 8.725 6 8.725H3C2.4 8.725 2 8.325 2 7.725V6.725L11 2.225C11.6 1.925 12.4 1.925 13.1 2.225L22 6.725ZM12 3.725C11.2 3.725 10.5 4.425 10.5 5.225C10.5 6.025 11.2 6.725 12 6.725C12.8 6.725 13.5 6.025 13.5 5.225C13.5 4.425 12.8 3.725 12 3.725Z"
                                        fill="currentColor"
                                      />
                                    </svg>
                                  </span>
                                  {/*end::Svg Icon*/}
                                </span>
                              </div>
                              {/*end::Symbol*/}
                              {/*begin::Title*/}
                              <div className="d-flex flex-column">
                                <a
                                  href="#"
                                  className="fs-6 text-gray-800 text-hover-primary fw-bold"
                                >
                                  Shopix Mobile App
                                </a>
                                <span className="fs-7 text-muted fw-bold">
                                  #45690
                                </span>
                              </div>
                              {/*end::Title*/}
                            </div>
                            {/*end::Item*/}
                            {/*begin::Item*/}
                            <div className="d-flex align-items-center mb-5">
                              {/*begin::Symbol*/}
                              <div className="symbol symbol-40px me-4">
                                <span className="symbol-label bg-light">
                                  {/*begin::Svg Icon | path: icons/duotune/graphs/gra002.svg*/}
                                  <span className="svg-icon svg-icon-2 svg-icon-primary">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                    >
                                      <path
                                        opacity="0.3"
                                        d="M20 8L12.5 5L5 14V19H20V8Z"
                                        fill="currentColor"
                                      />
                                      <path
                                        d="M21 18H6V3C6 2.4 5.6 2 5 2C4.4 2 4 2.4 4 3V18H3C2.4 18 2 18.4 2 19C2 19.6 2.4 20 3 20H4V21C4 21.6 4.4 22 5 22C5.6 22 6 21.6 6 21V20H21C21.6 20 22 19.6 22 19C22 18.4 21.6 18 21 18Z"
                                        fill="currentColor"
                                      />
                                    </svg>
                                  </span>
                                  {/*end::Svg Icon*/}
                                </span>
                              </div>
                              {/*end::Symbol*/}
                              {/*begin::Title*/}
                              <div className="d-flex flex-column">
                                <a
                                  href="#"
                                  className="fs-6 text-gray-800 text-hover-primary fw-bold"
                                >
                                  "Landing UI Design" Launch
                                </a>
                                <span className="fs-7 text-muted fw-bold">
                                  #24005
                                </span>
                              </div>
                              {/*end::Title*/}
                            </div>
                            {/*end::Item*/}
                          </div>
                          {/*end::Items*/}
                        </div>
                        {/*end::Recently viewed*/}
                        {/*begin::Empty*/}
                        <div
                          data-kt-search-element="empty"
                          className="text-center d-none"
                        >
                          {/*begin::Icon*/}
                          <div className="pt-10 pb-10">
                            {/*begin::Svg Icon | path: icons/duotune/files/fil024.svg*/}
                            <span className="svg-icon svg-icon-4x opacity-50">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={24}
                                height={24}
                                viewBox="0 0 24 24"
                                fill="none"
                              >
                                <path
                                  opacity="0.3"
                                  d="M14 2H6C4.89543 2 4 2.89543 4 4V20C4 21.1046 4.89543 22 6 22H18C19.1046 22 20 21.1046 20 20V8L14 2Z"
                                  fill="currentColor"
                                />
                                <path
                                  d="M20 8L14 2V6C14 7.10457 14.8954 8 16 8H20Z"
                                  fill="currentColor"
                                />
                                <rect
                                  x="13.6993"
                                  y="13.6656"
                                  width="4.42828"
                                  height="1.73089"
                                  rx="0.865447"
                                  transform="rotate(45 13.6993 13.6656)"
                                  fill="currentColor"
                                />
                                <path
                                  d="M15 12C15 14.2 13.2 16 11 16C8.8 16 7 14.2 7 12C7 9.8 8.8 8 11 8C13.2 8 15 9.8 15 12ZM11 9.6C9.68 9.6 8.6 10.68 8.6 12C8.6 13.32 9.68 14.4 11 14.4C12.32 14.4 13.4 13.32 13.4 12C13.4 10.68 12.32 9.6 11 9.6Z"
                                  fill="currentColor"
                                />
                              </svg>
                            </span>
                            {/*end::Svg Icon*/}
                          </div>
                          {/*end::Icon*/}
                          {/*begin::Message*/}
                          <div className="pb-15 fw-bold">
                            <h3 className="text-gray-600 fs-5 mb-2">
                              No result found
                            </h3>
                            <div className="text-muted fs-7">
                              Please try again with a different query
                            </div>
                          </div>
                          {/*end::Message*/}
                        </div>
                        {/*end::Empty*/}
                      </div>
                      {/*end::Wrapper*/}
                      {/*begin::Preferences*/}
                      <form
                        data-kt-search-element="advanced-options-form"
                        className="pt-1 d-none"
                      >
                        {/*begin::Heading*/}
                        <h3 className="fw-bold text-dark mb-7">
                          Advanced Search
                        </h3>
                        {/*end::Heading*/}
                        {/*begin::Input group*/}
                        <div className="mb-5">
                          <input
                            type="text"
                            className="form-control form-control-sm form-control-solid"
                            placeholder="Contains the word"
                            name="query"
                          />
                        </div>
                        {/*end::Input group*/}
                        {/*begin::Input group*/}
                        <div className="mb-5">
                          {/*begin::Radio group*/}
                          <div className="nav-group nav-group-fluid">
                            {/*begin::Option*/}
                            <label>
                              <input
                                type="radio"
                                className="btn-check"
                                name="type"
                                defaultValue="has"
                                defaultChecked="checked"
                              />
                              <span className="btn btn-sm btn-color-muted btn-active btn-active-primary">
                                All
                              </span>
                            </label>
                            {/*end::Option*/}
                            {/*begin::Option*/}
                            <label>
                              <input
                                type="radio"
                                className="btn-check"
                                name="type"
                                defaultValue="users"
                              />
                              <span className="btn btn-sm btn-color-muted btn-active btn-active-primary px-4">
                                Users
                              </span>
                            </label>
                            {/*end::Option*/}
                            {/*begin::Option*/}
                            <label>
                              <input
                                type="radio"
                                className="btn-check"
                                name="type"
                                defaultValue="orders"
                              />
                              <span className="btn btn-sm btn-color-muted btn-active btn-active-primary px-4">
                                Orders
                              </span>
                            </label>
                            {/*end::Option*/}
                            {/*begin::Option*/}
                            <label>
                              <input
                                type="radio"
                                className="btn-check"
                                name="type"
                                defaultValue="projects"
                              />
                              <span className="btn btn-sm btn-color-muted btn-active btn-active-primary px-4">
                                Projects
                              </span>
                            </label>
                            {/*end::Option*/}
                          </div>
                          {/*end::Radio group*/}
                        </div>
                        {/*end::Input group*/}
                        {/*begin::Input group*/}
                        <div className="mb-5">
                          <input
                            type="text"
                            name="assignedto"
                            className="form-control form-control-sm form-control-solid"
                            placeholder="Assigned to"
                            defaultValue
                          />
                        </div>
                        {/*end::Input group*/}
                        {/*begin::Input group*/}
                        <div className="mb-5">
                          <input
                            type="text"
                            name="collaborators"
                            className="form-control form-control-sm form-control-solid"
                            placeholder="Collaborators"
                            defaultValue
                          />
                        </div>
                        {/*end::Input group*/}
                        {/*begin::Input group*/}
                        <div className="mb-5">
                          {/*begin::Radio group*/}
                          <div className="nav-group nav-group-fluid">
                            {/*begin::Option*/}
                            <label>
                              <input
                                type="radio"
                                className="btn-check"
                                name="attachment"
                                defaultValue="has"
                                defaultChecked="checked"
                              />
                              <span className="btn btn-sm btn-color-muted btn-active btn-active-primary">
                                Has attachment
                              </span>
                            </label>
                            {/*end::Option*/}
                            {/*begin::Option*/}
                            <label>
                              <input
                                type="radio"
                                className="btn-check"
                                name="attachment"
                                defaultValue="any"
                              />
                              <span className="btn btn-sm btn-color-muted btn-active btn-active-primary px-4">
                                Any
                              </span>
                            </label>
                            {/*end::Option*/}
                          </div>
                          {/*end::Radio group*/}
                        </div>
                        {/*end::Input group*/}
                        {/*begin::Input group*/}
                        <div className="mb-5">
                          <select
                            name="timezone"
                            aria-label="Select a Timezone"
                            data-control="select2"
                            data-placeholder="date_period"
                            className="form-select form-select-sm form-select-solid select2-hidden-accessible"
                            data-select2-id="select2-data-1-wyh5"
                            tabIndex={-1}
                            aria-hidden="true"
                          >
                            <option
                              value="next"
                              data-select2-id="select2-data-3-2fvk"
                            >
                              Within the next
                            </option>
                            <option value="last">Within the last</option>
                            <option value="between">Between</option>
                            <option value="on">On</option>
                          </select>
                          <span
                            className="select2 select2-container select2-container--bootstrap5"
                            dir="ltr"
                            data-select2-id="select2-data-2-2rb6"
                            style={{ width: "100%" }}
                          >
                            <span className="selection">
                              <span
                                className="select2-selection select2-selection--single form-select form-select-sm form-select-solid"
                                role="combobox"
                                aria-haspopup="true"
                                aria-expanded="false"
                                tabIndex={0}
                                aria-disabled="false"
                                aria-labelledby="select2-timezone-51-container"
                                aria-controls="select2-timezone-51-container"
                              >
                                <span
                                  className="select2-selection__rendered"
                                  id="select2-timezone-51-container"
                                  role="textbox"
                                  aria-readonly="true"
                                  title="Within the next"
                                >
                                  Within the next
                                </span>
                                <span
                                  className="select2-selection__arrow"
                                  role="presentation"
                                >
                                  <b role="presentation" />
                                </span>
                              </span>
                            </span>
                            <span
                              className="dropdown-wrapper"
                              aria-hidden="true"
                            />
                          </span>
                        </div>
                        {/*end::Input group*/}
                        {/*begin::Input group*/}
                        <div className="row mb-8">
                          {/*begin::Col*/}
                          <div className="col-6">
                            <input
                              type="number"
                              name="date_number"
                              className="form-control form-control-sm form-control-solid"
                              placeholder="Lenght"
                              defaultValue
                            />
                          </div>
                          {/*end::Col*/}
                          {/*begin::Col*/}
                          <div className="col-6">
                            <select
                              name="date_typer"
                              aria-label="Select a Timezone"
                              data-control="select2"
                              data-placeholder="Period"
                              className="form-select form-select-sm form-select-solid select2-hidden-accessible"
                              data-select2-id="select2-data-4-t5hu"
                              tabIndex={-1}
                              aria-hidden="true"
                            >
                              <option
                                value="days"
                                data-select2-id="select2-data-6-6cco"
                              >
                                Days
                              </option>
                              <option value="weeks">Weeks</option>
                              <option value="months">Months</option>
                              <option value="years">Years</option>
                            </select>
                            <span
                              className="select2 select2-container select2-container--bootstrap5"
                              dir="ltr"
                              data-select2-id="select2-data-5-h3a6"
                              style={{ width: "100%" }}
                            >
                              <span className="selection">
                                <span
                                  className="select2-selection select2-selection--single form-select form-select-sm form-select-solid"
                                  role="combobox"
                                  aria-haspopup="true"
                                  aria-expanded="false"
                                  tabIndex={0}
                                  aria-disabled="false"
                                  aria-labelledby="select2-date_typer-mf-container"
                                  aria-controls="select2-date_typer-mf-container"
                                >
                                  <span
                                    className="select2-selection__rendered"
                                    id="select2-date_typer-mf-container"
                                    role="textbox"
                                    aria-readonly="true"
                                    title="Days"
                                  >
                                    Days
                                  </span>
                                  <span
                                    className="select2-selection__arrow"
                                    role="presentation"
                                  >
                                    <b role="presentation" />
                                  </span>
                                </span>
                              </span>
                              <span
                                className="dropdown-wrapper"
                                aria-hidden="true"
                              />
                            </span>
                          </div>
                          {/*end::Col*/}
                        </div>
                        {/*end::Input group*/}
                        {/*begin::Actions*/}
                        <div className="d-flex justify-content-end">
                          <button
                            type="reset"
                            className="btn btn-sm btn-light fw-bolder btn-active-light-primary me-2"
                            data-kt-search-element="advanced-options-form-cancel"
                          >
                            Cancel
                          </button>
                          <a
                            href="/metronic8/demo1/../demo1/pages/search/horizontal.html"
                            className="btn btn-sm fw-bolder btn-primary"
                            data-kt-search-element="advanced-options-form-search"
                          >
                            Search
                          </a>
                        </div>
                        {/*end::Actions*/}
                      </form>
                      {/*end::Preferences*/}
                      {/*begin::Preferences*/}
                      <form
                        data-kt-search-element="preferences"
                        className="pt-1 d-none"
                      >
                        {/*begin::Heading*/}
                        <h3 className="fw-bold text-dark mb-7">
                          Search Preferences
                        </h3>
                        {/*end::Heading*/}
                        {/*begin::Input group*/}
                        <div className="pb-4 border-bottom">
                          <label className="form-check form-switch form-switch-sm form-check-custom form-check-solid flex-stack">
                            <span className="form-check-label text-gray-700 fs-6 fw-bold ms-0 me-2">
                              Projects
                            </span>
                            <input
                              className="form-check-input"
                              type="checkbox"
                              defaultValue={1}
                              defaultChecked="checked"
                            />
                          </label>
                        </div>
                        {/*end::Input group*/}
                        {/*begin::Input group*/}
                        <div className="py-4 border-bottom">
                          <label className="form-check form-switch form-switch-sm form-check-custom form-check-solid flex-stack">
                            <span className="form-check-label text-gray-700 fs-6 fw-bold ms-0 me-2">
                              Targets
                            </span>
                            <input
                              className="form-check-input"
                              type="checkbox"
                              defaultValue={1}
                              defaultChecked="checked"
                            />
                          </label>
                        </div>
                        {/*end::Input group*/}
                        {/*begin::Input group*/}
                        <div className="py-4 border-bottom">
                          <label className="form-check form-switch form-switch-sm form-check-custom form-check-solid flex-stack">
                            <span className="form-check-label text-gray-700 fs-6 fw-bold ms-0 me-2">
                              Affiliate Programs
                            </span>
                            <input
                              className="form-check-input"
                              type="checkbox"
                              defaultValue={1}
                            />
                          </label>
                        </div>
                        {/*end::Input group*/}
                        {/*begin::Input group*/}
                        <div className="py-4 border-bottom">
                          <label className="form-check form-switch form-switch-sm form-check-custom form-check-solid flex-stack">
                            <span className="form-check-label text-gray-700 fs-6 fw-bold ms-0 me-2">
                              Referrals
                            </span>
                            <input
                              className="form-check-input"
                              type="checkbox"
                              defaultValue={1}
                              defaultChecked="checked"
                            />
                          </label>
                        </div>
                        {/*end::Input group*/}
                        {/*begin::Input group*/}
                        <div className="py-4 border-bottom">
                          <label className="form-check form-switch form-switch-sm form-check-custom form-check-solid flex-stack">
                            <span className="form-check-label text-gray-700 fs-6 fw-bold ms-0 me-2">
                              Users
                            </span>
                            <input
                              className="form-check-input"
                              type="checkbox"
                              defaultValue={1}
                            />
                          </label>
                        </div>
                        {/*end::Input group*/}
                        {/*begin::Actions*/}
                        <div className="d-flex justify-content-end pt-7">
                          <button
                            type="reset"
                            className="btn btn-sm btn-light fw-bolder btn-active-light-primary me-2"
                            data-kt-search-element="preferences-dismiss"
                          >
                            Cancel
                          </button>
                          <button
                            type="submit"
                            className="btn btn-sm fw-bolder btn-primary"
                          >
                            Save Changes
                          </button>
                        </div>
                        {/*end::Actions*/}
                      </form>
                      {/*end::Preferences*/}
                    </div>
                    {/*end::Menu*/}
                  </div>
                  {/*end::Search*/}
                </div>
                {/*end::Search*/}
                {/*begin::Activities*/}
                <div className="d-flex align-items-center ms-1 ms-lg-3">
                  {/*begin::Drawer toggle*/}
                  <div
                    className="btn btn-icon btn-icon-muted btn-active-light btn-active-color-primary w-30px h-30px w-md-40px h-md-40px"
                    id="kt_activities_toggle"
                  >
                    {/*begin::Svg Icon | path: icons/duotune/general/gen032.svg*/}
                    <span className="svg-icon svg-icon-1">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <rect
                          x={8}
                          y={9}
                          width={3}
                          height={10}
                          rx="1.5"
                          fill="currentColor"
                        />
                        <rect
                          opacity="0.5"
                          x={13}
                          y={5}
                          width={3}
                          height={14}
                          rx="1.5"
                          fill="currentColor"
                        />
                        <rect
                          x={18}
                          y={11}
                          width={3}
                          height={8}
                          rx="1.5"
                          fill="currentColor"
                        />
                        <rect
                          x={3}
                          y={13}
                          width={3}
                          height={6}
                          rx="1.5"
                          fill="currentColor"
                        />
                      </svg>
                    </span>
                    {/*end::Svg Icon*/}
                  </div>
                  {/*end::Drawer toggle*/}
                </div>
                {/*end::Activities*/}
                {/*begin::Notifications*/}
                <div className="d-flex align-items-center ms-1 ms-lg-3">
                  {/*begin::Menu- wrapper*/}
                  <div
                    className="btn btn-icon btn-icon-muted btn-active-light btn-active-color-primary w-30px h-30px w-md-40px h-md-40px"
                    data-kt-menu-trigger="click"
                    data-kt-menu-attach="parent"
                    data-kt-menu-placement="bottom-end"
                  >
                    {/*begin::Svg Icon | path: icons/duotune/general/gen022.svg*/}
                    <span className="svg-icon svg-icon-1">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M11.2929 2.70711C11.6834 2.31658 12.3166 2.31658 12.7071 2.70711L15.2929 5.29289C15.6834 5.68342 15.6834 6.31658 15.2929 6.70711L12.7071 9.29289C12.3166 9.68342 11.6834 9.68342 11.2929 9.29289L8.70711 6.70711C8.31658 6.31658 8.31658 5.68342 8.70711 5.29289L11.2929 2.70711Z"
                          fill="currentColor"
                        />
                        <path
                          d="M11.2929 14.7071C11.6834 14.3166 12.3166 14.3166 12.7071 14.7071L15.2929 17.2929C15.6834 17.6834 15.6834 18.3166 15.2929 18.7071L12.7071 21.2929C12.3166 21.6834 11.6834 21.6834 11.2929 21.2929L8.70711 18.7071C8.31658 18.3166 8.31658 17.6834 8.70711 17.2929L11.2929 14.7071Z"
                          fill="currentColor"
                        />
                        <path
                          opacity="0.3"
                          d="M5.29289 8.70711C5.68342 8.31658 6.31658 8.31658 6.70711 8.70711L9.29289 11.2929C9.68342 11.6834 9.68342 12.3166 9.29289 12.7071L6.70711 15.2929C6.31658 15.6834 5.68342 15.6834 5.29289 15.2929L2.70711 12.7071C2.31658 12.3166 2.31658 11.6834 2.70711 11.2929L5.29289 8.70711Z"
                          fill="currentColor"
                        />
                        <path
                          opacity="0.3"
                          d="M17.2929 8.70711C17.6834 8.31658 18.3166 8.31658 18.7071 8.70711L21.2929 11.2929C21.6834 11.6834 21.6834 12.3166 21.2929 12.7071L18.7071 15.2929C18.3166 15.6834 17.6834 15.6834 17.2929 15.2929L14.7071 12.7071C14.3166 12.3166 14.3166 11.6834 14.7071 11.2929L17.2929 8.70711Z"
                          fill="currentColor"
                        />
                      </svg>
                    </span>
                    {/*end::Svg Icon*/}
                  </div>
                  {/*begin::Menu*/}
                  <div
                    className="menu menu-sub menu-sub-dropdown menu-column w-350px w-lg-375px"
                    data-kt-menu="true"
                  >
                    {/*begin::Heading*/}
                    <div
                      className="d-flex flex-column bgi-no-repeat rounded-top"
                      style={{
                        backgroundImage:
                          'url("/metronic8/demo1/assets/media/misc/pattern-1.jpg")',
                      }}
                    >
                      {/*begin::Title*/}
                      <h3 className="text-white fw-bold px-9 mt-10 mb-6">
                        Notifications
                        <span className="fs-8 opacity-75 ps-3">24 reports</span>
                      </h3>
                      {/*end::Title*/}
                      {/*begin::Tabs*/}
                      <ul className="nav nav-line-tabs nav-line-tabs-2x nav-stretch fw-bold px-9">
                        <li className="nav-item">
                          <a
                            className="nav-link text-white opacity-75 opacity-state-100 pb-4"
                            data-bs-toggle="tab"
                            href="#kt_topbar_notifications_1"
                          >
                            Alerts
                          </a>
                        </li>
                        <li className="nav-item">
                          <a
                            className="nav-link text-white opacity-75 opacity-state-100 pb-4 active"
                            data-bs-toggle="tab"
                            href="#kt_topbar_notifications_2"
                          >
                            Updates
                          </a>
                        </li>
                        <li className="nav-item">
                          <a
                            className="nav-link text-white opacity-75 opacity-state-100 pb-4"
                            data-bs-toggle="tab"
                            href="#kt_topbar_notifications_3"
                          >
                            Logs
                          </a>
                        </li>
                      </ul>
                      {/*end::Tabs*/}
                    </div>
                    {/*end::Heading*/}
                    {/*begin::Tab content*/}
                    <div className="tab-content">
                      {/*begin::Tab panel*/}
                      <div
                        className="tab-pane fade"
                        id="kt_topbar_notifications_1"
                        role="tabpanel"
                      >
                        {/*begin::Items*/}
                        <div className="scroll-y mh-325px my-5 px-8">
                          {/*begin::Item*/}
                          <div className="d-flex flex-stack py-4">
                            {/*begin::Section*/}
                            <div className="d-flex align-items-center">
                              {/*begin::Symbol*/}
                              <div className="symbol symbol-35px me-4">
                                <span className="symbol-label bg-light-primary">
                                  {/*begin::Svg Icon | path: icons/duotune/technology/teh008.svg*/}
                                  <span className="svg-icon svg-icon-2 svg-icon-primary">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                    >
                                      <path
                                        opacity="0.3"
                                        d="M11 6.5C11 9 9 11 6.5 11C4 11 2 9 2 6.5C2 4 4 2 6.5 2C9 2 11 4 11 6.5ZM17.5 2C15 2 13 4 13 6.5C13 9 15 11 17.5 11C20 11 22 9 22 6.5C22 4 20 2 17.5 2ZM6.5 13C4 13 2 15 2 17.5C2 20 4 22 6.5 22C9 22 11 20 11 17.5C11 15 9 13 6.5 13ZM17.5 13C15 13 13 15 13 17.5C13 20 15 22 17.5 22C20 22 22 20 22 17.5C22 15 20 13 17.5 13Z"
                                        fill="currentColor"
                                      />
                                      <path
                                        d="M17.5 16C17.5 16 17.4 16 17.5 16L16.7 15.3C16.1 14.7 15.7 13.9 15.6 13.1C15.5 12.4 15.5 11.6 15.6 10.8C15.7 9.99999 16.1 9.19998 16.7 8.59998L17.4 7.90002H17.5C18.3 7.90002 19 7.20002 19 6.40002C19 5.60002 18.3 4.90002 17.5 4.90002C16.7 4.90002 16 5.60002 16 6.40002V6.5L15.3 7.20001C14.7 7.80001 13.9 8.19999 13.1 8.29999C12.4 8.39999 11.6 8.39999 10.8 8.29999C9.99999 8.19999 9.20001 7.80001 8.60001 7.20001L7.89999 6.5V6.40002C7.89999 5.60002 7.19999 4.90002 6.39999 4.90002C5.59999 4.90002 4.89999 5.60002 4.89999 6.40002C4.89999 7.20002 5.59999 7.90002 6.39999 7.90002H6.5L7.20001 8.59998C7.80001 9.19998 8.19999 9.99999 8.29999 10.8C8.39999 11.5 8.39999 12.3 8.29999 13.1C8.19999 13.9 7.80001 14.7 7.20001 15.3L6.5 16H6.39999C5.59999 16 4.89999 16.7 4.89999 17.5C4.89999 18.3 5.59999 19 6.39999 19C7.19999 19 7.89999 18.3 7.89999 17.5V17.4L8.60001 16.7C9.20001 16.1 9.99999 15.7 10.8 15.6C11.5 15.5 12.3 15.5 13.1 15.6C13.9 15.7 14.7 16.1 15.3 16.7L16 17.4V17.5C16 18.3 16.7 19 17.5 19C18.3 19 19 18.3 19 17.5C19 16.7 18.3 16 17.5 16Z"
                                        fill="currentColor"
                                      />
                                    </svg>
                                  </span>
                                  {/*end::Svg Icon*/}
                                </span>
                              </div>
                              {/*end::Symbol*/}
                              {/*begin::Title*/}
                              <div className="mb-0 me-2">
                                <a
                                  href="#"
                                  className="fs-6 text-gray-800 text-hover-primary fw-bolder"
                                >
                                  Project Alice
                                </a>
                                <div className="text-gray-400 fs-7">
                                  Phase 1 development
                                </div>
                              </div>
                              {/*end::Title*/}
                            </div>
                            {/*end::Section*/}
                            {/*begin::Label*/}
                            <span className="badge badge-light fs-8">1 hr</span>
                            {/*end::Label*/}
                          </div>
                          {/*end::Item*/}
                          {/*begin::Item*/}
                          <div className="d-flex flex-stack py-4">
                            {/*begin::Section*/}
                            <div className="d-flex align-items-center">
                              {/*begin::Symbol*/}
                              <div className="symbol symbol-35px me-4">
                                <span className="symbol-label bg-light-danger">
                                  {/*begin::Svg Icon | path: icons/duotune/general/gen044.svg*/}
                                  <span className="svg-icon svg-icon-2 svg-icon-danger">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                    >
                                      <rect
                                        opacity="0.3"
                                        x={2}
                                        y={2}
                                        width={20}
                                        height={20}
                                        rx={10}
                                        fill="currentColor"
                                      />
                                      <rect
                                        x={11}
                                        y={14}
                                        width={7}
                                        height={2}
                                        rx={1}
                                        transform="rotate(-90 11 14)"
                                        fill="currentColor"
                                      />
                                      <rect
                                        x={11}
                                        y={17}
                                        width={2}
                                        height={2}
                                        rx={1}
                                        transform="rotate(-90 11 17)"
                                        fill="currentColor"
                                      />
                                    </svg>
                                  </span>
                                  {/*end::Svg Icon*/}
                                </span>
                              </div>
                              {/*end::Symbol*/}
                              {/*begin::Title*/}
                              <div className="mb-0 me-2">
                                <a
                                  href="#"
                                  className="fs-6 text-gray-800 text-hover-primary fw-bolder"
                                >
                                  HR Confidential
                                </a>
                                <div className="text-gray-400 fs-7">
                                  Confidential staff documents
                                </div>
                              </div>
                              {/*end::Title*/}
                            </div>
                            {/*end::Section*/}
                            {/*begin::Label*/}
                            <span className="badge badge-light fs-8">
                              2 hrs
                            </span>
                            {/*end::Label*/}
                          </div>
                          {/*end::Item*/}
                          {/*begin::Item*/}
                          <div className="d-flex flex-stack py-4">
                            {/*begin::Section*/}
                            <div className="d-flex align-items-center">
                              {/*begin::Symbol*/}
                              <div className="symbol symbol-35px me-4">
                                <span className="symbol-label bg-light-warning">
                                  {/*begin::Svg Icon | path: icons/duotune/finance/fin006.svg*/}
                                  <span className="svg-icon svg-icon-2 svg-icon-warning">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                    >
                                      <path
                                        opacity="0.3"
                                        d="M20 15H4C2.9 15 2 14.1 2 13V7C2 6.4 2.4 6 3 6H21C21.6 6 22 6.4 22 7V13C22 14.1 21.1 15 20 15ZM13 12H11C10.5 12 10 12.4 10 13V16C10 16.5 10.4 17 11 17H13C13.6 17 14 16.6 14 16V13C14 12.4 13.6 12 13 12Z"
                                        fill="currentColor"
                                      />
                                      <path
                                        d="M14 6V5H10V6H8V5C8 3.9 8.9 3 10 3H14C15.1 3 16 3.9 16 5V6H14ZM20 15H14V16C14 16.6 13.5 17 13 17H11C10.5 17 10 16.6 10 16V15H4C3.6 15 3.3 14.9 3 14.7V18C3 19.1 3.9 20 5 20H19C20.1 20 21 19.1 21 18V14.7C20.7 14.9 20.4 15 20 15Z"
                                        fill="currentColor"
                                      />
                                    </svg>
                                  </span>
                                  {/*end::Svg Icon*/}
                                </span>
                              </div>
                              {/*end::Symbol*/}
                              {/*begin::Title*/}
                              <div className="mb-0 me-2">
                                <a
                                  href="#"
                                  className="fs-6 text-gray-800 text-hover-primary fw-bolder"
                                >
                                  Company HR
                                </a>
                                <div className="text-gray-400 fs-7">
                                  Corporeate staff profiles
                                </div>
                              </div>
                              {/*end::Title*/}
                            </div>
                            {/*end::Section*/}
                            {/*begin::Label*/}
                            <span className="badge badge-light fs-8">
                              5 hrs
                            </span>
                            {/*end::Label*/}
                          </div>
                          {/*end::Item*/}
                          {/*begin::Item*/}
                          <div className="d-flex flex-stack py-4">
                            {/*begin::Section*/}
                            <div className="d-flex align-items-center">
                              {/*begin::Symbol*/}
                              <div className="symbol symbol-35px me-4">
                                <span className="symbol-label bg-light-success">
                                  {/*begin::Svg Icon | path: icons/duotune/files/fil023.svg*/}
                                  <span className="svg-icon svg-icon-2 svg-icon-success">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                    >
                                      <path
                                        opacity="0.3"
                                        d="M5 15C3.3 15 2 13.7 2 12C2 10.3 3.3 9 5 9H5.10001C5.00001 8.7 5 8.3 5 8C5 5.2 7.2 3 10 3C11.9 3 13.5 4 14.3 5.5C14.8 5.2 15.4 5 16 5C17.7 5 19 6.3 19 8C19 8.4 18.9 8.7 18.8 9C18.9 9 18.9 9 19 9C20.7 9 22 10.3 22 12C22 13.7 20.7 15 19 15H5ZM5 12.6H13L9.7 9.29999C9.3 8.89999 8.7 8.89999 8.3 9.29999L5 12.6Z"
                                        fill="currentColor"
                                      />
                                      <path
                                        d="M17 17.4V12C17 11.4 16.6 11 16 11C15.4 11 15 11.4 15 12V17.4H17Z"
                                        fill="currentColor"
                                      />
                                      <path
                                        opacity="0.3"
                                        d="M12 17.4H20L16.7 20.7C16.3 21.1 15.7 21.1 15.3 20.7L12 17.4Z"
                                        fill="currentColor"
                                      />
                                      <path
                                        d="M8 12.6V18C8 18.6 8.4 19 9 19C9.6 19 10 18.6 10 18V12.6H8Z"
                                        fill="currentColor"
                                      />
                                    </svg>
                                  </span>
                                  {/*end::Svg Icon*/}
                                </span>
                              </div>
                              {/*end::Symbol*/}
                              {/*begin::Title*/}
                              <div className="mb-0 me-2">
                                <a
                                  href="#"
                                  className="fs-6 text-gray-800 text-hover-primary fw-bolder"
                                >
                                  Project Redux
                                </a>
                                <div className="text-gray-400 fs-7">
                                  New frontend admin theme
                                </div>
                              </div>
                              {/*end::Title*/}
                            </div>
                            {/*end::Section*/}
                            {/*begin::Label*/}
                            <span className="badge badge-light fs-8">
                              2 days
                            </span>
                            {/*end::Label*/}
                          </div>
                          {/*end::Item*/}
                          {/*begin::Item*/}
                          <div className="d-flex flex-stack py-4">
                            {/*begin::Section*/}
                            <div className="d-flex align-items-center">
                              {/*begin::Symbol*/}
                              <div className="symbol symbol-35px me-4">
                                <span className="symbol-label bg-light-primary">
                                  {/*begin::Svg Icon | path: icons/duotune/maps/map001.svg*/}
                                  <span className="svg-icon svg-icon-2 svg-icon-primary">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                    >
                                      <path
                                        opacity="0.3"
                                        d="M6 22H4V3C4 2.4 4.4 2 5 2C5.6 2 6 2.4 6 3V22Z"
                                        fill="currentColor"
                                      />
                                      <path
                                        d="M18 14H4V4H18C18.8 4 19.2 4.9 18.7 5.5L16 9L18.8 12.5C19.3 13.1 18.8 14 18 14Z"
                                        fill="currentColor"
                                      />
                                    </svg>
                                  </span>
                                  {/*end::Svg Icon*/}
                                </span>
                              </div>
                              {/*end::Symbol*/}
                              {/*begin::Title*/}
                              <div className="mb-0 me-2">
                                <a
                                  href="#"
                                  className="fs-6 text-gray-800 text-hover-primary fw-bolder"
                                >
                                  Project Breafing
                                </a>
                                <div className="text-gray-400 fs-7">
                                  Product launch status update
                                </div>
                              </div>
                              {/*end::Title*/}
                            </div>
                            {/*end::Section*/}
                            {/*begin::Label*/}
                            <span className="badge badge-light fs-8">
                              21 Jan
                            </span>
                            {/*end::Label*/}
                          </div>
                          {/*end::Item*/}
                          {/*begin::Item*/}
                          <div className="d-flex flex-stack py-4">
                            {/*begin::Section*/}
                            <div className="d-flex align-items-center">
                              {/*begin::Symbol*/}
                              <div className="symbol symbol-35px me-4">
                                <span className="symbol-label bg-light-info">
                                  {/*begin::Svg Icon | path: icons/duotune/general/gen006.svg*/}
                                  <span className="svg-icon svg-icon-2 svg-icon-info">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                    >
                                      <path
                                        opacity="0.3"
                                        d="M22 5V19C22 19.6 21.6 20 21 20H19.5L11.9 12.4C11.5 12 10.9 12 10.5 12.4L3 20C2.5 20 2 19.5 2 19V5C2 4.4 2.4 4 3 4H21C21.6 4 22 4.4 22 5ZM7.5 7C6.7 7 6 7.7 6 8.5C6 9.3 6.7 10 7.5 10C8.3 10 9 9.3 9 8.5C9 7.7 8.3 7 7.5 7Z"
                                        fill="currentColor"
                                      />
                                      <path
                                        d="M19.1 10C18.7 9.60001 18.1 9.60001 17.7 10L10.7 17H2V19C2 19.6 2.4 20 3 20H21C21.6 20 22 19.6 22 19V12.9L19.1 10Z"
                                        fill="currentColor"
                                      />
                                    </svg>
                                  </span>
                                  {/*end::Svg Icon*/}
                                </span>
                              </div>
                              {/*end::Symbol*/}
                              {/*begin::Title*/}
                              <div className="mb-0 me-2">
                                <a
                                  href="#"
                                  className="fs-6 text-gray-800 text-hover-primary fw-bolder"
                                >
                                  Banner Assets
                                </a>
                                <div className="text-gray-400 fs-7">
                                  Collection of banner images
                                </div>
                              </div>
                              {/*end::Title*/}
                            </div>
                            {/*end::Section*/}
                            {/*begin::Label*/}
                            <span className="badge badge-light fs-8">
                              21 Jan
                            </span>
                            {/*end::Label*/}
                          </div>
                          {/*end::Item*/}
                          {/*begin::Item*/}
                          <div className="d-flex flex-stack py-4">
                            {/*begin::Section*/}
                            <div className="d-flex align-items-center">
                              {/*begin::Symbol*/}
                              <div className="symbol symbol-35px me-4">
                                <span className="symbol-label bg-light-warning">
                                  {/*begin::Svg Icon | path: icons/duotune/art/art002.svg*/}
                                  <span className="svg-icon svg-icon-2 svg-icon-warning">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={25}
                                      viewBox="0 0 24 25"
                                      fill="none"
                                    >
                                      <path
                                        opacity="0.3"
                                        d="M8.9 21L7.19999 22.6999C6.79999 23.0999 6.2 23.0999 5.8 22.6999L4.1 21H8.9ZM4 16.0999L2.3 17.8C1.9 18.2 1.9 18.7999 2.3 19.1999L4 20.9V16.0999ZM19.3 9.1999L15.8 5.6999C15.4 5.2999 14.8 5.2999 14.4 5.6999L9 11.0999V21L19.3 10.6999C19.7 10.2999 19.7 9.5999 19.3 9.1999Z"
                                        fill="currentColor"
                                      />
                                      <path
                                        d="M21 15V20C21 20.6 20.6 21 20 21H11.8L18.8 14H20C20.6 14 21 14.4 21 15ZM10 21V4C10 3.4 9.6 3 9 3H4C3.4 3 3 3.4 3 4V21C3 21.6 3.4 22 4 22H9C9.6 22 10 21.6 10 21ZM7.5 18.5C7.5 19.1 7.1 19.5 6.5 19.5C5.9 19.5 5.5 19.1 5.5 18.5C5.5 17.9 5.9 17.5 6.5 17.5C7.1 17.5 7.5 17.9 7.5 18.5Z"
                                        fill="currentColor"
                                      />
                                    </svg>
                                  </span>
                                  {/*end::Svg Icon*/}
                                </span>
                              </div>
                              {/*end::Symbol*/}
                              {/*begin::Title*/}
                              <div className="mb-0 me-2">
                                <a
                                  href="#"
                                  className="fs-6 text-gray-800 text-hover-primary fw-bolder"
                                >
                                  Icon Assets
                                </a>
                                <div className="text-gray-400 fs-7">
                                  Collection of SVG icons
                                </div>
                              </div>
                              {/*end::Title*/}
                            </div>
                            {/*end::Section*/}
                            {/*begin::Label*/}
                            <span className="badge badge-light fs-8">
                              20 March
                            </span>
                            {/*end::Label*/}
                          </div>
                          {/*end::Item*/}
                        </div>
                        {/*end::Items*/}
                        {/*begin::View more*/}
                        <div className="py-3 text-center border-top">
                          <a
                            href="/metronic8/demo1/../demo1/pages/user-profile/activity.html"
                            className="btn btn-color-gray-600 btn-active-color-primary"
                          >
                            View All
                            {/*begin::Svg Icon | path: icons/duotune/arrows/arr064.svg*/}
                            <span className="svg-icon svg-icon-5">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={24}
                                height={24}
                                viewBox="0 0 24 24"
                                fill="none"
                              >
                                <rect
                                  opacity="0.5"
                                  x={18}
                                  y={13}
                                  width={13}
                                  height={2}
                                  rx={1}
                                  transform="rotate(-180 18 13)"
                                  fill="currentColor"
                                />
                                <path
                                  d="M15.4343 12.5657L11.25 16.75C10.8358 17.1642 10.8358 17.8358 11.25 18.25C11.6642 18.6642 12.3358 18.6642 12.75 18.25L18.2929 12.7071C18.6834 12.3166 18.6834 11.6834 18.2929 11.2929L12.75 5.75C12.3358 5.33579 11.6642 5.33579 11.25 5.75C10.8358 6.16421 10.8358 6.83579 11.25 7.25L15.4343 11.4343C15.7467 11.7467 15.7467 12.2533 15.4343 12.5657Z"
                                  fill="currentColor"
                                />
                              </svg>
                            </span>
                            {/*end::Svg Icon*/}
                          </a>
                        </div>
                        {/*end::View more*/}
                      </div>
                      {/*end::Tab panel*/}
                      {/*begin::Tab panel*/}
                      <div
                        className="tab-pane fade show active"
                        id="kt_topbar_notifications_2"
                        role="tabpanel"
                      >
                        {/*begin::Wrapper*/}
                        <div className="d-flex flex-column px-9">
                          {/*begin::Section*/}
                          <div className="pt-10 pb-0">
                            {/*begin::Title*/}
                            <h3 className="text-dark text-center fw-bolder">
                              Get Pro Access
                            </h3>
                            {/*end::Title*/}
                            {/*begin::Text*/}
                            <div className="text-center text-gray-600 fw-bold pt-1">
                              Outlines keep you honest. They stoping you from
                              amazing poorly about drive
                            </div>
                            {/*end::Text*/}
                            {/*begin::Action*/}
                            <div className="text-center mt-5 mb-9">
                              <a
                                href="#"
                                className="btn btn-sm btn-primary px-6"
                                data-bs-toggle="modal"
                                data-bs-target="#kt_modal_upgrade_plan"
                              >
                                Upgrade
                              </a>
                            </div>
                            {/*end::Action*/}
                          </div>
                          {/*end::Section*/}
                          {/*begin::Illustration*/}
                          <div className="text-center px-4">
                            <img
                              className="mw-100 mh-200px"
                              alt="image"
                              src="/metronic8/demo1/assets/media/illustrations/sketchy-1/1.png"
                            />
                          </div>
                          {/*end::Illustration*/}
                        </div>
                        {/*end::Wrapper*/}
                      </div>
                      {/*end::Tab panel*/}
                      {/*begin::Tab panel*/}
                      <div
                        className="tab-pane fade"
                        id="kt_topbar_notifications_3"
                        role="tabpanel"
                      >
                        {/*begin::Items*/}
                        <div className="scroll-y mh-325px my-5 px-8">
                          {/*begin::Item*/}
                          <div className="d-flex flex-stack py-4">
                            {/*begin::Section*/}
                            <div className="d-flex align-items-center me-2">
                              {/*begin::Code*/}
                              <span className="w-70px badge badge-light-success me-4">
                                200 OK
                              </span>
                              {/*end::Code*/}
                              {/*begin::Title*/}
                              <a
                                href="#"
                                className="text-gray-800 text-hover-primary fw-bold"
                              >
                                New order
                              </a>
                              {/*end::Title*/}
                            </div>
                            {/*end::Section*/}
                            {/*begin::Label*/}
                            <span className="badge badge-light fs-8">
                              Just now
                            </span>
                            {/*end::Label*/}
                          </div>
                          {/*end::Item*/}
                          {/*begin::Item*/}
                          <div className="d-flex flex-stack py-4">
                            {/*begin::Section*/}
                            <div className="d-flex align-items-center me-2">
                              {/*begin::Code*/}
                              <span className="w-70px badge badge-light-danger me-4">
                                500 ERR
                              </span>
                              {/*end::Code*/}
                              {/*begin::Title*/}
                              <a
                                href="#"
                                className="text-gray-800 text-hover-primary fw-bold"
                              >
                                New customer
                              </a>
                              {/*end::Title*/}
                            </div>
                            {/*end::Section*/}
                            {/*begin::Label*/}
                            <span className="badge badge-light fs-8">
                              2 hrs
                            </span>
                            {/*end::Label*/}
                          </div>
                          {/*end::Item*/}
                          {/*begin::Item*/}
                          <div className="d-flex flex-stack py-4">
                            {/*begin::Section*/}
                            <div className="d-flex align-items-center me-2">
                              {/*begin::Code*/}
                              <span className="w-70px badge badge-light-success me-4">
                                200 OK
                              </span>
                              {/*end::Code*/}
                              {/*begin::Title*/}
                              <a
                                href="#"
                                className="text-gray-800 text-hover-primary fw-bold"
                              >
                                Payment process
                              </a>
                              {/*end::Title*/}
                            </div>
                            {/*end::Section*/}
                            {/*begin::Label*/}
                            <span className="badge badge-light fs-8">
                              5 hrs
                            </span>
                            {/*end::Label*/}
                          </div>
                          {/*end::Item*/}
                          {/*begin::Item*/}
                          <div className="d-flex flex-stack py-4">
                            {/*begin::Section*/}
                            <div className="d-flex align-items-center me-2">
                              {/*begin::Code*/}
                              <span className="w-70px badge badge-light-warning me-4">
                                300 WRN
                              </span>
                              {/*end::Code*/}
                              {/*begin::Title*/}
                              <a
                                href="#"
                                className="text-gray-800 text-hover-primary fw-bold"
                              >
                                Search query
                              </a>
                              {/*end::Title*/}
                            </div>
                            {/*end::Section*/}
                            {/*begin::Label*/}
                            <span className="badge badge-light fs-8">
                              2 days
                            </span>
                            {/*end::Label*/}
                          </div>
                          {/*end::Item*/}
                          {/*begin::Item*/}
                          <div className="d-flex flex-stack py-4">
                            {/*begin::Section*/}
                            <div className="d-flex align-items-center me-2">
                              {/*begin::Code*/}
                              <span className="w-70px badge badge-light-success me-4">
                                200 OK
                              </span>
                              {/*end::Code*/}
                              {/*begin::Title*/}
                              <a
                                href="#"
                                className="text-gray-800 text-hover-primary fw-bold"
                              >
                                API connection
                              </a>
                              {/*end::Title*/}
                            </div>
                            {/*end::Section*/}
                            {/*begin::Label*/}
                            <span className="badge badge-light fs-8">
                              1 week
                            </span>
                            {/*end::Label*/}
                          </div>
                          {/*end::Item*/}
                          {/*begin::Item*/}
                          <div className="d-flex flex-stack py-4">
                            {/*begin::Section*/}
                            <div className="d-flex align-items-center me-2">
                              {/*begin::Code*/}
                              <span className="w-70px badge badge-light-success me-4">
                                200 OK
                              </span>
                              {/*end::Code*/}
                              {/*begin::Title*/}
                              <a
                                href="#"
                                className="text-gray-800 text-hover-primary fw-bold"
                              >
                                Database restore
                              </a>
                              {/*end::Title*/}
                            </div>
                            {/*end::Section*/}
                            {/*begin::Label*/}
                            <span className="badge badge-light fs-8">
                              Mar 5
                            </span>
                            {/*end::Label*/}
                          </div>
                          {/*end::Item*/}
                          {/*begin::Item*/}
                          <div className="d-flex flex-stack py-4">
                            {/*begin::Section*/}
                            <div className="d-flex align-items-center me-2">
                              {/*begin::Code*/}
                              <span className="w-70px badge badge-light-warning me-4">
                                300 WRN
                              </span>
                              {/*end::Code*/}
                              {/*begin::Title*/}
                              <a
                                href="#"
                                className="text-gray-800 text-hover-primary fw-bold"
                              >
                                System update
                              </a>
                              {/*end::Title*/}
                            </div>
                            {/*end::Section*/}
                            {/*begin::Label*/}
                            <span className="badge badge-light fs-8">
                              May 15
                            </span>
                            {/*end::Label*/}
                          </div>
                          {/*end::Item*/}
                          {/*begin::Item*/}
                          <div className="d-flex flex-stack py-4">
                            {/*begin::Section*/}
                            <div className="d-flex align-items-center me-2">
                              {/*begin::Code*/}
                              <span className="w-70px badge badge-light-warning me-4">
                                300 WRN
                              </span>
                              {/*end::Code*/}
                              {/*begin::Title*/}
                              <a
                                href="#"
                                className="text-gray-800 text-hover-primary fw-bold"
                              >
                                Server OS update
                              </a>
                              {/*end::Title*/}
                            </div>
                            {/*end::Section*/}
                            {/*begin::Label*/}
                            <span className="badge badge-light fs-8">
                              Apr 3
                            </span>
                            {/*end::Label*/}
                          </div>
                          {/*end::Item*/}
                          {/*begin::Item*/}
                          <div className="d-flex flex-stack py-4">
                            {/*begin::Section*/}
                            <div className="d-flex align-items-center me-2">
                              {/*begin::Code*/}
                              <span className="w-70px badge badge-light-warning me-4">
                                300 WRN
                              </span>
                              {/*end::Code*/}
                              {/*begin::Title*/}
                              <a
                                href="#"
                                className="text-gray-800 text-hover-primary fw-bold"
                              >
                                API rollback
                              </a>
                              {/*end::Title*/}
                            </div>
                            {/*end::Section*/}
                            {/*begin::Label*/}
                            <span className="badge badge-light fs-8">
                              Jun 30
                            </span>
                            {/*end::Label*/}
                          </div>
                          {/*end::Item*/}
                          {/*begin::Item*/}
                          <div className="d-flex flex-stack py-4">
                            {/*begin::Section*/}
                            <div className="d-flex align-items-center me-2">
                              {/*begin::Code*/}
                              <span className="w-70px badge badge-light-danger me-4">
                                500 ERR
                              </span>
                              {/*end::Code*/}
                              {/*begin::Title*/}
                              <a
                                href="#"
                                className="text-gray-800 text-hover-primary fw-bold"
                              >
                                Refund process
                              </a>
                              {/*end::Title*/}
                            </div>
                            {/*end::Section*/}
                            {/*begin::Label*/}
                            <span className="badge badge-light fs-8">
                              Jul 10
                            </span>
                            {/*end::Label*/}
                          </div>
                          {/*end::Item*/}
                          {/*begin::Item*/}
                          <div className="d-flex flex-stack py-4">
                            {/*begin::Section*/}
                            <div className="d-flex align-items-center me-2">
                              {/*begin::Code*/}
                              <span className="w-70px badge badge-light-danger me-4">
                                500 ERR
                              </span>
                              {/*end::Code*/}
                              {/*begin::Title*/}
                              <a
                                href="#"
                                className="text-gray-800 text-hover-primary fw-bold"
                              >
                                Withdrawal process
                              </a>
                              {/*end::Title*/}
                            </div>
                            {/*end::Section*/}
                            {/*begin::Label*/}
                            <span className="badge badge-light fs-8">
                              Sep 10
                            </span>
                            {/*end::Label*/}
                          </div>
                          {/*end::Item*/}
                          {/*begin::Item*/}
                          <div className="d-flex flex-stack py-4">
                            {/*begin::Section*/}
                            <div className="d-flex align-items-center me-2">
                              {/*begin::Code*/}
                              <span className="w-70px badge badge-light-danger me-4">
                                500 ERR
                              </span>
                              {/*end::Code*/}
                              {/*begin::Title*/}
                              <a
                                href="#"
                                className="text-gray-800 text-hover-primary fw-bold"
                              >
                                Mail tasks
                              </a>
                              {/*end::Title*/}
                            </div>
                            {/*end::Section*/}
                            {/*begin::Label*/}
                            <span className="badge badge-light fs-8">
                              Dec 10
                            </span>
                            {/*end::Label*/}
                          </div>
                          {/*end::Item*/}
                        </div>
                        {/*end::Items*/}
                        {/*begin::View more*/}
                        <div className="py-3 text-center border-top">
                          <a
                            href="/metronic8/demo1/../demo1/pages/user-profile/activity.html"
                            className="btn btn-color-gray-600 btn-active-color-primary"
                          >
                            View All
                            {/*begin::Svg Icon | path: icons/duotune/arrows/arr064.svg*/}
                            <span className="svg-icon svg-icon-5">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={24}
                                height={24}
                                viewBox="0 0 24 24"
                                fill="none"
                              >
                                <rect
                                  opacity="0.5"
                                  x={18}
                                  y={13}
                                  width={13}
                                  height={2}
                                  rx={1}
                                  transform="rotate(-180 18 13)"
                                  fill="currentColor"
                                />
                                <path
                                  d="M15.4343 12.5657L11.25 16.75C10.8358 17.1642 10.8358 17.8358 11.25 18.25C11.6642 18.6642 12.3358 18.6642 12.75 18.25L18.2929 12.7071C18.6834 12.3166 18.6834 11.6834 18.2929 11.2929L12.75 5.75C12.3358 5.33579 11.6642 5.33579 11.25 5.75C10.8358 6.16421 10.8358 6.83579 11.25 7.25L15.4343 11.4343C15.7467 11.7467 15.7467 12.2533 15.4343 12.5657Z"
                                  fill="currentColor"
                                />
                              </svg>
                            </span>
                            {/*end::Svg Icon*/}
                          </a>
                        </div>
                        {/*end::View more*/}
                      </div>
                      {/*end::Tab panel*/}
                    </div>
                    {/*end::Tab content*/}
                  </div>
                  {/*end::Menu*/}
                  {/*end::Menu wrapper*/}
                </div>
                {/*end::Notifications*/}
                {/*begin::Chat*/}
                <div className="d-flex align-items-center ms-1 ms-lg-3">
                  {/*begin::Menu wrapper*/}
                  <div
                    className="btn btn-icon btn-icon-muted btn-active-light btn-active-color-primary w-30px h-30px w-md-40px h-md-40px position-relative"
                    id="kt_drawer_chat_toggle"
                  >
                    {/*begin::Svg Icon | path: icons/duotune/communication/com012.svg*/}
                    <span className="svg-icon svg-icon-1">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          opacity="0.3"
                          d="M20 3H4C2.89543 3 2 3.89543 2 5V16C2 17.1046 2.89543 18 4 18H4.5C5.05228 18 5.5 18.4477 5.5 19V21.5052C5.5 22.1441 6.21212 22.5253 6.74376 22.1708L11.4885 19.0077C12.4741 18.3506 13.6321 18 14.8167 18H20C21.1046 18 22 17.1046 22 16V5C22 3.89543 21.1046 3 20 3Z"
                          fill="currentColor"
                        />
                        <rect
                          x={6}
                          y={12}
                          width={7}
                          height={2}
                          rx={1}
                          fill="currentColor"
                        />
                        <rect
                          x={6}
                          y={7}
                          width={12}
                          height={2}
                          rx={1}
                          fill="currentColor"
                        />
                      </svg>
                    </span>
                    {/*end::Svg Icon*/}
                    <span className="bullet bullet-dot bg-success h-6px w-6px position-absolute translate-middle top-0 start-50 animation-blink" />
                  </div>
                  {/*end::Menu wrapper*/}
                </div>
                {/*end::Chat*/}
                {/*begin::Quick links*/}
                <div className="d-flex align-items-center ms-1 ms-lg-3">
                  {/*begin::Menu wrapper*/}
                  <div
                    className="btn btn-icon btn-icon-muted btn-active-light btn-active-color-primary w-30px h-30px w-md-40px h-md-40px"
                    data-kt-menu-trigger="click"
                    data-kt-menu-attach="parent"
                    data-kt-menu-placement="bottom-end"
                  >
                    {/*begin::Svg Icon | path: icons/duotune/general/gen025.svg*/}
                    <span className="svg-icon svg-icon-1">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <rect
                          x={2}
                          y={2}
                          width={9}
                          height={9}
                          rx={2}
                          fill="currentColor"
                        />
                        <rect
                          opacity="0.3"
                          x={13}
                          y={2}
                          width={9}
                          height={9}
                          rx={2}
                          fill="currentColor"
                        />
                        <rect
                          opacity="0.3"
                          x={13}
                          y={13}
                          width={9}
                          height={9}
                          rx={2}
                          fill="currentColor"
                        />
                        <rect
                          opacity="0.3"
                          x={2}
                          y={13}
                          width={9}
                          height={9}
                          rx={2}
                          fill="currentColor"
                        />
                      </svg>
                    </span>
                    {/*end::Svg Icon*/}
                  </div>
                  {/*begin::Menu*/}
                  <div
                    className="menu menu-sub menu-sub-dropdown menu-column w-250px w-lg-325px"
                    data-kt-menu="true"
                  >
                    {/*begin::Heading*/}
                    <div
                      className="d-flex flex-column flex-center bgi-no-repeat rounded-top px-9 py-10"
                      style={{
                        backgroundImage:
                          'url("/metronic8/demo1/assets/media/misc/pattern-1.jpg")',
                      }}
                    >
                      {/*begin::Title*/}
                      <h3 className="text-white fw-bold mb-3">Quick Links</h3>
                      {/*end::Title*/}
                      {/*begin::Status*/}
                      <span className="badge bg-primary py-2 px-3">
                        25 pending tasks
                      </span>
                      {/*end::Status*/}
                    </div>
                    {/*end::Heading*/}
                    {/*begin:Nav*/}
                    <div className="row g-0">
                      {/*begin:Item*/}
                      <div className="col-6">
                        <a
                          href="/metronic8/demo1/../demo1/apps/projects/budget.html"
                          className="d-flex flex-column flex-center h-100 p-6 bg-hover-light border-end border-bottom"
                        >
                          {/*begin::Svg Icon | path: icons/duotune/finance/fin009.svg*/}
                          <span className="svg-icon svg-icon-3x svg-icon-primary mb-2">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width={24}
                              height={24}
                              viewBox="0 0 24 24"
                              fill="none"
                            >
                              <path
                                opacity="0.3"
                                d="M15.8 11.4H6C5.4 11.4 5 11 5 10.4C5 9.80002 5.4 9.40002 6 9.40002H15.8C16.4 9.40002 16.8 9.80002 16.8 10.4C16.8 11 16.3 11.4 15.8 11.4ZM15.7 13.7999C15.7 13.1999 15.3 12.7999 14.7 12.7999H6C5.4 12.7999 5 13.1999 5 13.7999C5 14.3999 5.4 14.7999 6 14.7999H14.8C15.3 14.7999 15.7 14.2999 15.7 13.7999Z"
                                fill="currentColor"
                              />
                              <path
                                d="M18.8 15.5C18.9 15.7 19 15.9 19.1 16.1C19.2 16.7 18.7 17.2 18.4 17.6C17.9 18.1 17.3 18.4999 16.6 18.7999C15.9 19.0999 15 19.2999 14.1 19.2999C13.4 19.2999 12.7 19.2 12.1 19.1C11.5 19 11 18.7 10.5 18.5C10 18.2 9.60001 17.7999 9.20001 17.2999C8.80001 16.8999 8.49999 16.3999 8.29999 15.7999C8.09999 15.1999 7.80001 14.7 7.70001 14.1C7.60001 13.5 7.5 12.8 7.5 12.2C7.5 11.1 7.7 10.1 8 9.19995C8.3 8.29995 8.79999 7.60002 9.39999 6.90002C9.99999 6.30002 10.7 5.8 11.5 5.5C12.3 5.2 13.2 5 14.1 5C15.2 5 16.2 5.19995 17.1 5.69995C17.8 6.09995 18.7 6.6 18.8 7.5C18.8 7.9 18.6 8.29998 18.3 8.59998C18.2 8.69998 18.1 8.69993 18 8.79993C17.7 8.89993 17.4 8.79995 17.2 8.69995C16.7 8.49995 16.5 7.99995 16 7.69995C15.5 7.39995 14.9 7.19995 14.2 7.19995C13.1 7.19995 12.1 7.6 11.5 8.5C10.9 9.4 10.5 10.6 10.5 12.2C10.5 13.3 10.7 14.2 11 14.9C11.3 15.6 11.7 16.1 12.3 16.5C12.9 16.9 13.5 17 14.2 17C15 17 15.7 16.8 16.2 16.4C16.8 16 17.2 15.2 17.9 15.1C18 15 18.5 15.2 18.8 15.5Z"
                                fill="currentColor"
                              />
                            </svg>
                          </span>
                          {/*end::Svg Icon*/}
                          <span className="fs-5 fw-bold text-gray-800 mb-0">
                            Accounting
                          </span>
                          <span className="fs-7 text-gray-400">eCommerce</span>
                        </a>
                      </div>
                      {/*end:Item*/}
                      {/*begin:Item*/}
                      <div className="col-6">
                        <a
                          href="/metronic8/demo1/../demo1/apps/projects/settings.html"
                          className="d-flex flex-column flex-center h-100 p-6 bg-hover-light border-bottom"
                        >
                          {/*begin::Svg Icon | path: icons/duotune/communication/com010.svg*/}
                          <span className="svg-icon svg-icon-3x svg-icon-primary mb-2">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width={24}
                              height={24}
                              viewBox="0 0 24 24"
                              fill="none"
                            >
                              <path
                                d="M6 8.725C6 8.125 6.4 7.725 7 7.725H14L18 11.725V12.925L22 9.725L12.6 2.225C12.2 1.925 11.7 1.925 11.4 2.225L2 9.725L6 12.925V8.725Z"
                                fill="currentColor"
                              />
                              <path
                                opacity="0.3"
                                d="M22 9.72498V20.725C22 21.325 21.6 21.725 21 21.725H3C2.4 21.725 2 21.325 2 20.725V9.72498L11.4 17.225C11.8 17.525 12.3 17.525 12.6 17.225L22 9.72498ZM15 11.725H18L14 7.72498V10.725C14 11.325 14.4 11.725 15 11.725Z"
                                fill="currentColor"
                              />
                            </svg>
                          </span>
                          {/*end::Svg Icon*/}
                          <span className="fs-5 fw-bold text-gray-800 mb-0">
                            Administration
                          </span>
                          <span className="fs-7 text-gray-400">Console</span>
                        </a>
                      </div>
                      {/*end:Item*/}
                      {/*begin:Item*/}
                      <div className="col-6">
                        <a
                          href="/metronic8/demo1/../demo1/apps/projects/list.html"
                          className="d-flex flex-column flex-center h-100 p-6 bg-hover-light border-end"
                        >
                          {/*begin::Svg Icon | path: icons/duotune/abstract/abs042.svg*/}
                          <span className="svg-icon svg-icon-3x svg-icon-primary mb-2">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width={24}
                              height={24}
                              viewBox="0 0 24 24"
                              fill="none"
                            >
                              <path
                                d="M18 21.6C16.6 20.4 9.1 20.3 6.3 21.2C5.7 21.4 5.1 21.2 4.7 20.8L2 18C4.2 15.8 10.8 15.1 15.8 15.8C16.2 18.3 17 20.5 18 21.6ZM18.8 2.8C18.4 2.4 17.8 2.20001 17.2 2.40001C14.4 3.30001 6.9 3.2 5.5 2C6.8 3.3 7.4 5.5 7.7 7.7C9 7.9 10.3 8 11.7 8C15.8 8 19.8 7.2 21.5 5.5L18.8 2.8Z"
                                fill="currentColor"
                              />
                              <path
                                opacity="0.3"
                                d="M21.2 17.3C21.4 17.9 21.2 18.5 20.8 18.9L18 21.6C15.8 19.4 15.1 12.8 15.8 7.8C18.3 7.4 20.4 6.70001 21.5 5.60001C20.4 7.00001 20.2 14.5 21.2 17.3ZM8 11.7C8 9 7.7 4.2 5.5 2L2.8 4.8C2.4 5.2 2.2 5.80001 2.4 6.40001C2.7 7.40001 3.00001 9.2 3.10001 11.7C3.10001 15.5 2.40001 17.6 2.10001 18C3.20001 16.9 5.3 16.2 7.8 15.8C8 14.2 8 12.7 8 11.7Z"
                                fill="currentColor"
                              />
                            </svg>
                          </span>
                          {/*end::Svg Icon*/}
                          <span className="fs-5 fw-bold text-gray-800 mb-0">
                            Projects
                          </span>
                          <span className="fs-7 text-gray-400">
                            Pending Tasks
                          </span>
                        </a>
                      </div>
                      {/*end:Item*/}
                      {/*begin:Item*/}
                      <div className="col-6">
                        <a
                          href="/metronic8/demo1/../demo1/apps/projects/users.html"
                          className="d-flex flex-column flex-center h-100 p-6 bg-hover-light"
                        >
                          {/*begin::Svg Icon | path: icons/duotune/finance/fin006.svg*/}
                          <span className="svg-icon svg-icon-3x svg-icon-primary mb-2">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width={24}
                              height={24}
                              viewBox="0 0 24 24"
                              fill="none"
                            >
                              <path
                                opacity="0.3"
                                d="M20 15H4C2.9 15 2 14.1 2 13V7C2 6.4 2.4 6 3 6H21C21.6 6 22 6.4 22 7V13C22 14.1 21.1 15 20 15ZM13 12H11C10.5 12 10 12.4 10 13V16C10 16.5 10.4 17 11 17H13C13.6 17 14 16.6 14 16V13C14 12.4 13.6 12 13 12Z"
                                fill="currentColor"
                              />
                              <path
                                d="M14 6V5H10V6H8V5C8 3.9 8.9 3 10 3H14C15.1 3 16 3.9 16 5V6H14ZM20 15H14V16C14 16.6 13.5 17 13 17H11C10.5 17 10 16.6 10 16V15H4C3.6 15 3.3 14.9 3 14.7V18C3 19.1 3.9 20 5 20H19C20.1 20 21 19.1 21 18V14.7C20.7 14.9 20.4 15 20 15Z"
                                fill="currentColor"
                              />
                            </svg>
                          </span>
                          {/*end::Svg Icon*/}
                          <span className="fs-5 fw-bold text-gray-800 mb-0">
                            Customers
                          </span>
                          <span className="fs-7 text-gray-400">
                            Latest cases
                          </span>
                        </a>
                      </div>
                      {/*end:Item*/}
                    </div>
                    {/*end:Nav*/}
                    {/*begin::View more*/}
                    <div className="py-2 text-center border-top">
                      <a
                        href="/metronic8/demo1/../demo1/pages/user-profile/activity.html"
                        className="btn btn-color-gray-600 btn-active-color-primary"
                      >
                        View All
                        {/*begin::Svg Icon | path: icons/duotune/arrows/arr064.svg*/}
                        <span className="svg-icon svg-icon-5">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width={24}
                            height={24}
                            viewBox="0 0 24 24"
                            fill="none"
                          >
                            <rect
                              opacity="0.5"
                              x={18}
                              y={13}
                              width={13}
                              height={2}
                              rx={1}
                              transform="rotate(-180 18 13)"
                              fill="currentColor"
                            />
                            <path
                              d="M15.4343 12.5657L11.25 16.75C10.8358 17.1642 10.8358 17.8358 11.25 18.25C11.6642 18.6642 12.3358 18.6642 12.75 18.25L18.2929 12.7071C18.6834 12.3166 18.6834 11.6834 18.2929 11.2929L12.75 5.75C12.3358 5.33579 11.6642 5.33579 11.25 5.75C10.8358 6.16421 10.8358 6.83579 11.25 7.25L15.4343 11.4343C15.7467 11.7467 15.7467 12.2533 15.4343 12.5657Z"
                              fill="currentColor"
                            />
                          </svg>
                        </span>
                        {/*end::Svg Icon*/}
                      </a>
                    </div>
                    {/*end::View more*/}
                  </div>
                  {/*end::Menu*/}
                  {/*end::Menu wrapper*/}
                </div>
                {/*end::Quick links*/}
                {/*begin::Theme mode*/}
                <div className="d-flex align-items-center ms-1 ms-lg-3">
                  {/*begin::Menu toggle*/}
                  <a
                    href="#"
                    className="btn btn-icon btn-icon-muted btn-active-light btn-active-color-primary w-30px h-30px w-md-40px h-md-40px"
                    data-kt-menu-trigger="click"
                    data-kt-menu-attach="parent"
                    data-kt-menu-placement="bottom-end"
                    data-kt-menu-flip="bottom"
                  >
                    <i className="fonticon-sun fs-2" />
                    <i className="fonticon-moon fs-2 d-none" />
                  </a>
                  {/*begin::Menu toggle*/}
                  {/*begin::Menu*/}
                  <div
                    className="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-title-gray-700 menu-icon-muted menu-active-bg menu-state-primary fw-bold py-4 fs-6 w-200px"
                    data-kt-menu="true"
                  >
                    {/*begin::Menu item*/}
                    <div className="menu-item px-3 my-1">
                      <a
                        href="/metronic8/demo1/../demo1/index.html"
                        className="menu-link px-3 active"
                      >
                        <span className="menu-icon">
                          <i className="fonticon-sun fs-2" />
                        </span>
                        <span className="menu-title">Light</span>
                      </a>
                    </div>
                    {/*end::Menu item*/}
                    {/*begin::Menu item*/}
                    <div className="menu-item px-3 my-1">
                      <a
                        href="/metronic8/demo1/../demo1/dark/index.html"
                        className="menu-link px-3"
                      >
                        <span className="menu-icon">
                          <i className="fonticon-moon fs-2" />
                        </span>
                        <span className="menu-title">Dark</span>
                      </a>
                    </div>
                    {/*end::Menu item*/}
                  </div>
                  {/*end::Menu*/}
                </div>
                {/*end::Theme mode*/}
                {/*begin::User menu*/}
                <div
                  className="d-flex align-items-center ms-1 ms-lg-3"
                  id="kt_header_user_menu_toggle"
                >
                  {/*begin::Menu wrapper*/}
                  <div
                    className="cursor-pointer symbol symbol-30px symbol-md-40px"
                    data-kt-menu-trigger="click"
                    data-kt-menu-attach="parent"
                    data-kt-menu-placement="bottom-end"
                  >
                    <img
                      src="/metronic8/demo1/assets/media/avatars/300-1.jpg"
                      alt="user"
                    />
                  </div>
                  {/*begin::User account menu*/}
                  <div
                    className="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-275px"
                    data-kt-menu="true"
                  >
                    {/*begin::Menu item*/}
                    <div className="menu-item px-3">
                      <div className="menu-content d-flex align-items-center px-3">
                        {/*begin::Avatar*/}
                        <div className="symbol symbol-50px me-5">
                          <img
                            alt="Logo"
                            src="/metronic8/demo1/assets/media/avatars/300-1.jpg"
                          />
                        </div>
                        {/*end::Avatar*/}
                        {/*begin::Username*/}
                        <div className="d-flex flex-column">
                          <div className="fw-bolder d-flex align-items-center fs-5">
                            Max Smith
                            <span className="badge badge-light-success fw-bolder fs-8 px-2 py-1 ms-2">
                              Pro
                            </span>
                          </div>
                          <a
                            href="#"
                            className="fw-bold text-muted text-hover-primary fs-7"
                          >
                            max@kt.com
                          </a>
                        </div>
                        {/*end::Username*/}
                      </div>
                    </div>
                    {/*end::Menu item*/}
                    {/*begin::Menu separator*/}
                    <div className="separator my-2" />
                    {/*end::Menu separator*/}
                    {/*begin::Menu item*/}
                    <div className="menu-item px-5">
                      <a
                        href="/metronic8/demo1/../demo1/account/overview.html"
                        className="menu-link px-5"
                      >
                        My Profile
                      </a>
                    </div>
                    {/*end::Menu item*/}
                    {/*begin::Menu item*/}
                    <div className="menu-item px-5">
                      <a
                        href="/metronic8/demo1/../demo1/apps/projects/list.html"
                        className="menu-link px-5"
                      >
                        <span className="menu-text">My Projects</span>
                        <span className="menu-badge">
                          <span className="badge badge-light-danger badge-circle fw-bolder fs-7">
                            3
                          </span>
                        </span>
                      </a>
                    </div>
                    {/*end::Menu item*/}
                    {/*begin::Menu item*/}
                    <div
                      className="menu-item px-5"
                      data-kt-menu-trigger="hover"
                      data-kt-menu-placement="left-start"
                    >
                      <a href="#" className="menu-link px-5">
                        <span className="menu-title">My Subscription</span>
                        <span className="menu-arrow" />
                      </a>
                      {/*begin::Menu sub*/}
                      <div className="menu-sub menu-sub-dropdown w-175px py-4">
                        {/*begin::Menu item*/}
                        <div className="menu-item px-3">
                          <a
                            href="/metronic8/demo1/../demo1/account/referrals.html"
                            className="menu-link px-5"
                          >
                            Referrals
                          </a>
                        </div>
                        {/*end::Menu item*/}
                        {/*begin::Menu item*/}
                        <div className="menu-item px-3">
                          <a
                            href="/metronic8/demo1/../demo1/account/billing.html"
                            className="menu-link px-5"
                          >
                            Billing
                          </a>
                        </div>
                        {/*end::Menu item*/}
                        {/*begin::Menu item*/}
                        <div className="menu-item px-3">
                          <a
                            href="/metronic8/demo1/../demo1/account/statements.html"
                            className="menu-link px-5"
                          >
                            Payments
                          </a>
                        </div>
                        {/*end::Menu item*/}
                        {/*begin::Menu item*/}
                        <div className="menu-item px-3">
                          <a
                            href="/metronic8/demo1/../demo1/account/statements.html"
                            className="menu-link d-flex flex-stack px-5"
                          >
                            Statements
                            <i
                              className="fas fa-exclamation-circle ms-2 fs-7"
                              data-bs-toggle="tooltip"
                              title
                              data-bs-original-title="View your statements"
                              aria-label="View your statements"
                            />
                          </a>
                        </div>
                        {/*end::Menu item*/}
                        {/*begin::Menu separator*/}
                        <div className="separator my-2" />
                        {/*end::Menu separator*/}
                        {/*begin::Menu item*/}
                        <div className="menu-item px-3">
                          <div className="menu-content px-3">
                            <label className="form-check form-switch form-check-custom form-check-solid">
                              <input
                                className="form-check-input w-30px h-20px"
                                type="checkbox"
                                defaultValue={1}
                                defaultChecked="checked"
                                name="notifications"
                              />
                              <span className="form-check-label text-muted fs-7">
                                Notifications
                              </span>
                            </label>
                          </div>
                        </div>
                        {/*end::Menu item*/}
                      </div>
                      {/*end::Menu sub*/}
                    </div>
                    {/*end::Menu item*/}
                    {/*begin::Menu item*/}
                    <div className="menu-item px-5">
                      <a
                        href="/metronic8/demo1/../demo1/account/statements.html"
                        className="menu-link px-5"
                      >
                        My Statements
                      </a>
                    </div>
                    {/*end::Menu item*/}
                    {/*begin::Menu separator*/}
                    <div className="separator my-2" />
                    {/*end::Menu separator*/}
                    {/*begin::Menu item*/}
                    <div
                      className="menu-item px-5"
                      data-kt-menu-trigger="hover"
                      data-kt-menu-placement="left-start"
                    >
                      <a href="#" className="menu-link px-5">
                        <span className="menu-title position-relative">
                          Language
                          <span className="fs-8 rounded bg-light px-3 py-2 position-absolute translate-middle-y top-50 end-0">
                            English
                            <img
                              className="w-15px h-15px rounded-1 ms-2"
                              src="/metronic8/demo1/assets/media/flags/united-states.svg"
                              alt=""
                            />
                          </span>
                        </span>
                      </a>
                      {/*begin::Menu sub*/}
                      <div className="menu-sub menu-sub-dropdown w-175px py-4">
                        {/*begin::Menu item*/}
                        <div className="menu-item px-3">
                          <a
                            href="/metronic8/demo1/../demo1/account/settings.html"
                            className="menu-link d-flex px-5 active"
                          >
                            <span className="symbol symbol-20px me-4">
                              <img
                                className="rounded-1"
                                src="/metronic8/demo1/assets/media/flags/united-states.svg"
                                alt=""
                              />
                            </span>
                            English
                          </a>
                        </div>
                        {/*end::Menu item*/}
                        {/*begin::Menu item*/}
                        <div className="menu-item px-3">
                          <a
                            href="/metronic8/demo1/../demo1/account/settings.html"
                            className="menu-link d-flex px-5"
                          >
                            <span className="symbol symbol-20px me-4">
                              <img
                                className="rounded-1"
                                src="/metronic8/demo1/assets/media/flags/spain.svg"
                                alt=""
                              />
                            </span>
                            Spanish
                          </a>
                        </div>
                        {/*end::Menu item*/}
                        {/*begin::Menu item*/}
                        <div className="menu-item px-3">
                          <a
                            href="/metronic8/demo1/../demo1/account/settings.html"
                            className="menu-link d-flex px-5"
                          >
                            <span className="symbol symbol-20px me-4">
                              <img
                                className="rounded-1"
                                src="/metronic8/demo1/assets/media/flags/germany.svg"
                                alt=""
                              />
                            </span>
                            German
                          </a>
                        </div>
                        {/*end::Menu item*/}
                        {/*begin::Menu item*/}
                        <div className="menu-item px-3">
                          <a
                            href="/metronic8/demo1/../demo1/account/settings.html"
                            className="menu-link d-flex px-5"
                          >
                            <span className="symbol symbol-20px me-4">
                              <img
                                className="rounded-1"
                                src="/metronic8/demo1/assets/media/flags/japan.svg"
                                alt=""
                              />
                            </span>
                            Japanese
                          </a>
                        </div>
                        {/*end::Menu item*/}
                        {/*begin::Menu item*/}
                        <div className="menu-item px-3">
                          <a
                            href="/metronic8/demo1/../demo1/account/settings.html"
                            className="menu-link d-flex px-5"
                          >
                            <span className="symbol symbol-20px me-4">
                              <img
                                className="rounded-1"
                                src="/metronic8/demo1/assets/media/flags/france.svg"
                                alt=""
                              />
                            </span>
                            French
                          </a>
                        </div>
                        {/*end::Menu item*/}
                      </div>
                      {/*end::Menu sub*/}
                    </div>
                    {/*end::Menu item*/}
                    {/*begin::Menu item*/}
                    <div className="menu-item px-5 my-1">
                      <a
                        href="/metronic8/demo1/../demo1/account/settings.html"
                        className="menu-link px-5"
                      >
                        Account Settings
                      </a>
                    </div>
                    {/*end::Menu item*/}
                    {/*begin::Menu item*/}
                    <div className="menu-item px-5">
                      <a
                        href="/metronic8/demo1/../demo1/authentication/flows/basic/sign-in.html"
                        className="menu-link px-5"
                      >
                        Sign Out
                      </a>
                    </div>
                    {/*end::Menu item*/}
                    {/*begin::Menu separator*/}
                    <div className="separator my-2" />
                    {/*end::Menu separator*/}
                    {/*begin::Menu item*/}
                    <div className="menu-item px-5">
                      <div className="menu-content px-5">
                        <label
                          className="form-check form-switch form-check-custom form-check-solid pulse pulse-success"
                          htmlFor="kt_user_menu_dark_mode_toggle"
                        >
                          <input
                            className="form-check-input w-30px h-20px"
                            type="checkbox"
                            defaultValue={1}
                            name="mode"
                            id="kt_user_menu_dark_mode_toggle"
                            data-kt-url="/metronic8/demo1/../demo1/dark/index.html"
                          />
                          <span className="pulse-ring ms-n1" />
                          <span className="form-check-label text-gray-600 fs-7">
                            Dark Mode
                          </span>
                        </label>
                      </div>
                    </div>
                    {/*end::Menu item*/}
                  </div>
                  {/*end::User account menu*/}
                  {/*end::Menu wrapper*/}
                </div>
                {/*end::User menu*/}
                {/*begin::Header menu toggle*/}
                <div
                  className="d-flex align-items-center d-lg-none ms-2 me-n3"
                  title="Show header menu"
                >
                  <div
                    className="btn btn-icon btn-active-light-primary w-30px h-30px w-md-40px h-md-40px"
                    id="kt_header_menu_mobile_toggle"
                  >
                    {/*begin::Svg Icon | path: icons/duotune/text/txt001.svg*/}
                    <span className="svg-icon svg-icon-1">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M13 11H3C2.4 11 2 10.6 2 10V9C2 8.4 2.4 8 3 8H13C13.6 8 14 8.4 14 9V10C14 10.6 13.6 11 13 11ZM22 5V4C22 3.4 21.6 3 21 3H3C2.4 3 2 3.4 2 4V5C2 5.6 2.4 6 3 6H21C21.6 6 22 5.6 22 5Z"
                          fill="currentColor"
                        />
                        <path
                          opacity="0.3"
                          d="M21 16H3C2.4 16 2 15.6 2 15V14C2 13.4 2.4 13 3 13H21C21.6 13 22 13.4 22 14V15C22 15.6 21.6 16 21 16ZM14 20V19C14 18.4 13.6 18 13 18H3C2.4 18 2 18.4 2 19V20C2 20.6 2.4 21 3 21H13C13.6 21 14 20.6 14 20Z"
                          fill="currentColor"
                        />
                      </svg>
                    </span>
                    {/*end::Svg Icon*/}
                  </div>
                </div>
                {/*end::Header menu toggle*/}
              </div>
              {/*end::Toolbar wrapper*/}
            </div>
            {/*end::Wrapper*/}
          </div>
          {/*end::Container*/}
        </div>
        {/*end::Header*/}
        {/*begin::Content*/}
        <div
          className="content d-flex flex-column flex-column-fluid"
          id="kt_content"
        >
          {/*begin::Toolbar*/}
          <div className="toolbar" id="kt_toolbar">
            {/*begin::Container*/}
            <div
              id="kt_toolbar_container"
              className="container-fluid d-flex flex-stack"
            >
              {/*begin::Page title*/}
              <div
                data-kt-swapper="true"
                data-kt-swapper-mode="prepend"
                data-kt-swapper-parent="{default: '#kt_content_container', 'lg': '#kt_toolbar_container'}"
                className="page-title d-flex align-items-center flex-wrap me-3 mb-5 mb-lg-0"
              >
                {/*begin::Title*/}
                <h1 className="d-flex text-dark fw-bolder fs-3 align-items-center my-1">
                  Dashboard
                  {/*begin::Separator*/}
                  <span className="h-20px border-1 border-gray-200 border-start ms-3 mx-2 me-1" />
                  {/*end::Separator*/}
                  {/*begin::Description*/}
                  <span className="text-muted fs-7 fw-bold mt-2">
                    #XRS-45670
                  </span>
                  {/*end::Description*/}
                </h1>
                {/*end::Title*/}
              </div>
              {/*end::Page title*/}
              {/*begin::Actions*/}
              <div className="d-flex align-items-center gap-2 gap-lg-3">
                {/*begin::Filter menu*/}
                <div className="m-0">
                  {/*begin::Menu toggle*/}
                  <a
                    href="#"
                    className="btn btn-sm btn-flex btn-light btn-active-primary fw-bolder"
                    data-kt-menu-trigger="click"
                    data-kt-menu-placement="bottom-end"
                  >
                    {/*begin::Svg Icon | path: icons/duotune/general/gen031.svg*/}
                    <span className="svg-icon svg-icon-5 svg-icon-gray-500 me-1">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M19.0759 3H4.72777C3.95892 3 3.47768 3.83148 3.86067 4.49814L8.56967 12.6949C9.17923 13.7559 9.5 14.9582 9.5 16.1819V19.5072C9.5 20.2189 10.2223 20.7028 10.8805 20.432L13.8805 19.1977C14.2553 19.0435 14.5 18.6783 14.5 18.273V13.8372C14.5 12.8089 14.8171 11.8056 15.408 10.964L19.8943 4.57465C20.3596 3.912 19.8856 3 19.0759 3Z"
                          fill="currentColor"
                        />
                      </svg>
                    </span>
                    {/*end::Svg Icon*/}Filter
                  </a>
                  {/*end::Menu toggle*/}
                  {/*begin::Menu 1*/}
                  <div
                    className="menu menu-sub menu-sub-dropdown w-250px w-md-300px"
                    data-kt-menu="true"
                    id="kt_menu_6247115a68fd3"
                  >
                    {/*begin::Header*/}
                    <div className="px-7 py-5">
                      <div className="fs-5 text-dark fw-bolder">
                        Filter Options
                      </div>
                    </div>
                    {/*end::Header*/}
                    {/*begin::Menu separator*/}
                    <div className="separator border-gray-200" />
                    {/*end::Menu separator*/}
                    {/*begin::Form*/}
                    <div className="px-7 py-5">
                      {/*begin::Input group*/}
                      <div className="mb-10">
                        {/*begin::Label*/}
                        <label className="form-label fw-bold">Status:</label>
                        {/*end::Label*/}
                        {/*begin::Input*/}
                        <div>
                          <select
                            className="form-select form-select-solid select2-hidden-accessible"
                            data-kt-select2="true"
                            data-placeholder="Select option"
                            data-dropdown-parent="#kt_menu_6247115a68fd3"
                            data-allow-clear="true"
                            data-select2-id="select2-data-7-x1ds"
                            tabIndex={-1}
                            aria-hidden="true"
                          >
                            <option data-select2-id="select2-data-9-tthd" />
                            <option value={1}>Approved</option>
                            <option value={2}>Pending</option>
                            <option value={2}>In Process</option>
                            <option value={2}>Rejected</option>
                          </select>
                          <span
                            className="select2 select2-container select2-container--bootstrap5"
                            dir="ltr"
                            data-select2-id="select2-data-8-0e6l"
                            style={{ width: "100%" }}
                          >
                            <span className="selection">
                              <span
                                className="select2-selection select2-selection--single form-select form-select-solid"
                                role="combobox"
                                aria-haspopup="true"
                                aria-expanded="false"
                                tabIndex={0}
                                aria-disabled="false"
                                aria-labelledby="select2-c2ow-container"
                                aria-controls="select2-c2ow-container"
                              >
                                <span
                                  className="select2-selection__rendered"
                                  id="select2-c2ow-container"
                                  role="textbox"
                                  aria-readonly="true"
                                  title="Select option"
                                >
                                  <span className="select2-selection__placeholder">
                                    Select option
                                  </span>
                                </span>
                                <span
                                  className="select2-selection__arrow"
                                  role="presentation"
                                >
                                  <b role="presentation" />
                                </span>
                              </span>
                            </span>
                            <span
                              className="dropdown-wrapper"
                              aria-hidden="true"
                            />
                          </span>
                        </div>
                        {/*end::Input*/}
                      </div>
                      {/*end::Input group*/}
                      {/*begin::Input group*/}
                      <div className="mb-10">
                        {/*begin::Label*/}
                        <label className="form-label fw-bold">
                          Member Type:
                        </label>
                        {/*end::Label*/}
                        {/*begin::Options*/}
                        <div className="d-flex">
                          {/*begin::Options*/}
                          <label className="form-check form-check-sm form-check-custom form-check-solid me-5">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              defaultValue={1}
                            />
                            <span className="form-check-label">Author</span>
                          </label>
                          {/*end::Options*/}
                          {/*begin::Options*/}
                          <label className="form-check form-check-sm form-check-custom form-check-solid">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              defaultValue={2}
                              defaultChecked="checked"
                            />
                            <span className="form-check-label">Customer</span>
                          </label>
                          {/*end::Options*/}
                        </div>
                        {/*end::Options*/}
                      </div>
                      {/*end::Input group*/}
                      {/*begin::Input group*/}
                      <div className="mb-10">
                        {/*begin::Label*/}
                        <label className="form-label fw-bold">
                          Notifications:
                        </label>
                        {/*end::Label*/}
                        {/*begin::Switch*/}
                        <div className="form-check form-switch form-switch-sm form-check-custom form-check-solid">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            defaultValue
                            name="notifications"
                            defaultChecked="checked"
                          />
                          <label className="form-check-label">Enabled</label>
                        </div>
                        {/*end::Switch*/}
                      </div>
                      {/*end::Input group*/}
                      {/*begin::Actions*/}
                      <div className="d-flex justify-content-end">
                        <button
                          type="reset"
                          className="btn btn-sm btn-light btn-active-light-primary me-2"
                          data-kt-menu-dismiss="true"
                        >
                          Reset
                        </button>
                        <button
                          type="submit"
                          className="btn btn-sm btn-primary"
                          data-kt-menu-dismiss="true"
                        >
                          Apply
                        </button>
                      </div>
                      {/*end::Actions*/}
                    </div>
                    {/*end::Form*/}
                  </div>
                  {/*end::Menu 1*/}
                </div>
                {/*end::Filter menu*/}
                {/*begin::Secondary button*/}
                {/*end::Secondary button*/}
                {/*begin::Primary button*/}
                <a
                  href="/metronic8/demo1/../demo1/.html"
                  className="btn btn-sm btn-primary"
                  data-bs-toggle="modal"
                  data-bs-target="#kt_modal_create_app"
                >
                  Create
                </a>
                {/*end::Primary button*/}
              </div>
              {/*end::Actions*/}
            </div>
            {/*end::Container*/}
          </div>
          {/*end::Toolbar*/}
          {/*begin::Post*/}
          <div className="post d-flex flex-column-fluid" id="kt_post">
            {/*begin::Container*/}
            <div id="kt_content_container" className="container-xxl">
              {/*begin::Row*/}
              <div className="row gy-5 g-xl-8">
                {/*begin::Col*/}
                <div className="col-xl-4">
                  {/*begin::Mixed Widget 2*/}
                  <div className="card card-xl-stretch">
                    {/*begin::Header*/}
                    <div className="card-header border-0 bg-danger py-5">
                      <h3 className="card-title fw-bolder text-white">
                        Sales Statistics
                      </h3>
                      <div className="card-toolbar">
                        {/*begin::Menu*/}
                        <button
                          type="button"
                          className="btn btn-sm btn-icon btn-color-white btn-active-white btn-active-color- border-0 me-n3"
                          data-kt-menu-trigger="click"
                          data-kt-menu-placement="bottom-end"
                        >
                          {/*begin::Svg Icon | path: icons/duotune/general/gen024.svg*/}
                          <span className="svg-icon svg-icon-2">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24px"
                              height="24px"
                              viewBox="0 0 24 24"
                            >
                              <g
                                stroke="none"
                                strokeWidth={1}
                                fill="none"
                                fillRule="evenodd"
                              >
                                <rect
                                  x={5}
                                  y={5}
                                  width={5}
                                  height={5}
                                  rx={1}
                                  fill="currentColor"
                                />
                                <rect
                                  x={14}
                                  y={5}
                                  width={5}
                                  height={5}
                                  rx={1}
                                  fill="currentColor"
                                  opacity="0.3"
                                />
                                <rect
                                  x={5}
                                  y={14}
                                  width={5}
                                  height={5}
                                  rx={1}
                                  fill="currentColor"
                                  opacity="0.3"
                                />
                                <rect
                                  x={14}
                                  y={14}
                                  width={5}
                                  height={5}
                                  rx={1}
                                  fill="currentColor"
                                  opacity="0.3"
                                />
                              </g>
                            </svg>
                          </span>
                          {/*end::Svg Icon*/}
                        </button>
                        {/*begin::Menu 3*/}
                        <div
                          className="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg-light-primary fw-bold w-200px py-3"
                          data-kt-menu="true"
                        >
                          {/*begin::Heading*/}
                          <div className="menu-item px-3">
                            <div className="menu-content text-muted pb-2 px-3 fs-7 text-uppercase">
                              Payments
                            </div>
                          </div>
                          {/*end::Heading*/}
                          {/*begin::Menu item*/}
                          <div className="menu-item px-3">
                            <a href="#" className="menu-link px-3">
                              Create Invoice
                            </a>
                          </div>
                          {/*end::Menu item*/}
                          {/*begin::Menu item*/}
                          <div className="menu-item px-3">
                            <a href="#" className="menu-link flex-stack px-3">
                              Create Payment
                              <i
                                className="fas fa-exclamation-circle ms-2 fs-7"
                                data-bs-toggle="tooltip"
                                title
                                data-bs-original-title="Specify a target name for future usage and reference"
                                aria-label="Specify a target name for future usage and reference"
                              />
                            </a>
                          </div>
                          {/*end::Menu item*/}
                          {/*begin::Menu item*/}
                          <div className="menu-item px-3">
                            <a href="#" className="menu-link px-3">
                              Generate Bill
                            </a>
                          </div>
                          {/*end::Menu item*/}
                          {/*begin::Menu item*/}
                          <div
                            className="menu-item px-3"
                            data-kt-menu-trigger="hover"
                            data-kt-menu-placement="right-end"
                          >
                            <a href="#" className="menu-link px-3">
                              <span className="menu-title">Subscription</span>
                              <span className="menu-arrow" />
                            </a>
                            {/*begin::Menu sub*/}
                            <div className="menu-sub menu-sub-dropdown w-175px py-4">
                              {/*begin::Menu item*/}
                              <div className="menu-item px-3">
                                <a href="#" className="menu-link px-3">
                                  Plans
                                </a>
                              </div>
                              {/*end::Menu item*/}
                              {/*begin::Menu item*/}
                              <div className="menu-item px-3">
                                <a href="#" className="menu-link px-3">
                                  Billing
                                </a>
                              </div>
                              {/*end::Menu item*/}
                              {/*begin::Menu item*/}
                              <div className="menu-item px-3">
                                <a href="#" className="menu-link px-3">
                                  Statements
                                </a>
                              </div>
                              {/*end::Menu item*/}
                              {/*begin::Menu separator*/}
                              <div className="separator my-2" />
                              {/*end::Menu separator*/}
                              {/*begin::Menu item*/}
                              <div className="menu-item px-3">
                                <div className="menu-content px-3">
                                  {/*begin::Switch*/}
                                  <label className="form-check form-switch form-check-custom form-check-solid">
                                    {/*begin::Input*/}
                                    <input
                                      className="form-check-input w-30px h-20px"
                                      type="checkbox"
                                      defaultValue={1}
                                      defaultChecked="checked"
                                      name="notifications"
                                    />
                                    {/*end::Input*/}
                                    {/*end::Label*/}
                                    <span className="form-check-label text-muted fs-6">
                                      Recuring
                                    </span>
                                    {/*end::Label*/}
                                  </label>
                                  {/*end::Switch*/}
                                </div>
                              </div>
                              {/*end::Menu item*/}
                            </div>
                            {/*end::Menu sub*/}
                          </div>
                          {/*end::Menu item*/}
                          {/*begin::Menu item*/}
                          <div className="menu-item px-3 my-1">
                            <a href="#" className="menu-link px-3">
                              Settings
                            </a>
                          </div>
                          {/*end::Menu item*/}
                        </div>
                        {/*end::Menu 3*/}
                        {/*end::Menu*/}
                      </div>
                    </div>
                    {/*end::Header*/}
                    {/*begin::Body*/}
                    <div className="card-body p-0">
                      {/*begin::Chart*/}
                      <div
                        className="mixed-widget-2-chart card-rounded-bottom bg-danger"
                        data-kt-color="danger"
                        style={{ height: "200px", minHeight: "200px" }}
                      >
                        <div
                          id="apexchartsju43y7uq"
                          className="apexcharts-canvas apexchartsju43y7uq apexcharts-theme-light"
                          style={{ width: "403px", height: "200px" }}
                        >
                          <svg
                            id="SvgjsSvg1006"
                            width={403}
                            height={200}
                            xmlns="http://www.w3.org/2000/svg"
                            version="1.1"
                            xmlnsXlink="http://www.w3.org/1999/xlink"
                            // // xmlns:svgjs="http://svgjs.dev"
                            className="apexcharts-svg"
                            // // xmlns:data="ApexChartsNS"
                            transform="translate(0, 0)"
                            style={{ background: "transparent" }}
                          >
                            <g
                              id="SvgjsG1008"
                              className="apexcharts-inner apexcharts-graphical"
                              transform="translate(0, 0)"
                            >
                              <defs id="SvgjsDefs1007">
                                <clipPath id="gridRectMaskju43y7uq">
                                  <rect
                                    id="SvgjsRect1011"
                                    width={410}
                                    height={203}
                                    x="-3.5"
                                    y="-1.5"
                                    rx={0}
                                    ry={0}
                                    opacity={1}
                                    strokeWidth={0}
                                    stroke="none"
                                    strokeDasharray={0}
                                    fill="#fff"
                                  />
                                </clipPath>
                                <clipPath id="forecastMaskju43y7uq" />
                                <clipPath id="nonForecastMaskju43y7uq" />
                                <clipPath id="gridRectMarkerMaskju43y7uq">
                                  <rect
                                    id="SvgjsRect1012"
                                    width={407}
                                    height={204}
                                    x={-2}
                                    y={-2}
                                    rx={0}
                                    ry={0}
                                    opacity={1}
                                    strokeWidth={0}
                                    stroke="none"
                                    strokeDasharray={0}
                                    fill="#fff"
                                  />
                                </clipPath>
                                <filter
                                  id="SvgjsFilter1018"
                                  filterUnits="userSpaceOnUse"
                                  width="200%"
                                  height="200%"
                                  x="-50%"
                                  y="-50%"
                                >
                                  <feFlood
                                    id="SvgjsFeFlood1019"
                                    floodColor="#cb1b46"
                                    floodOpacity="0.5"
                                    result="SvgjsFeFlood1019Out"
                                    in="SourceGraphic"
                                  />
                                  <feComposite
                                    id="SvgjsFeComposite1020"
                                    in="SvgjsFeFlood1019Out"
                                    in2="SourceAlpha"
                                    operator="in"
                                    result="SvgjsFeComposite1020Out"
                                  />
                                  <feOffset
                                    id="SvgjsFeOffset1021"
                                    dx={0}
                                    dy={5}
                                    result="SvgjsFeOffset1021Out"
                                    in="SvgjsFeComposite1020Out"
                                  />
                                  <feGaussianBlur
                                    id="SvgjsFeGaussianBlur1022"
                                    stdDeviation={3}
                                    result="SvgjsFeGaussianBlur1022Out"
                                    in="SvgjsFeOffset1021Out"
                                  />
                                  <feMerge
                                    id="SvgjsFeMerge1023"
                                    result="SvgjsFeMerge1023Out"
                                    in="SourceGraphic"
                                  >
                                    <feMergeNode
                                      id="SvgjsFeMergeNode1024"
                                      in="SvgjsFeGaussianBlur1022Out"
                                    />
                                    <feMergeNode
                                      id="SvgjsFeMergeNode1025"
                                      in="[object Arguments]"
                                    />
                                  </feMerge>
                                  <feBlend
                                    id="SvgjsFeBlend1026"
                                    in="SourceGraphic"
                                    in2="SvgjsFeMerge1023Out"
                                    mode="normal"
                                    result="SvgjsFeBlend1026Out"
                                  />
                                </filter>
                                <filter
                                  id="SvgjsFilter1028"
                                  filterUnits="userSpaceOnUse"
                                  width="200%"
                                  height="200%"
                                  x="-50%"
                                  y="-50%"
                                >
                                  <feFlood
                                    id="SvgjsFeFlood1029"
                                    floodColor="#cb1b46"
                                    floodOpacity="0.5"
                                    result="SvgjsFeFlood1029Out"
                                    in="SourceGraphic"
                                  />
                                  <feComposite
                                    id="SvgjsFeComposite1030"
                                    in="SvgjsFeFlood1029Out"
                                    in2="SourceAlpha"
                                    operator="in"
                                    result="SvgjsFeComposite1030Out"
                                  />
                                  <feOffset
                                    id="SvgjsFeOffset1031"
                                    dx={0}
                                    dy={5}
                                    result="SvgjsFeOffset1031Out"
                                    in="SvgjsFeComposite1030Out"
                                  />
                                  <feGaussianBlur
                                    id="SvgjsFeGaussianBlur1032"
                                    stdDeviation={3}
                                    result="SvgjsFeGaussianBlur1032Out"
                                    in="SvgjsFeOffset1031Out"
                                  />
                                  <feMerge
                                    id="SvgjsFeMerge1033"
                                    result="SvgjsFeMerge1033Out"
                                    in="SourceGraphic"
                                  >
                                    <feMergeNode
                                      id="SvgjsFeMergeNode1034"
                                      in="SvgjsFeGaussianBlur1032Out"
                                    />
                                    <feMergeNode
                                      id="SvgjsFeMergeNode1035"
                                      in="[object Arguments]"
                                    />
                                  </feMerge>
                                  <feBlend
                                    id="SvgjsFeBlend1036"
                                    in="SourceGraphic"
                                    in2="SvgjsFeMerge1033Out"
                                    mode="normal"
                                    result="SvgjsFeBlend1036Out"
                                  />
                                </filter>
                              </defs>
                              <g
                                id="SvgjsG1037"
                                className="apexcharts-xaxis"
                                transform="translate(0, 0)"
                              >
                                <g
                                  id="SvgjsG1038"
                                  className="apexcharts-xaxis-texts-g"
                                  transform="translate(0, -4)"
                                />
                              </g>
                              <g id="SvgjsG1047" className="apexcharts-grid">
                                <g
                                  id="SvgjsG1048"
                                  className="apexcharts-gridlines-horizontal"
                                  style={{ display: "none" }}
                                >
                                  <line
                                    id="SvgjsLine1050"
                                    x1={0}
                                    y1={0}
                                    x2={403}
                                    y2={0}
                                    stroke="#e0e0e0"
                                    strokeDasharray={0}
                                    strokeLinecap="butt"
                                    className="apexcharts-gridline"
                                  />
                                  <line
                                    id="SvgjsLine1051"
                                    x1={0}
                                    y1={20}
                                    x2={403}
                                    y2={20}
                                    stroke="#e0e0e0"
                                    strokeDasharray={0}
                                    strokeLinecap="butt"
                                    className="apexcharts-gridline"
                                  />
                                  <line
                                    id="SvgjsLine1052"
                                    x1={0}
                                    y1={40}
                                    x2={403}
                                    y2={40}
                                    stroke="#e0e0e0"
                                    strokeDasharray={0}
                                    strokeLinecap="butt"
                                    className="apexcharts-gridline"
                                  />
                                  <line
                                    id="SvgjsLine1053"
                                    x1={0}
                                    y1={60}
                                    x2={403}
                                    y2={60}
                                    stroke="#e0e0e0"
                                    strokeDasharray={0}
                                    strokeLinecap="butt"
                                    className="apexcharts-gridline"
                                  />
                                  <line
                                    id="SvgjsLine1054"
                                    x1={0}
                                    y1={80}
                                    x2={403}
                                    y2={80}
                                    stroke="#e0e0e0"
                                    strokeDasharray={0}
                                    strokeLinecap="butt"
                                    className="apexcharts-gridline"
                                  />
                                  <line
                                    id="SvgjsLine1055"
                                    x1={0}
                                    y1={100}
                                    x2={403}
                                    y2={100}
                                    stroke="#e0e0e0"
                                    strokeDasharray={0}
                                    strokeLinecap="butt"
                                    className="apexcharts-gridline"
                                  />
                                  <line
                                    id="SvgjsLine1056"
                                    x1={0}
                                    y1={120}
                                    x2={403}
                                    y2={120}
                                    stroke="#e0e0e0"
                                    strokeDasharray={0}
                                    strokeLinecap="butt"
                                    className="apexcharts-gridline"
                                  />
                                  <line
                                    id="SvgjsLine1057"
                                    x1={0}
                                    y1={140}
                                    x2={403}
                                    y2={140}
                                    stroke="#e0e0e0"
                                    strokeDasharray={0}
                                    strokeLinecap="butt"
                                    className="apexcharts-gridline"
                                  />
                                  <line
                                    id="SvgjsLine1058"
                                    x1={0}
                                    y1={160}
                                    x2={403}
                                    y2={160}
                                    stroke="#e0e0e0"
                                    strokeDasharray={0}
                                    strokeLinecap="butt"
                                    className="apexcharts-gridline"
                                  />
                                  <line
                                    id="SvgjsLine1059"
                                    x1={0}
                                    y1={180}
                                    x2={403}
                                    y2={180}
                                    stroke="#e0e0e0"
                                    strokeDasharray={0}
                                    strokeLinecap="butt"
                                    className="apexcharts-gridline"
                                  />
                                  <line
                                    id="SvgjsLine1060"
                                    x1={0}
                                    y1={200}
                                    x2={403}
                                    y2={200}
                                    stroke="#e0e0e0"
                                    strokeDasharray={0}
                                    strokeLinecap="butt"
                                    className="apexcharts-gridline"
                                  />
                                </g>
                                <g
                                  id="SvgjsG1049"
                                  className="apexcharts-gridlines-vertical"
                                  style={{ display: "none" }}
                                />
                                <line
                                  id="SvgjsLine1062"
                                  x1={0}
                                  y1={200}
                                  x2={403}
                                  y2={200}
                                  stroke="transparent"
                                  strokeDasharray={0}
                                  strokeLinecap="butt"
                                />
                                <line
                                  id="SvgjsLine1061"
                                  x1={0}
                                  y1={1}
                                  x2={0}
                                  y2={200}
                                  stroke="transparent"
                                  strokeDasharray={0}
                                  strokeLinecap="butt"
                                />
                              </g>
                              <g
                                id="SvgjsG1013"
                                className="apexcharts-area-series apexcharts-plot-series"
                              >
                                <g
                                  id="SvgjsG1014"
                                  className="apexcharts-series"
                                  seriesname="NetxProfit"
                                  // // data:longestseries="true"
                                  rel={1}
                                  // // data:realindex={0}
                                >
                                  <path
                                    id="SvgjsPath1017"
                                    d="M0 200L0 125C23.508333333333333 125 43.65833333333334 87.5 67.16666666666667 87.5C90.67500000000001 87.5 110.82500000000002 120 134.33333333333334 120C157.84166666666667 120 177.99166666666667 25 201.5 25C225.00833333333333 25 245.15833333333336 100 268.6666666666667 100C292.175 100 312.325 100 335.8333333333333 100C359.34166666666664 100 379.4916666666667 100 403 100C403 100 403 100 403 200M403 100C403 100 403 100 403 100 "
                                    fill="transparent"
                                    fillOpacity={1}
                                    strokeOpacity={1}
                                    strokeLinecap="butt"
                                    strokeWidth={0}
                                    strokeDasharray={0}
                                    className="apexcharts-area"
                                    index={0}
                                    clipPath="url(#gridRectMaskju43y7uq)"
                                    filter="url(#SvgjsFilter1018)"
                                    pathto="M 0 200L 0 125C 23.508333333333333 125 43.65833333333334 87.5 67.16666666666667 87.5C 90.67500000000001 87.5 110.82500000000002 120 134.33333333333334 120C 157.84166666666667 120 177.99166666666667 25 201.5 25C 225.00833333333333 25 245.15833333333336 100 268.6666666666667 100C 292.175 100 312.325 100 335.8333333333333 100C 359.34166666666664 100 379.4916666666667 100 403 100C 403 100 403 100 403 200M 403 100z"
                                    pathfrom="M -1 200L -1 200L 67.16666666666667 200L 134.33333333333334 200L 201.5 200L 268.6666666666667 200L 335.8333333333333 200L 403 200"
                                  />
                                  <path
                                    id="SvgjsPath1027"
                                    d="M0 125C23.508333333333333 125 43.65833333333334 87.5 67.16666666666667 87.5C90.67500000000001 87.5 110.82500000000002 120 134.33333333333334 120C157.84166666666667 120 177.99166666666667 25 201.5 25C225.00833333333333 25 245.15833333333336 100 268.6666666666667 100C292.175 100 312.325 100 335.8333333333333 100C359.34166666666664 100 379.4916666666667 100 403 100C403 100 403 100 403 100 "
                                    fill="none"
                                    fillOpacity={1}
                                    stroke="#cb1b46"
                                    strokeOpacity={1}
                                    strokeLinecap="butt"
                                    strokeWidth={3}
                                    strokeDasharray={0}
                                    className="apexcharts-area"
                                    index={0}
                                    clipPath="url(#gridRectMaskju43y7uq)"
                                    filter="url(#SvgjsFilter1028)"
                                    pathto="M 0 125C 23.508333333333333 125 43.65833333333334 87.5 67.16666666666667 87.5C 90.67500000000001 87.5 110.82500000000002 120 134.33333333333334 120C 157.84166666666667 120 177.99166666666667 25 201.5 25C 225.00833333333333 25 245.15833333333336 100 268.6666666666667 100C 292.175 100 312.325 100 335.8333333333333 100C 359.34166666666664 100 379.4916666666667 100 403 100"
                                    pathfrom="M -1 200L -1 200L 67.16666666666667 200L 134.33333333333334 200L 201.5 200L 268.6666666666667 200L 335.8333333333333 200L 403 200"
                                  />
                                  <g
                                    id="SvgjsG1015"
                                    className="apexcharts-series-markers-wrap"
                                    // // data:realindex={0}
                                  >
                                    <g className="apexcharts-series-markers">
                                      <circle
                                        id="SvgjsCircle1068"
                                        r={0}
                                        cx="201.5"
                                        cy={25}
                                        className="apexcharts-marker wc3bnyoazj no-pointer-events"
                                        stroke="#cb1b46"
                                        fill="#f1416c"
                                        fillOpacity={1}
                                        strokeWidth={3}
                                        strokeOpacity="0.9"
                                        default-marker-size={0}
                                      />
                                    </g>
                                  </g>
                                </g>
                                <g
                                  id="SvgjsG1016"
                                  className="apexcharts-datalabels"
                                  // // data:realindex={0}
                                />
                              </g>
                              <line
                                id="SvgjsLine1063"
                                x1={0}
                                y1={0}
                                x2={403}
                                y2={0}
                                stroke="#b6b6b6"
                                strokeDasharray={0}
                                strokeWidth={1}
                                strokeLinecap="butt"
                                className="apexcharts-ycrosshairs"
                              />
                              <line
                                id="SvgjsLine1064"
                                x1={0}
                                y1={0}
                                x2={403}
                                y2={0}
                                strokeDasharray={0}
                                strokeWidth={0}
                                strokeLinecap="butt"
                                className="apexcharts-ycrosshairs-hidden"
                              />
                              <g
                                id="SvgjsG1065"
                                className="apexcharts-yaxis-annotations"
                              />
                              <g
                                id="SvgjsG1066"
                                className="apexcharts-xaxis-annotations"
                              />
                              <g
                                id="SvgjsG1067"
                                className="apexcharts-point-annotations"
                              />
                            </g>
                            <g
                              id="SvgjsG1046"
                              className="apexcharts-yaxis"
                              rel={0}
                              transform="translate(-18, 0)"
                            />
                            <g
                              id="SvgjsG1009"
                              className="apexcharts-annotations"
                            />
                          </svg>
                          <div
                            className="apexcharts-legend"
                            style={{ maxHeight: "100px" }}
                          />
                          <div
                            className="apexcharts-tooltip apexcharts-theme-light"
                            style={{ left: "21.4062px", top: "28px" }}
                          >
                            <div
                              className="apexcharts-tooltip-title"
                              style={{
                                fontFamily: "inherit",
                                fontSize: "12px",
                              }}
                            >
                              May
                            </div>
                            <div
                              className="apexcharts-tooltip-series-group apexcharts-active"
                              style={{ order: 1, display: "flex" }}
                            >
                              <span
                                className="apexcharts-tooltip-marker"
                                style={{
                                  backgroundColor: "transparent",
                                  display: "none",
                                }}
                              />
                              <div
                                className="apexcharts-tooltip-text"
                                style={{
                                  fontFamily: "inherit",
                                  fontSize: "12px",
                                }}
                              >
                                <div className="apexcharts-tooltip-y-group">
                                  <span className="apexcharts-tooltip-text-y-label">
                                    Net Profit:{" "}
                                  </span>
                                  <span className="apexcharts-tooltip-text-y-value">
                                    $70 thousands
                                  </span>
                                </div>
                                <div className="apexcharts-tooltip-goals-group">
                                  <span className="apexcharts-tooltip-text-goals-label" />
                                  <span className="apexcharts-tooltip-text-goals-value" />
                                </div>
                                <div className="apexcharts-tooltip-z-group">
                                  <span className="apexcharts-tooltip-text-z-label" />
                                  <span className="apexcharts-tooltip-text-z-value" />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="apexcharts-yaxistooltip apexcharts-yaxistooltip-0 apexcharts-yaxistooltip-left apexcharts-theme-light">
                            <div className="apexcharts-yaxistooltip-text" />
                          </div>
                        </div>
                      </div>
                      {/*end::Chart*/}
                      {/*begin::Stats*/}
                      <div className="card-p mt-n20 position-relative">
                        {/*begin::Row*/}
                        <div className="row g-0">
                          {/*begin::Col*/}
                          <div className="col bg-light-warning px-6 py-8 rounded-2 me-7 mb-7">
                            {/*begin::Svg Icon | path: icons/duotune/general/gen032.svg*/}
                            <span className="svg-icon svg-icon-3x svg-icon-warning d-block my-2">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={24}
                                height={24}
                                viewBox="0 0 24 24"
                                fill="none"
                              >
                                <rect
                                  x={8}
                                  y={9}
                                  width={3}
                                  height={10}
                                  rx="1.5"
                                  fill="currentColor"
                                />
                                <rect
                                  opacity="0.5"
                                  x={13}
                                  y={5}
                                  width={3}
                                  height={14}
                                  rx="1.5"
                                  fill="currentColor"
                                />
                                <rect
                                  x={18}
                                  y={11}
                                  width={3}
                                  height={8}
                                  rx="1.5"
                                  fill="currentColor"
                                />
                                <rect
                                  x={3}
                                  y={13}
                                  width={3}
                                  height={6}
                                  rx="1.5"
                                  fill="currentColor"
                                />
                              </svg>
                            </span>
                            {/*end::Svg Icon*/}
                            <a href="#" className="text-warning fw-bold fs-6">
                              Weekly Sales
                            </a>
                          </div>
                          {/*end::Col*/}
                          {/*begin::Col*/}
                          <div className="col bg-light-primary px-6 py-8 rounded-2 mb-7">
                            {/*begin::Svg Icon | path: icons/duotune/finance/fin006.svg*/}
                            <span className="svg-icon svg-icon-3x svg-icon-primary d-block my-2">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={24}
                                height={24}
                                viewBox="0 0 24 24"
                                fill="none"
                              >
                                <path
                                  opacity="0.3"
                                  d="M20 15H4C2.9 15 2 14.1 2 13V7C2 6.4 2.4 6 3 6H21C21.6 6 22 6.4 22 7V13C22 14.1 21.1 15 20 15ZM13 12H11C10.5 12 10 12.4 10 13V16C10 16.5 10.4 17 11 17H13C13.6 17 14 16.6 14 16V13C14 12.4 13.6 12 13 12Z"
                                  fill="currentColor"
                                />
                                <path
                                  d="M14 6V5H10V6H8V5C8 3.9 8.9 3 10 3H14C15.1 3 16 3.9 16 5V6H14ZM20 15H14V16C14 16.6 13.5 17 13 17H11C10.5 17 10 16.6 10 16V15H4C3.6 15 3.3 14.9 3 14.7V18C3 19.1 3.9 20 5 20H19C20.1 20 21 19.1 21 18V14.7C20.7 14.9 20.4 15 20 15Z"
                                  fill="currentColor"
                                />
                              </svg>
                            </span>
                            {/*end::Svg Icon*/}
                            <a href="#" className="text-primary fw-bold fs-6">
                              New Projects
                            </a>
                          </div>
                          {/*end::Col*/}
                        </div>
                        {/*end::Row*/}
                        {/*begin::Row*/}
                        <div className="row g-0">
                          {/*begin::Col*/}
                          <div className="col bg-light-danger px-6 py-8 rounded-2 me-7">
                            {/*begin::Svg Icon | path: icons/duotune/abstract/abs027.svg*/}
                            <span className="svg-icon svg-icon-3x svg-icon-danger d-block my-2">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={24}
                                height={24}
                                viewBox="0 0 24 24"
                                fill="none"
                              >
                                <path
                                  opacity="0.3"
                                  d="M21.25 18.525L13.05 21.825C12.35 22.125 11.65 22.125 10.95 21.825L2.75 18.525C1.75 18.125 1.75 16.725 2.75 16.325L4.04999 15.825L10.25 18.325C10.85 18.525 11.45 18.625 12.05 18.625C12.65 18.625 13.25 18.525 13.85 18.325L20.05 15.825L21.35 16.325C22.35 16.725 22.35 18.125 21.25 18.525ZM13.05 16.425L21.25 13.125C22.25 12.725 22.25 11.325 21.25 10.925L13.05 7.62502C12.35 7.32502 11.65 7.32502 10.95 7.62502L2.75 10.925C1.75 11.325 1.75 12.725 2.75 13.125L10.95 16.425C11.65 16.725 12.45 16.725 13.05 16.425Z"
                                  fill="currentColor"
                                />
                                <path
                                  d="M11.05 11.025L2.84998 7.725C1.84998 7.325 1.84998 5.925 2.84998 5.525L11.05 2.225C11.75 1.925 12.45 1.925 13.15 2.225L21.35 5.525C22.35 5.925 22.35 7.325 21.35 7.725L13.05 11.025C12.45 11.325 11.65 11.325 11.05 11.025Z"
                                  fill="currentColor"
                                />
                              </svg>
                            </span>
                            {/*end::Svg Icon*/}
                            <a
                              href="#"
                              className="text-danger fw-bold fs-6 mt-2"
                            >
                              Item Orders
                            </a>
                          </div>
                          {/*end::Col*/}
                          {/*begin::Col*/}
                          <div className="col bg-light-success px-6 py-8 rounded-2">
                            {/*begin::Svg Icon | path: icons/duotune/communication/com010.svg*/}
                            <span className="svg-icon svg-icon-3x svg-icon-success d-block my-2">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={24}
                                height={24}
                                viewBox="0 0 24 24"
                                fill="none"
                              >
                                <path
                                  d="M6 8.725C6 8.125 6.4 7.725 7 7.725H14L18 11.725V12.925L22 9.725L12.6 2.225C12.2 1.925 11.7 1.925 11.4 2.225L2 9.725L6 12.925V8.725Z"
                                  fill="currentColor"
                                />
                                <path
                                  opacity="0.3"
                                  d="M22 9.72498V20.725C22 21.325 21.6 21.725 21 21.725H3C2.4 21.725 2 21.325 2 20.725V9.72498L11.4 17.225C11.8 17.525 12.3 17.525 12.6 17.225L22 9.72498ZM15 11.725H18L14 7.72498V10.725C14 11.325 14.4 11.725 15 11.725Z"
                                  fill="currentColor"
                                />
                              </svg>
                            </span>
                            {/*end::Svg Icon*/}
                            <a
                              href="#"
                              className="text-success fw-bold fs-6 mt-2"
                            >
                              Bug Reports
                            </a>
                          </div>
                          {/*end::Col*/}
                        </div>
                        {/*end::Row*/}
                      </div>
                      {/*end::Stats*/}
                    </div>
                    {/*end::Body*/}
                  </div>
                  {/*end::Mixed Widget 2*/}
                </div>
                {/*end::Col*/}
                {/*begin::Col*/}
                <div className="col-xl-4">
                  {/*begin::List Widget 5*/}
                  <div className="card card-xl-stretch">
                    {/*begin::Header*/}
                    <div className="card-header align-items-center border-0 mt-4">
                      <h3 className="card-title align-items-start flex-column">
                        <span className="fw-bolder mb-2 text-dark">
                          Activities
                        </span>
                        <span className="text-muted fw-bold fs-7">
                          890,344 Sales
                        </span>
                      </h3>
                      <div className="card-toolbar">
                        {/*begin::Menu*/}
                        <button
                          type="button"
                          className="btn btn-sm btn-icon btn-color-primary btn-active-light-primary"
                          data-kt-menu-trigger="click"
                          data-kt-menu-placement="bottom-end"
                        >
                          {/*begin::Svg Icon | path: icons/duotune/general/gen024.svg*/}
                          <span className="svg-icon svg-icon-2">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24px"
                              height="24px"
                              viewBox="0 0 24 24"
                            >
                              <g
                                stroke="none"
                                strokeWidth={1}
                                fill="none"
                                fillRule="evenodd"
                              >
                                <rect
                                  x={5}
                                  y={5}
                                  width={5}
                                  height={5}
                                  rx={1}
                                  fill="currentColor"
                                />
                                <rect
                                  x={14}
                                  y={5}
                                  width={5}
                                  height={5}
                                  rx={1}
                                  fill="currentColor"
                                  opacity="0.3"
                                />
                                <rect
                                  x={5}
                                  y={14}
                                  width={5}
                                  height={5}
                                  rx={1}
                                  fill="currentColor"
                                  opacity="0.3"
                                />
                                <rect
                                  x={14}
                                  y={14}
                                  width={5}
                                  height={5}
                                  rx={1}
                                  fill="currentColor"
                                  opacity="0.3"
                                />
                              </g>
                            </svg>
                          </span>
                          {/*end::Svg Icon*/}
                        </button>
                        {/*begin::Menu 1*/}
                        <div
                          className="menu menu-sub menu-sub-dropdown w-250px w-md-300px"
                          data-kt-menu="true"
                          id="kt_menu_6247115a691ad"
                        >
                          {/*begin::Header*/}
                          <div className="px-7 py-5">
                            <div className="fs-5 text-dark fw-bolder">
                              Filter Options
                            </div>
                          </div>
                          {/*end::Header*/}
                          {/*begin::Menu separator*/}
                          <div className="separator border-gray-200" />
                          {/*end::Menu separator*/}
                          {/*begin::Form*/}
                          <div className="px-7 py-5">
                            {/*begin::Input group*/}
                            <div className="mb-10">
                              {/*begin::Label*/}
                              <label className="form-label fw-bold">
                                Status:
                              </label>
                              {/*end::Label*/}
                              {/*begin::Input*/}
                              <div>
                                <select
                                  className="form-select form-select-solid select2-hidden-accessible"
                                  data-kt-select2="true"
                                  data-placeholder="Select option"
                                  data-dropdown-parent="#kt_menu_6247115a691ad"
                                  data-allow-clear="true"
                                  data-select2-id="select2-data-10-u6rc"
                                  tabIndex={-1}
                                  aria-hidden="true"
                                >
                                  <option data-select2-id="select2-data-12-ypgy" />
                                  <option value={1}>Approved</option>
                                  <option value={2}>Pending</option>
                                  <option value={2}>In Process</option>
                                  <option value={2}>Rejected</option>
                                </select>
                                <span
                                  className="select2 select2-container select2-container--bootstrap5"
                                  dir="ltr"
                                  data-select2-id="select2-data-11-td3g"
                                  style={{ width: "100%" }}
                                >
                                  <span className="selection">
                                    <span
                                      className="select2-selection select2-selection--single form-select form-select-solid"
                                      role="combobox"
                                      aria-haspopup="true"
                                      aria-expanded="false"
                                      tabIndex={0}
                                      aria-disabled="false"
                                      aria-labelledby="select2-wq2x-container"
                                      aria-controls="select2-wq2x-container"
                                    >
                                      <span
                                        className="select2-selection__rendered"
                                        id="select2-wq2x-container"
                                        role="textbox"
                                        aria-readonly="true"
                                        title="Select option"
                                      >
                                        <span className="select2-selection__placeholder">
                                          Select option
                                        </span>
                                      </span>
                                      <span
                                        className="select2-selection__arrow"
                                        role="presentation"
                                      >
                                        <b role="presentation" />
                                      </span>
                                    </span>
                                  </span>
                                  <span
                                    className="dropdown-wrapper"
                                    aria-hidden="true"
                                  />
                                </span>
                              </div>
                              {/*end::Input*/}
                            </div>
                            {/*end::Input group*/}
                            {/*begin::Input group*/}
                            <div className="mb-10">
                              {/*begin::Label*/}
                              <label className="form-label fw-bold">
                                Member Type:
                              </label>
                              {/*end::Label*/}
                              {/*begin::Options*/}
                              <div className="d-flex">
                                {/*begin::Options*/}
                                <label className="form-check form-check-sm form-check-custom form-check-solid me-5">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    defaultValue={1}
                                  />
                                  <span className="form-check-label">
                                    Author
                                  </span>
                                </label>
                                {/*end::Options*/}
                                {/*begin::Options*/}
                                <label className="form-check form-check-sm form-check-custom form-check-solid">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    defaultValue={2}
                                    defaultChecked="checked"
                                  />
                                  <span className="form-check-label">
                                    Customer
                                  </span>
                                </label>
                                {/*end::Options*/}
                              </div>
                              {/*end::Options*/}
                            </div>
                            {/*end::Input group*/}
                            {/*begin::Input group*/}
                            <div className="mb-10">
                              {/*begin::Label*/}
                              <label className="form-label fw-bold">
                                Notifications:
                              </label>
                              {/*end::Label*/}
                              {/*begin::Switch*/}
                              <div className="form-check form-switch form-switch-sm form-check-custom form-check-solid">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  defaultValue
                                  name="notifications"
                                  defaultChecked="checked"
                                />
                                <label className="form-check-label">
                                  Enabled
                                </label>
                              </div>
                              {/*end::Switch*/}
                            </div>
                            {/*end::Input group*/}
                            {/*begin::Actions*/}
                            <div className="d-flex justify-content-end">
                              <button
                                type="reset"
                                className="btn btn-sm btn-light btn-active-light-primary me-2"
                                data-kt-menu-dismiss="true"
                              >
                                Reset
                              </button>
                              <button
                                type="submit"
                                className="btn btn-sm btn-primary"
                                data-kt-menu-dismiss="true"
                              >
                                Apply
                              </button>
                            </div>
                            {/*end::Actions*/}
                          </div>
                          {/*end::Form*/}
                        </div>
                        {/*end::Menu 1*/}
                        {/*end::Menu*/}
                      </div>
                    </div>
                    {/*end::Header*/}
                    {/*begin::Body*/}
                    <div className="card-body pt-5">
                      {/*begin::Timeline*/}
                      <div className="timeline-label">
                        {/*begin::Item*/}
                        <div className="timeline-item">
                          {/*begin::Label*/}
                          <div className="timeline-label fw-bolder text-gray-800 fs-6">
                            08:42
                          </div>
                          {/*end::Label*/}
                          {/*begin::Badge*/}
                          <div className="timeline-badge">
                            <i className="fa fa-genderless text-warning fs-1" />
                          </div>
                          {/*end::Badge*/}
                          {/*begin::Text*/}
                          <div className="fw-mormal timeline-content text-muted ps-3">
                            Outlines keep you honest. And keep structure
                          </div>
                          {/*end::Text*/}
                        </div>
                        {/*end::Item*/}
                        {/*begin::Item*/}
                        <div className="timeline-item">
                          {/*begin::Label*/}
                          <div className="timeline-label fw-bolder text-gray-800 fs-6">
                            10:00
                          </div>
                          {/*end::Label*/}
                          {/*begin::Badge*/}
                          <div className="timeline-badge">
                            <i className="fa fa-genderless text-success fs-1" />
                          </div>
                          {/*end::Badge*/}
                          {/*begin::Content*/}
                          <div className="timeline-content d-flex">
                            <span className="fw-bolder text-gray-800 ps-3">
                              AEOL meeting
                            </span>
                          </div>
                          {/*end::Content*/}
                        </div>
                        {/*end::Item*/}
                        {/*begin::Item*/}
                        <div className="timeline-item">
                          {/*begin::Label*/}
                          <div className="timeline-label fw-bolder text-gray-800 fs-6">
                            14:37
                          </div>
                          {/*end::Label*/}
                          {/*begin::Badge*/}
                          <div className="timeline-badge">
                            <i className="fa fa-genderless text-danger fs-1" />
                          </div>
                          {/*end::Badge*/}
                          {/*begin::Desc*/}
                          <div className="timeline-content fw-bolder text-gray-800 ps-3">
                            Make deposit
                            <a href="#" className="text-primary">
                              USD 700
                            </a>
                            . to ESL
                          </div>
                          {/*end::Desc*/}
                        </div>
                        {/*end::Item*/}
                        {/*begin::Item*/}
                        <div className="timeline-item">
                          {/*begin::Label*/}
                          <div className="timeline-label fw-bolder text-gray-800 fs-6">
                            16:50
                          </div>
                          {/*end::Label*/}
                          {/*begin::Badge*/}
                          <div className="timeline-badge">
                            <i className="fa fa-genderless text-primary fs-1" />
                          </div>
                          {/*end::Badge*/}
                          {/*begin::Text*/}
                          <div className="timeline-content fw-mormal text-muted ps-3">
                            Indulging in poorly driving and keep structure keep
                            great
                          </div>
                          {/*end::Text*/}
                        </div>
                        {/*end::Item*/}
                        {/*begin::Item*/}
                        <div className="timeline-item">
                          {/*begin::Label*/}
                          <div className="timeline-label fw-bolder text-gray-800 fs-6">
                            21:03
                          </div>
                          {/*end::Label*/}
                          {/*begin::Badge*/}
                          <div className="timeline-badge">
                            <i className="fa fa-genderless text-danger fs-1" />
                          </div>
                          {/*end::Badge*/}
                          {/*begin::Desc*/}
                          <div className="timeline-content fw-bold text-gray-800 ps-3">
                            New order placed
                            <a href="#" className="text-primary">
                              #XF-2356
                            </a>
                            .
                          </div>
                          {/*end::Desc*/}
                        </div>
                        {/*end::Item*/}
                        {/*begin::Item*/}
                        <div className="timeline-item">
                          {/*begin::Label*/}
                          <div className="timeline-label fw-bolder text-gray-800 fs-6">
                            16:50
                          </div>
                          {/*end::Label*/}
                          {/*begin::Badge*/}
                          <div className="timeline-badge">
                            <i className="fa fa-genderless text-primary fs-1" />
                          </div>
                          {/*end::Badge*/}
                          {/*begin::Text*/}
                          <div className="timeline-content fw-mormal text-muted ps-3">
                            Indulging in poorly driving and keep structure keep
                            great
                          </div>
                          {/*end::Text*/}
                        </div>
                        {/*end::Item*/}
                        {/*begin::Item*/}
                        <div className="timeline-item">
                          {/*begin::Label*/}
                          <div className="timeline-label fw-bolder text-gray-800 fs-6">
                            21:03
                          </div>
                          {/*end::Label*/}
                          {/*begin::Badge*/}
                          <div className="timeline-badge">
                            <i className="fa fa-genderless text-danger fs-1" />
                          </div>
                          {/*end::Badge*/}
                          {/*begin::Desc*/}
                          <div className="timeline-content fw-bold text-gray-800 ps-3">
                            New order placed
                            <a href="#" className="text-primary">
                              #XF-2356
                            </a>
                            .
                          </div>
                          {/*end::Desc*/}
                        </div>
                        {/*end::Item*/}
                        {/*begin::Item*/}
                        <div className="timeline-item mb-9">
                          {/*begin::Label*/}
                          <div className="timeline-label fw-bolder text-gray-800 fs-6">
                            10:30
                          </div>
                          {/*end::Label*/}
                          {/*begin::Badge*/}
                          <div className="timeline-badge">
                            <i className="fa fa-genderless text-success fs-1" />
                          </div>
                          {/*end::Badge*/}
                          {/*begin::Text*/}
                          <div className="timeline-content fw-mormal text-muted ps-3">
                            Finance KPI Mobile app launch preparion meeting
                          </div>
                          {/*end::Text*/}
                        </div>
                        {/*end::Item*/}
                      </div>
                      {/*end::Timeline*/}
                    </div>
                    {/*end: Card Body*/}
                  </div>
                  {/*end: List Widget 5*/}
                </div>
                {/*end::Col*/}
                {/*begin::Col*/}
                <div className="col-xl-4">
                  {/*begin::Mixed Widget 7*/}
                  <div className="card card-xl-stretch-50 mb-5 mb-xl-8">
                    {/*begin::Body*/}
                    <div className="card-body d-flex flex-column p-0">
                      {/*begin::Stats*/}
                      <div className="flex-grow-1 card-p pb-0">
                        <div className="d-flex flex-stack flex-wrap">
                          <div className="me-2">
                            <a
                              href="#"
                              className="text-dark text-hover-primary fw-bolder fs-3"
                            >
                              Generate Reports
                            </a>
                            <div className="text-muted fs-7 fw-bold">
                              Finance and accounting reports
                            </div>
                          </div>
                          <div className="fw-bolder fs-3 text-primary">
                            $24,500
                          </div>
                        </div>
                      </div>
                      {/*end::Stats*/}
                      {/*begin::Chart*/}
                      <div
                        className="mixed-widget-7-chart card-rounded-bottom"
                        data-kt-chart-color="primary"
                        style={{ height: "150px", minHeight: "150px" }}
                      >
                        <div
                          id="apexchartsb7ashbp"
                          className="apexcharts-canvas apexchartsb7ashbp apexcharts-theme-light"
                          style={{ width: "403px", height: "150px" }}
                        >
                          <svg
                            id="SvgjsSvg1113"
                            width={403}
                            height={150}
                            xmlns="http://www.w3.org/2000/svg"
                            version="1.1"
                            xmlnsXlink="http://www.w3.org/1999/xlink"
                            // // xmlns:svgjs="http://svgjs.dev"
                            className="apexcharts-svg"
                            // // xmlns:data="ApexChartsNS"
                            transform="translate(0, 0)"
                            style={{ background: "transparent" }}
                          >
                            <g
                              id="SvgjsG1115"
                              className="apexcharts-inner apexcharts-graphical"
                              transform="translate(0, 0)"
                            >
                              <defs id="SvgjsDefs1114">
                                <clipPath id="gridRectMaskb7ashbp">
                                  <rect
                                    id="SvgjsRect1118"
                                    width={410}
                                    height={153}
                                    x="-3.5"
                                    y="-1.5"
                                    rx={0}
                                    ry={0}
                                    opacity={1}
                                    strokeWidth={0}
                                    stroke="none"
                                    strokeDasharray={0}
                                    fill="#fff"
                                  />
                                </clipPath>
                                <clipPath id="forecastMaskb7ashbp" />
                                <clipPath id="nonForecastMaskb7ashbp" />
                                <clipPath id="gridRectMarkerMaskb7ashbp">
                                  <rect
                                    id="SvgjsRect1119"
                                    width={407}
                                    height={154}
                                    x={-2}
                                    y={-2}
                                    rx={0}
                                    ry={0}
                                    opacity={1}
                                    strokeWidth={0}
                                    stroke="none"
                                    strokeDasharray={0}
                                    fill="#fff"
                                  />
                                </clipPath>
                              </defs>
                              <g
                                id="SvgjsG1126"
                                className="apexcharts-xaxis"
                                transform="translate(0, 0)"
                              >
                                <g
                                  id="SvgjsG1127"
                                  className="apexcharts-xaxis-texts-g"
                                  transform="translate(0, -4)"
                                />
                              </g>
                              <g id="SvgjsG1135" className="apexcharts-grid">
                                <g
                                  id="SvgjsG1136"
                                  className="apexcharts-gridlines-horizontal"
                                  style={{ display: "none" }}
                                >
                                  <line
                                    id="SvgjsLine1138"
                                    x1={0}
                                    y1={0}
                                    x2={403}
                                    y2={0}
                                    stroke="#e0e0e0"
                                    strokeDasharray={0}
                                    strokeLinecap="butt"
                                    className="apexcharts-gridline"
                                  />
                                  <line
                                    id="SvgjsLine1139"
                                    x1={0}
                                    y1={15}
                                    x2={403}
                                    y2={15}
                                    stroke="#e0e0e0"
                                    strokeDasharray={0}
                                    strokeLinecap="butt"
                                    className="apexcharts-gridline"
                                  />
                                  <line
                                    id="SvgjsLine1140"
                                    x1={0}
                                    y1={30}
                                    x2={403}
                                    y2={30}
                                    stroke="#e0e0e0"
                                    strokeDasharray={0}
                                    strokeLinecap="butt"
                                    className="apexcharts-gridline"
                                  />
                                  <line
                                    id="SvgjsLine1141"
                                    x1={0}
                                    y1={45}
                                    x2={403}
                                    y2={45}
                                    stroke="#e0e0e0"
                                    strokeDasharray={0}
                                    strokeLinecap="butt"
                                    className="apexcharts-gridline"
                                  />
                                  <line
                                    id="SvgjsLine1142"
                                    x1={0}
                                    y1={60}
                                    x2={403}
                                    y2={60}
                                    stroke="#e0e0e0"
                                    strokeDasharray={0}
                                    strokeLinecap="butt"
                                    className="apexcharts-gridline"
                                  />
                                  <line
                                    id="SvgjsLine1143"
                                    x1={0}
                                    y1={75}
                                    x2={403}
                                    y2={75}
                                    stroke="#e0e0e0"
                                    strokeDasharray={0}
                                    strokeLinecap="butt"
                                    className="apexcharts-gridline"
                                  />
                                  <line
                                    id="SvgjsLine1144"
                                    x1={0}
                                    y1={90}
                                    x2={403}
                                    y2={90}
                                    stroke="#e0e0e0"
                                    strokeDasharray={0}
                                    strokeLinecap="butt"
                                    className="apexcharts-gridline"
                                  />
                                  <line
                                    id="SvgjsLine1145"
                                    x1={0}
                                    y1={105}
                                    x2={403}
                                    y2={105}
                                    stroke="#e0e0e0"
                                    strokeDasharray={0}
                                    strokeLinecap="butt"
                                    className="apexcharts-gridline"
                                  />
                                  <line
                                    id="SvgjsLine1146"
                                    x1={0}
                                    y1={120}
                                    x2={403}
                                    y2={120}
                                    stroke="#e0e0e0"
                                    strokeDasharray={0}
                                    strokeLinecap="butt"
                                    className="apexcharts-gridline"
                                  />
                                  <line
                                    id="SvgjsLine1147"
                                    x1={0}
                                    y1={135}
                                    x2={403}
                                    y2={135}
                                    stroke="#e0e0e0"
                                    strokeDasharray={0}
                                    strokeLinecap="butt"
                                    className="apexcharts-gridline"
                                  />
                                  <line
                                    id="SvgjsLine1148"
                                    x1={0}
                                    y1={150}
                                    x2={403}
                                    y2={150}
                                    stroke="#e0e0e0"
                                    strokeDasharray={0}
                                    strokeLinecap="butt"
                                    className="apexcharts-gridline"
                                  />
                                </g>
                                <g
                                  id="SvgjsG1137"
                                  className="apexcharts-gridlines-vertical"
                                  style={{ display: "none" }}
                                />
                                <line
                                  id="SvgjsLine1150"
                                  x1={0}
                                  y1={150}
                                  x2={403}
                                  y2={150}
                                  stroke="transparent"
                                  strokeDasharray={0}
                                  strokeLinecap="butt"
                                />
                                <line
                                  id="SvgjsLine1149"
                                  x1={0}
                                  y1={1}
                                  x2={0}
                                  y2={150}
                                  stroke="transparent"
                                  strokeDasharray={0}
                                  strokeLinecap="butt"
                                />
                              </g>
                              <g
                                id="SvgjsG1120"
                                className="apexcharts-area-series apexcharts-plot-series"
                              >
                                <g
                                  id="SvgjsG1121"
                                  className="apexcharts-series"
                                  seriesname="NetxProfit"
                                  // data:longestseries="true"
                                  rel={1}
                                  // data:realindex={0}
                                >
                                  <path
                                    id="SvgjsPath1124"
                                    d="M0 150L0 112.5C28.209999999999997 112.5 52.39 87.5 80.6 87.5C108.80999999999999 87.5 132.98999999999998 112.5 161.2 112.5C189.41 112.5 213.58999999999997 50 241.79999999999998 50C270.01 50 294.19 100 322.4 100C350.60999999999996 100 374.79 25 403 25C403 25 403 25 403 150M403 25C403 25 403 25 403 25 "
                                    fill="rgba(241,250,255,1)"
                                    fillOpacity={1}
                                    strokeOpacity={1}
                                    strokeLinecap="butt"
                                    strokeWidth={0}
                                    strokeDasharray={0}
                                    className="apexcharts-area"
                                    index={0}
                                    clipPath="url(#gridRectMaskb7ashbp)"
                                    pathto="M 0 150L 0 112.5C 28.209999999999997 112.5 52.39 87.5 80.6 87.5C 108.80999999999999 87.5 132.98999999999998 112.5 161.2 112.5C 189.41 112.5 213.58999999999997 50 241.79999999999998 50C 270.01 50 294.19 100 322.4 100C 350.60999999999996 100 374.79 25 403 25C 403 25 403 25 403 150M 403 25z"
                                    pathfrom="M -1 150L -1 150L 80.6 150L 161.2 150L 241.79999999999998 150L 322.4 150L 403 150"
                                  />
                                  <path
                                    id="SvgjsPath1125"
                                    d="M0 112.5C28.209999999999997 112.5 52.39 87.5 80.6 87.5C108.80999999999999 87.5 132.98999999999998 112.5 161.2 112.5C189.41 112.5 213.58999999999997 50 241.79999999999998 50C270.01 50 294.19 100 322.4 100C350.60999999999996 100 374.79 25 403 25C403 25 403 25 403 25 "
                                    fill="none"
                                    fillOpacity={1}
                                    stroke="#009ef7"
                                    strokeOpacity={1}
                                    strokeLinecap="butt"
                                    strokeWidth={3}
                                    strokeDasharray={0}
                                    className="apexcharts-area"
                                    index={0}
                                    clipPath="url(#gridRectMaskb7ashbp)"
                                    pathto="M 0 112.5C 28.209999999999997 112.5 52.39 87.5 80.6 87.5C 108.80999999999999 87.5 132.98999999999998 112.5 161.2 112.5C 189.41 112.5 213.58999999999997 50 241.79999999999998 50C 270.01 50 294.19 100 322.4 100C 350.60999999999996 100 374.79 25 403 25"
                                    pathfrom="M -1 150L -1 150L 80.6 150L 161.2 150L 241.79999999999998 150L 322.4 150L 403 150"
                                  />
                                  <g
                                    id="SvgjsG1122"
                                    className="apexcharts-series-markers-wrap"
                                    // data:realindex={0}
                                  >
                                    <g className="apexcharts-series-markers">
                                      <circle
                                        id="SvgjsCircle1156"
                                        r={0}
                                        cx={0}
                                        cy={0}
                                        className="apexcharts-marker we4tqumzu no-pointer-events"
                                        stroke="#009ef7"
                                        fill="#f1faff"
                                        fillOpacity={1}
                                        strokeWidth={3}
                                        strokeOpacity="0.9"
                                        default-marker-size={0}
                                      />
                                    </g>
                                  </g>
                                </g>
                                <g
                                  id="SvgjsG1123"
                                  className="apexcharts-datalabels"
                                  // data:realindex={0}
                                />
                              </g>
                              <line
                                id="SvgjsLine1151"
                                x1={0}
                                y1={0}
                                x2={403}
                                y2={0}
                                stroke="#b6b6b6"
                                strokeDasharray={0}
                                strokeWidth={1}
                                strokeLinecap="butt"
                                className="apexcharts-ycrosshairs"
                              />
                              <line
                                id="SvgjsLine1152"
                                x1={0}
                                y1={0}
                                x2={403}
                                y2={0}
                                strokeDasharray={0}
                                strokeWidth={0}
                                strokeLinecap="butt"
                                className="apexcharts-ycrosshairs-hidden"
                              />
                              <g
                                id="SvgjsG1153"
                                className="apexcharts-yaxis-annotations"
                              />
                              <g
                                id="SvgjsG1154"
                                className="apexcharts-xaxis-annotations"
                              />
                              <g
                                id="SvgjsG1155"
                                className="apexcharts-point-annotations"
                              />
                            </g>
                            <g
                              id="SvgjsG1134"
                              className="apexcharts-yaxis"
                              rel={0}
                              transform="translate(-18, 0)"
                            />
                            <g
                              id="SvgjsG1116"
                              className="apexcharts-annotations"
                            />
                          </svg>
                          <div
                            className="apexcharts-legend"
                            style={{ maxHeight: "75px" }}
                          />
                          <div className="apexcharts-tooltip apexcharts-theme-light">
                            <div
                              className="apexcharts-tooltip-title"
                              style={{
                                fontFamily: "inherit",
                                fontSize: "12px",
                              }}
                            />
                            <div
                              className="apexcharts-tooltip-series-group"
                              style={{ order: 1 }}
                            >
                              <span
                                className="apexcharts-tooltip-marker"
                                style={{
                                  backgroundColor: "rgb(241, 250, 255)",
                                }}
                              />
                              <div
                                className="apexcharts-tooltip-text"
                                style={{
                                  fontFamily: "inherit",
                                  fontSize: "12px",
                                }}
                              >
                                <div className="apexcharts-tooltip-y-group">
                                  <span className="apexcharts-tooltip-text-y-label" />
                                  <span className="apexcharts-tooltip-text-y-value" />
                                </div>
                                <div className="apexcharts-tooltip-goals-group">
                                  <span className="apexcharts-tooltip-text-goals-label" />
                                  <span className="apexcharts-tooltip-text-goals-value" />
                                </div>
                                <div className="apexcharts-tooltip-z-group">
                                  <span className="apexcharts-tooltip-text-z-label" />
                                  <span className="apexcharts-tooltip-text-z-value" />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="apexcharts-xaxistooltip apexcharts-xaxistooltip-bottom apexcharts-theme-light">
                            <div
                              className="apexcharts-xaxistooltip-text"
                              style={{
                                fontFamily: "inherit",
                                fontSize: "12px",
                              }}
                            />
                          </div>
                          <div className="apexcharts-yaxistooltip apexcharts-yaxistooltip-0 apexcharts-yaxistooltip-left apexcharts-theme-light">
                            <div className="apexcharts-yaxistooltip-text" />
                          </div>
                        </div>
                      </div>
                      {/*end::Chart*/}
                    </div>
                    {/*end::Body*/}
                  </div>
                  {/*end::Mixed Widget 7*/}
                  {/*begin::Mixed Widget 10*/}
                  <div className="card card-xl-stretch-50 mb-5 mb-xl-8">
                    {/*begin::Body*/}
                    <div className="card-body p-0 d-flex justify-content-between flex-column overflow-hidden">
                      {/*begin::Hidden*/}
                      <div className="d-flex flex-stack flex-wrap flex-grow-1 px-9 pt-9 pb-3">
                        <div className="me-2">
                          <span className="fw-bolder text-gray-800 d-block fs-3">
                            Sales
                          </span>
                          <span className="text-gray-400 fw-bold">
                            Oct 8 - Oct 26 22
                          </span>
                        </div>
                        <div className="fw-bolder fs-3 text-primary">
                          $15,300
                        </div>
                      </div>
                      {/*end::Hidden*/}
                      {/*begin::Chart*/}
                      <div
                        className="mixed-widget-10-chart"
                        data-kt-color="primary"
                        style={{ height: "175px", minHeight: "183px" }}
                      >
                        <div
                          id="apexchartsj865etdb"
                          className="apexcharts-canvas apexchartsj865etdb apexcharts-theme-light"
                          style={{ width: "403px", height: "168px" }}
                        >
                          <svg
                            id="SvgjsSvg1157"
                            width={403}
                            height={168}
                            xmlns="http://www.w3.org/2000/svg"
                            version="1.1"
                            xmlnsXlink="http://www.w3.org/1999/xlink"
                            // xmlns:svgjs="http://svgjs.dev"
                            className="apexcharts-svg"
                            // xmlns:data="ApexChartsNS"
                            transform="translate(0, 0)"
                            style={{ background: "transparent" }}
                          >
                            <g
                              id="SvgjsG1159"
                              className="apexcharts-inner apexcharts-graphical"
                              transform="translate(42.572021484375, 40)"
                            >
                              <defs id="SvgjsDefs1158">
                                <linearGradient
                                  id="SvgjsLinearGradient1163"
                                  x1={0}
                                  y1={0}
                                  x2={0}
                                  y2={1}
                                >
                                  <stop
                                    id="SvgjsStop1164"
                                    stopOpacity="0.4"
                                    stopColor="rgba(216,227,240,0.4)"
                                    offset={0}
                                  />
                                  <stop
                                    id="SvgjsStop1165"
                                    stopOpacity="0.5"
                                    stopColor="rgba(190,209,230,0.5)"
                                    offset={1}
                                  />
                                  <stop
                                    id="SvgjsStop1166"
                                    stopOpacity="0.5"
                                    stopColor="rgba(190,209,230,0.5)"
                                    offset={1}
                                  />
                                </linearGradient>
                                <clipPath id="gridRectMaskj865etdb">
                                  <rect
                                    id="SvgjsRect1168"
                                    width="356.427978515625"
                                    height="87.494"
                                    x={-3}
                                    y={-1}
                                    rx={0}
                                    ry={0}
                                    opacity={1}
                                    strokeWidth={0}
                                    stroke="none"
                                    strokeDasharray={0}
                                    fill="#fff"
                                  />
                                </clipPath>
                                <clipPath id="forecastMaskj865etdb" />
                                <clipPath id="nonForecastMaskj865etdb" />
                                <clipPath id="gridRectMarkerMaskj865etdb">
                                  <rect
                                    id="SvgjsRect1169"
                                    width="354.427978515625"
                                    height="89.494"
                                    x={-2}
                                    y={-2}
                                    rx={0}
                                    ry={0}
                                    opacity={1}
                                    strokeWidth={0}
                                    stroke="none"
                                    strokeDasharray={0}
                                    fill="#fff"
                                  />
                                </clipPath>
                              </defs>
                              <rect
                                id="SvgjsRect1167"
                                width="10.950874328613281"
                                height="85.494"
                                x={0}
                                y={0}
                                rx={0}
                                ry={0}
                                opacity={1}
                                strokeWidth={0}
                                strokeDasharray={3}
                                fill="url(#SvgjsLinearGradient1163)"
                                className="apexcharts-xcrosshairs"
                                y2="85.494"
                                filter="none"
                                fillOpacity="0.9"
                              />
                              <g
                                id="SvgjsG1209"
                                className="apexcharts-xaxis"
                                transform="translate(0, 0)"
                              >
                                <g
                                  id="SvgjsG1210"
                                  className="apexcharts-xaxis-texts-g"
                                  transform="translate(0, -4)"
                                >
                                  <text
                                    id="SvgjsText1212"
                                    fontFamily="inherit"
                                    x="21.901748657226562"
                                    y="114.494"
                                    textAnchor="middle"
                                    dominantBaseline="auto"
                                    fontSize="12px"
                                    fontWeight={400}
                                    fill="#a1a5b7"
                                    className="apexcharts-text apexcharts-xaxis-label "
                                    style={{ fontFamily: "inherit" }}
                                  >
                                    <tspan id="SvgjsTspan1213">Feb</tspan>
                                    <title>Feb</title>
                                  </text>
                                  <text
                                    id="SvgjsText1215"
                                    fontFamily="inherit"
                                    x="65.70524597167969"
                                    y="114.494"
                                    textAnchor="middle"
                                    dominantBaseline="auto"
                                    fontSize="12px"
                                    fontWeight={400}
                                    fill="#a1a5b7"
                                    className="apexcharts-text apexcharts-xaxis-label "
                                    style={{ fontFamily: "inherit" }}
                                  >
                                    <tspan id="SvgjsTspan1216">Mar</tspan>
                                    <title>Mar</title>
                                  </text>
                                  <text
                                    id="SvgjsText1218"
                                    fontFamily="inherit"
                                    x="109.50874328613281"
                                    y="114.494"
                                    textAnchor="middle"
                                    dominantBaseline="auto"
                                    fontSize="12px"
                                    fontWeight={400}
                                    fill="#a1a5b7"
                                    className="apexcharts-text apexcharts-xaxis-label "
                                    style={{ fontFamily: "inherit" }}
                                  >
                                    <tspan id="SvgjsTspan1219">Apr</tspan>
                                    <title>Apr</title>
                                  </text>
                                  <text
                                    id="SvgjsText1221"
                                    fontFamily="inherit"
                                    x="153.31224060058594"
                                    y="114.494"
                                    textAnchor="middle"
                                    dominantBaseline="auto"
                                    fontSize="12px"
                                    fontWeight={400}
                                    fill="#a1a5b7"
                                    className="apexcharts-text apexcharts-xaxis-label "
                                    style={{ fontFamily: "inherit" }}
                                  >
                                    <tspan id="SvgjsTspan1222">May</tspan>
                                    <title>May</title>
                                  </text>
                                  <text
                                    id="SvgjsText1224"
                                    fontFamily="inherit"
                                    x="197.11573791503906"
                                    y="114.494"
                                    textAnchor="middle"
                                    dominantBaseline="auto"
                                    fontSize="12px"
                                    fontWeight={400}
                                    fill="#a1a5b7"
                                    className="apexcharts-text apexcharts-xaxis-label "
                                    style={{ fontFamily: "inherit" }}
                                  >
                                    <tspan id="SvgjsTspan1225">Jun</tspan>
                                    <title>Jun</title>
                                  </text>
                                  <text
                                    id="SvgjsText1227"
                                    fontFamily="inherit"
                                    x="240.9192352294922"
                                    y="114.494"
                                    textAnchor="middle"
                                    dominantBaseline="auto"
                                    fontSize="12px"
                                    fontWeight={400}
                                    fill="#a1a5b7"
                                    className="apexcharts-text apexcharts-xaxis-label "
                                    style={{ fontFamily: "inherit" }}
                                  >
                                    <tspan id="SvgjsTspan1228">Jul</tspan>
                                    <title>Jul</title>
                                  </text>
                                  <text
                                    id="SvgjsText1230"
                                    fontFamily="inherit"
                                    x="284.7227325439453"
                                    y="114.494"
                                    textAnchor="middle"
                                    dominantBaseline="auto"
                                    fontSize="12px"
                                    fontWeight={400}
                                    fill="#a1a5b7"
                                    className="apexcharts-text apexcharts-xaxis-label "
                                    style={{ fontFamily: "inherit" }}
                                  >
                                    <tspan id="SvgjsTspan1231">Aug</tspan>
                                    <title>Aug</title>
                                  </text>
                                  <text
                                    id="SvgjsText1233"
                                    fontFamily="inherit"
                                    x="328.52622985839844"
                                    y="114.494"
                                    textAnchor="middle"
                                    dominantBaseline="auto"
                                    fontSize="12px"
                                    fontWeight={400}
                                    fill="#a1a5b7"
                                    className="apexcharts-text apexcharts-xaxis-label "
                                    style={{ fontFamily: "inherit" }}
                                  >
                                    <tspan id="SvgjsTspan1234">Sep</tspan>
                                    <title>Sep</title>
                                  </text>
                                </g>
                              </g>
                              <g id="SvgjsG1247" className="apexcharts-grid">
                                <g
                                  id="SvgjsG1248"
                                  className="apexcharts-gridlines-horizontal"
                                >
                                  <line
                                    id="SvgjsLine1250"
                                    x1={0}
                                    y1={0}
                                    x2="350.427978515625"
                                    y2={0}
                                    stroke="#eff2f5"
                                    strokeDasharray={4}
                                    strokeLinecap="butt"
                                    className="apexcharts-gridline"
                                  />
                                  <line
                                    id="SvgjsLine1251"
                                    x1={0}
                                    y1="21.3735"
                                    x2="350.427978515625"
                                    y2="21.3735"
                                    stroke="#eff2f5"
                                    strokeDasharray={4}
                                    strokeLinecap="butt"
                                    className="apexcharts-gridline"
                                  />
                                  <line
                                    id="SvgjsLine1252"
                                    x1={0}
                                    y1="42.747"
                                    x2="350.427978515625"
                                    y2="42.747"
                                    stroke="#eff2f5"
                                    strokeDasharray={4}
                                    strokeLinecap="butt"
                                    className="apexcharts-gridline"
                                  />
                                  <line
                                    id="SvgjsLine1253"
                                    x1={0}
                                    y1="64.12049999999999"
                                    x2="350.427978515625"
                                    y2="64.12049999999999"
                                    stroke="#eff2f5"
                                    strokeDasharray={4}
                                    strokeLinecap="butt"
                                    className="apexcharts-gridline"
                                  />
                                  <line
                                    id="SvgjsLine1254"
                                    x1={0}
                                    y1="85.494"
                                    x2="350.427978515625"
                                    y2="85.494"
                                    stroke="#eff2f5"
                                    strokeDasharray={4}
                                    strokeLinecap="butt"
                                    className="apexcharts-gridline"
                                  />
                                </g>
                                <g
                                  id="SvgjsG1249"
                                  className="apexcharts-gridlines-vertical"
                                />
                                <line
                                  id="SvgjsLine1256"
                                  x1={0}
                                  y1="85.494"
                                  x2="350.427978515625"
                                  y2="85.494"
                                  stroke="transparent"
                                  strokeDasharray={0}
                                  strokeLinecap="butt"
                                />
                                <line
                                  id="SvgjsLine1255"
                                  x1={0}
                                  y1={1}
                                  x2={0}
                                  y2="85.494"
                                  stroke="transparent"
                                  strokeDasharray={0}
                                  strokeLinecap="butt"
                                />
                              </g>
                              <g
                                id="SvgjsG1170"
                                className="apexcharts-bar-series apexcharts-plot-series"
                              >
                                <g
                                  id="SvgjsG1171"
                                  className="apexcharts-series"
                                  rel={1}
                                  seriesname="NetxProfit"
                                  // data:realindex={0}
                                >
                                  <path
                                    id="SvgjsPath1175"
                                    d="M10.950874328613281 85.494L10.950874328613281 36.06025C10.950874328613281 33.39358333333334 12.284207661946613 32.06025 14.950874328613281 32.06025L15.901748657226562 32.06025C18.568415323893227 32.06025 19.901748657226562 33.39358333333334 19.901748657226562 36.06025L19.901748657226562 36.06025L19.901748657226562 85.494L19.901748657226562 85.494C19.901748657226562 85.494 10.950874328613281 85.494 10.950874328613281 85.494 "
                                    fill="rgba(0,158,247,0.85)"
                                    fillOpacity={1}
                                    stroke="transparent"
                                    strokeOpacity={1}
                                    strokeLinecap="round"
                                    strokeWidth={2}
                                    strokeDasharray={0}
                                    className="apexcharts-bar-area"
                                    index={0}
                                    clipPath="url(#gridRectMaskj865etdb)"
                                    pathto="M 10.950874328613281 85.494L 10.950874328613281 36.06025Q 10.950874328613281 32.06025 14.950874328613281 32.06025L 15.901748657226562 32.06025Q 19.901748657226562 32.06025 19.901748657226562 36.06025L 19.901748657226562 36.06025L 19.901748657226562 85.494L 19.901748657226562 85.494z"
                                    pathfrom="M 10.950874328613281 85.494L 10.950874328613281 85.494L 19.901748657226562 85.494L 19.901748657226562 85.494L 19.901748657226562 85.494L 19.901748657226562 85.494L 19.901748657226562 85.494L 10.950874328613281 85.494"
                                    cy="32.06025"
                                    cx="53.754371643066406"
                                    j={0}
                                    val={50}
                                    barheight="53.433749999999996"
                                    barwidth="10.950874328613281"
                                  />
                                  <path
                                    id="SvgjsPath1177"
                                    d="M54.754371643066406 85.494L54.754371643066406 25.373500000000007C54.754371643066406 22.706833333333336 56.087704976399735 21.373500000000007 58.754371643066406 21.373500000000007L59.70524597167969 21.373500000000007C62.37191263834635 21.373500000000007 63.70524597167969 22.706833333333336 63.70524597167969 25.373500000000007L63.70524597167969 25.373500000000007L63.70524597167969 85.494L63.70524597167969 85.494C63.70524597167969 85.494 54.754371643066406 85.494 54.754371643066406 85.494 "
                                    fill="rgba(0,158,247,0.85)"
                                    fillOpacity={1}
                                    stroke="transparent"
                                    strokeOpacity={1}
                                    strokeLinecap="round"
                                    strokeWidth={2}
                                    strokeDasharray={0}
                                    className="apexcharts-bar-area"
                                    index={0}
                                    clipPath="url(#gridRectMaskj865etdb)"
                                    pathto="M 54.754371643066406 85.494L 54.754371643066406 25.373500000000007Q 54.754371643066406 21.373500000000007 58.754371643066406 21.373500000000007L 59.70524597167969 21.373500000000007Q 63.70524597167969 21.373500000000007 63.70524597167969 25.373500000000007L 63.70524597167969 25.373500000000007L 63.70524597167969 85.494L 63.70524597167969 85.494z"
                                    pathfrom="M 54.754371643066406 85.494L 54.754371643066406 85.494L 63.70524597167969 85.494L 63.70524597167969 85.494L 63.70524597167969 85.494L 63.70524597167969 85.494L 63.70524597167969 85.494L 54.754371643066406 85.494"
                                    cy="21.373500000000007"
                                    cx="97.55786895751953"
                                    j={1}
                                    val={60}
                                    barheight="64.12049999999999"
                                    barwidth="10.950874328613281"
                                  />
                                  <path
                                    id="SvgjsPath1179"
                                    d="M98.55786895751953 85.494L98.55786895751953 14.686750000000004C98.55786895751953 12.020083333333332 99.89120229085287 10.686750000000004 102.55786895751953 10.686750000000004L103.50874328613281 10.686750000000004C106.17540995279948 10.686750000000004 107.50874328613281 12.020083333333332 107.50874328613281 14.686750000000004L107.50874328613281 14.686750000000004L107.50874328613281 85.494L107.50874328613281 85.494C107.50874328613281 85.494 98.55786895751953 85.494 98.55786895751953 85.494 "
                                    fill="rgba(0,158,247,0.85)"
                                    fillOpacity={1}
                                    stroke="transparent"
                                    strokeOpacity={1}
                                    strokeLinecap="round"
                                    strokeWidth={2}
                                    strokeDasharray={0}
                                    className="apexcharts-bar-area"
                                    index={0}
                                    clipPath="url(#gridRectMaskj865etdb)"
                                    pathto="M 98.55786895751953 85.494L 98.55786895751953 14.686750000000004Q 98.55786895751953 10.686750000000004 102.55786895751953 10.686750000000004L 103.50874328613281 10.686750000000004Q 107.50874328613281 10.686750000000004 107.50874328613281 14.686750000000004L 107.50874328613281 14.686750000000004L 107.50874328613281 85.494L 107.50874328613281 85.494z"
                                    pathfrom="M 98.55786895751953 85.494L 98.55786895751953 85.494L 107.50874328613281 85.494L 107.50874328613281 85.494L 107.50874328613281 85.494L 107.50874328613281 85.494L 107.50874328613281 85.494L 98.55786895751953 85.494"
                                    cy="10.686750000000004"
                                    cx="141.36136627197266"
                                    j={2}
                                    val={70}
                                    barheight="74.80725"
                                    barwidth="10.950874328613281"
                                  />
                                  <path
                                    id="SvgjsPath1181"
                                    d="M142.36136627197266 85.494L142.36136627197266 4C142.36136627197266 1.3333333333333286 143.694699605306 0 146.36136627197266 0L147.31224060058594 0C149.97890726725262 0 151.31224060058594 1.3333333333333286 151.31224060058594 4L151.31224060058594 4L151.31224060058594 85.494L151.31224060058594 85.494C151.31224060058594 85.494 142.36136627197266 85.494 142.36136627197266 85.494 "
                                    fill="rgba(0,158,247,0.85)"
                                    fillOpacity={1}
                                    stroke="transparent"
                                    strokeOpacity={1}
                                    strokeLinecap="round"
                                    strokeWidth={2}
                                    strokeDasharray={0}
                                    className="apexcharts-bar-area"
                                    index={0}
                                    clipPath="url(#gridRectMaskj865etdb)"
                                    pathto="M 142.36136627197266 85.494L 142.36136627197266 4Q 142.36136627197266 0 146.36136627197266 0L 147.31224060058594 0Q 151.31224060058594 0 151.31224060058594 4L 151.31224060058594 4L 151.31224060058594 85.494L 151.31224060058594 85.494z"
                                    pathfrom="M 142.36136627197266 85.494L 142.36136627197266 85.494L 151.31224060058594 85.494L 151.31224060058594 85.494L 151.31224060058594 85.494L 151.31224060058594 85.494L 151.31224060058594 85.494L 142.36136627197266 85.494"
                                    cy={0}
                                    cx="185.16486358642578"
                                    j={3}
                                    val={80}
                                    barheight="85.494"
                                    barwidth="10.950874328613281"
                                  />
                                  <path
                                    id="SvgjsPath1183"
                                    d="M186.16486358642578 85.494L186.16486358642578 25.373500000000007C186.16486358642578 22.706833333333336 187.49819691975912 21.373500000000007 190.16486358642578 21.373500000000007L191.11573791503906 21.373500000000007C193.78240458170572 21.373500000000007 195.11573791503906 22.706833333333336 195.11573791503906 25.373500000000007L195.11573791503906 25.373500000000007L195.11573791503906 85.494L195.11573791503906 85.494C195.11573791503906 85.494 186.16486358642578 85.494 186.16486358642578 85.494 "
                                    fill="rgba(0,158,247,0.85)"
                                    fillOpacity={1}
                                    stroke="transparent"
                                    strokeOpacity={1}
                                    strokeLinecap="round"
                                    strokeWidth={2}
                                    strokeDasharray={0}
                                    className="apexcharts-bar-area"
                                    index={0}
                                    clipPath="url(#gridRectMaskj865etdb)"
                                    pathto="M 186.16486358642578 85.494L 186.16486358642578 25.373500000000007Q 186.16486358642578 21.373500000000007 190.16486358642578 21.373500000000007L 191.11573791503906 21.373500000000007Q 195.11573791503906 21.373500000000007 195.11573791503906 25.373500000000007L 195.11573791503906 25.373500000000007L 195.11573791503906 85.494L 195.11573791503906 85.494z"
                                    pathfrom="M 186.16486358642578 85.494L 186.16486358642578 85.494L 195.11573791503906 85.494L 195.11573791503906 85.494L 195.11573791503906 85.494L 195.11573791503906 85.494L 195.11573791503906 85.494L 186.16486358642578 85.494"
                                    cy="21.373500000000007"
                                    cx="228.9683609008789"
                                    j={4}
                                    val={60}
                                    barheight="64.12049999999999"
                                    barwidth="10.950874328613281"
                                  />
                                  <path
                                    id="SvgjsPath1185"
                                    d="M229.9683609008789 85.494L229.9683609008789 36.06025C229.9683609008789 33.39358333333334 231.30169423421222 32.06025 233.9683609008789 32.06025L234.9192352294922 32.06025C237.58590189615884 32.06025 238.9192352294922 33.39358333333334 238.9192352294922 36.06025L238.9192352294922 36.06025L238.9192352294922 85.494L238.9192352294922 85.494C238.9192352294922 85.494 229.9683609008789 85.494 229.9683609008789 85.494 "
                                    fill="rgba(0,158,247,0.85)"
                                    fillOpacity={1}
                                    stroke="transparent"
                                    strokeOpacity={1}
                                    strokeLinecap="round"
                                    strokeWidth={2}
                                    strokeDasharray={0}
                                    className="apexcharts-bar-area"
                                    index={0}
                                    clipPath="url(#gridRectMaskj865etdb)"
                                    pathto="M 229.9683609008789 85.494L 229.9683609008789 36.06025Q 229.9683609008789 32.06025 233.9683609008789 32.06025L 234.9192352294922 32.06025Q 238.9192352294922 32.06025 238.9192352294922 36.06025L 238.9192352294922 36.06025L 238.9192352294922 85.494L 238.9192352294922 85.494z"
                                    pathfrom="M 229.9683609008789 85.494L 229.9683609008789 85.494L 238.9192352294922 85.494L 238.9192352294922 85.494L 238.9192352294922 85.494L 238.9192352294922 85.494L 238.9192352294922 85.494L 229.9683609008789 85.494"
                                    cy="32.06025"
                                    cx="272.77185821533203"
                                    j={5}
                                    val={50}
                                    barheight="53.433749999999996"
                                    barwidth="10.950874328613281"
                                  />
                                  <path
                                    id="SvgjsPath1187"
                                    d="M273.77185821533203 85.494L273.77185821533203 14.686750000000004C273.77185821533203 12.020083333333332 275.10519154866535 10.686750000000004 277.77185821533203 10.686750000000004L278.7227325439453 10.686750000000004C281.38939921061194 10.686750000000004 282.7227325439453 12.020083333333332 282.7227325439453 14.686750000000004L282.7227325439453 14.686750000000004L282.7227325439453 85.494L282.7227325439453 85.494C282.7227325439453 85.494 273.77185821533203 85.494 273.77185821533203 85.494 "
                                    fill="rgba(0,158,247,0.85)"
                                    fillOpacity={1}
                                    stroke="transparent"
                                    strokeOpacity={1}
                                    strokeLinecap="round"
                                    strokeWidth={2}
                                    strokeDasharray={0}
                                    className="apexcharts-bar-area"
                                    index={0}
                                    clipPath="url(#gridRectMaskj865etdb)"
                                    pathto="M 273.77185821533203 85.494L 273.77185821533203 14.686750000000004Q 273.77185821533203 10.686750000000004 277.77185821533203 10.686750000000004L 278.7227325439453 10.686750000000004Q 282.7227325439453 10.686750000000004 282.7227325439453 14.686750000000004L 282.7227325439453 14.686750000000004L 282.7227325439453 85.494L 282.7227325439453 85.494z"
                                    pathfrom="M 273.77185821533203 85.494L 273.77185821533203 85.494L 282.7227325439453 85.494L 282.7227325439453 85.494L 282.7227325439453 85.494L 282.7227325439453 85.494L 282.7227325439453 85.494L 273.77185821533203 85.494"
                                    cy="10.686750000000004"
                                    cx="316.57535552978516"
                                    j={6}
                                    val={70}
                                    barheight="74.80725"
                                    barwidth="10.950874328613281"
                                  />
                                  <path
                                    id="SvgjsPath1189"
                                    d="M317.57535552978516 85.494L317.57535552978516 25.373500000000007C317.57535552978516 22.706833333333336 318.90868886311847 21.373500000000007 321.57535552978516 21.373500000000007L322.52622985839844 21.373500000000007C325.19289652506507 21.373500000000007 326.52622985839844 22.706833333333336 326.52622985839844 25.373500000000007L326.52622985839844 25.373500000000007L326.52622985839844 85.494L326.52622985839844 85.494C326.52622985839844 85.494 317.57535552978516 85.494 317.57535552978516 85.494 "
                                    fill="rgba(0,158,247,0.85)"
                                    fillOpacity={1}
                                    stroke="transparent"
                                    strokeOpacity={1}
                                    strokeLinecap="round"
                                    strokeWidth={2}
                                    strokeDasharray={0}
                                    className="apexcharts-bar-area"
                                    index={0}
                                    clipPath="url(#gridRectMaskj865etdb)"
                                    pathto="M 317.57535552978516 85.494L 317.57535552978516 25.373500000000007Q 317.57535552978516 21.373500000000007 321.57535552978516 21.373500000000007L 322.52622985839844 21.373500000000007Q 326.52622985839844 21.373500000000007 326.52622985839844 25.373500000000007L 326.52622985839844 25.373500000000007L 326.52622985839844 85.494L 326.52622985839844 85.494z"
                                    pathfrom="M 317.57535552978516 85.494L 317.57535552978516 85.494L 326.52622985839844 85.494L 326.52622985839844 85.494L 326.52622985839844 85.494L 326.52622985839844 85.494L 326.52622985839844 85.494L 317.57535552978516 85.494"
                                    cy="21.373500000000007"
                                    cx="360.3788528442383"
                                    j={7}
                                    val={60}
                                    barheight="64.12049999999999"
                                    barwidth="10.950874328613281"
                                  />
                                  <g
                                    id="SvgjsG1173"
                                    className="apexcharts-bar-goals-markers"
                                    style={{ pointerEvents: "none" }}
                                  >
                                    <g
                                      id="SvgjsG1174"
                                      classname="apexcharts-bar-goals-groups"
                                    />
                                    <g
                                      id="SvgjsG1176"
                                      classname="apexcharts-bar-goals-groups"
                                    />
                                    <g
                                      id="SvgjsG1178"
                                      classname="apexcharts-bar-goals-groups"
                                    />
                                    <g
                                      id="SvgjsG1180"
                                      classname="apexcharts-bar-goals-groups"
                                    />
                                    <g
                                      id="SvgjsG1182"
                                      classname="apexcharts-bar-goals-groups"
                                    />
                                    <g
                                      id="SvgjsG1184"
                                      classname="apexcharts-bar-goals-groups"
                                    />
                                    <g
                                      id="SvgjsG1186"
                                      classname="apexcharts-bar-goals-groups"
                                    />
                                    <g
                                      id="SvgjsG1188"
                                      classname="apexcharts-bar-goals-groups"
                                    />
                                  </g>
                                </g>
                                <g
                                  id="SvgjsG1190"
                                  className="apexcharts-series"
                                  rel={2}
                                  seriesname="Revenue"
                                  // data:realindex={1}
                                >
                                  <path
                                    id="SvgjsPath1194"
                                    d="M21.901748657226562 85.494L21.901748657226562 36.06025C21.901748657226562 33.39358333333334 23.235081990559898 32.06025 25.901748657226562 32.06025L26.852622985839844 32.06025C29.51928965250651 32.06025 30.852622985839844 33.39358333333334 30.852622985839844 36.06025L30.852622985839844 36.06025L30.852622985839844 85.494L30.852622985839844 85.494C30.852622985839844 85.494 21.901748657226562 85.494 21.901748657226562 85.494 "
                                    fill="rgba(228,230,239,0.85)"
                                    fillOpacity={1}
                                    stroke="transparent"
                                    strokeOpacity={1}
                                    strokeLinecap="round"
                                    strokeWidth={2}
                                    strokeDasharray={0}
                                    className="apexcharts-bar-area"
                                    index={1}
                                    clipPath="url(#gridRectMaskj865etdb)"
                                    pathto="M 21.901748657226562 85.494L 21.901748657226562 36.06025Q 21.901748657226562 32.06025 25.901748657226562 32.06025L 26.852622985839844 32.06025Q 30.852622985839844 32.06025 30.852622985839844 36.06025L 30.852622985839844 36.06025L 30.852622985839844 85.494L 30.852622985839844 85.494z"
                                    pathfrom="M 21.901748657226562 85.494L 21.901748657226562 85.494L 30.852622985839844 85.494L 30.852622985839844 85.494L 30.852622985839844 85.494L 30.852622985839844 85.494L 30.852622985839844 85.494L 21.901748657226562 85.494"
                                    cy="32.06025"
                                    cx="64.70524597167969"
                                    j={0}
                                    val={50}
                                    barheight="53.433749999999996"
                                    barwidth="10.950874328613281"
                                  />
                                  <path
                                    id="SvgjsPath1196"
                                    d="M65.70524597167969 85.494L65.70524597167969 25.373500000000007C65.70524597167969 22.706833333333336 67.03857930501302 21.373500000000007 69.70524597167969 21.373500000000007L70.65612030029297 21.373500000000007C73.32278696695963 21.373500000000007 74.65612030029297 22.706833333333336 74.65612030029297 25.373500000000007L74.65612030029297 25.373500000000007L74.65612030029297 85.494L74.65612030029297 85.494C74.65612030029297 85.494 65.70524597167969 85.494 65.70524597167969 85.494 "
                                    fill="rgba(228,230,239,0.85)"
                                    fillOpacity={1}
                                    stroke="transparent"
                                    strokeOpacity={1}
                                    strokeLinecap="round"
                                    strokeWidth={2}
                                    strokeDasharray={0}
                                    className="apexcharts-bar-area"
                                    index={1}
                                    clipPath="url(#gridRectMaskj865etdb)"
                                    pathto="M 65.70524597167969 85.494L 65.70524597167969 25.373500000000007Q 65.70524597167969 21.373500000000007 69.70524597167969 21.373500000000007L 70.65612030029297 21.373500000000007Q 74.65612030029297 21.373500000000007 74.65612030029297 25.373500000000007L 74.65612030029297 25.373500000000007L 74.65612030029297 85.494L 74.65612030029297 85.494z"
                                    pathfrom="M 65.70524597167969 85.494L 65.70524597167969 85.494L 74.65612030029297 85.494L 74.65612030029297 85.494L 74.65612030029297 85.494L 74.65612030029297 85.494L 74.65612030029297 85.494L 65.70524597167969 85.494"
                                    cy="21.373500000000007"
                                    cx="108.50874328613281"
                                    j={1}
                                    val={60}
                                    barheight="64.12049999999999"
                                    barwidth="10.950874328613281"
                                  />
                                  <path
                                    id="SvgjsPath1198"
                                    d="M109.50874328613281 85.494L109.50874328613281 14.686750000000004C109.50874328613281 12.020083333333332 110.84207661946616 10.686750000000004 113.50874328613281 10.686750000000004L114.4596176147461 10.686750000000004C117.12628428141277 10.686750000000004 118.4596176147461 12.020083333333332 118.4596176147461 14.686750000000004L118.4596176147461 14.686750000000004L118.4596176147461 85.494L118.4596176147461 85.494C118.4596176147461 85.494 109.50874328613281 85.494 109.50874328613281 85.494 "
                                    fill="rgba(228,230,239,0.85)"
                                    fillOpacity={1}
                                    stroke="transparent"
                                    strokeOpacity={1}
                                    strokeLinecap="round"
                                    strokeWidth={2}
                                    strokeDasharray={0}
                                    className="apexcharts-bar-area"
                                    index={1}
                                    clipPath="url(#gridRectMaskj865etdb)"
                                    pathto="M 109.50874328613281 85.494L 109.50874328613281 14.686750000000004Q 109.50874328613281 10.686750000000004 113.50874328613281 10.686750000000004L 114.4596176147461 10.686750000000004Q 118.4596176147461 10.686750000000004 118.4596176147461 14.686750000000004L 118.4596176147461 14.686750000000004L 118.4596176147461 85.494L 118.4596176147461 85.494z"
                                    pathfrom="M 109.50874328613281 85.494L 109.50874328613281 85.494L 118.4596176147461 85.494L 118.4596176147461 85.494L 118.4596176147461 85.494L 118.4596176147461 85.494L 118.4596176147461 85.494L 109.50874328613281 85.494"
                                    cy="10.686750000000004"
                                    cx="152.31224060058594"
                                    j={2}
                                    val={70}
                                    barheight="74.80725"
                                    barwidth="10.950874328613281"
                                  />
                                  <path
                                    id="SvgjsPath1200"
                                    d="M153.31224060058594 85.494L153.31224060058594 4C153.31224060058594 1.3333333333333286 154.64557393391928 0 157.31224060058594 0L158.26311492919922 0C160.9297815958659 0 162.26311492919922 1.3333333333333286 162.26311492919922 4L162.26311492919922 4L162.26311492919922 85.494L162.26311492919922 85.494C162.26311492919922 85.494 153.31224060058594 85.494 153.31224060058594 85.494 "
                                    fill="rgba(228,230,239,0.85)"
                                    fillOpacity={1}
                                    stroke="transparent"
                                    strokeOpacity={1}
                                    strokeLinecap="round"
                                    strokeWidth={2}
                                    strokeDasharray={0}
                                    className="apexcharts-bar-area"
                                    index={1}
                                    clipPath="url(#gridRectMaskj865etdb)"
                                    pathto="M 153.31224060058594 85.494L 153.31224060058594 4Q 153.31224060058594 0 157.31224060058594 0L 158.26311492919922 0Q 162.26311492919922 0 162.26311492919922 4L 162.26311492919922 4L 162.26311492919922 85.494L 162.26311492919922 85.494z"
                                    pathfrom="M 153.31224060058594 85.494L 153.31224060058594 85.494L 162.26311492919922 85.494L 162.26311492919922 85.494L 162.26311492919922 85.494L 162.26311492919922 85.494L 162.26311492919922 85.494L 153.31224060058594 85.494"
                                    cy={0}
                                    cx="196.11573791503906"
                                    j={3}
                                    val={80}
                                    barheight="85.494"
                                    barwidth="10.950874328613281"
                                  />
                                  <path
                                    id="SvgjsPath1202"
                                    d="M197.11573791503906 85.494L197.11573791503906 25.373500000000007C197.11573791503906 22.706833333333336 198.44907124837238 21.373500000000007 201.11573791503906 21.373500000000007L202.06661224365234 21.373500000000007C204.733278910319 21.373500000000007 206.06661224365234 22.706833333333336 206.06661224365234 25.373500000000007L206.06661224365234 25.373500000000007L206.06661224365234 85.494L206.06661224365234 85.494C206.06661224365234 85.494 197.11573791503906 85.494 197.11573791503906 85.494 "
                                    fill="rgba(228,230,239,0.85)"
                                    fillOpacity={1}
                                    stroke="transparent"
                                    strokeOpacity={1}
                                    strokeLinecap="round"
                                    strokeWidth={2}
                                    strokeDasharray={0}
                                    className="apexcharts-bar-area"
                                    index={1}
                                    clipPath="url(#gridRectMaskj865etdb)"
                                    pathto="M 197.11573791503906 85.494L 197.11573791503906 25.373500000000007Q 197.11573791503906 21.373500000000007 201.11573791503906 21.373500000000007L 202.06661224365234 21.373500000000007Q 206.06661224365234 21.373500000000007 206.06661224365234 25.373500000000007L 206.06661224365234 25.373500000000007L 206.06661224365234 85.494L 206.06661224365234 85.494z"
                                    pathfrom="M 197.11573791503906 85.494L 197.11573791503906 85.494L 206.06661224365234 85.494L 206.06661224365234 85.494L 206.06661224365234 85.494L 206.06661224365234 85.494L 206.06661224365234 85.494L 197.11573791503906 85.494"
                                    cy="21.373500000000007"
                                    cx="239.9192352294922"
                                    j={4}
                                    val={60}
                                    barheight="64.12049999999999"
                                    barwidth="10.950874328613281"
                                  />
                                  <path
                                    id="SvgjsPath1204"
                                    d="M240.9192352294922 85.494L240.9192352294922 36.06025C240.9192352294922 33.39358333333334 242.2525685628255 32.06025 244.9192352294922 32.06025L245.87010955810547 32.06025C248.53677622477213 32.06025 249.87010955810547 33.39358333333334 249.87010955810547 36.06025L249.87010955810547 36.06025L249.87010955810547 85.494L249.87010955810547 85.494C249.87010955810547 85.494 240.9192352294922 85.494 240.9192352294922 85.494 "
                                    fill="rgba(228,230,239,0.85)"
                                    fillOpacity={1}
                                    stroke="transparent"
                                    strokeOpacity={1}
                                    strokeLinecap="round"
                                    strokeWidth={2}
                                    strokeDasharray={0}
                                    className="apexcharts-bar-area"
                                    index={1}
                                    clipPath="url(#gridRectMaskj865etdb)"
                                    pathto="M 240.9192352294922 85.494L 240.9192352294922 36.06025Q 240.9192352294922 32.06025 244.9192352294922 32.06025L 245.87010955810547 32.06025Q 249.87010955810547 32.06025 249.87010955810547 36.06025L 249.87010955810547 36.06025L 249.87010955810547 85.494L 249.87010955810547 85.494z"
                                    pathfrom="M 240.9192352294922 85.494L 240.9192352294922 85.494L 249.87010955810547 85.494L 249.87010955810547 85.494L 249.87010955810547 85.494L 249.87010955810547 85.494L 249.87010955810547 85.494L 240.9192352294922 85.494"
                                    cy="32.06025"
                                    cx="283.7227325439453"
                                    j={5}
                                    val={50}
                                    barheight="53.433749999999996"
                                    barwidth="10.950874328613281"
                                  />
                                  <path
                                    id="SvgjsPath1206"
                                    d="M284.7227325439453 85.494L284.7227325439453 14.686750000000004C284.7227325439453 12.020083333333332 286.0560658772786 10.686750000000004 288.7227325439453 10.686750000000004L289.6736068725586 10.686750000000004C292.3402735392252 10.686750000000004 293.6736068725586 12.020083333333332 293.6736068725586 14.686750000000004L293.6736068725586 14.686750000000004L293.6736068725586 85.494L293.6736068725586 85.494C293.6736068725586 85.494 284.7227325439453 85.494 284.7227325439453 85.494 "
                                    fill="rgba(228,230,239,0.85)"
                                    fillOpacity={1}
                                    stroke="transparent"
                                    strokeOpacity={1}
                                    strokeLinecap="round"
                                    strokeWidth={2}
                                    strokeDasharray={0}
                                    className="apexcharts-bar-area"
                                    index={1}
                                    clipPath="url(#gridRectMaskj865etdb)"
                                    pathto="M 284.7227325439453 85.494L 284.7227325439453 14.686750000000004Q 284.7227325439453 10.686750000000004 288.7227325439453 10.686750000000004L 289.6736068725586 10.686750000000004Q 293.6736068725586 10.686750000000004 293.6736068725586 14.686750000000004L 293.6736068725586 14.686750000000004L 293.6736068725586 85.494L 293.6736068725586 85.494z"
                                    pathfrom="M 284.7227325439453 85.494L 284.7227325439453 85.494L 293.6736068725586 85.494L 293.6736068725586 85.494L 293.6736068725586 85.494L 293.6736068725586 85.494L 293.6736068725586 85.494L 284.7227325439453 85.494"
                                    cy="10.686750000000004"
                                    cx="327.52622985839844"
                                    j={6}
                                    val={70}
                                    barheight="74.80725"
                                    barwidth="10.950874328613281"
                                  />
                                  <path
                                    id="SvgjsPath1208"
                                    d="M328.52622985839844 85.494L328.52622985839844 25.373500000000007C328.52622985839844 22.706833333333336 329.85956319173175 21.373500000000007 332.52622985839844 21.373500000000007L333.4771041870117 21.373500000000007C336.14377085367835 21.373500000000007 337.4771041870117 22.706833333333336 337.4771041870117 25.373500000000007L337.4771041870117 25.373500000000007L337.4771041870117 85.494L337.4771041870117 85.494C337.4771041870117 85.494 328.52622985839844 85.494 328.52622985839844 85.494 "
                                    fill="rgba(228,230,239,0.85)"
                                    fillOpacity={1}
                                    stroke="transparent"
                                    strokeOpacity={1}
                                    strokeLinecap="round"
                                    strokeWidth={2}
                                    strokeDasharray={0}
                                    className="apexcharts-bar-area"
                                    index={1}
                                    clipPath="url(#gridRectMaskj865etdb)"
                                    pathto="M 328.52622985839844 85.494L 328.52622985839844 25.373500000000007Q 328.52622985839844 21.373500000000007 332.52622985839844 21.373500000000007L 333.4771041870117 21.373500000000007Q 337.4771041870117 21.373500000000007 337.4771041870117 25.373500000000007L 337.4771041870117 25.373500000000007L 337.4771041870117 85.494L 337.4771041870117 85.494z"
                                    pathfrom="M 328.52622985839844 85.494L 328.52622985839844 85.494L 337.4771041870117 85.494L 337.4771041870117 85.494L 337.4771041870117 85.494L 337.4771041870117 85.494L 337.4771041870117 85.494L 328.52622985839844 85.494"
                                    cy="21.373500000000007"
                                    cx="371.32972717285156"
                                    j={7}
                                    val={60}
                                    barheight="64.12049999999999"
                                    barwidth="10.950874328613281"
                                  />
                                  <g
                                    id="SvgjsG1192"
                                    className="apexcharts-bar-goals-markers"
                                    style={{ pointerEvents: "none" }}
                                  >
                                    <g
                                      id="SvgjsG1193"
                                      classname="apexcharts-bar-goals-groups"
                                    />
                                    <g
                                      id="SvgjsG1195"
                                      classname="apexcharts-bar-goals-groups"
                                    />
                                    <g
                                      id="SvgjsG1197"
                                      classname="apexcharts-bar-goals-groups"
                                    />
                                    <g
                                      id="SvgjsG1199"
                                      classname="apexcharts-bar-goals-groups"
                                    />
                                    <g
                                      id="SvgjsG1201"
                                      classname="apexcharts-bar-goals-groups"
                                    />
                                    <g
                                      id="SvgjsG1203"
                                      classname="apexcharts-bar-goals-groups"
                                    />
                                    <g
                                      id="SvgjsG1205"
                                      classname="apexcharts-bar-goals-groups"
                                    />
                                    <g
                                      id="SvgjsG1207"
                                      classname="apexcharts-bar-goals-groups"
                                    />
                                  </g>
                                </g>
                                <g
                                  id="SvgjsG1172"
                                  className="apexcharts-datalabels"
                                  // data:realindex={0}
                                />
                                <g
                                  id="SvgjsG1191"
                                  className="apexcharts-datalabels"
                                  // data:realindex={1}
                                />
                              </g>
                              <line
                                id="SvgjsLine1257"
                                x1={0}
                                y1={0}
                                x2="350.427978515625"
                                y2={0}
                                stroke="#b6b6b6"
                                strokeDasharray={0}
                                strokeWidth={1}
                                strokeLinecap="butt"
                                className="apexcharts-ycrosshairs"
                              />
                              <line
                                id="SvgjsLine1258"
                                x1={0}
                                y1={0}
                                x2="350.427978515625"
                                y2={0}
                                strokeDasharray={0}
                                strokeWidth={0}
                                strokeLinecap="butt"
                                className="apexcharts-ycrosshairs-hidden"
                              />
                              <g
                                id="SvgjsG1259"
                                className="apexcharts-yaxis-annotations"
                              />
                              <g
                                id="SvgjsG1260"
                                className="apexcharts-xaxis-annotations"
                              />
                              <g
                                id="SvgjsG1261"
                                className="apexcharts-point-annotations"
                              />
                            </g>
                            <g
                              id="SvgjsG1235"
                              className="apexcharts-yaxis"
                              rel={0}
                              transform="translate(12.572021484375, 0)"
                            >
                              <g
                                id="SvgjsG1236"
                                className="apexcharts-yaxis-texts-g"
                              >
                                <text
                                  id="SvgjsText1237"
                                  fontFamily="inherit"
                                  x={20}
                                  y="41.4"
                                  textAnchor="end"
                                  dominantBaseline="auto"
                                  fontSize="12px"
                                  fontWeight={400}
                                  fill="#a1a5b7"
                                  className="apexcharts-text apexcharts-yaxis-label "
                                  style={{ fontFamily: "inherit" }}
                                >
                                  <tspan id="SvgjsTspan1238">80</tspan>
                                  <title>80</title>
                                </text>
                                <text
                                  id="SvgjsText1239"
                                  fontFamily="inherit"
                                  x={20}
                                  y="62.7735"
                                  textAnchor="end"
                                  dominantBaseline="auto"
                                  fontSize="12px"
                                  fontWeight={400}
                                  fill="#a1a5b7"
                                  className="apexcharts-text apexcharts-yaxis-label "
                                  style={{ fontFamily: "inherit" }}
                                >
                                  <tspan id="SvgjsTspan1240">60</tspan>
                                  <title>60</title>
                                </text>
                                <text
                                  id="SvgjsText1241"
                                  fontFamily="inherit"
                                  x={20}
                                  y="84.147"
                                  textAnchor="end"
                                  dominantBaseline="auto"
                                  fontSize="12px"
                                  fontWeight={400}
                                  fill="#a1a5b7"
                                  className="apexcharts-text apexcharts-yaxis-label "
                                  style={{ fontFamily: "inherit" }}
                                >
                                  <tspan id="SvgjsTspan1242">40</tspan>
                                  <title>40</title>
                                </text>
                                <text
                                  id="SvgjsText1243"
                                  fontFamily="inherit"
                                  x={20}
                                  y="105.5205"
                                  textAnchor="end"
                                  dominantBaseline="auto"
                                  fontSize="12px"
                                  fontWeight={400}
                                  fill="#a1a5b7"
                                  className="apexcharts-text apexcharts-yaxis-label "
                                  style={{ fontFamily: "inherit" }}
                                >
                                  <tspan id="SvgjsTspan1244">20</tspan>
                                  <title>20</title>
                                </text>
                                <text
                                  id="SvgjsText1245"
                                  fontFamily="inherit"
                                  x={20}
                                  y="126.894"
                                  textAnchor="end"
                                  dominantBaseline="auto"
                                  fontSize="12px"
                                  fontWeight={400}
                                  fill="#a1a5b7"
                                  className="apexcharts-text apexcharts-yaxis-label "
                                  style={{ fontFamily: "inherit" }}
                                >
                                  <tspan id="SvgjsTspan1246">0</tspan>
                                  <title>0</title>
                                </text>
                              </g>
                            </g>
                            <g
                              id="SvgjsG1160"
                              className="apexcharts-annotations"
                            />
                          </svg>
                          <div
                            className="apexcharts-legend"
                            style={{ maxHeight: "84px" }}
                          />
                          <div className="apexcharts-tooltip apexcharts-theme-light">
                            <div
                              className="apexcharts-tooltip-title"
                              style={{
                                fontFamily: "inherit",
                                fontSize: "12px",
                              }}
                            />
                            <div
                              className="apexcharts-tooltip-series-group"
                              style={{ order: 1 }}
                            >
                              <span
                                className="apexcharts-tooltip-marker"
                                style={{ backgroundColor: "rgb(0, 158, 247)" }}
                              />
                              <div
                                className="apexcharts-tooltip-text"
                                style={{
                                  fontFamily: "inherit",
                                  fontSize: "12px",
                                }}
                              >
                                <div className="apexcharts-tooltip-y-group">
                                  <span className="apexcharts-tooltip-text-y-label" />
                                  <span className="apexcharts-tooltip-text-y-value" />
                                </div>
                                <div className="apexcharts-tooltip-goals-group">
                                  <span className="apexcharts-tooltip-text-goals-label" />
                                  <span className="apexcharts-tooltip-text-goals-value" />
                                </div>
                                <div className="apexcharts-tooltip-z-group">
                                  <span className="apexcharts-tooltip-text-z-label" />
                                  <span className="apexcharts-tooltip-text-z-value" />
                                </div>
                              </div>
                            </div>
                            <div
                              className="apexcharts-tooltip-series-group"
                              style={{ order: 2 }}
                            >
                              <span
                                className="apexcharts-tooltip-marker"
                                style={{
                                  backgroundColor: "rgb(228, 230, 239)",
                                }}
                              />
                              <div
                                className="apexcharts-tooltip-text"
                                style={{
                                  fontFamily: "inherit",
                                  fontSize: "12px",
                                }}
                              >
                                <div className="apexcharts-tooltip-y-group">
                                  <span className="apexcharts-tooltip-text-y-label" />
                                  <span className="apexcharts-tooltip-text-y-value" />
                                </div>
                                <div className="apexcharts-tooltip-goals-group">
                                  <span className="apexcharts-tooltip-text-goals-label" />
                                  <span className="apexcharts-tooltip-text-goals-value" />
                                </div>
                                <div className="apexcharts-tooltip-z-group">
                                  <span className="apexcharts-tooltip-text-z-label" />
                                  <span className="apexcharts-tooltip-text-z-value" />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="apexcharts-yaxistooltip apexcharts-yaxistooltip-0 apexcharts-yaxistooltip-left apexcharts-theme-light">
                            <div className="apexcharts-yaxistooltip-text" />
                          </div>
                        </div>
                      </div>
                      {/*end::Chart*/}
                    </div>
                  </div>
                  {/*end::Mixed Widget 10*/}
                </div>
                {/*end::Col*/}
              </div>
              {/*end::Row*/}
              {/*begin::Row*/}
              <div className="row gy-5 g-xl-8">
                {/*begin::Col*/}
                <div className="col-xl-4">
                  {/*begin::List Widget 3*/}
                  <div className="card card-xl-stretch mb-xl-8">
                    {/*begin::Header*/}
                    <div className="card-header border-0">
                      <h3 className="card-title fw-bolder text-dark">Todo</h3>
                      <div className="card-toolbar">
                        {/*begin::Menu*/}
                        <button
                          type="button"
                          className="btn btn-sm btn-icon btn-color-primary btn-active-light-primary"
                          data-kt-menu-trigger="click"
                          data-kt-menu-placement="bottom-end"
                        >
                          {/*begin::Svg Icon | path: icons/duotune/general/gen024.svg*/}
                          <span className="svg-icon svg-icon-2">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24px"
                              height="24px"
                              viewBox="0 0 24 24"
                            >
                              <g
                                stroke="none"
                                strokeWidth={1}
                                fill="none"
                                fillRule="evenodd"
                              >
                                <rect
                                  x={5}
                                  y={5}
                                  width={5}
                                  height={5}
                                  rx={1}
                                  fill="currentColor"
                                />
                                <rect
                                  x={14}
                                  y={5}
                                  width={5}
                                  height={5}
                                  rx={1}
                                  fill="currentColor"
                                  opacity="0.3"
                                />
                                <rect
                                  x={5}
                                  y={14}
                                  width={5}
                                  height={5}
                                  rx={1}
                                  fill="currentColor"
                                  opacity="0.3"
                                />
                                <rect
                                  x={14}
                                  y={14}
                                  width={5}
                                  height={5}
                                  rx={1}
                                  fill="currentColor"
                                  opacity="0.3"
                                />
                              </g>
                            </svg>
                          </span>
                          {/*end::Svg Icon*/}
                        </button>
                        {/*begin::Menu 3*/}
                        <div
                          className="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg-light-primary fw-bold w-200px py-3"
                          data-kt-menu="true"
                        >
                          {/*begin::Heading*/}
                          <div className="menu-item px-3">
                            <div className="menu-content text-muted pb-2 px-3 fs-7 text-uppercase">
                              Payments
                            </div>
                          </div>
                          {/*end::Heading*/}
                          {/*begin::Menu item*/}
                          <div className="menu-item px-3">
                            <a href="#" className="menu-link px-3">
                              Create Invoice
                            </a>
                          </div>
                          {/*end::Menu item*/}
                          {/*begin::Menu item*/}
                          <div className="menu-item px-3">
                            <a href="#" className="menu-link flex-stack px-3">
                              Create Payment
                              <i
                                className="fas fa-exclamation-circle ms-2 fs-7"
                                data-bs-toggle="tooltip"
                                title
                                data-bs-original-title="Specify a target name for future usage and reference"
                                aria-label="Specify a target name for future usage and reference"
                              />
                            </a>
                          </div>
                          {/*end::Menu item*/}
                          {/*begin::Menu item*/}
                          <div className="menu-item px-3">
                            <a href="#" className="menu-link px-3">
                              Generate Bill
                            </a>
                          </div>
                          {/*end::Menu item*/}
                          {/*begin::Menu item*/}
                          <div
                            className="menu-item px-3"
                            data-kt-menu-trigger="hover"
                            data-kt-menu-placement="right-end"
                          >
                            <a href="#" className="menu-link px-3">
                              <span className="menu-title">Subscription</span>
                              <span className="menu-arrow" />
                            </a>
                            {/*begin::Menu sub*/}
                            <div className="menu-sub menu-sub-dropdown w-175px py-4">
                              {/*begin::Menu item*/}
                              <div className="menu-item px-3">
                                <a href="#" className="menu-link px-3">
                                  Plans
                                </a>
                              </div>
                              {/*end::Menu item*/}
                              {/*begin::Menu item*/}
                              <div className="menu-item px-3">
                                <a href="#" className="menu-link px-3">
                                  Billing
                                </a>
                              </div>
                              {/*end::Menu item*/}
                              {/*begin::Menu item*/}
                              <div className="menu-item px-3">
                                <a href="#" className="menu-link px-3">
                                  Statements
                                </a>
                              </div>
                              {/*end::Menu item*/}
                              {/*begin::Menu separator*/}
                              <div className="separator my-2" />
                              {/*end::Menu separator*/}
                              {/*begin::Menu item*/}
                              <div className="menu-item px-3">
                                <div className="menu-content px-3">
                                  {/*begin::Switch*/}
                                  <label className="form-check form-switch form-check-custom form-check-solid">
                                    {/*begin::Input*/}
                                    <input
                                      className="form-check-input w-30px h-20px"
                                      type="checkbox"
                                      defaultValue={1}
                                      defaultChecked="checked"
                                      name="notifications"
                                    />
                                    {/*end::Input*/}
                                    {/*end::Label*/}
                                    <span className="form-check-label text-muted fs-6">
                                      Recuring
                                    </span>
                                    {/*end::Label*/}
                                  </label>
                                  {/*end::Switch*/}
                                </div>
                              </div>
                              {/*end::Menu item*/}
                            </div>
                            {/*end::Menu sub*/}
                          </div>
                          {/*end::Menu item*/}
                          {/*begin::Menu item*/}
                          <div className="menu-item px-3 my-1">
                            <a href="#" className="menu-link px-3">
                              Settings
                            </a>
                          </div>
                          {/*end::Menu item*/}
                        </div>
                        {/*end::Menu 3*/}
                        {/*end::Menu*/}
                      </div>
                    </div>
                    {/*end::Header*/}
                    {/*begin::Body*/}
                    <div className="card-body pt-2">
                      {/*begin::Item*/}
                      <div className="d-flex align-items-center mb-8">
                        {/*begin::Bullet*/}
                        <span className="bullet bullet-vertical h-40px bg-success" />
                        {/*end::Bullet*/}
                        {/*begin::Checkbox*/}
                        <div className="form-check form-check-custom form-check-solid mx-5">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            defaultValue
                          />
                        </div>
                        {/*end::Checkbox*/}
                        {/*begin::Description*/}
                        <div className="flex-grow-1">
                          <a
                            href="#"
                            className="text-gray-800 text-hover-primary fw-bolder fs-6"
                          >
                            Create FireStone Logo
                          </a>
                          <span className="text-muted fw-bold d-block">
                            Due in 2 Days
                          </span>
                        </div>
                        {/*end::Description*/}
                        <span className="badge badge-light-success fs-8 fw-bolder">
                          New
                        </span>
                      </div>
                      {/*end:Item*/}
                      {/*begin::Item*/}
                      <div className="d-flex align-items-center mb-8">
                        {/*begin::Bullet*/}
                        <span className="bullet bullet-vertical h-40px bg-primary" />
                        {/*end::Bullet*/}
                        {/*begin::Checkbox*/}
                        <div className="form-check form-check-custom form-check-solid mx-5">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            defaultValue
                          />
                        </div>
                        {/*end::Checkbox*/}
                        {/*begin::Description*/}
                        <div className="flex-grow-1">
                          <a
                            href="#"
                            className="text-gray-800 text-hover-primary fw-bolder fs-6"
                          >
                            Stakeholder Meeting
                          </a>
                          <span className="text-muted fw-bold d-block">
                            Due in 3 Days
                          </span>
                        </div>
                        {/*end::Description*/}
                        <span className="badge badge-light-primary fs-8 fw-bolder">
                          New
                        </span>
                      </div>
                      {/*end:Item*/}
                      {/*begin::Item*/}
                      <div className="d-flex align-items-center mb-8">
                        {/*begin::Bullet*/}
                        <span className="bullet bullet-vertical h-40px bg-warning" />
                        {/*end::Bullet*/}
                        {/*begin::Checkbox*/}
                        <div className="form-check form-check-custom form-check-solid mx-5">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            defaultValue
                          />
                        </div>
                        {/*end::Checkbox*/}
                        {/*begin::Description*/}
                        <div className="flex-grow-1">
                          <a
                            href="#"
                            className="text-gray-800 text-hover-primary fw-bolder fs-6"
                          >
                            Scoping &amp; Estimations
                          </a>
                          <span className="text-muted fw-bold d-block">
                            Due in 5 Days
                          </span>
                        </div>
                        {/*end::Description*/}
                        <span className="badge badge-light-warning fs-8 fw-bolder">
                          New
                        </span>
                      </div>
                      {/*end:Item*/}
                      {/*begin::Item*/}
                      <div className="d-flex align-items-center mb-8">
                        {/*begin::Bullet*/}
                        <span className="bullet bullet-vertical h-40px bg-primary" />
                        {/*end::Bullet*/}
                        {/*begin::Checkbox*/}
                        <div className="form-check form-check-custom form-check-solid mx-5">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            defaultValue
                          />
                        </div>
                        {/*end::Checkbox*/}
                        {/*begin::Description*/}
                        <div className="flex-grow-1">
                          <a
                            href="#"
                            className="text-gray-800 text-hover-primary fw-bolder fs-6"
                          >
                            KPI App Showcase
                          </a>
                          <span className="text-muted fw-bold d-block">
                            Due in 2 Days
                          </span>
                        </div>
                        {/*end::Description*/}
                        <span className="badge badge-light-primary fs-8 fw-bolder">
                          New
                        </span>
                      </div>
                      {/*end:Item*/}
                      {/*begin::Item*/}
                      <div className="d-flex align-items-center mb-8">
                        {/*begin::Bullet*/}
                        <span className="bullet bullet-vertical h-40px bg-danger" />
                        {/*end::Bullet*/}
                        {/*begin::Checkbox*/}
                        <div className="form-check form-check-custom form-check-solid mx-5">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            defaultValue
                          />
                        </div>
                        {/*end::Checkbox*/}
                        {/*begin::Description*/}
                        <div className="flex-grow-1">
                          <a
                            href="#"
                            className="text-gray-800 text-hover-primary fw-bolder fs-6"
                          >
                            Project Meeting
                          </a>
                          <span className="text-muted fw-bold d-block">
                            Due in 12 Days
                          </span>
                        </div>
                        {/*end::Description*/}
                        <span className="badge badge-light-danger fs-8 fw-bolder">
                          New
                        </span>
                      </div>
                      {/*end:Item*/}
                      {/*begin::Item*/}
                      <div className="d-flex align-items-center">
                        {/*begin::Bullet*/}
                        <span className="bullet bullet-vertical h-40px bg-success" />
                        {/*end::Bullet*/}
                        {/*begin::Checkbox*/}
                        <div className="form-check form-check-custom form-check-solid mx-5">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            defaultValue
                          />
                        </div>
                        {/*end::Checkbox*/}
                        {/*begin::Description*/}
                        <div className="flex-grow-1">
                          <a
                            href="#"
                            className="text-gray-800 text-hover-primary fw-bolder fs-6"
                          >
                            Customers Update
                          </a>
                          <span className="text-muted fw-bold d-block">
                            Due in 1 week
                          </span>
                        </div>
                        {/*end::Description*/}
                        <span className="badge badge-light-success fs-8 fw-bolder">
                          New
                        </span>
                      </div>
                      {/*end:Item*/}
                    </div>
                    {/*end::Body*/}
                  </div>
                  {/*end:List Widget 3*/}
                </div>
                {/*end::Col*/}
                {/*begin::Col*/}
                <div className="col-xl-8">
                  {/*begin::Tables Widget 9*/}
                  <div className="card card-xl-stretch mb-5 mb-xl-8">
                    {/*begin::Header*/}
                    <div className="card-header border-0 pt-5">
                      <h3 className="card-title align-items-start flex-column">
                        <span className="card-label fw-bolder fs-3 mb-1">
                          Members Statistics
                        </span>
                        <span className="text-muted mt-1 fw-bold fs-7">
                          Over 500 members
                        </span>
                      </h3>
                      <div
                        className="card-toolbar"
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        data-bs-trigger="hover"
                        title
                        data-bs-original-title="Click to add a user"
                      >
                        <a
                          href="#"
                          className="btn btn-sm btn-light btn-active-primary"
                          data-bs-toggle="modal"
                          data-bs-target="#kt_modal_invite_friends"
                        >
                          {/*begin::Svg Icon | path: icons/duotune/arrows/arr075.svg*/}
                          <span className="svg-icon svg-icon-3">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width={24}
                              height={24}
                              viewBox="0 0 24 24"
                              fill="none"
                            >
                              <rect
                                opacity="0.5"
                                x="11.364"
                                y="20.364"
                                width={16}
                                height={2}
                                rx={1}
                                transform="rotate(-90 11.364 20.364)"
                                fill="currentColor"
                              />
                              <rect
                                x="4.36396"
                                y="11.364"
                                width={16}
                                height={2}
                                rx={1}
                                fill="currentColor"
                              />
                            </svg>
                          </span>
                          {/*end::Svg Icon*/}New Member
                        </a>
                      </div>
                    </div>
                    {/*end::Header*/}
                    {/*begin::Body*/}
                    <div className="card-body py-3">
                      {/*begin::Table container*/}
                      <div className="table-responsive">
                        {/*begin::Table*/}
                        <table className="table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4">
                          {/*begin::Table head*/}
                          <thead>
                            <tr className="fw-bolder text-muted">
                              <th className="w-25px">
                                <div className="form-check form-check-sm form-check-custom form-check-solid">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    defaultValue={1}
                                    data-kt-check="true"
                                    data-kt-check-target=".widget-9-check"
                                  />
                                </div>
                              </th>
                              <th className="min-w-200px">Authors</th>
                              <th className="min-w-150px">Company</th>
                              <th className="min-w-150px">Progress</th>
                              <th className="min-w-100px text-end">Actions</th>
                            </tr>
                          </thead>
                          {/*end::Table head*/}
                          {/*begin::Table body*/}
                          <tbody>
                            <tr>
                              <td>
                                <div className="form-check form-check-sm form-check-custom form-check-solid">
                                  <input
                                    className="form-check-input widget-9-check"
                                    type="checkbox"
                                    defaultValue={1}
                                  />
                                </div>
                              </td>
                              <td>
                                <div className="d-flex align-items-center">
                                  <div className="symbol symbol-45px me-5">
                                    <img
                                      src="/metronic8/demo1/assets/media/avatars/300-14.jpg"
                                      alt=""
                                    />
                                  </div>
                                  <div className="d-flex justify-content-start flex-column">
                                    <a
                                      href="#"
                                      className="text-dark fw-bolder text-hover-primary fs-6"
                                    >
                                      Ana Simmons
                                    </a>
                                    <span className="text-muted fw-bold text-muted d-block fs-7">
                                      HTML, JS, ReactJS
                                    </span>
                                  </div>
                                </div>
                              </td>
                              <td>
                                <a
                                  href="#"
                                  className="text-dark fw-bolder text-hover-primary d-block fs-6"
                                >
                                  Intertico
                                </a>
                                <span className="text-muted fw-bold text-muted d-block fs-7">
                                  Web, UI/UX Design
                                </span>
                              </td>
                              <td className="text-end">
                                <div className="d-flex flex-column w-100 me-2">
                                  <div className="d-flex flex-stack mb-2">
                                    <span className="text-muted me-2 fs-7 fw-bold">
                                      50%
                                    </span>
                                  </div>
                                  <div className="progress h-6px w-100">
                                    <div
                                      className="progress-bar bg-primary"
                                      role="progressbar"
                                      style={{ width: "50%" }}
                                      aria-valuenow={50}
                                      aria-valuemin={0}
                                      aria-valuemax={100}
                                    />
                                  </div>
                                </div>
                              </td>
                              <td>
                                <div className="d-flex justify-content-end flex-shrink-0">
                                  <a
                                    href="#"
                                    className="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1"
                                  >
                                    {/*begin::Svg Icon | path: icons/duotune/general/gen019.svg*/}
                                    <span className="svg-icon svg-icon-3">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width={24}
                                        height={24}
                                        viewBox="0 0 24 24"
                                        fill="none"
                                      >
                                        <path
                                          d="M17.5 11H6.5C4 11 2 9 2 6.5C2 4 4 2 6.5 2H17.5C20 2 22 4 22 6.5C22 9 20 11 17.5 11ZM15 6.5C15 7.9 16.1 9 17.5 9C18.9 9 20 7.9 20 6.5C20 5.1 18.9 4 17.5 4C16.1 4 15 5.1 15 6.5Z"
                                          fill="currentColor"
                                        />
                                        <path
                                          opacity="0.3"
                                          d="M17.5 22H6.5C4 22 2 20 2 17.5C2 15 4 13 6.5 13H17.5C20 13 22 15 22 17.5C22 20 20 22 17.5 22ZM4 17.5C4 18.9 5.1 20 6.5 20C7.9 20 9 18.9 9 17.5C9 16.1 7.9 15 6.5 15C5.1 15 4 16.1 4 17.5Z"
                                          fill="currentColor"
                                        />
                                      </svg>
                                    </span>
                                    {/*end::Svg Icon*/}
                                  </a>
                                  <a
                                    href="#"
                                    className="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1"
                                  >
                                    {/*begin::Svg Icon | path: icons/duotune/art/art005.svg*/}
                                    <span className="svg-icon svg-icon-3">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width={24}
                                        height={24}
                                        viewBox="0 0 24 24"
                                        fill="none"
                                      >
                                        <path
                                          opacity="0.3"
                                          d="M21.4 8.35303L19.241 10.511L13.485 4.755L15.643 2.59595C16.0248 2.21423 16.5426 1.99988 17.0825 1.99988C17.6224 1.99988 18.1402 2.21423 18.522 2.59595L21.4 5.474C21.7817 5.85581 21.9962 6.37355 21.9962 6.91345C21.9962 7.45335 21.7817 7.97122 21.4 8.35303ZM3.68699 21.932L9.88699 19.865L4.13099 14.109L2.06399 20.309C1.98815 20.5354 1.97703 20.7787 2.03189 21.0111C2.08674 21.2436 2.2054 21.4561 2.37449 21.6248C2.54359 21.7934 2.75641 21.9115 2.989 21.9658C3.22158 22.0201 3.4647 22.0084 3.69099 21.932H3.68699Z"
                                          fill="currentColor"
                                        />
                                        <path
                                          d="M5.574 21.3L3.692 21.928C3.46591 22.0032 3.22334 22.0141 2.99144 21.9594C2.75954 21.9046 2.54744 21.7864 2.3789 21.6179C2.21036 21.4495 2.09202 21.2375 2.03711 21.0056C1.9822 20.7737 1.99289 20.5312 2.06799 20.3051L2.696 18.422L5.574 21.3ZM4.13499 14.105L9.891 19.861L19.245 10.507L13.489 4.75098L4.13499 14.105Z"
                                          fill="currentColor"
                                        />
                                      </svg>
                                    </span>
                                    {/*end::Svg Icon*/}
                                  </a>
                                  <a
                                    href="#"
                                    className="btn btn-icon btn-bg-light btn-active-color-primary btn-sm"
                                  >
                                    {/*begin::Svg Icon | path: icons/duotune/general/gen027.svg*/}
                                    <span className="svg-icon svg-icon-3">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width={24}
                                        height={24}
                                        viewBox="0 0 24 24"
                                        fill="none"
                                      >
                                        <path
                                          d="M5 9C5 8.44772 5.44772 8 6 8H18C18.5523 8 19 8.44772 19 9V18C19 19.6569 17.6569 21 16 21H8C6.34315 21 5 19.6569 5 18V9Z"
                                          fill="currentColor"
                                        />
                                        <path
                                          opacity="0.5"
                                          d="M5 5C5 4.44772 5.44772 4 6 4H18C18.5523 4 19 4.44772 19 5V5C19 5.55228 18.5523 6 18 6H6C5.44772 6 5 5.55228 5 5V5Z"
                                          fill="currentColor"
                                        />
                                        <path
                                          opacity="0.5"
                                          d="M9 4C9 3.44772 9.44772 3 10 3H14C14.5523 3 15 3.44772 15 4V4H9V4Z"
                                          fill="currentColor"
                                        />
                                      </svg>
                                    </span>
                                    {/*end::Svg Icon*/}
                                  </a>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <div className="form-check form-check-sm form-check-custom form-check-solid">
                                  <input
                                    className="form-check-input widget-9-check"
                                    type="checkbox"
                                    defaultValue={1}
                                  />
                                </div>
                              </td>
                              <td>
                                <div className="d-flex align-items-center">
                                  <div className="symbol symbol-45px me-5">
                                    <img
                                      src="/metronic8/demo1/assets/media/avatars/300-2.jpg"
                                      alt=""
                                    />
                                  </div>
                                  <div className="d-flex justify-content-start flex-column">
                                    <a
                                      href="#"
                                      className="text-dark fw-bolder text-hover-primary fs-6"
                                    >
                                      Jessie Clarcson
                                    </a>
                                    <span className="text-muted fw-bold text-muted d-block fs-7">
                                      C#, ASP.NET, MS SQL
                                    </span>
                                  </div>
                                </div>
                              </td>
                              <td>
                                <a
                                  href="#"
                                  className="text-dark fw-bolder text-hover-primary d-block fs-6"
                                >
                                  Agoda
                                </a>
                                <span className="text-muted fw-bold text-muted d-block fs-7">
                                  Houses &amp; Hotels
                                </span>
                              </td>
                              <td className="text-end">
                                <div className="d-flex flex-column w-100 me-2">
                                  <div className="d-flex flex-stack mb-2">
                                    <span className="text-muted me-2 fs-7 fw-bold">
                                      70%
                                    </span>
                                  </div>
                                  <div className="progress h-6px w-100">
                                    <div
                                      className="progress-bar bg-danger"
                                      role="progressbar"
                                      style={{ width: "70%" }}
                                      aria-valuenow={70}
                                      aria-valuemin={0}
                                      aria-valuemax={100}
                                    />
                                  </div>
                                </div>
                              </td>
                              <td>
                                <div className="d-flex justify-content-end flex-shrink-0">
                                  <a
                                    href="#"
                                    className="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1"
                                  >
                                    {/*begin::Svg Icon | path: icons/duotune/general/gen019.svg*/}
                                    <span className="svg-icon svg-icon-3">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width={24}
                                        height={24}
                                        viewBox="0 0 24 24"
                                        fill="none"
                                      >
                                        <path
                                          d="M17.5 11H6.5C4 11 2 9 2 6.5C2 4 4 2 6.5 2H17.5C20 2 22 4 22 6.5C22 9 20 11 17.5 11ZM15 6.5C15 7.9 16.1 9 17.5 9C18.9 9 20 7.9 20 6.5C20 5.1 18.9 4 17.5 4C16.1 4 15 5.1 15 6.5Z"
                                          fill="currentColor"
                                        />
                                        <path
                                          opacity="0.3"
                                          d="M17.5 22H6.5C4 22 2 20 2 17.5C2 15 4 13 6.5 13H17.5C20 13 22 15 22 17.5C22 20 20 22 17.5 22ZM4 17.5C4 18.9 5.1 20 6.5 20C7.9 20 9 18.9 9 17.5C9 16.1 7.9 15 6.5 15C5.1 15 4 16.1 4 17.5Z"
                                          fill="currentColor"
                                        />
                                      </svg>
                                    </span>
                                    {/*end::Svg Icon*/}
                                  </a>
                                  <a
                                    href="#"
                                    className="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1"
                                  >
                                    {/*begin::Svg Icon | path: icons/duotune/art/art005.svg*/}
                                    <span className="svg-icon svg-icon-3">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width={24}
                                        height={24}
                                        viewBox="0 0 24 24"
                                        fill="none"
                                      >
                                        <path
                                          opacity="0.3"
                                          d="M21.4 8.35303L19.241 10.511L13.485 4.755L15.643 2.59595C16.0248 2.21423 16.5426 1.99988 17.0825 1.99988C17.6224 1.99988 18.1402 2.21423 18.522 2.59595L21.4 5.474C21.7817 5.85581 21.9962 6.37355 21.9962 6.91345C21.9962 7.45335 21.7817 7.97122 21.4 8.35303ZM3.68699 21.932L9.88699 19.865L4.13099 14.109L2.06399 20.309C1.98815 20.5354 1.97703 20.7787 2.03189 21.0111C2.08674 21.2436 2.2054 21.4561 2.37449 21.6248C2.54359 21.7934 2.75641 21.9115 2.989 21.9658C3.22158 22.0201 3.4647 22.0084 3.69099 21.932H3.68699Z"
                                          fill="currentColor"
                                        />
                                        <path
                                          d="M5.574 21.3L3.692 21.928C3.46591 22.0032 3.22334 22.0141 2.99144 21.9594C2.75954 21.9046 2.54744 21.7864 2.3789 21.6179C2.21036 21.4495 2.09202 21.2375 2.03711 21.0056C1.9822 20.7737 1.99289 20.5312 2.06799 20.3051L2.696 18.422L5.574 21.3ZM4.13499 14.105L9.891 19.861L19.245 10.507L13.489 4.75098L4.13499 14.105Z"
                                          fill="currentColor"
                                        />
                                      </svg>
                                    </span>
                                    {/*end::Svg Icon*/}
                                  </a>
                                  <a
                                    href="#"
                                    className="btn btn-icon btn-bg-light btn-active-color-primary btn-sm"
                                  >
                                    {/*begin::Svg Icon | path: icons/duotune/general/gen027.svg*/}
                                    <span className="svg-icon svg-icon-3">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width={24}
                                        height={24}
                                        viewBox="0 0 24 24"
                                        fill="none"
                                      >
                                        <path
                                          d="M5 9C5 8.44772 5.44772 8 6 8H18C18.5523 8 19 8.44772 19 9V18C19 19.6569 17.6569 21 16 21H8C6.34315 21 5 19.6569 5 18V9Z"
                                          fill="currentColor"
                                        />
                                        <path
                                          opacity="0.5"
                                          d="M5 5C5 4.44772 5.44772 4 6 4H18C18.5523 4 19 4.44772 19 5V5C19 5.55228 18.5523 6 18 6H6C5.44772 6 5 5.55228 5 5V5Z"
                                          fill="currentColor"
                                        />
                                        <path
                                          opacity="0.5"
                                          d="M9 4C9 3.44772 9.44772 3 10 3H14C14.5523 3 15 3.44772 15 4V4H9V4Z"
                                          fill="currentColor"
                                        />
                                      </svg>
                                    </span>
                                    {/*end::Svg Icon*/}
                                  </a>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <div className="form-check form-check-sm form-check-custom form-check-solid">
                                  <input
                                    className="form-check-input widget-9-check"
                                    type="checkbox"
                                    defaultValue={1}
                                  />
                                </div>
                              </td>
                              <td>
                                <div className="d-flex align-items-center">
                                  <div className="symbol symbol-45px me-5">
                                    <img
                                      src="/metronic8/demo1/assets/media/avatars/300-5.jpg"
                                      alt=""
                                    />
                                  </div>
                                  <div className="d-flex justify-content-start flex-column">
                                    <a
                                      href="#"
                                      className="text-dark fw-bolder text-hover-primary fs-6"
                                    >
                                      Lebron Wayde
                                    </a>
                                    <span className="text-muted fw-bold text-muted d-block fs-7">
                                      PHP, Laravel, VueJS
                                    </span>
                                  </div>
                                </div>
                              </td>
                              <td>
                                <a
                                  href="#"
                                  className="text-dark fw-bolder text-hover-primary d-block fs-6"
                                >
                                  RoadGee
                                </a>
                                <span className="text-muted fw-bold text-muted d-block fs-7">
                                  Transportation
                                </span>
                              </td>
                              <td className="text-end">
                                <div className="d-flex flex-column w-100 me-2">
                                  <div className="d-flex flex-stack mb-2">
                                    <span className="text-muted me-2 fs-7 fw-bold">
                                      60%
                                    </span>
                                  </div>
                                  <div className="progress h-6px w-100">
                                    <div
                                      className="progress-bar bg-success"
                                      role="progressbar"
                                      style={{ width: "60%" }}
                                      aria-valuenow={60}
                                      aria-valuemin={0}
                                      aria-valuemax={100}
                                    />
                                  </div>
                                </div>
                              </td>
                              <td>
                                <div className="d-flex justify-content-end flex-shrink-0">
                                  <a
                                    href="#"
                                    className="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1"
                                  >
                                    {/*begin::Svg Icon | path: icons/duotune/general/gen019.svg*/}
                                    <span className="svg-icon svg-icon-3">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width={24}
                                        height={24}
                                        viewBox="0 0 24 24"
                                        fill="none"
                                      >
                                        <path
                                          d="M17.5 11H6.5C4 11 2 9 2 6.5C2 4 4 2 6.5 2H17.5C20 2 22 4 22 6.5C22 9 20 11 17.5 11ZM15 6.5C15 7.9 16.1 9 17.5 9C18.9 9 20 7.9 20 6.5C20 5.1 18.9 4 17.5 4C16.1 4 15 5.1 15 6.5Z"
                                          fill="currentColor"
                                        />
                                        <path
                                          opacity="0.3"
                                          d="M17.5 22H6.5C4 22 2 20 2 17.5C2 15 4 13 6.5 13H17.5C20 13 22 15 22 17.5C22 20 20 22 17.5 22ZM4 17.5C4 18.9 5.1 20 6.5 20C7.9 20 9 18.9 9 17.5C9 16.1 7.9 15 6.5 15C5.1 15 4 16.1 4 17.5Z"
                                          fill="currentColor"
                                        />
                                      </svg>
                                    </span>
                                    {/*end::Svg Icon*/}
                                  </a>
                                  <a
                                    href="#"
                                    className="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1"
                                  >
                                    {/*begin::Svg Icon | path: icons/duotune/art/art005.svg*/}
                                    <span className="svg-icon svg-icon-3">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width={24}
                                        height={24}
                                        viewBox="0 0 24 24"
                                        fill="none"
                                      >
                                        <path
                                          opacity="0.3"
                                          d="M21.4 8.35303L19.241 10.511L13.485 4.755L15.643 2.59595C16.0248 2.21423 16.5426 1.99988 17.0825 1.99988C17.6224 1.99988 18.1402 2.21423 18.522 2.59595L21.4 5.474C21.7817 5.85581 21.9962 6.37355 21.9962 6.91345C21.9962 7.45335 21.7817 7.97122 21.4 8.35303ZM3.68699 21.932L9.88699 19.865L4.13099 14.109L2.06399 20.309C1.98815 20.5354 1.97703 20.7787 2.03189 21.0111C2.08674 21.2436 2.2054 21.4561 2.37449 21.6248C2.54359 21.7934 2.75641 21.9115 2.989 21.9658C3.22158 22.0201 3.4647 22.0084 3.69099 21.932H3.68699Z"
                                          fill="currentColor"
                                        />
                                        <path
                                          d="M5.574 21.3L3.692 21.928C3.46591 22.0032 3.22334 22.0141 2.99144 21.9594C2.75954 21.9046 2.54744 21.7864 2.3789 21.6179C2.21036 21.4495 2.09202 21.2375 2.03711 21.0056C1.9822 20.7737 1.99289 20.5312 2.06799 20.3051L2.696 18.422L5.574 21.3ZM4.13499 14.105L9.891 19.861L19.245 10.507L13.489 4.75098L4.13499 14.105Z"
                                          fill="currentColor"
                                        />
                                      </svg>
                                    </span>
                                    {/*end::Svg Icon*/}
                                  </a>
                                  <a
                                    href="#"
                                    className="btn btn-icon btn-bg-light btn-active-color-primary btn-sm"
                                  >
                                    {/*begin::Svg Icon | path: icons/duotune/general/gen027.svg*/}
                                    <span className="svg-icon svg-icon-3">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width={24}
                                        height={24}
                                        viewBox="0 0 24 24"
                                        fill="none"
                                      >
                                        <path
                                          d="M5 9C5 8.44772 5.44772 8 6 8H18C18.5523 8 19 8.44772 19 9V18C19 19.6569 17.6569 21 16 21H8C6.34315 21 5 19.6569 5 18V9Z"
                                          fill="currentColor"
                                        />
                                        <path
                                          opacity="0.5"
                                          d="M5 5C5 4.44772 5.44772 4 6 4H18C18.5523 4 19 4.44772 19 5V5C19 5.55228 18.5523 6 18 6H6C5.44772 6 5 5.55228 5 5V5Z"
                                          fill="currentColor"
                                        />
                                        <path
                                          opacity="0.5"
                                          d="M9 4C9 3.44772 9.44772 3 10 3H14C14.5523 3 15 3.44772 15 4V4H9V4Z"
                                          fill="currentColor"
                                        />
                                      </svg>
                                    </span>
                                    {/*end::Svg Icon*/}
                                  </a>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <div className="form-check form-check-sm form-check-custom form-check-solid">
                                  <input
                                    className="form-check-input widget-9-check"
                                    type="checkbox"
                                    defaultValue={1}
                                  />
                                </div>
                              </td>
                              <td>
                                <div className="d-flex align-items-center">
                                  <div className="symbol symbol-45px me-5">
                                    <img
                                      src="/metronic8/demo1/assets/media/avatars/300-20.jpg"
                                      alt=""
                                    />
                                  </div>
                                  <div className="d-flex justify-content-start flex-column">
                                    <a
                                      href="#"
                                      className="text-dark fw-bolder text-hover-primary fs-6"
                                    >
                                      Natali Goodwin
                                    </a>
                                    <span className="text-muted fw-bold text-muted d-block fs-7">
                                      Python, PostgreSQL, ReactJS
                                    </span>
                                  </div>
                                </div>
                              </td>
                              <td>
                                <a
                                  href="#"
                                  className="text-dark fw-bolder text-hover-primary d-block fs-6"
                                >
                                  The Hill
                                </a>
                                <span className="text-muted fw-bold text-muted d-block fs-7">
                                  Insurance
                                </span>
                              </td>
                              <td className="text-end">
                                <div className="d-flex flex-column w-100 me-2">
                                  <div className="d-flex flex-stack mb-2">
                                    <span className="text-muted me-2 fs-7 fw-bold">
                                      50%
                                    </span>
                                  </div>
                                  <div className="progress h-6px w-100">
                                    <div
                                      className="progress-bar bg-warning"
                                      role="progressbar"
                                      style={{ width: "50%" }}
                                      aria-valuenow={50}
                                      aria-valuemin={0}
                                      aria-valuemax={100}
                                    />
                                  </div>
                                </div>
                              </td>
                              <td>
                                <div className="d-flex justify-content-end flex-shrink-0">
                                  <a
                                    href="#"
                                    className="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1"
                                  >
                                    {/*begin::Svg Icon | path: icons/duotune/general/gen019.svg*/}
                                    <span className="svg-icon svg-icon-3">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width={24}
                                        height={24}
                                        viewBox="0 0 24 24"
                                        fill="none"
                                      >
                                        <path
                                          d="M17.5 11H6.5C4 11 2 9 2 6.5C2 4 4 2 6.5 2H17.5C20 2 22 4 22 6.5C22 9 20 11 17.5 11ZM15 6.5C15 7.9 16.1 9 17.5 9C18.9 9 20 7.9 20 6.5C20 5.1 18.9 4 17.5 4C16.1 4 15 5.1 15 6.5Z"
                                          fill="currentColor"
                                        />
                                        <path
                                          opacity="0.3"
                                          d="M17.5 22H6.5C4 22 2 20 2 17.5C2 15 4 13 6.5 13H17.5C20 13 22 15 22 17.5C22 20 20 22 17.5 22ZM4 17.5C4 18.9 5.1 20 6.5 20C7.9 20 9 18.9 9 17.5C9 16.1 7.9 15 6.5 15C5.1 15 4 16.1 4 17.5Z"
                                          fill="currentColor"
                                        />
                                      </svg>
                                    </span>
                                    {/*end::Svg Icon*/}
                                  </a>
                                  <a
                                    href="#"
                                    className="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1"
                                  >
                                    {/*begin::Svg Icon | path: icons/duotune/art/art005.svg*/}
                                    <span className="svg-icon svg-icon-3">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width={24}
                                        height={24}
                                        viewBox="0 0 24 24"
                                        fill="none"
                                      >
                                        <path
                                          opacity="0.3"
                                          d="M21.4 8.35303L19.241 10.511L13.485 4.755L15.643 2.59595C16.0248 2.21423 16.5426 1.99988 17.0825 1.99988C17.6224 1.99988 18.1402 2.21423 18.522 2.59595L21.4 5.474C21.7817 5.85581 21.9962 6.37355 21.9962 6.91345C21.9962 7.45335 21.7817 7.97122 21.4 8.35303ZM3.68699 21.932L9.88699 19.865L4.13099 14.109L2.06399 20.309C1.98815 20.5354 1.97703 20.7787 2.03189 21.0111C2.08674 21.2436 2.2054 21.4561 2.37449 21.6248C2.54359 21.7934 2.75641 21.9115 2.989 21.9658C3.22158 22.0201 3.4647 22.0084 3.69099 21.932H3.68699Z"
                                          fill="currentColor"
                                        />
                                        <path
                                          d="M5.574 21.3L3.692 21.928C3.46591 22.0032 3.22334 22.0141 2.99144 21.9594C2.75954 21.9046 2.54744 21.7864 2.3789 21.6179C2.21036 21.4495 2.09202 21.2375 2.03711 21.0056C1.9822 20.7737 1.99289 20.5312 2.06799 20.3051L2.696 18.422L5.574 21.3ZM4.13499 14.105L9.891 19.861L19.245 10.507L13.489 4.75098L4.13499 14.105Z"
                                          fill="currentColor"
                                        />
                                      </svg>
                                    </span>
                                    {/*end::Svg Icon*/}
                                  </a>
                                  <a
                                    href="#"
                                    className="btn btn-icon btn-bg-light btn-active-color-primary btn-sm"
                                  >
                                    {/*begin::Svg Icon | path: icons/duotune/general/gen027.svg*/}
                                    <span className="svg-icon svg-icon-3">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width={24}
                                        height={24}
                                        viewBox="0 0 24 24"
                                        fill="none"
                                      >
                                        <path
                                          d="M5 9C5 8.44772 5.44772 8 6 8H18C18.5523 8 19 8.44772 19 9V18C19 19.6569 17.6569 21 16 21H8C6.34315 21 5 19.6569 5 18V9Z"
                                          fill="currentColor"
                                        />
                                        <path
                                          opacity="0.5"
                                          d="M5 5C5 4.44772 5.44772 4 6 4H18C18.5523 4 19 4.44772 19 5V5C19 5.55228 18.5523 6 18 6H6C5.44772 6 5 5.55228 5 5V5Z"
                                          fill="currentColor"
                                        />
                                        <path
                                          opacity="0.5"
                                          d="M9 4C9 3.44772 9.44772 3 10 3H14C14.5523 3 15 3.44772 15 4V4H9V4Z"
                                          fill="currentColor"
                                        />
                                      </svg>
                                    </span>
                                    {/*end::Svg Icon*/}
                                  </a>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <div className="form-check form-check-sm form-check-custom form-check-solid">
                                  <input
                                    className="form-check-input widget-9-check"
                                    type="checkbox"
                                    defaultValue={1}
                                  />
                                </div>
                              </td>
                              <td>
                                <div className="d-flex align-items-center">
                                  <div className="symbol symbol-45px me-5">
                                    <img
                                      src="/metronic8/demo1/assets/media/avatars/300-23.jpg"
                                      alt=""
                                    />
                                  </div>
                                  <div className="d-flex justify-content-start flex-column">
                                    <a
                                      href="#"
                                      className="text-dark fw-bolder text-hover-primary fs-6"
                                    >
                                      Kevin Leonard
                                    </a>
                                    <span className="text-muted fw-bold text-muted d-block fs-7">
                                      HTML, JS, ReactJS
                                    </span>
                                  </div>
                                </div>
                              </td>
                              <td>
                                <a
                                  href="#"
                                  className="text-dark fw-bolder text-hover-primary d-block fs-6"
                                >
                                  RoadGee
                                </a>
                                <span className="text-muted fw-bold text-muted d-block fs-7">
                                  Art Director
                                </span>
                              </td>
                              <td className="text-end">
                                <div className="d-flex flex-column w-100 me-2">
                                  <div className="d-flex flex-stack mb-2">
                                    <span className="text-muted me-2 fs-7 fw-bold">
                                      90%
                                    </span>
                                  </div>
                                  <div className="progress h-6px w-100">
                                    <div
                                      className="progress-bar bg-info"
                                      role="progressbar"
                                      style={{ width: "90%" }}
                                      aria-valuenow={90}
                                      aria-valuemin={0}
                                      aria-valuemax={100}
                                    />
                                  </div>
                                </div>
                              </td>
                              <td>
                                <div className="d-flex justify-content-end flex-shrink-0">
                                  <a
                                    href="#"
                                    className="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1"
                                  >
                                    {/*begin::Svg Icon | path: icons/duotune/general/gen019.svg*/}
                                    <span className="svg-icon svg-icon-3">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width={24}
                                        height={24}
                                        viewBox="0 0 24 24"
                                        fill="none"
                                      >
                                        <path
                                          d="M17.5 11H6.5C4 11 2 9 2 6.5C2 4 4 2 6.5 2H17.5C20 2 22 4 22 6.5C22 9 20 11 17.5 11ZM15 6.5C15 7.9 16.1 9 17.5 9C18.9 9 20 7.9 20 6.5C20 5.1 18.9 4 17.5 4C16.1 4 15 5.1 15 6.5Z"
                                          fill="currentColor"
                                        />
                                        <path
                                          opacity="0.3"
                                          d="M17.5 22H6.5C4 22 2 20 2 17.5C2 15 4 13 6.5 13H17.5C20 13 22 15 22 17.5C22 20 20 22 17.5 22ZM4 17.5C4 18.9 5.1 20 6.5 20C7.9 20 9 18.9 9 17.5C9 16.1 7.9 15 6.5 15C5.1 15 4 16.1 4 17.5Z"
                                          fill="currentColor"
                                        />
                                      </svg>
                                    </span>
                                    {/*end::Svg Icon*/}
                                  </a>
                                  <a
                                    href="#"
                                    className="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1"
                                  >
                                    {/*begin::Svg Icon | path: icons/duotune/art/art005.svg*/}
                                    <span className="svg-icon svg-icon-3">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width={24}
                                        height={24}
                                        viewBox="0 0 24 24"
                                        fill="none"
                                      >
                                        <path
                                          opacity="0.3"
                                          d="M21.4 8.35303L19.241 10.511L13.485 4.755L15.643 2.59595C16.0248 2.21423 16.5426 1.99988 17.0825 1.99988C17.6224 1.99988 18.1402 2.21423 18.522 2.59595L21.4 5.474C21.7817 5.85581 21.9962 6.37355 21.9962 6.91345C21.9962 7.45335 21.7817 7.97122 21.4 8.35303ZM3.68699 21.932L9.88699 19.865L4.13099 14.109L2.06399 20.309C1.98815 20.5354 1.97703 20.7787 2.03189 21.0111C2.08674 21.2436 2.2054 21.4561 2.37449 21.6248C2.54359 21.7934 2.75641 21.9115 2.989 21.9658C3.22158 22.0201 3.4647 22.0084 3.69099 21.932H3.68699Z"
                                          fill="currentColor"
                                        />
                                        <path
                                          d="M5.574 21.3L3.692 21.928C3.46591 22.0032 3.22334 22.0141 2.99144 21.9594C2.75954 21.9046 2.54744 21.7864 2.3789 21.6179C2.21036 21.4495 2.09202 21.2375 2.03711 21.0056C1.9822 20.7737 1.99289 20.5312 2.06799 20.3051L2.696 18.422L5.574 21.3ZM4.13499 14.105L9.891 19.861L19.245 10.507L13.489 4.75098L4.13499 14.105Z"
                                          fill="currentColor"
                                        />
                                      </svg>
                                    </span>
                                    {/*end::Svg Icon*/}
                                  </a>
                                  <a
                                    href="#"
                                    className="btn btn-icon btn-bg-light btn-active-color-primary btn-sm"
                                  >
                                    {/*begin::Svg Icon | path: icons/duotune/general/gen027.svg*/}
                                    <span className="svg-icon svg-icon-3">
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width={24}
                                        height={24}
                                        viewBox="0 0 24 24"
                                        fill="none"
                                      >
                                        <path
                                          d="M5 9C5 8.44772 5.44772 8 6 8H18C18.5523 8 19 8.44772 19 9V18C19 19.6569 17.6569 21 16 21H8C6.34315 21 5 19.6569 5 18V9Z"
                                          fill="currentColor"
                                        />
                                        <path
                                          opacity="0.5"
                                          d="M5 5C5 4.44772 5.44772 4 6 4H18C18.5523 4 19 4.44772 19 5V5C19 5.55228 18.5523 6 18 6H6C5.44772 6 5 5.55228 5 5V5Z"
                                          fill="currentColor"
                                        />
                                        <path
                                          opacity="0.5"
                                          d="M9 4C9 3.44772 9.44772 3 10 3H14C14.5523 3 15 3.44772 15 4V4H9V4Z"
                                          fill="currentColor"
                                        />
                                      </svg>
                                    </span>
                                    {/*end::Svg Icon*/}
                                  </a>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                          {/*end::Table body*/}
                        </table>
                        {/*end::Table*/}
                      </div>
                      {/*end::Table container*/}
                    </div>
                    {/*begin::Body*/}
                  </div>
                  {/*end::Tables Widget 9*/}
                </div>
                {/*end::Col*/}
              </div>
              {/*end::Row*/}
              {/*begin::Row*/}
              <div className="row gy-5 g-xl-8">
                {/*begin::Col*/}
                <div className="col-xl-4">
                  {/*begin::List Widget 2*/}
                  <div className="card card-xl-stretch mb-xl-8">
                    {/*begin::Header*/}
                    <div className="card-header border-0">
                      <h3 className="card-title fw-bolder text-dark">
                        Authors
                      </h3>
                      <div className="card-toolbar">
                        {/*begin::Menu*/}
                        <button
                          type="button"
                          className="btn btn-sm btn-icon btn-color-primary btn-active-light-primary"
                          data-kt-menu-trigger="click"
                          data-kt-menu-placement="bottom-end"
                        >
                          {/*begin::Svg Icon | path: icons/duotune/general/gen024.svg*/}
                          <span className="svg-icon svg-icon-2">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24px"
                              height="24px"
                              viewBox="0 0 24 24"
                            >
                              <g
                                stroke="none"
                                strokeWidth={1}
                                fill="none"
                                fillRule="evenodd"
                              >
                                <rect
                                  x={5}
                                  y={5}
                                  width={5}
                                  height={5}
                                  rx={1}
                                  fill="currentColor"
                                />
                                <rect
                                  x={14}
                                  y={5}
                                  width={5}
                                  height={5}
                                  rx={1}
                                  fill="currentColor"
                                  opacity="0.3"
                                />
                                <rect
                                  x={5}
                                  y={14}
                                  width={5}
                                  height={5}
                                  rx={1}
                                  fill="currentColor"
                                  opacity="0.3"
                                />
                                <rect
                                  x={14}
                                  y={14}
                                  width={5}
                                  height={5}
                                  rx={1}
                                  fill="currentColor"
                                  opacity="0.3"
                                />
                              </g>
                            </svg>
                          </span>
                          {/*end::Svg Icon*/}
                        </button>
                        {/*begin::Menu 2*/}
                        <div
                          className="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg-light-primary fw-bold w-200px"
                          data-kt-menu="true"
                        >
                          {/*begin::Menu item*/}
                          <div className="menu-item px-3">
                            <div className="menu-content fs-6 text-dark fw-bolder px-3 py-4">
                              Quick Actions
                            </div>
                          </div>
                          {/*end::Menu item*/}
                          {/*begin::Menu separator*/}
                          <div className="separator mb-3 opacity-75" />
                          {/*end::Menu separator*/}
                          {/*begin::Menu item*/}
                          <div className="menu-item px-3">
                            <a href="#" className="menu-link px-3">
                              New Ticket
                            </a>
                          </div>
                          {/*end::Menu item*/}
                          {/*begin::Menu item*/}
                          <div className="menu-item px-3">
                            <a href="#" className="menu-link px-3">
                              New Customer
                            </a>
                          </div>
                          {/*end::Menu item*/}
                          {/*begin::Menu item*/}
                          <div
                            className="menu-item px-3"
                            data-kt-menu-trigger="hover"
                            data-kt-menu-placement="right-start"
                          >
                            {/*begin::Menu item*/}
                            <a href="#" className="menu-link px-3">
                              <span className="menu-title">New Group</span>
                              <span className="menu-arrow" />
                            </a>
                            {/*end::Menu item*/}
                            {/*begin::Menu sub*/}
                            <div className="menu-sub menu-sub-dropdown w-175px py-4">
                              {/*begin::Menu item*/}
                              <div className="menu-item px-3">
                                <a href="#" className="menu-link px-3">
                                  Admin Group
                                </a>
                              </div>
                              {/*end::Menu item*/}
                              {/*begin::Menu item*/}
                              <div className="menu-item px-3">
                                <a href="#" className="menu-link px-3">
                                  Staff Group
                                </a>
                              </div>
                              {/*end::Menu item*/}
                              {/*begin::Menu item*/}
                              <div className="menu-item px-3">
                                <a href="#" className="menu-link px-3">
                                  Member Group
                                </a>
                              </div>
                              {/*end::Menu item*/}
                            </div>
                            {/*end::Menu sub*/}
                          </div>
                          {/*end::Menu item*/}
                          {/*begin::Menu item*/}
                          <div className="menu-item px-3">
                            <a href="#" className="menu-link px-3">
                              New Contact
                            </a>
                          </div>
                          {/*end::Menu item*/}
                          {/*begin::Menu separator*/}
                          <div className="separator mt-3 opacity-75" />
                          {/*end::Menu separator*/}
                          {/*begin::Menu item*/}
                          <div className="menu-item px-3">
                            <div className="menu-content px-3 py-3">
                              <a
                                className="btn btn-primary btn-sm px-4"
                                href="#"
                              >
                                Generate Reports
                              </a>
                            </div>
                          </div>
                          {/*end::Menu item*/}
                        </div>
                        {/*end::Menu 2*/}
                        {/*end::Menu*/}
                      </div>
                    </div>
                    {/*end::Header*/}
                    {/*begin::Body*/}
                    <div className="card-body pt-2">
                      {/*begin::Item*/}
                      <div className="d-flex align-items-center mb-7">
                        {/*begin::Avatar*/}
                        <div className="symbol symbol-50px me-5">
                          <img
                            src="/metronic8/demo1/assets/media/avatars/300-6.jpg"
                            className
                            alt=""
                          />
                        </div>
                        {/*end::Avatar*/}
                        {/*begin::Text*/}
                        <div className="flex-grow-1">
                          <a
                            href="#"
                            className="text-dark fw-bolder text-hover-primary fs-6"
                          >
                            Emma Smith
                          </a>
                          <span className="text-muted d-block fw-bold">
                            Project Manager
                          </span>
                        </div>
                        {/*end::Text*/}
                      </div>
                      {/*end::Item*/}
                      {/*begin::Item*/}
                      <div className="d-flex align-items-center mb-7">
                        {/*begin::Avatar*/}
                        <div className="symbol symbol-50px me-5">
                          <img
                            src="/metronic8/demo1/assets/media/avatars/300-5.jpg"
                            className
                            alt=""
                          />
                        </div>
                        {/*end::Avatar*/}
                        {/*begin::Text*/}
                        <div className="flex-grow-1">
                          <a
                            href="#"
                            className="text-dark fw-bolder text-hover-primary fs-6"
                          >
                            Sean Bean
                          </a>
                          <span className="text-muted d-block fw-bold">
                            PHP, SQLite, Artisan CLI
                          </span>
                        </div>
                        {/*end::Text*/}
                      </div>
                      {/*end::Item*/}
                      {/*begin::Item*/}
                      <div className="d-flex align-items-center mb-7">
                        {/*begin::Avatar*/}
                        <div className="symbol symbol-50px me-5">
                          <img
                            src="/metronic8/demo1/assets/media/avatars/300-11.jpg"
                            className
                            alt=""
                          />
                        </div>
                        {/*end::Avatar*/}
                        {/*begin::Text*/}
                        <div className="flex-grow-1">
                          <a
                            href="#"
                            className="text-dark fw-bolder text-hover-primary fs-6"
                          >
                            Brian Cox
                          </a>
                          <span className="text-muted d-block fw-bold">
                            PHP, SQLite, Artisan CLI
                          </span>
                        </div>
                        {/*end::Text*/}
                      </div>
                      {/*end::Item*/}
                      {/*begin::Item*/}
                      <div className="d-flex align-items-center mb-7">
                        {/*begin::Avatar*/}
                        <div className="symbol symbol-50px me-5">
                          <img
                            src="/metronic8/demo1/assets/media/avatars/300-9.jpg"
                            className
                            alt=""
                          />
                        </div>
                        {/*end::Avatar*/}
                        {/*begin::Text*/}
                        <div className="flex-grow-1">
                          <a
                            href="#"
                            className="text-dark fw-bolder text-hover-primary fs-6"
                          >
                            Francis Mitcham
                          </a>
                          <span className="text-muted d-block fw-bold">
                            PHP, SQLite, Artisan CLI
                          </span>
                        </div>
                        {/*end::Text*/}
                      </div>
                      {/*end::Item*/}
                      {/*begin::Item*/}
                      <div className="d-flex align-items-center">
                        {/*begin::Avatar*/}
                        <div className="symbol symbol-50px me-5">
                          <img
                            src="/metronic8/demo1/assets/media/avatars/300-23.jpg"
                            className
                            alt=""
                          />
                        </div>
                        {/*end::Avatar*/}
                        {/*begin::Text*/}
                        <div className="flex-grow-1">
                          <a
                            href="#"
                            className="text-dark fw-bolder text-hover-primary fs-6"
                          >
                            Dan Wilson
                          </a>
                          <span className="text-muted d-block fw-bold">
                            PHP, SQLite, Artisan CLI
                          </span>
                        </div>
                        {/*end::Text*/}
                      </div>
                      {/*end::Item*/}
                    </div>
                    {/*end::Body*/}
                  </div>
                  {/*end::List Widget 2*/}
                </div>
                {/*end::Col*/}
                {/*begin::Col*/}
                <div className="col-xl-4">
                  {/*begin::List Widget 6*/}
                  <div className="card card-xl-stretch mb-xl-8">
                    {/*begin::Header*/}
                    <div className="card-header border-0">
                      <h3 className="card-title fw-bolder text-dark">
                        Notifications
                      </h3>
                      <div className="card-toolbar">
                        {/*begin::Menu*/}
                        <button
                          type="button"
                          className="btn btn-sm btn-icon btn-color-primary btn-active-light-primary"
                          data-kt-menu-trigger="click"
                          data-kt-menu-placement="bottom-end"
                        >
                          {/*begin::Svg Icon | path: icons/duotune/general/gen024.svg*/}
                          <span className="svg-icon svg-icon-2">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24px"
                              height="24px"
                              viewBox="0 0 24 24"
                            >
                              <g
                                stroke="none"
                                strokeWidth={1}
                                fill="none"
                                fillRule="evenodd"
                              >
                                <rect
                                  x={5}
                                  y={5}
                                  width={5}
                                  height={5}
                                  rx={1}
                                  fill="currentColor"
                                />
                                <rect
                                  x={14}
                                  y={5}
                                  width={5}
                                  height={5}
                                  rx={1}
                                  fill="currentColor"
                                  opacity="0.3"
                                />
                                <rect
                                  x={5}
                                  y={14}
                                  width={5}
                                  height={5}
                                  rx={1}
                                  fill="currentColor"
                                  opacity="0.3"
                                />
                                <rect
                                  x={14}
                                  y={14}
                                  width={5}
                                  height={5}
                                  rx={1}
                                  fill="currentColor"
                                  opacity="0.3"
                                />
                              </g>
                            </svg>
                          </span>
                          {/*end::Svg Icon*/}
                        </button>
                        {/*begin::Menu 3*/}
                        <div
                          className="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg-light-primary fw-bold w-200px py-3"
                          data-kt-menu="true"
                        >
                          {/*begin::Heading*/}
                          <div className="menu-item px-3">
                            <div className="menu-content text-muted pb-2 px-3 fs-7 text-uppercase">
                              Payments
                            </div>
                          </div>
                          {/*end::Heading*/}
                          {/*begin::Menu item*/}
                          <div className="menu-item px-3">
                            <a href="#" className="menu-link px-3">
                              Create Invoice
                            </a>
                          </div>
                          {/*end::Menu item*/}
                          {/*begin::Menu item*/}
                          <div className="menu-item px-3">
                            <a href="#" className="menu-link flex-stack px-3">
                              Create Payment
                              <i
                                className="fas fa-exclamation-circle ms-2 fs-7"
                                data-bs-toggle="tooltip"
                                title
                                data-bs-original-title="Specify a target name for future usage and reference"
                                aria-label="Specify a target name for future usage and reference"
                              />
                            </a>
                          </div>
                          {/*end::Menu item*/}
                          {/*begin::Menu item*/}
                          <div className="menu-item px-3">
                            <a href="#" className="menu-link px-3">
                              Generate Bill
                            </a>
                          </div>
                          {/*end::Menu item*/}
                          {/*begin::Menu item*/}
                          <div
                            className="menu-item px-3"
                            data-kt-menu-trigger="hover"
                            data-kt-menu-placement="right-end"
                          >
                            <a href="#" className="menu-link px-3">
                              <span className="menu-title">Subscription</span>
                              <span className="menu-arrow" />
                            </a>
                            {/*begin::Menu sub*/}
                            <div className="menu-sub menu-sub-dropdown w-175px py-4">
                              {/*begin::Menu item*/}
                              <div className="menu-item px-3">
                                <a href="#" className="menu-link px-3">
                                  Plans
                                </a>
                              </div>
                              {/*end::Menu item*/}
                              {/*begin::Menu item*/}
                              <div className="menu-item px-3">
                                <a href="#" className="menu-link px-3">
                                  Billing
                                </a>
                              </div>
                              {/*end::Menu item*/}
                              {/*begin::Menu item*/}
                              <div className="menu-item px-3">
                                <a href="#" className="menu-link px-3">
                                  Statements
                                </a>
                              </div>
                              {/*end::Menu item*/}
                              {/*begin::Menu separator*/}
                              <div className="separator my-2" />
                              {/*end::Menu separator*/}
                              {/*begin::Menu item*/}
                              <div className="menu-item px-3">
                                <div className="menu-content px-3">
                                  {/*begin::Switch*/}
                                  <label className="form-check form-switch form-check-custom form-check-solid">
                                    {/*begin::Input*/}
                                    <input
                                      className="form-check-input w-30px h-20px"
                                      type="checkbox"
                                      defaultValue={1}
                                      defaultChecked="checked"
                                      name="notifications"
                                    />
                                    {/*end::Input*/}
                                    {/*end::Label*/}
                                    <span className="form-check-label text-muted fs-6">
                                      Recuring
                                    </span>
                                    {/*end::Label*/}
                                  </label>
                                  {/*end::Switch*/}
                                </div>
                              </div>
                              {/*end::Menu item*/}
                            </div>
                            {/*end::Menu sub*/}
                          </div>
                          {/*end::Menu item*/}
                          {/*begin::Menu item*/}
                          <div className="menu-item px-3 my-1">
                            <a href="#" className="menu-link px-3">
                              Settings
                            </a>
                          </div>
                          {/*end::Menu item*/}
                        </div>
                        {/*end::Menu 3*/}
                        {/*end::Menu*/}
                      </div>
                    </div>
                    {/*end::Header*/}
                    {/*begin::Body*/}
                    <div className="card-body pt-0">
                      {/*begin::Item*/}
                      <div className="d-flex align-items-center bg-light-warning rounded p-5 mb-7">
                        {/*begin::Icon*/}
                        <span className="svg-icon svg-icon-warning me-5">
                          {/*begin::Svg Icon | path: icons/duotune/abstract/abs027.svg*/}
                          <span className="svg-icon svg-icon-1">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width={24}
                              height={24}
                              viewBox="0 0 24 24"
                              fill="none"
                            >
                              <path
                                opacity="0.3"
                                d="M21.25 18.525L13.05 21.825C12.35 22.125 11.65 22.125 10.95 21.825L2.75 18.525C1.75 18.125 1.75 16.725 2.75 16.325L4.04999 15.825L10.25 18.325C10.85 18.525 11.45 18.625 12.05 18.625C12.65 18.625 13.25 18.525 13.85 18.325L20.05 15.825L21.35 16.325C22.35 16.725 22.35 18.125 21.25 18.525ZM13.05 16.425L21.25 13.125C22.25 12.725 22.25 11.325 21.25 10.925L13.05 7.62502C12.35 7.32502 11.65 7.32502 10.95 7.62502L2.75 10.925C1.75 11.325 1.75 12.725 2.75 13.125L10.95 16.425C11.65 16.725 12.45 16.725 13.05 16.425Z"
                                fill="currentColor"
                              />
                              <path
                                d="M11.05 11.025L2.84998 7.725C1.84998 7.325 1.84998 5.925 2.84998 5.525L11.05 2.225C11.75 1.925 12.45 1.925 13.15 2.225L21.35 5.525C22.35 5.925 22.35 7.325 21.35 7.725L13.05 11.025C12.45 11.325 11.65 11.325 11.05 11.025Z"
                                fill="currentColor"
                              />
                            </svg>
                          </span>
                          {/*end::Svg Icon*/}
                        </span>
                        {/*end::Icon*/}
                        {/*begin::Title*/}
                        <div className="flex-grow-1 me-2">
                          <a
                            href="#"
                            className="fw-bolder text-gray-800 text-hover-primary fs-6"
                          >
                            Group lunch celebration
                          </a>
                          <span className="text-muted fw-bold d-block">
                            Due in 2 Days
                          </span>
                        </div>
                        {/*end::Title*/}
                        {/*begin::Lable*/}
                        <span className="fw-bolder text-warning py-1">
                          +28%
                        </span>
                        {/*end::Lable*/}
                      </div>
                      {/*end::Item*/}
                      {/*begin::Item*/}
                      <div className="d-flex align-items-center bg-light-success rounded p-5 mb-7">
                        {/*begin::Icon*/}
                        <span className="svg-icon svg-icon-success me-5">
                          {/*begin::Svg Icon | path: icons/duotune/abstract/abs027.svg*/}
                          <span className="svg-icon svg-icon-1">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width={24}
                              height={24}
                              viewBox="0 0 24 24"
                              fill="none"
                            >
                              <path
                                opacity="0.3"
                                d="M21.25 18.525L13.05 21.825C12.35 22.125 11.65 22.125 10.95 21.825L2.75 18.525C1.75 18.125 1.75 16.725 2.75 16.325L4.04999 15.825L10.25 18.325C10.85 18.525 11.45 18.625 12.05 18.625C12.65 18.625 13.25 18.525 13.85 18.325L20.05 15.825L21.35 16.325C22.35 16.725 22.35 18.125 21.25 18.525ZM13.05 16.425L21.25 13.125C22.25 12.725 22.25 11.325 21.25 10.925L13.05 7.62502C12.35 7.32502 11.65 7.32502 10.95 7.62502L2.75 10.925C1.75 11.325 1.75 12.725 2.75 13.125L10.95 16.425C11.65 16.725 12.45 16.725 13.05 16.425Z"
                                fill="currentColor"
                              />
                              <path
                                d="M11.05 11.025L2.84998 7.725C1.84998 7.325 1.84998 5.925 2.84998 5.525L11.05 2.225C11.75 1.925 12.45 1.925 13.15 2.225L21.35 5.525C22.35 5.925 22.35 7.325 21.35 7.725L13.05 11.025C12.45 11.325 11.65 11.325 11.05 11.025Z"
                                fill="currentColor"
                              />
                            </svg>
                          </span>
                          {/*end::Svg Icon*/}
                        </span>
                        {/*end::Icon*/}
                        {/*begin::Title*/}
                        <div className="flex-grow-1 me-2">
                          <a
                            href="#"
                            className="fw-bolder text-gray-800 text-hover-primary fs-6"
                          >
                            Navigation optimization
                          </a>
                          <span className="text-muted fw-bold d-block">
                            Due in 2 Days
                          </span>
                        </div>
                        {/*end::Title*/}
                        {/*begin::Lable*/}
                        <span className="fw-bolder text-success py-1">
                          +50%
                        </span>
                        {/*end::Lable*/}
                      </div>
                      {/*end::Item*/}
                      {/*begin::Item*/}
                      <div className="d-flex align-items-center bg-light-danger rounded p-5 mb-7">
                        {/*begin::Icon*/}
                        <span className="svg-icon svg-icon-danger me-5">
                          {/*begin::Svg Icon | path: icons/duotune/abstract/abs027.svg*/}
                          <span className="svg-icon svg-icon-1">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width={24}
                              height={24}
                              viewBox="0 0 24 24"
                              fill="none"
                            >
                              <path
                                opacity="0.3"
                                d="M21.25 18.525L13.05 21.825C12.35 22.125 11.65 22.125 10.95 21.825L2.75 18.525C1.75 18.125 1.75 16.725 2.75 16.325L4.04999 15.825L10.25 18.325C10.85 18.525 11.45 18.625 12.05 18.625C12.65 18.625 13.25 18.525 13.85 18.325L20.05 15.825L21.35 16.325C22.35 16.725 22.35 18.125 21.25 18.525ZM13.05 16.425L21.25 13.125C22.25 12.725 22.25 11.325 21.25 10.925L13.05 7.62502C12.35 7.32502 11.65 7.32502 10.95 7.62502L2.75 10.925C1.75 11.325 1.75 12.725 2.75 13.125L10.95 16.425C11.65 16.725 12.45 16.725 13.05 16.425Z"
                                fill="currentColor"
                              />
                              <path
                                d="M11.05 11.025L2.84998 7.725C1.84998 7.325 1.84998 5.925 2.84998 5.525L11.05 2.225C11.75 1.925 12.45 1.925 13.15 2.225L21.35 5.525C22.35 5.925 22.35 7.325 21.35 7.725L13.05 11.025C12.45 11.325 11.65 11.325 11.05 11.025Z"
                                fill="currentColor"
                              />
                            </svg>
                          </span>
                          {/*end::Svg Icon*/}
                        </span>
                        {/*end::Icon*/}
                        {/*begin::Title*/}
                        <div className="flex-grow-1 me-2">
                          <a
                            href="#"
                            className="fw-bolder text-gray-800 text-hover-primary fs-6"
                          >
                            Rebrand strategy planning
                          </a>
                          <span className="text-muted fw-bold d-block">
                            Due in 5 Days
                          </span>
                        </div>
                        {/*end::Title*/}
                        {/*begin::Lable*/}
                        <span className="fw-bolder text-danger py-1">-27%</span>
                        {/*end::Lable*/}
                      </div>
                      {/*end::Item*/}
                      {/*begin::Item*/}
                      <div className="d-flex align-items-center bg-light-info rounded p-5">
                        {/*begin::Icon*/}
                        <span className="svg-icon svg-icon-info me-5">
                          {/*begin::Svg Icon | path: icons/duotune/abstract/abs027.svg*/}
                          <span className="svg-icon svg-icon-1">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width={24}
                              height={24}
                              viewBox="0 0 24 24"
                              fill="none"
                            >
                              <path
                                opacity="0.3"
                                d="M21.25 18.525L13.05 21.825C12.35 22.125 11.65 22.125 10.95 21.825L2.75 18.525C1.75 18.125 1.75 16.725 2.75 16.325L4.04999 15.825L10.25 18.325C10.85 18.525 11.45 18.625 12.05 18.625C12.65 18.625 13.25 18.525 13.85 18.325L20.05 15.825L21.35 16.325C22.35 16.725 22.35 18.125 21.25 18.525ZM13.05 16.425L21.25 13.125C22.25 12.725 22.25 11.325 21.25 10.925L13.05 7.62502C12.35 7.32502 11.65 7.32502 10.95 7.62502L2.75 10.925C1.75 11.325 1.75 12.725 2.75 13.125L10.95 16.425C11.65 16.725 12.45 16.725 13.05 16.425Z"
                                fill="currentColor"
                              />
                              <path
                                d="M11.05 11.025L2.84998 7.725C1.84998 7.325 1.84998 5.925 2.84998 5.525L11.05 2.225C11.75 1.925 12.45 1.925 13.15 2.225L21.35 5.525C22.35 5.925 22.35 7.325 21.35 7.725L13.05 11.025C12.45 11.325 11.65 11.325 11.05 11.025Z"
                                fill="currentColor"
                              />
                            </svg>
                          </span>
                          {/*end::Svg Icon*/}
                        </span>
                        {/*end::Icon*/}
                        {/*begin::Title*/}
                        <div className="flex-grow-1 me-2">
                          <a
                            href="#"
                            className="fw-bolder text-gray-800 text-hover-primary fs-6"
                          >
                            Product goals strategy
                          </a>
                          <span className="text-muted fw-bold d-block">
                            Due in 7 Days
                          </span>
                        </div>
                        {/*end::Title*/}
                        {/*begin::Lable*/}
                        <span className="fw-bolder text-info py-1">+8%</span>
                        {/*end::Lable*/}
                      </div>
                      {/*end::Item*/}
                    </div>
                    {/*end::Body*/}
                  </div>
                  {/*end::List Widget 6*/}
                </div>
                {/*end::Col*/}
                {/*begin::Col*/}
                <div className="col-xl-4">
                  {/*begin::List Widget 4*/}
                  <div className="card card-xl-stretch mb-5 mb-xl-8">
                    {/*begin::Header*/}
                    <div className="card-header border-0 pt-5">
                      <h3 className="card-title align-items-start flex-column">
                        <span className="card-label fw-bolder text-dark">
                          Trends
                        </span>
                        <span className="text-muted mt-1 fw-bold fs-7">
                          Latest tech trends
                        </span>
                      </h3>
                      <div className="card-toolbar">
                        {/*begin::Menu*/}
                        <button
                          type="button"
                          className="btn btn-sm btn-icon btn-color-primary btn-active-light-primary"
                          data-kt-menu-trigger="click"
                          data-kt-menu-placement="bottom-end"
                        >
                          {/*begin::Svg Icon | path: icons/duotune/general/gen024.svg*/}
                          <span className="svg-icon svg-icon-2">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24px"
                              height="24px"
                              viewBox="0 0 24 24"
                            >
                              <g
                                stroke="none"
                                strokeWidth={1}
                                fill="none"
                                fillRule="evenodd"
                              >
                                <rect
                                  x={5}
                                  y={5}
                                  width={5}
                                  height={5}
                                  rx={1}
                                  fill="currentColor"
                                />
                                <rect
                                  x={14}
                                  y={5}
                                  width={5}
                                  height={5}
                                  rx={1}
                                  fill="currentColor"
                                  opacity="0.3"
                                />
                                <rect
                                  x={5}
                                  y={14}
                                  width={5}
                                  height={5}
                                  rx={1}
                                  fill="currentColor"
                                  opacity="0.3"
                                />
                                <rect
                                  x={14}
                                  y={14}
                                  width={5}
                                  height={5}
                                  rx={1}
                                  fill="currentColor"
                                  opacity="0.3"
                                />
                              </g>
                            </svg>
                          </span>
                          {/*end::Svg Icon*/}
                        </button>
                        {/*begin::Menu 3*/}
                        <div
                          className="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg-light-primary fw-bold w-200px py-3"
                          data-kt-menu="true"
                        >
                          {/*begin::Heading*/}
                          <div className="menu-item px-3">
                            <div className="menu-content text-muted pb-2 px-3 fs-7 text-uppercase">
                              Payments
                            </div>
                          </div>
                          {/*end::Heading*/}
                          {/*begin::Menu item*/}
                          <div className="menu-item px-3">
                            <a href="#" className="menu-link px-3">
                              Create Invoice
                            </a>
                          </div>
                          {/*end::Menu item*/}
                          {/*begin::Menu item*/}
                          <div className="menu-item px-3">
                            <a href="#" className="menu-link flex-stack px-3">
                              Create Payment
                              <i
                                className="fas fa-exclamation-circle ms-2 fs-7"
                                data-bs-toggle="tooltip"
                                title
                                data-bs-original-title="Specify a target name for future usage and reference"
                                aria-label="Specify a target name for future usage and reference"
                              />
                            </a>
                          </div>
                          {/*end::Menu item*/}
                          {/*begin::Menu item*/}
                          <div className="menu-item px-3">
                            <a href="#" className="menu-link px-3">
                              Generate Bill
                            </a>
                          </div>
                          {/*end::Menu item*/}
                          {/*begin::Menu item*/}
                          <div
                            className="menu-item px-3"
                            data-kt-menu-trigger="hover"
                            data-kt-menu-placement="right-end"
                          >
                            <a href="#" className="menu-link px-3">
                              <span className="menu-title">Subscription</span>
                              <span className="menu-arrow" />
                            </a>
                            {/*begin::Menu sub*/}
                            <div className="menu-sub menu-sub-dropdown w-175px py-4">
                              {/*begin::Menu item*/}
                              <div className="menu-item px-3">
                                <a href="#" className="menu-link px-3">
                                  Plans
                                </a>
                              </div>
                              {/*end::Menu item*/}
                              {/*begin::Menu item*/}
                              <div className="menu-item px-3">
                                <a href="#" className="menu-link px-3">
                                  Billing
                                </a>
                              </div>
                              {/*end::Menu item*/}
                              {/*begin::Menu item*/}
                              <div className="menu-item px-3">
                                <a href="#" className="menu-link px-3">
                                  Statements
                                </a>
                              </div>
                              {/*end::Menu item*/}
                              {/*begin::Menu separator*/}
                              <div className="separator my-2" />
                              {/*end::Menu separator*/}
                              {/*begin::Menu item*/}
                              <div className="menu-item px-3">
                                <div className="menu-content px-3">
                                  {/*begin::Switch*/}
                                  <label className="form-check form-switch form-check-custom form-check-solid">
                                    {/*begin::Input*/}
                                    <input
                                      className="form-check-input w-30px h-20px"
                                      type="checkbox"
                                      defaultValue={1}
                                      defaultChecked="checked"
                                      name="notifications"
                                    />
                                    {/*end::Input*/}
                                    {/*end::Label*/}
                                    <span className="form-check-label text-muted fs-6">
                                      Recuring
                                    </span>
                                    {/*end::Label*/}
                                  </label>
                                  {/*end::Switch*/}
                                </div>
                              </div>
                              {/*end::Menu item*/}
                            </div>
                            {/*end::Menu sub*/}
                          </div>
                          {/*end::Menu item*/}
                          {/*begin::Menu item*/}
                          <div className="menu-item px-3 my-1">
                            <a href="#" className="menu-link px-3">
                              Settings
                            </a>
                          </div>
                          {/*end::Menu item*/}
                        </div>
                        {/*end::Menu 3*/}
                        {/*end::Menu*/}
                      </div>
                    </div>
                    {/*end::Header*/}
                    {/*begin::Body*/}
                    <div className="card-body pt-5">
                      {/*begin::Item*/}
                      <div className="d-flex align-items-sm-center mb-7">
                        {/*begin::Symbol*/}
                        <div className="symbol symbol-50px me-5">
                          <span className="symbol-label">
                            <img
                              src="/metronic8/demo1/assets/media/svg/brand-logos/plurk.svg"
                              className="h-50 align-self-center"
                              alt=""
                            />
                          </span>
                        </div>
                        {/*end::Symbol*/}
                        {/*begin::Section*/}
                        <div className="d-flex align-items-center flex-row-fluid flex-wrap">
                          <div className="flex-grow-1 me-2">
                            <a
                              href="#"
                              className="text-gray-800 text-hover-primary fs-6 fw-bolder"
                            >
                              Top Authors
                            </a>
                            <span className="text-muted fw-bold d-block fs-7">
                              Mark, Rowling, Esther
                            </span>
                          </div>
                          <span className="badge badge-light fw-bolder my-2">
                            +82$
                          </span>
                        </div>
                        {/*end::Section*/}
                      </div>
                      {/*end::Item*/}
                      {/*begin::Item*/}
                      <div className="d-flex align-items-sm-center mb-7">
                        {/*begin::Symbol*/}
                        <div className="symbol symbol-50px me-5">
                          <span className="symbol-label">
                            <img
                              src="/metronic8/demo1/assets/media/svg/brand-logos/telegram.svg"
                              className="h-50 align-self-center"
                              alt=""
                            />
                          </span>
                        </div>
                        {/*end::Symbol*/}
                        {/*begin::Section*/}
                        <div className="d-flex align-items-center flex-row-fluid flex-wrap">
                          <div className="flex-grow-1 me-2">
                            <a
                              href="#"
                              className="text-gray-800 text-hover-primary fs-6 fw-bolder"
                            >
                              Popular Authors
                            </a>
                            <span className="text-muted fw-bold d-block fs-7">
                              Randy, Steve, Mike
                            </span>
                          </div>
                          <span className="badge badge-light fw-bolder my-2">
                            +280$
                          </span>
                        </div>
                        {/*end::Section*/}
                      </div>
                      {/*end::Item*/}
                      {/*begin::Item*/}
                      <div className="d-flex align-items-sm-center mb-7">
                        {/*begin::Symbol*/}
                        <div className="symbol symbol-50px me-5">
                          <span className="symbol-label">
                            <img
                              src="/metronic8/demo1/assets/media/svg/brand-logos/vimeo.svg"
                              className="h-50 align-self-center"
                              alt=""
                            />
                          </span>
                        </div>
                        {/*end::Symbol*/}
                        {/*begin::Section*/}
                        <div className="d-flex align-items-center flex-row-fluid flex-wrap">
                          <div className="flex-grow-1 me-2">
                            <a
                              href="#"
                              className="text-gray-800 text-hover-primary fs-6 fw-bolder"
                            >
                              New Users
                            </a>
                            <span className="text-muted fw-bold d-block fs-7">
                              John, Pat, Jimmy
                            </span>
                          </div>
                          <span className="badge badge-light fw-bolder my-2">
                            +4500$
                          </span>
                        </div>
                        {/*end::Section*/}
                      </div>
                      {/*end::Item*/}
                      {/*begin::Item*/}
                      <div className="d-flex align-items-sm-center mb-7">
                        {/*begin::Symbol*/}
                        <div className="symbol symbol-50px me-5">
                          <span className="symbol-label">
                            <img
                              src="/metronic8/demo1/assets/media/svg/brand-logos/bebo.svg"
                              className="h-50 align-self-center"
                              alt=""
                            />
                          </span>
                        </div>
                        {/*end::Symbol*/}
                        {/*begin::Section*/}
                        <div className="d-flex align-items-center flex-row-fluid flex-wrap">
                          <div className="flex-grow-1 me-2">
                            <a
                              href="#"
                              className="text-gray-800 text-hover-primary fs-6 fw-bolder"
                            >
                              Active Customers
                            </a>
                            <span className="text-muted fw-bold d-block fs-7">
                              Mark, Rowling, Esther
                            </span>
                          </div>
                          <span className="badge badge-light fw-bolder my-2">
                            +686$
                          </span>
                        </div>
                        {/*end::Section*/}
                      </div>
                      {/*end::Item*/}
                      {/*begin::Item*/}
                      <div className="d-flex align-items-sm-center mb-7">
                        {/*begin::Symbol*/}
                        <div className="symbol symbol-50px me-5">
                          <span className="symbol-label">
                            <img
                              src="/metronic8/demo1/assets/media/svg/brand-logos/kickstarter.svg"
                              className="h-50 align-self-center"
                              alt=""
                            />
                          </span>
                        </div>
                        {/*end::Symbol*/}
                        {/*begin::Section*/}
                        <div className="d-flex align-items-center flex-row-fluid flex-wrap">
                          <div className="flex-grow-1 me-2">
                            <a
                              href="#"
                              className="text-gray-800 text-hover-primary fs-6 fw-bolder"
                            >
                              Bestseller Theme
                            </a>
                            <span className="text-muted fw-bold d-block fs-7">
                              Disco, Retro, Sports
                            </span>
                          </div>
                          <span className="badge badge-light fw-bolder my-2">
                            +726$
                          </span>
                        </div>
                        {/*end::Section*/}
                      </div>
                      {/*end::Item*/}
                    </div>
                    {/*end::Body*/}
                  </div>
                  {/*end::List Widget 4*/}
                </div>
                {/*end::Col*/}
              </div>
              {/*end::Row*/}
              {/*begin::Row*/}
              <div className="row g-5 g-xl-8">
                {/*begin::Col*/}
                <div className="col-xl-4">
                  {/*begin::Mixed Widget 5*/}
                  <div className="card card-xxl-stretch mb-xl-8">
                    {/*begin::Beader*/}
                    <div className="card-header border-0 py-5">
                      <h3 className="card-title align-items-start flex-column">
                        <span className="card-label fw-bolder fs-3 mb-1">
                          Trends
                        </span>
                        <span className="text-muted fw-bold fs-7">
                          Latest trends
                        </span>
                      </h3>
                      <div className="card-toolbar">
                        {/*begin::Menu*/}
                        <button
                          type="button"
                          className="btn btn-sm btn-icon btn-color-primary btn-active-light-primary"
                          data-kt-menu-trigger="click"
                          data-kt-menu-placement="bottom-end"
                        >
                          {/*begin::Svg Icon | path: icons/duotune/general/gen024.svg*/}
                          <span className="svg-icon svg-icon-2">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24px"
                              height="24px"
                              viewBox="0 0 24 24"
                            >
                              <g
                                stroke="none"
                                strokeWidth={1}
                                fill="none"
                                fillRule="evenodd"
                              >
                                <rect
                                  x={5}
                                  y={5}
                                  width={5}
                                  height={5}
                                  rx={1}
                                  fill="currentColor"
                                />
                                <rect
                                  x={14}
                                  y={5}
                                  width={5}
                                  height={5}
                                  rx={1}
                                  fill="currentColor"
                                  opacity="0.3"
                                />
                                <rect
                                  x={5}
                                  y={14}
                                  width={5}
                                  height={5}
                                  rx={1}
                                  fill="currentColor"
                                  opacity="0.3"
                                />
                                <rect
                                  x={14}
                                  y={14}
                                  width={5}
                                  height={5}
                                  rx={1}
                                  fill="currentColor"
                                  opacity="0.3"
                                />
                              </g>
                            </svg>
                          </span>
                          {/*end::Svg Icon*/}
                        </button>
                        {/*begin::Menu 3*/}
                        <div
                          className="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg-light-primary fw-bold w-200px py-3"
                          data-kt-menu="true"
                        >
                          {/*begin::Heading*/}
                          <div className="menu-item px-3">
                            <div className="menu-content text-muted pb-2 px-3 fs-7 text-uppercase">
                              Payments
                            </div>
                          </div>
                          {/*end::Heading*/}
                          {/*begin::Menu item*/}
                          <div className="menu-item px-3">
                            <a href="#" className="menu-link px-3">
                              Create Invoice
                            </a>
                          </div>
                          {/*end::Menu item*/}
                          {/*begin::Menu item*/}
                          <div className="menu-item px-3">
                            <a href="#" className="menu-link flex-stack px-3">
                              Create Payment
                              <i
                                className="fas fa-exclamation-circle ms-2 fs-7"
                                data-bs-toggle="tooltip"
                                title
                                data-bs-original-title="Specify a target name for future usage and reference"
                                aria-label="Specify a target name for future usage and reference"
                              />
                            </a>
                          </div>
                          {/*end::Menu item*/}
                          {/*begin::Menu item*/}
                          <div className="menu-item px-3">
                            <a href="#" className="menu-link px-3">
                              Generate Bill
                            </a>
                          </div>
                          {/*end::Menu item*/}
                          {/*begin::Menu item*/}
                          <div
                            className="menu-item px-3"
                            data-kt-menu-trigger="hover"
                            data-kt-menu-placement="right-end"
                          >
                            <a href="#" className="menu-link px-3">
                              <span className="menu-title">Subscription</span>
                              <span className="menu-arrow" />
                            </a>
                            {/*begin::Menu sub*/}
                            <div className="menu-sub menu-sub-dropdown w-175px py-4">
                              {/*begin::Menu item*/}
                              <div className="menu-item px-3">
                                <a href="#" className="menu-link px-3">
                                  Plans
                                </a>
                              </div>
                              {/*end::Menu item*/}
                              {/*begin::Menu item*/}
                              <div className="menu-item px-3">
                                <a href="#" className="menu-link px-3">
                                  Billing
                                </a>
                              </div>
                              {/*end::Menu item*/}
                              {/*begin::Menu item*/}
                              <div className="menu-item px-3">
                                <a href="#" className="menu-link px-3">
                                  Statements
                                </a>
                              </div>
                              {/*end::Menu item*/}
                              {/*begin::Menu separator*/}
                              <div className="separator my-2" />
                              {/*end::Menu separator*/}
                              {/*begin::Menu item*/}
                              <div className="menu-item px-3">
                                <div className="menu-content px-3">
                                  {/*begin::Switch*/}
                                  <label className="form-check form-switch form-check-custom form-check-solid">
                                    {/*begin::Input*/}
                                    <input
                                      className="form-check-input w-30px h-20px"
                                      type="checkbox"
                                      defaultValue={1}
                                      defaultChecked="checked"
                                      name="notifications"
                                    />
                                    {/*end::Input*/}
                                    {/*end::Label*/}
                                    <span className="form-check-label text-muted fs-6">
                                      Recuring
                                    </span>
                                    {/*end::Label*/}
                                  </label>
                                  {/*end::Switch*/}
                                </div>
                              </div>
                              {/*end::Menu item*/}
                            </div>
                            {/*end::Menu sub*/}
                          </div>
                          {/*end::Menu item*/}
                          {/*begin::Menu item*/}
                          <div className="menu-item px-3 my-1">
                            <a href="#" className="menu-link px-3">
                              Settings
                            </a>
                          </div>
                          {/*end::Menu item*/}
                        </div>
                        {/*end::Menu 3*/}
                        {/*end::Menu*/}
                      </div>
                    </div>
                    {/*end::Header*/}
                    {/*begin::Body*/}
                    <div className="card-body d-flex flex-column">
                      {/*begin::Chart*/}
                      <div
                        className="mixed-widget-5-chart card-rounded-top"
                        data-kt-chart-color="success"
                        style={{ height: "150px", minHeight: "150px" }}
                      >
                        <div
                          id="apexcharts0xc3u0c1"
                          className="apexcharts-canvas apexcharts0xc3u0c1 apexcharts-theme-light"
                          style={{ width: "344px", height: "150px" }}
                        >
                          <svg
                            id="SvgjsSvg1069"
                            width={344}
                            height={150}
                            xmlns="http://www.w3.org/2000/svg"
                            version="1.1"
                            xmlnsXlink="http://www.w3.org/1999/xlink"
                            // xmlns:svgjs="http://svgjs.dev"
                            className="apexcharts-svg"
                            // xmlns:data="ApexChartsNS"
                            transform="translate(0, 0)"
                            style={{ background: "transparent" }}
                          >
                            <g
                              id="SvgjsG1071"
                              className="apexcharts-inner apexcharts-graphical"
                              transform="translate(0, 0)"
                            >
                              <defs id="SvgjsDefs1070">
                                <clipPath id="gridRectMask0xc3u0c1">
                                  <rect
                                    id="SvgjsRect1074"
                                    width={351}
                                    height={153}
                                    x="-3.5"
                                    y="-1.5"
                                    rx={0}
                                    ry={0}
                                    opacity={1}
                                    strokeWidth={0}
                                    stroke="none"
                                    strokeDasharray={0}
                                    fill="#fff"
                                  />
                                </clipPath>
                                <clipPath id="forecastMask0xc3u0c1" />
                                <clipPath id="nonForecastMask0xc3u0c1" />
                                <clipPath id="gridRectMarkerMask0xc3u0c1">
                                  <rect
                                    id="SvgjsRect1075"
                                    width={348}
                                    height={154}
                                    x={-2}
                                    y={-2}
                                    rx={0}
                                    ry={0}
                                    opacity={1}
                                    strokeWidth={0}
                                    stroke="none"
                                    strokeDasharray={0}
                                    fill="#fff"
                                  />
                                </clipPath>
                              </defs>
                              <g
                                id="SvgjsG1082"
                                className="apexcharts-xaxis"
                                transform="translate(0, 0)"
                              >
                                <g
                                  id="SvgjsG1083"
                                  className="apexcharts-xaxis-texts-g"
                                  transform="translate(0, -4)"
                                />
                              </g>
                              <g id="SvgjsG1091" className="apexcharts-grid">
                                <g
                                  id="SvgjsG1092"
                                  className="apexcharts-gridlines-horizontal"
                                  style={{ display: "none" }}
                                >
                                  <line
                                    id="SvgjsLine1094"
                                    x1={0}
                                    y1={0}
                                    x2={344}
                                    y2={0}
                                    stroke="#e0e0e0"
                                    strokeDasharray={0}
                                    strokeLinecap="butt"
                                    className="apexcharts-gridline"
                                  />
                                  <line
                                    id="SvgjsLine1095"
                                    x1={0}
                                    y1={15}
                                    x2={344}
                                    y2={15}
                                    stroke="#e0e0e0"
                                    strokeDasharray={0}
                                    strokeLinecap="butt"
                                    className="apexcharts-gridline"
                                  />
                                  <line
                                    id="SvgjsLine1096"
                                    x1={0}
                                    y1={30}
                                    x2={344}
                                    y2={30}
                                    stroke="#e0e0e0"
                                    strokeDasharray={0}
                                    strokeLinecap="butt"
                                    className="apexcharts-gridline"
                                  />
                                  <line
                                    id="SvgjsLine1097"
                                    x1={0}
                                    y1={45}
                                    x2={344}
                                    y2={45}
                                    stroke="#e0e0e0"
                                    strokeDasharray={0}
                                    strokeLinecap="butt"
                                    className="apexcharts-gridline"
                                  />
                                  <line
                                    id="SvgjsLine1098"
                                    x1={0}
                                    y1={60}
                                    x2={344}
                                    y2={60}
                                    stroke="#e0e0e0"
                                    strokeDasharray={0}
                                    strokeLinecap="butt"
                                    className="apexcharts-gridline"
                                  />
                                  <line
                                    id="SvgjsLine1099"
                                    x1={0}
                                    y1={75}
                                    x2={344}
                                    y2={75}
                                    stroke="#e0e0e0"
                                    strokeDasharray={0}
                                    strokeLinecap="butt"
                                    className="apexcharts-gridline"
                                  />
                                  <line
                                    id="SvgjsLine1100"
                                    x1={0}
                                    y1={90}
                                    x2={344}
                                    y2={90}
                                    stroke="#e0e0e0"
                                    strokeDasharray={0}
                                    strokeLinecap="butt"
                                    className="apexcharts-gridline"
                                  />
                                  <line
                                    id="SvgjsLine1101"
                                    x1={0}
                                    y1={105}
                                    x2={344}
                                    y2={105}
                                    stroke="#e0e0e0"
                                    strokeDasharray={0}
                                    strokeLinecap="butt"
                                    className="apexcharts-gridline"
                                  />
                                  <line
                                    id="SvgjsLine1102"
                                    x1={0}
                                    y1={120}
                                    x2={344}
                                    y2={120}
                                    stroke="#e0e0e0"
                                    strokeDasharray={0}
                                    strokeLinecap="butt"
                                    className="apexcharts-gridline"
                                  />
                                  <line
                                    id="SvgjsLine1103"
                                    x1={0}
                                    y1={135}
                                    x2={344}
                                    y2={135}
                                    stroke="#e0e0e0"
                                    strokeDasharray={0}
                                    strokeLinecap="butt"
                                    className="apexcharts-gridline"
                                  />
                                  <line
                                    id="SvgjsLine1104"
                                    x1={0}
                                    y1={150}
                                    x2={344}
                                    y2={150}
                                    stroke="#e0e0e0"
                                    strokeDasharray={0}
                                    strokeLinecap="butt"
                                    className="apexcharts-gridline"
                                  />
                                </g>
                                <g
                                  id="SvgjsG1093"
                                  className="apexcharts-gridlines-vertical"
                                  style={{ display: "none" }}
                                />
                                <line
                                  id="SvgjsLine1106"
                                  x1={0}
                                  y1={150}
                                  x2={344}
                                  y2={150}
                                  stroke="transparent"
                                  strokeDasharray={0}
                                  strokeLinecap="butt"
                                />
                                <line
                                  id="SvgjsLine1105"
                                  x1={0}
                                  y1={1}
                                  x2={0}
                                  y2={150}
                                  stroke="transparent"
                                  strokeDasharray={0}
                                  strokeLinecap="butt"
                                />
                              </g>
                              <g
                                id="SvgjsG1076"
                                className="apexcharts-area-series apexcharts-plot-series"
                              >
                                <g
                                  id="SvgjsG1077"
                                  className="apexcharts-series"
                                  seriesname="NetxProfit"
                                  // data:longestseries="true"
                                  rel={1}
                                  // data:realindex={0}
                                >
                                  <path
                                    id="SvgjsPath1080"
                                    d="M0 150L0 80.76923076923077C24.08 80.76923076923077 44.72 80.76923076923077 68.8 80.76923076923077C92.88 80.76923076923077 113.52 11.538461538461547 137.6 11.538461538461547C161.68 11.538461538461547 182.32 92.3076923076923 206.4 92.3076923076923C230.48 92.3076923076923 251.12 92.3076923076923 275.2 92.3076923076923C299.28 92.3076923076923 319.92 57.69230769230769 344 57.69230769230769C344 57.69230769230769 344 57.69230769230769 344 150M344 57.69230769230769C344 57.69230769230769 344 57.69230769230769 344 57.69230769230769 "
                                    fill="rgba(232,255,243,1)"
                                    fillOpacity={1}
                                    strokeOpacity={1}
                                    strokeLinecap="butt"
                                    strokeWidth={0}
                                    strokeDasharray={0}
                                    className="apexcharts-area"
                                    index={0}
                                    clipPath="url(#gridRectMask0xc3u0c1)"
                                    pathto="M 0 150L 0 80.76923076923077C 24.08 80.76923076923077 44.72 80.76923076923077 68.8 80.76923076923077C 92.88 80.76923076923077 113.52 11.538461538461547 137.6 11.538461538461547C 161.68 11.538461538461547 182.32 92.3076923076923 206.4 92.3076923076923C 230.48 92.3076923076923 251.12 92.3076923076923 275.2 92.3076923076923C 299.28 92.3076923076923 319.92 57.69230769230769 344 57.69230769230769C 344 57.69230769230769 344 57.69230769230769 344 150M 344 57.69230769230769z"
                                    pathfrom="M -1 150L -1 150L 68.8 150L 137.6 150L 206.4 150L 275.2 150L 344 150"
                                  />
                                  <path
                                    id="SvgjsPath1081"
                                    d="M0 80.76923076923077C24.08 80.76923076923077 44.72 80.76923076923077 68.8 80.76923076923077C92.88 80.76923076923077 113.52 11.538461538461547 137.6 11.538461538461547C161.68 11.538461538461547 182.32 92.3076923076923 206.4 92.3076923076923C230.48 92.3076923076923 251.12 92.3076923076923 275.2 92.3076923076923C299.28 92.3076923076923 319.92 57.69230769230769 344 57.69230769230769C344 57.69230769230769 344 57.69230769230769 344 57.69230769230769 "
                                    fill="none"
                                    fillOpacity={1}
                                    stroke="#50cd89"
                                    strokeOpacity={1}
                                    strokeLinecap="butt"
                                    strokeWidth={3}
                                    strokeDasharray={0}
                                    className="apexcharts-area"
                                    index={0}
                                    clipPath="url(#gridRectMask0xc3u0c1)"
                                    pathto="M 0 80.76923076923077C 24.08 80.76923076923077 44.72 80.76923076923077 68.8 80.76923076923077C 92.88 80.76923076923077 113.52 11.538461538461547 137.6 11.538461538461547C 161.68 11.538461538461547 182.32 92.3076923076923 206.4 92.3076923076923C 230.48 92.3076923076923 251.12 92.3076923076923 275.2 92.3076923076923C 299.28 92.3076923076923 319.92 57.69230769230769 344 57.69230769230769"
                                    pathfrom="M -1 150L -1 150L 68.8 150L 137.6 150L 206.4 150L 275.2 150L 344 150"
                                  />
                                  <g
                                    id="SvgjsG1078"
                                    className="apexcharts-series-markers-wrap"
                                    // data:realindex={0}
                                  >
                                    <g className="apexcharts-series-markers">
                                      <circle
                                        id="SvgjsCircle1112"
                                        r={0}
                                        cx={0}
                                        cy={0}
                                        className="apexcharts-marker w2scv65ppl no-pointer-events"
                                        stroke="#50cd89"
                                        fill="#e8fff3"
                                        fillOpacity={1}
                                        strokeWidth={3}
                                        strokeOpacity="0.9"
                                        default-marker-size={0}
                                      />
                                    </g>
                                  </g>
                                </g>
                                <g
                                  id="SvgjsG1079"
                                  className="apexcharts-datalabels"
                                  // data:realindex={0}
                                />
                              </g>
                              <line
                                id="SvgjsLine1107"
                                x1={0}
                                y1={0}
                                x2={344}
                                y2={0}
                                stroke="#b6b6b6"
                                strokeDasharray={0}
                                strokeWidth={1}
                                strokeLinecap="butt"
                                className="apexcharts-ycrosshairs"
                              />
                              <line
                                id="SvgjsLine1108"
                                x1={0}
                                y1={0}
                                x2={344}
                                y2={0}
                                strokeDasharray={0}
                                strokeWidth={0}
                                strokeLinecap="butt"
                                className="apexcharts-ycrosshairs-hidden"
                              />
                              <g
                                id="SvgjsG1109"
                                className="apexcharts-yaxis-annotations"
                              />
                              <g
                                id="SvgjsG1110"
                                className="apexcharts-xaxis-annotations"
                              />
                              <g
                                id="SvgjsG1111"
                                className="apexcharts-point-annotations"
                              />
                            </g>
                            <g
                              id="SvgjsG1090"
                              className="apexcharts-yaxis"
                              rel={0}
                              transform="translate(-18, 0)"
                            />
                            <g
                              id="SvgjsG1072"
                              className="apexcharts-annotations"
                            />
                          </svg>
                          <div
                            className="apexcharts-legend"
                            style={{ maxHeight: "75px" }}
                          />
                          <div className="apexcharts-tooltip apexcharts-theme-light">
                            <div
                              className="apexcharts-tooltip-title"
                              style={{
                                fontFamily: "inherit",
                                fontSize: "12px",
                              }}
                            />
                            <div
                              className="apexcharts-tooltip-series-group"
                              style={{ order: 1 }}
                            >
                              <span
                                className="apexcharts-tooltip-marker"
                                style={{
                                  backgroundColor: "rgb(232, 255, 243)",
                                }}
                              />
                              <div
                                className="apexcharts-tooltip-text"
                                style={{
                                  fontFamily: "inherit",
                                  fontSize: "12px",
                                }}
                              >
                                <div className="apexcharts-tooltip-y-group">
                                  <span className="apexcharts-tooltip-text-y-label" />
                                  <span className="apexcharts-tooltip-text-y-value" />
                                </div>
                                <div className="apexcharts-tooltip-goals-group">
                                  <span className="apexcharts-tooltip-text-goals-label" />
                                  <span className="apexcharts-tooltip-text-goals-value" />
                                </div>
                                <div className="apexcharts-tooltip-z-group">
                                  <span className="apexcharts-tooltip-text-z-label" />
                                  <span className="apexcharts-tooltip-text-z-value" />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="apexcharts-xaxistooltip apexcharts-xaxistooltip-bottom apexcharts-theme-light">
                            <div
                              className="apexcharts-xaxistooltip-text"
                              style={{
                                fontFamily: "inherit",
                                fontSize: "12px",
                              }}
                            />
                          </div>
                          <div className="apexcharts-yaxistooltip apexcharts-yaxistooltip-0 apexcharts-yaxistooltip-left apexcharts-theme-light">
                            <div className="apexcharts-yaxistooltip-text" />
                          </div>
                        </div>
                      </div>
                      {/*end::Chart*/}
                      {/*begin::Items*/}
                      <div className="mt-5">
                        {/*begin::Item*/}
                        <div className="d-flex flex-stack mb-5">
                          {/*begin::Section*/}
                          <div className="d-flex align-items-center me-2">
                            {/*begin::Symbol*/}
                            <div className="symbol symbol-50px me-3">
                              <div className="symbol-label bg-light">
                                <img
                                  src="/metronic8/demo1/assets/media/svg/brand-logos/plurk.svg"
                                  className="h-50"
                                  alt=""
                                />
                              </div>
                            </div>
                            {/*end::Symbol*/}
                            {/*begin::Title*/}
                            <div>
                              <a
                                href="#"
                                className="fs-6 text-gray-800 text-hover-primary fw-bolder"
                              >
                                Top Authors
                              </a>
                              <div className="fs-7 text-muted fw-bold mt-1">
                                Ricky Hunt, Sandra Trepp
                              </div>
                            </div>
                            {/*end::Title*/}
                          </div>
                          {/*end::Section*/}
                          {/*begin::Label*/}
                          <div className="badge badge-light fw-bold py-4 px-3">
                            +82$
                          </div>
                          {/*end::Label*/}
                        </div>
                        {/*end::Item*/}
                        {/*begin::Item*/}
                        <div className="d-flex flex-stack mb-5">
                          {/*begin::Section*/}
                          <div className="d-flex align-items-center me-2">
                            {/*begin::Symbol*/}
                            <div className="symbol symbol-50px me-3">
                              <div className="symbol-label bg-light">
                                <img
                                  src="/metronic8/demo1/assets/media/svg/brand-logos/figma-1.svg"
                                  className="h-50"
                                  alt=""
                                />
                              </div>
                            </div>
                            {/*end::Symbol*/}
                            {/*begin::Title*/}
                            <div>
                              <a
                                href="#"
                                className="fs-6 text-gray-800 text-hover-primary fw-bolder"
                              >
                                Top Sales
                              </a>
                              <div className="fs-7 text-muted fw-bold mt-1">
                                PitStop Emails
                              </div>
                            </div>
                            {/*end::Title*/}
                          </div>
                          {/*end::Section*/}
                          {/*begin::Label*/}
                          <div className="badge badge-light fw-bold py-4 px-3">
                            +82$
                          </div>
                          {/*end::Label*/}
                        </div>
                        {/*end::Item*/}
                        {/*begin::Item*/}
                        <div className="d-flex flex-stack">
                          {/*begin::Section*/}
                          <div className="d-flex align-items-center me-2">
                            {/*begin::Symbol*/}
                            <div className="symbol symbol-50px me-3">
                              <div className="symbol-label bg-light">
                                <img
                                  src="/metronic8/demo1/assets/media/svg/brand-logos/vimeo.svg"
                                  className="h-50"
                                  alt=""
                                />
                              </div>
                            </div>
                            {/*end::Symbol*/}
                            {/*begin::Title*/}
                            <div className="py-1">
                              <a
                                href="#"
                                className="fs-6 text-gray-800 text-hover-primary fw-bolder"
                              >
                                Top Engagement
                              </a>
                              <div className="fs-7 text-muted fw-bold mt-1">
                                KT.com
                              </div>
                            </div>
                            {/*end::Title*/}
                          </div>
                          {/*end::Section*/}
                          {/*begin::Label*/}
                          <div className="badge badge-light fw-bold py-4 px-3">
                            +82$
                          </div>
                          {/*end::Label*/}
                        </div>
                        {/*end::Item*/}
                      </div>
                      {/*end::Items*/}
                    </div>
                    {/*end::Body*/}
                  </div>
                  {/*end::Mixed Widget 5*/}
                </div>
                {/*end::Col*/}
                {/*begin::Col*/}
                <div className="col-xl-8">
                  {/*begin::Tables Widget 5*/}
                  <div className="card card-xxl-stretch mb-5 mb-xl-8">
                    {/*begin::Header*/}
                    <div className="card-header border-0 pt-5">
                      <h3 className="card-title align-items-start flex-column">
                        <span className="card-label fw-bolder fs-3 mb-1">
                          Latest Products
                        </span>
                        <span className="text-muted mt-1 fw-bold fs-7">
                          More than 400 new products
                        </span>
                      </h3>
                      <div className="card-toolbar">
                        <ul className="nav">
                          <li className="nav-item">
                            <a
                              className="nav-link btn btn-sm btn-color-muted btn-active btn-active-secondary fw-bolder px-4 me-1 active"
                              data-bs-toggle="tab"
                              href="#kt_table_widget_5_tab_1"
                            >
                              Month
                            </a>
                          </li>
                          <li className="nav-item">
                            <a
                              className="nav-link btn btn-sm btn-color-muted btn-active btn-active-secondary fw-bolder px-4 me-1"
                              data-bs-toggle="tab"
                              href="#kt_table_widget_5_tab_2"
                            >
                              Week
                            </a>
                          </li>
                          <li className="nav-item">
                            <a
                              className="nav-link btn btn-sm btn-color-muted btn-active btn-active-secondary fw-bolder px-4"
                              data-bs-toggle="tab"
                              href="#kt_table_widget_5_tab_3"
                            >
                              Day
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                    {/*end::Header*/}
                    {/*begin::Body*/}
                    <div className="card-body py-3">
                      <div className="tab-content">
                        {/*begin::Tap pane*/}
                        <div
                          className="tab-pane fade show active"
                          id="kt_table_widget_5_tab_1"
                        >
                          {/*begin::Table container*/}
                          <div className="table-responsive">
                            {/*begin::Table*/}
                            <table className="table table-row-dashed table-row-gray-200 align-middle gs-0 gy-4">
                              {/*begin::Table head*/}
                              <thead>
                                <tr className="border-0">
                                  <th className="p-0 w-50px" />
                                  <th className="p-0 min-w-150px" />
                                  <th className="p-0 min-w-140px" />
                                  <th className="p-0 min-w-110px" />
                                  <th className="p-0 min-w-50px" />
                                </tr>
                              </thead>
                              {/*end::Table head*/}
                              {/*begin::Table body*/}
                              <tbody>
                                <tr>
                                  <td>
                                    <div className="symbol symbol-45px me-2">
                                      <span className="symbol-label">
                                        <img
                                          src="/metronic8/demo1/assets/media/svg/brand-logos/plurk.svg"
                                          className="h-50 align-self-center"
                                          alt=""
                                        />
                                      </span>
                                    </div>
                                  </td>
                                  <td>
                                    <a
                                      href="#"
                                      className="text-dark fw-bolder text-hover-primary mb-1 fs-6"
                                    >
                                      Brad Simmons
                                    </a>
                                    <span className="text-muted fw-bold d-block">
                                      Movie Creator
                                    </span>
                                  </td>
                                  <td className="text-end text-muted fw-bold">
                                    React, HTML
                                  </td>
                                  <td className="text-end">
                                    <span className="badge badge-light-success">
                                      Approved
                                    </span>
                                  </td>
                                  <td className="text-end">
                                    <a
                                      href="#"
                                      className="btn btn-sm btn-icon btn-bg-light btn-active-color-primary"
                                    >
                                      {/*begin::Svg Icon | path: icons/duotune/arrows/arr064.svg*/}
                                      <span className="svg-icon svg-icon-2">
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width={24}
                                          height={24}
                                          viewBox="0 0 24 24"
                                          fill="none"
                                        >
                                          <rect
                                            opacity="0.5"
                                            x={18}
                                            y={13}
                                            width={13}
                                            height={2}
                                            rx={1}
                                            transform="rotate(-180 18 13)"
                                            fill="currentColor"
                                          />
                                          <path
                                            d="M15.4343 12.5657L11.25 16.75C10.8358 17.1642 10.8358 17.8358 11.25 18.25C11.6642 18.6642 12.3358 18.6642 12.75 18.25L18.2929 12.7071C18.6834 12.3166 18.6834 11.6834 18.2929 11.2929L12.75 5.75C12.3358 5.33579 11.6642 5.33579 11.25 5.75C10.8358 6.16421 10.8358 6.83579 11.25 7.25L15.4343 11.4343C15.7467 11.7467 15.7467 12.2533 15.4343 12.5657Z"
                                            fill="currentColor"
                                          />
                                        </svg>
                                      </span>
                                      {/*end::Svg Icon*/}
                                    </a>
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <div className="symbol symbol-45px me-2">
                                      <span className="symbol-label">
                                        <img
                                          src="/metronic8/demo1/assets/media/svg/brand-logos/telegram.svg"
                                          className="h-50 align-self-center"
                                          alt=""
                                        />
                                      </span>
                                    </div>
                                  </td>
                                  <td>
                                    <a
                                      href="#"
                                      className="text-dark fw-bolder text-hover-primary mb-1 fs-6"
                                    >
                                      Popular Authors
                                    </a>
                                    <span className="text-muted fw-bold d-block">
                                      Most Successful
                                    </span>
                                  </td>
                                  <td className="text-end text-muted fw-bold">
                                    Python, MySQL
                                  </td>
                                  <td className="text-end">
                                    <span className="badge badge-light-warning">
                                      In Progress
                                    </span>
                                  </td>
                                  <td className="text-end">
                                    <a
                                      href="#"
                                      className="btn btn-sm btn-icon btn-bg-light btn-active-color-primary"
                                    >
                                      {/*begin::Svg Icon | path: icons/duotune/arrows/arr064.svg*/}
                                      <span className="svg-icon svg-icon-2">
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width={24}
                                          height={24}
                                          viewBox="0 0 24 24"
                                          fill="none"
                                        >
                                          <rect
                                            opacity="0.5"
                                            x={18}
                                            y={13}
                                            width={13}
                                            height={2}
                                            rx={1}
                                            transform="rotate(-180 18 13)"
                                            fill="currentColor"
                                          />
                                          <path
                                            d="M15.4343 12.5657L11.25 16.75C10.8358 17.1642 10.8358 17.8358 11.25 18.25C11.6642 18.6642 12.3358 18.6642 12.75 18.25L18.2929 12.7071C18.6834 12.3166 18.6834 11.6834 18.2929 11.2929L12.75 5.75C12.3358 5.33579 11.6642 5.33579 11.25 5.75C10.8358 6.16421 10.8358 6.83579 11.25 7.25L15.4343 11.4343C15.7467 11.7467 15.7467 12.2533 15.4343 12.5657Z"
                                            fill="currentColor"
                                          />
                                        </svg>
                                      </span>
                                      {/*end::Svg Icon*/}
                                    </a>
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <div className="symbol symbol-45px me-2">
                                      <span className="symbol-label">
                                        <img
                                          src="/metronic8/demo1/assets/media/svg/brand-logos/vimeo.svg"
                                          className="h-50 align-self-center"
                                          alt=""
                                        />
                                      </span>
                                    </div>
                                  </td>
                                  <td>
                                    <a
                                      href="#"
                                      className="text-dark fw-bolder text-hover-primary mb-1 fs-6"
                                    >
                                      New Users
                                    </a>
                                    <span className="text-muted fw-bold d-block">
                                      Awesome Users
                                    </span>
                                  </td>
                                  <td className="text-end text-muted fw-bold">
                                    Laravel,Metronic
                                  </td>
                                  <td className="text-end">
                                    <span className="badge badge-light-primary">
                                      Success
                                    </span>
                                  </td>
                                  <td className="text-end">
                                    <a
                                      href="#"
                                      className="btn btn-sm btn-icon btn-bg-light btn-active-color-primary"
                                    >
                                      {/*begin::Svg Icon | path: icons/duotune/arrows/arr064.svg*/}
                                      <span className="svg-icon svg-icon-2">
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width={24}
                                          height={24}
                                          viewBox="0 0 24 24"
                                          fill="none"
                                        >
                                          <rect
                                            opacity="0.5"
                                            x={18}
                                            y={13}
                                            width={13}
                                            height={2}
                                            rx={1}
                                            transform="rotate(-180 18 13)"
                                            fill="currentColor"
                                          />
                                          <path
                                            d="M15.4343 12.5657L11.25 16.75C10.8358 17.1642 10.8358 17.8358 11.25 18.25C11.6642 18.6642 12.3358 18.6642 12.75 18.25L18.2929 12.7071C18.6834 12.3166 18.6834 11.6834 18.2929 11.2929L12.75 5.75C12.3358 5.33579 11.6642 5.33579 11.25 5.75C10.8358 6.16421 10.8358 6.83579 11.25 7.25L15.4343 11.4343C15.7467 11.7467 15.7467 12.2533 15.4343 12.5657Z"
                                            fill="currentColor"
                                          />
                                        </svg>
                                      </span>
                                      {/*end::Svg Icon*/}
                                    </a>
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <div className="symbol symbol-45px me-2">
                                      <span className="symbol-label">
                                        <img
                                          src="/metronic8/demo1/assets/media/svg/brand-logos/bebo.svg"
                                          className="h-50 align-self-center"
                                          alt=""
                                        />
                                      </span>
                                    </div>
                                  </td>
                                  <td>
                                    <a
                                      href="#"
                                      className="text-dark fw-bolder text-hover-primary mb-1 fs-6"
                                    >
                                      Active Customers
                                    </a>
                                    <span className="text-muted fw-bold d-block">
                                      Movie Creator
                                    </span>
                                  </td>
                                  <td className="text-end text-muted fw-bold">
                                    AngularJS, C#
                                  </td>
                                  <td className="text-end">
                                    <span className="badge badge-light-danger">
                                      Rejected
                                    </span>
                                  </td>
                                  <td className="text-end">
                                    <a
                                      href="#"
                                      className="btn btn-sm btn-icon btn-bg-light btn-active-color-primary"
                                    >
                                      {/*begin::Svg Icon | path: icons/duotune/arrows/arr064.svg*/}
                                      <span className="svg-icon svg-icon-2">
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width={24}
                                          height={24}
                                          viewBox="0 0 24 24"
                                          fill="none"
                                        >
                                          <rect
                                            opacity="0.5"
                                            x={18}
                                            y={13}
                                            width={13}
                                            height={2}
                                            rx={1}
                                            transform="rotate(-180 18 13)"
                                            fill="currentColor"
                                          />
                                          <path
                                            d="M15.4343 12.5657L11.25 16.75C10.8358 17.1642 10.8358 17.8358 11.25 18.25C11.6642 18.6642 12.3358 18.6642 12.75 18.25L18.2929 12.7071C18.6834 12.3166 18.6834 11.6834 18.2929 11.2929L12.75 5.75C12.3358 5.33579 11.6642 5.33579 11.25 5.75C10.8358 6.16421 10.8358 6.83579 11.25 7.25L15.4343 11.4343C15.7467 11.7467 15.7467 12.2533 15.4343 12.5657Z"
                                            fill="currentColor"
                                          />
                                        </svg>
                                      </span>
                                      {/*end::Svg Icon*/}
                                    </a>
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <div className="symbol symbol-45px me-2">
                                      <span className="symbol-label">
                                        <img
                                          src="/metronic8/demo1/assets/media/svg/brand-logos/kickstarter.svg"
                                          className="h-50 align-self-center"
                                          alt=""
                                        />
                                      </span>
                                    </div>
                                  </td>
                                  <td>
                                    <a
                                      href="#"
                                      className="text-dark fw-bolder text-hover-primary mb-1 fs-6"
                                    >
                                      Bestseller Theme
                                    </a>
                                    <span className="text-muted fw-bold d-block">
                                      Best Customers
                                    </span>
                                  </td>
                                  <td className="text-end text-muted fw-bold">
                                    ReactJS, Ruby
                                  </td>
                                  <td className="text-end">
                                    <span className="badge badge-light-warning">
                                      In Progress
                                    </span>
                                  </td>
                                  <td className="text-end">
                                    <a
                                      href="#"
                                      className="btn btn-sm btn-icon btn-bg-light btn-active-color-primary"
                                    >
                                      {/*begin::Svg Icon | path: icons/duotune/arrows/arr064.svg*/}
                                      <span className="svg-icon svg-icon-2">
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width={24}
                                          height={24}
                                          viewBox="0 0 24 24"
                                          fill="none"
                                        >
                                          <rect
                                            opacity="0.5"
                                            x={18}
                                            y={13}
                                            width={13}
                                            height={2}
                                            rx={1}
                                            transform="rotate(-180 18 13)"
                                            fill="currentColor"
                                          />
                                          <path
                                            d="M15.4343 12.5657L11.25 16.75C10.8358 17.1642 10.8358 17.8358 11.25 18.25C11.6642 18.6642 12.3358 18.6642 12.75 18.25L18.2929 12.7071C18.6834 12.3166 18.6834 11.6834 18.2929 11.2929L12.75 5.75C12.3358 5.33579 11.6642 5.33579 11.25 5.75C10.8358 6.16421 10.8358 6.83579 11.25 7.25L15.4343 11.4343C15.7467 11.7467 15.7467 12.2533 15.4343 12.5657Z"
                                            fill="currentColor"
                                          />
                                        </svg>
                                      </span>
                                      {/*end::Svg Icon*/}
                                    </a>
                                  </td>
                                </tr>
                              </tbody>
                              {/*end::Table body*/}
                            </table>
                          </div>
                          {/*end::Table*/}
                        </div>
                        {/*end::Tap pane*/}
                        {/*begin::Tap pane*/}
                        <div
                          className="tab-pane fade"
                          id="kt_table_widget_5_tab_2"
                        >
                          {/*begin::Table container*/}
                          <div className="table-responsive">
                            {/*begin::Table*/}
                            <table className="table table-row-dashed table-row-gray-200 align-middle gs-0 gy-4">
                              {/*begin::Table head*/}
                              <thead>
                                <tr className="border-0">
                                  <th className="p-0 w-50px" />
                                  <th className="p-0 min-w-150px" />
                                  <th className="p-0 min-w-140px" />
                                  <th className="p-0 min-w-110px" />
                                  <th className="p-0 min-w-50px" />
                                </tr>
                              </thead>
                              {/*end::Table head*/}
                              {/*begin::Table body*/}
                              <tbody>
                                <tr>
                                  <td>
                                    <div className="symbol symbol-45px me-2">
                                      <span className="symbol-label">
                                        <img
                                          src="/metronic8/demo1/assets/media/svg/brand-logos/plurk.svg"
                                          className="h-50 align-self-center"
                                          alt=""
                                        />
                                      </span>
                                    </div>
                                  </td>
                                  <td>
                                    <a
                                      href="#"
                                      className="text-dark fw-bolder text-hover-primary mb-1 fs-6"
                                    >
                                      Brad Simmons
                                    </a>
                                    <span className="text-muted fw-bold d-block">
                                      Movie Creator
                                    </span>
                                  </td>
                                  <td className="text-end text-muted fw-bold">
                                    React, HTML
                                  </td>
                                  <td className="text-end">
                                    <span className="badge badge-light-success">
                                      Approved
                                    </span>
                                  </td>
                                  <td className="text-end">
                                    <a
                                      href="#"
                                      className="btn btn-sm btn-icon btn-bg-light btn-active-color-primary"
                                    >
                                      {/*begin::Svg Icon | path: icons/duotune/arrows/arr064.svg*/}
                                      <span className="svg-icon svg-icon-2">
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width={24}
                                          height={24}
                                          viewBox="0 0 24 24"
                                          fill="none"
                                        >
                                          <rect
                                            opacity="0.5"
                                            x={18}
                                            y={13}
                                            width={13}
                                            height={2}
                                            rx={1}
                                            transform="rotate(-180 18 13)"
                                            fill="currentColor"
                                          />
                                          <path
                                            d="M15.4343 12.5657L11.25 16.75C10.8358 17.1642 10.8358 17.8358 11.25 18.25C11.6642 18.6642 12.3358 18.6642 12.75 18.25L18.2929 12.7071C18.6834 12.3166 18.6834 11.6834 18.2929 11.2929L12.75 5.75C12.3358 5.33579 11.6642 5.33579 11.25 5.75C10.8358 6.16421 10.8358 6.83579 11.25 7.25L15.4343 11.4343C15.7467 11.7467 15.7467 12.2533 15.4343 12.5657Z"
                                            fill="currentColor"
                                          />
                                        </svg>
                                      </span>
                                      {/*end::Svg Icon*/}
                                    </a>
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <div className="symbol symbol-45px me-2">
                                      <span className="symbol-label">
                                        <img
                                          src="/metronic8/demo1/assets/media/svg/brand-logos/telegram.svg"
                                          className="h-50 align-self-center"
                                          alt=""
                                        />
                                      </span>
                                    </div>
                                  </td>
                                  <td>
                                    <a
                                      href="#"
                                      className="text-dark fw-bolder text-hover-primary mb-1 fs-6"
                                    >
                                      Popular Authors
                                    </a>
                                    <span className="text-muted fw-bold d-block">
                                      Most Successful
                                    </span>
                                  </td>
                                  <td className="text-end text-muted fw-bold">
                                    Python, MySQL
                                  </td>
                                  <td className="text-end">
                                    <span className="badge badge-light-warning">
                                      In Progress
                                    </span>
                                  </td>
                                  <td className="text-end">
                                    <a
                                      href="#"
                                      className="btn btn-sm btn-icon btn-bg-light btn-active-color-primary"
                                    >
                                      {/*begin::Svg Icon | path: icons/duotune/arrows/arr064.svg*/}
                                      <span className="svg-icon svg-icon-2">
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width={24}
                                          height={24}
                                          viewBox="0 0 24 24"
                                          fill="none"
                                        >
                                          <rect
                                            opacity="0.5"
                                            x={18}
                                            y={13}
                                            width={13}
                                            height={2}
                                            rx={1}
                                            transform="rotate(-180 18 13)"
                                            fill="currentColor"
                                          />
                                          <path
                                            d="M15.4343 12.5657L11.25 16.75C10.8358 17.1642 10.8358 17.8358 11.25 18.25C11.6642 18.6642 12.3358 18.6642 12.75 18.25L18.2929 12.7071C18.6834 12.3166 18.6834 11.6834 18.2929 11.2929L12.75 5.75C12.3358 5.33579 11.6642 5.33579 11.25 5.75C10.8358 6.16421 10.8358 6.83579 11.25 7.25L15.4343 11.4343C15.7467 11.7467 15.7467 12.2533 15.4343 12.5657Z"
                                            fill="currentColor"
                                          />
                                        </svg>
                                      </span>
                                      {/*end::Svg Icon*/}
                                    </a>
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <div className="symbol symbol-45px me-2">
                                      <span className="symbol-label">
                                        <img
                                          src="/metronic8/demo1/assets/media/svg/brand-logos/bebo.svg"
                                          className="h-50 align-self-center"
                                          alt=""
                                        />
                                      </span>
                                    </div>
                                  </td>
                                  <td>
                                    <a
                                      href="#"
                                      className="text-dark fw-bolder text-hover-primary mb-1 fs-6"
                                    >
                                      Active Customers
                                    </a>
                                    <span className="text-muted fw-bold d-block">
                                      Movie Creator
                                    </span>
                                  </td>
                                  <td className="text-end text-muted fw-bold">
                                    AngularJS, C#
                                  </td>
                                  <td className="text-end">
                                    <span className="badge badge-light-danger">
                                      Rejected
                                    </span>
                                  </td>
                                  <td className="text-end">
                                    <a
                                      href="#"
                                      className="btn btn-sm btn-icon btn-bg-light btn-active-color-primary"
                                    >
                                      {/*begin::Svg Icon | path: icons/duotune/arrows/arr064.svg*/}
                                      <span className="svg-icon svg-icon-2">
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width={24}
                                          height={24}
                                          viewBox="0 0 24 24"
                                          fill="none"
                                        >
                                          <rect
                                            opacity="0.5"
                                            x={18}
                                            y={13}
                                            width={13}
                                            height={2}
                                            rx={1}
                                            transform="rotate(-180 18 13)"
                                            fill="currentColor"
                                          />
                                          <path
                                            d="M15.4343 12.5657L11.25 16.75C10.8358 17.1642 10.8358 17.8358 11.25 18.25C11.6642 18.6642 12.3358 18.6642 12.75 18.25L18.2929 12.7071C18.6834 12.3166 18.6834 11.6834 18.2929 11.2929L12.75 5.75C12.3358 5.33579 11.6642 5.33579 11.25 5.75C10.8358 6.16421 10.8358 6.83579 11.25 7.25L15.4343 11.4343C15.7467 11.7467 15.7467 12.2533 15.4343 12.5657Z"
                                            fill="currentColor"
                                          />
                                        </svg>
                                      </span>
                                      {/*end::Svg Icon*/}
                                    </a>
                                  </td>
                                </tr>
                              </tbody>
                              {/*end::Table body*/}
                            </table>
                          </div>
                          {/*end::Table*/}
                        </div>
                        {/*end::Tap pane*/}
                        {/*begin::Tap pane*/}
                        <div
                          className="tab-pane fade"
                          id="kt_table_widget_5_tab_3"
                        >
                          {/*begin::Table container*/}
                          <div className="table-responsive">
                            {/*begin::Table*/}
                            <table className="table table-row-dashed table-row-gray-200 align-middle gs-0 gy-4">
                              {/*begin::Table head*/}
                              <thead>
                                <tr className="border-0">
                                  <th className="p-0 w-50px" />
                                  <th className="p-0 min-w-150px" />
                                  <th className="p-0 min-w-140px" />
                                  <th className="p-0 min-w-110px" />
                                  <th className="p-0 min-w-50px" />
                                </tr>
                              </thead>
                              {/*end::Table head*/}
                              {/*begin::Table body*/}
                              <tbody>
                                <tr>
                                  <td>
                                    <div className="symbol symbol-45px me-2">
                                      <span className="symbol-label">
                                        <img
                                          src="/metronic8/demo1/assets/media/svg/brand-logos/kickstarter.svg"
                                          className="h-50 align-self-center"
                                          alt=""
                                        />
                                      </span>
                                    </div>
                                  </td>
                                  <td>
                                    <a
                                      href="#"
                                      className="text-dark fw-bolder text-hover-primary mb-1 fs-6"
                                    >
                                      Bestseller Theme
                                    </a>
                                    <span className="text-muted fw-bold d-block">
                                      Best Customers
                                    </span>
                                  </td>
                                  <td className="text-end text-muted fw-bold">
                                    ReactJS, Ruby
                                  </td>
                                  <td className="text-end">
                                    <span className="badge badge-light-warning">
                                      In Progress
                                    </span>
                                  </td>
                                  <td className="text-end">
                                    <a
                                      href="#"
                                      className="btn btn-sm btn-icon btn-bg-light btn-active-color-primary"
                                    >
                                      {/*begin::Svg Icon | path: icons/duotune/arrows/arr064.svg*/}
                                      <span className="svg-icon svg-icon-2">
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width={24}
                                          height={24}
                                          viewBox="0 0 24 24"
                                          fill="none"
                                        >
                                          <rect
                                            opacity="0.5"
                                            x={18}
                                            y={13}
                                            width={13}
                                            height={2}
                                            rx={1}
                                            transform="rotate(-180 18 13)"
                                            fill="currentColor"
                                          />
                                          <path
                                            d="M15.4343 12.5657L11.25 16.75C10.8358 17.1642 10.8358 17.8358 11.25 18.25C11.6642 18.6642 12.3358 18.6642 12.75 18.25L18.2929 12.7071C18.6834 12.3166 18.6834 11.6834 18.2929 11.2929L12.75 5.75C12.3358 5.33579 11.6642 5.33579 11.25 5.75C10.8358 6.16421 10.8358 6.83579 11.25 7.25L15.4343 11.4343C15.7467 11.7467 15.7467 12.2533 15.4343 12.5657Z"
                                            fill="currentColor"
                                          />
                                        </svg>
                                      </span>
                                      {/*end::Svg Icon*/}
                                    </a>
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <div className="symbol symbol-45px me-2">
                                      <span className="symbol-label">
                                        <img
                                          src="/metronic8/demo1/assets/media/svg/brand-logos/bebo.svg"
                                          className="h-50 align-self-center"
                                          alt=""
                                        />
                                      </span>
                                    </div>
                                  </td>
                                  <td>
                                    <a
                                      href="#"
                                      className="text-dark fw-bolder text-hover-primary mb-1 fs-6"
                                    >
                                      Active Customers
                                    </a>
                                    <span className="text-muted fw-bold d-block">
                                      Movie Creator
                                    </span>
                                  </td>
                                  <td className="text-end text-muted fw-bold">
                                    AngularJS, C#
                                  </td>
                                  <td className="text-end">
                                    <span className="badge badge-light-danger">
                                      Rejected
                                    </span>
                                  </td>
                                  <td className="text-end">
                                    <a
                                      href="#"
                                      className="btn btn-sm btn-icon btn-bg-light btn-active-color-primary"
                                    >
                                      {/*begin::Svg Icon | path: icons/duotune/arrows/arr064.svg*/}
                                      <span className="svg-icon svg-icon-2">
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width={24}
                                          height={24}
                                          viewBox="0 0 24 24"
                                          fill="none"
                                        >
                                          <rect
                                            opacity="0.5"
                                            x={18}
                                            y={13}
                                            width={13}
                                            height={2}
                                            rx={1}
                                            transform="rotate(-180 18 13)"
                                            fill="currentColor"
                                          />
                                          <path
                                            d="M15.4343 12.5657L11.25 16.75C10.8358 17.1642 10.8358 17.8358 11.25 18.25C11.6642 18.6642 12.3358 18.6642 12.75 18.25L18.2929 12.7071C18.6834 12.3166 18.6834 11.6834 18.2929 11.2929L12.75 5.75C12.3358 5.33579 11.6642 5.33579 11.25 5.75C10.8358 6.16421 10.8358 6.83579 11.25 7.25L15.4343 11.4343C15.7467 11.7467 15.7467 12.2533 15.4343 12.5657Z"
                                            fill="currentColor"
                                          />
                                        </svg>
                                      </span>
                                      {/*end::Svg Icon*/}
                                    </a>
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <div className="symbol symbol-45px me-2">
                                      <span className="symbol-label">
                                        <img
                                          src="/metronic8/demo1/assets/media/svg/brand-logos/vimeo.svg"
                                          className="h-50 align-self-center"
                                          alt=""
                                        />
                                      </span>
                                    </div>
                                  </td>
                                  <td>
                                    <a
                                      href="#"
                                      className="text-dark fw-bolder text-hover-primary mb-1 fs-6"
                                    >
                                      New Users
                                    </a>
                                    <span className="text-muted fw-bold d-block">
                                      Awesome Users
                                    </span>
                                  </td>
                                  <td className="text-end text-muted fw-bold">
                                    Laravel,Metronic
                                  </td>
                                  <td className="text-end">
                                    <span className="badge badge-light-primary">
                                      Success
                                    </span>
                                  </td>
                                  <td className="text-end">
                                    <a
                                      href="#"
                                      className="btn btn-sm btn-icon btn-bg-light btn-active-color-primary"
                                    >
                                      {/*begin::Svg Icon | path: icons/duotune/arrows/arr064.svg*/}
                                      <span className="svg-icon svg-icon-2">
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width={24}
                                          height={24}
                                          viewBox="0 0 24 24"
                                          fill="none"
                                        >
                                          <rect
                                            opacity="0.5"
                                            x={18}
                                            y={13}
                                            width={13}
                                            height={2}
                                            rx={1}
                                            transform="rotate(-180 18 13)"
                                            fill="currentColor"
                                          />
                                          <path
                                            d="M15.4343 12.5657L11.25 16.75C10.8358 17.1642 10.8358 17.8358 11.25 18.25C11.6642 18.6642 12.3358 18.6642 12.75 18.25L18.2929 12.7071C18.6834 12.3166 18.6834 11.6834 18.2929 11.2929L12.75 5.75C12.3358 5.33579 11.6642 5.33579 11.25 5.75C10.8358 6.16421 10.8358 6.83579 11.25 7.25L15.4343 11.4343C15.7467 11.7467 15.7467 12.2533 15.4343 12.5657Z"
                                            fill="currentColor"
                                          />
                                        </svg>
                                      </span>
                                      {/*end::Svg Icon*/}
                                    </a>
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <div className="symbol symbol-45px me-2">
                                      <span className="symbol-label">
                                        <img
                                          src="/metronic8/demo1/assets/media/svg/brand-logos/telegram.svg"
                                          className="h-50 align-self-center"
                                          alt=""
                                        />
                                      </span>
                                    </div>
                                  </td>
                                  <td>
                                    <a
                                      href="#"
                                      className="text-dark fw-bolder text-hover-primary mb-1 fs-6"
                                    >
                                      Popular Authors
                                    </a>
                                    <span className="text-muted fw-bold d-block">
                                      Most Successful
                                    </span>
                                  </td>
                                  <td className="text-end text-muted fw-bold">
                                    Python, MySQL
                                  </td>
                                  <td className="text-end">
                                    <span className="badge badge-light-warning">
                                      In Progress
                                    </span>
                                  </td>
                                  <td className="text-end">
                                    <a
                                      href="#"
                                      className="btn btn-sm btn-icon btn-bg-light btn-active-color-primary"
                                    >
                                      {/*begin::Svg Icon | path: icons/duotune/arrows/arr064.svg*/}
                                      <span className="svg-icon svg-icon-2">
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width={24}
                                          height={24}
                                          viewBox="0 0 24 24"
                                          fill="none"
                                        >
                                          <rect
                                            opacity="0.5"
                                            x={18}
                                            y={13}
                                            width={13}
                                            height={2}
                                            rx={1}
                                            transform="rotate(-180 18 13)"
                                            fill="currentColor"
                                          />
                                          <path
                                            d="M15.4343 12.5657L11.25 16.75C10.8358 17.1642 10.8358 17.8358 11.25 18.25C11.6642 18.6642 12.3358 18.6642 12.75 18.25L18.2929 12.7071C18.6834 12.3166 18.6834 11.6834 18.2929 11.2929L12.75 5.75C12.3358 5.33579 11.6642 5.33579 11.25 5.75C10.8358 6.16421 10.8358 6.83579 11.25 7.25L15.4343 11.4343C15.7467 11.7467 15.7467 12.2533 15.4343 12.5657Z"
                                            fill="currentColor"
                                          />
                                        </svg>
                                      </span>
                                      {/*end::Svg Icon*/}
                                    </a>
                                  </td>
                                </tr>
                              </tbody>
                              {/*end::Table body*/}
                            </table>
                          </div>
                          {/*end::Table*/}
                        </div>
                        {/*end::Tap pane*/}
                      </div>
                    </div>
                    {/*end::Body*/}
                  </div>
                  {/*end::Tables Widget 5*/}
                </div>
                {/*end::Col*/}
              </div>
              {/*end::Row*/}
              {/*begin::Calendar Widget 1*/}
              <div className="card">
                {/*begin::Card header*/}
                <div className="card-header">
                  <h3 className="card-title align-items-start flex-column">
                    <span className="card-label fw-bolder text-dark">
                      My Calendar
                    </span>
                    <span className="text-muted mt-1 fw-bold fs-7">
                      Preview monthly events
                    </span>
                  </h3>
                  <div className="card-toolbar">
                    <a
                      href="/metronic8/demo1/../demo1/apps/calendar.html"
                      className="btn btn-primary"
                    >
                      Manage Calendar
                    </a>
                  </div>
                </div>
                {/*end::Card header*/}
                {/*begin::Card body*/}
                <div className="card-body">
                  {/*begin::Calendar*/}
                  <div
                    id="kt_calendar_widget_1"
                    className="fc fc-media-screen fc-direction-ltr fc-theme-standard"
                    style={{ height: "800px" }}
                  >
                    <div className="fc-header-toolbar fc-toolbar fc-toolbar-ltr">
                      <div className="fc-toolbar-chunk">
                        <div className="fc-button-group">
                          <button
                            type="button"
                            title="Previous month"
                            aria-pressed="false"
                            className="fc-prev-button fc-button fc-button-primary"
                          >
                            <span className="fc-icon fc-icon-chevron-left" />
                          </button>
                          <button
                            type="button"
                            title="Next month"
                            aria-pressed="false"
                            className="fc-next-button fc-button fc-button-primary"
                          >
                            <span className="fc-icon fc-icon-chevron-right" />
                          </button>
                        </div>
                        <button
                          type="button"
                          title="This month"
                          disabled
                          aria-pressed="false"
                          className="fc-today-button fc-button fc-button-primary"
                        >
                          today
                        </button>
                      </div>
                      <div className="fc-toolbar-chunk">
                        <h2 className="fc-toolbar-title" id="fc-dom-1">
                          April 2022
                        </h2>
                      </div>
                      <div className="fc-toolbar-chunk">
                        <div className="fc-button-group">
                          <button
                            type="button"
                            title="month view"
                            aria-pressed="true"
                            className="fc-dayGridMonth-button fc-button fc-button-primary fc-button-active"
                          >
                            month
                          </button>
                          <button
                            type="button"
                            title="week view"
                            aria-pressed="false"
                            className="fc-timeGridWeek-button fc-button fc-button-primary"
                          >
                            week
                          </button>
                          <button
                            type="button"
                            title="day view"
                            aria-pressed="false"
                            className="fc-timeGridDay-button fc-button fc-button-primary"
                          >
                            day
                          </button>
                          <button
                            type="button"
                            title="list view"
                            aria-pressed="false"
                            className="fc-listMonth-button fc-button fc-button-primary"
                          >
                            list
                          </button>
                        </div>
                      </div>
                    </div>
                    <div
                      aria-labelledby="fc-dom-1"
                      className="fc-view-harness fc-view-harness-active"
                    >
                      <div className="fc-daygrid fc-dayGridMonth-view fc-view">
                        <table
                          role="grid"
                          className="fc-scrollgrid  fc-scrollgrid-liquid"
                        >
                          <thead role="rowgroup">
                            <tr
                              role="presentation"
                              className="fc-scrollgrid-section fc-scrollgrid-section-header "
                            >
                              <th role="presentation">
                                <div className="fc-scroller-harness">
                                  <div
                                    className="fc-scroller"
                                    style={{ overflow: "hidden" }}
                                  >
                                    <table
                                      role="presentation"
                                      className="fc-col-header "
                                      style={{ width: "1199px" }}
                                    >
                                      <colgroup />
                                      <thead role="presentation">
                                        <tr role="row">
                                          <th
                                            role="columnheader"
                                            className="fc-col-header-cell fc-day fc-day-sun"
                                          >
                                            <div className="fc-scrollgrid-sync-inner">
                                              <a
                                                aria-label="Sunday"
                                                className="fc-col-header-cell-cushion "
                                              >
                                                Sun
                                              </a>
                                            </div>
                                          </th>
                                          <th
                                            role="columnheader"
                                            className="fc-col-header-cell fc-day fc-day-mon"
                                          >
                                            <div className="fc-scrollgrid-sync-inner">
                                              <a
                                                aria-label="Monday"
                                                className="fc-col-header-cell-cushion "
                                              >
                                                Mon
                                              </a>
                                            </div>
                                          </th>
                                          <th
                                            role="columnheader"
                                            className="fc-col-header-cell fc-day fc-day-tue"
                                          >
                                            <div className="fc-scrollgrid-sync-inner">
                                              <a
                                                aria-label="Tuesday"
                                                className="fc-col-header-cell-cushion "
                                              >
                                                Tue
                                              </a>
                                            </div>
                                          </th>
                                          <th
                                            role="columnheader"
                                            className="fc-col-header-cell fc-day fc-day-wed"
                                          >
                                            <div className="fc-scrollgrid-sync-inner">
                                              <a
                                                aria-label="Wednesday"
                                                className="fc-col-header-cell-cushion "
                                              >
                                                Wed
                                              </a>
                                            </div>
                                          </th>
                                          <th
                                            role="columnheader"
                                            className="fc-col-header-cell fc-day fc-day-thu"
                                          >
                                            <div className="fc-scrollgrid-sync-inner">
                                              <a
                                                aria-label="Thursday"
                                                className="fc-col-header-cell-cushion "
                                              >
                                                Thu
                                              </a>
                                            </div>
                                          </th>
                                          <th
                                            role="columnheader"
                                            className="fc-col-header-cell fc-day fc-day-fri"
                                          >
                                            <div className="fc-scrollgrid-sync-inner">
                                              <a
                                                aria-label="Friday"
                                                className="fc-col-header-cell-cushion "
                                              >
                                                Fri
                                              </a>
                                            </div>
                                          </th>
                                          <th
                                            role="columnheader"
                                            className="fc-col-header-cell fc-day fc-day-sat"
                                          >
                                            <div className="fc-scrollgrid-sync-inner">
                                              <a
                                                aria-label="Saturday"
                                                className="fc-col-header-cell-cushion "
                                              >
                                                Sat
                                              </a>
                                            </div>
                                          </th>
                                        </tr>
                                      </thead>
                                    </table>
                                  </div>
                                </div>
                              </th>
                            </tr>
                          </thead>
                          <tbody role="rowgroup">
                            <tr
                              role="presentation"
                              className="fc-scrollgrid-section fc-scrollgrid-section-body  fc-scrollgrid-section-liquid"
                            >
                              <td role="presentation">
                                <div className="fc-scroller-harness fc-scroller-harness-liquid">
                                  <div
                                    className="fc-scroller fc-scroller-liquid-absolute"
                                    style={{ overflow: "hidden auto" }}
                                  >
                                    <div
                                      className="fc-daygrid-body fc-daygrid-body-balanced "
                                      style={{ width: "1199px" }}
                                    >
                                      <table
                                        role="presentation"
                                        className="fc-scrollgrid-sync-table"
                                        style={{
                                          width: "1199px",
                                          height: "692px",
                                        }}
                                      >
                                        <colgroup />
                                        <tbody role="presentation">
                                          <tr role="row">
                                            <td
                                              role="gridcell"
                                              className="fc-daygrid-day fc-day fc-day-sun fc-day-past fc-day-other"
                                              data-date="2022-03-27"
                                              aria-labelledby="fc-dom-2"
                                            >
                                              <div className="fc-daygrid-day-frame fc-scrollgrid-sync-inner">
                                                <div className="fc-daygrid-day-top">
                                                  <a
                                                    id="fc-dom-2"
                                                    className="fc-daygrid-day-number"
                                                    title="Go to March 27, 2022"
                                                    data-navlink
                                                    tabIndex={0}
                                                  >
                                                    27
                                                  </a>
                                                </div>
                                                <div className="fc-daygrid-day-events">
                                                  <div
                                                    className="fc-daygrid-day-bottom"
                                                    style={{ marginTop: "0px" }}
                                                  />
                                                </div>
                                                <div className="fc-daygrid-day-bg" />
                                              </div>
                                            </td>
                                            <td
                                              role="gridcell"
                                              className="fc-daygrid-day fc-day fc-day-mon fc-day-past fc-day-other"
                                              data-date="2022-03-28"
                                              aria-labelledby="fc-dom-4"
                                            >
                                              <div className="fc-daygrid-day-frame fc-scrollgrid-sync-inner">
                                                <div className="fc-daygrid-day-top">
                                                  <a
                                                    id="fc-dom-4"
                                                    className="fc-daygrid-day-number"
                                                    title="Go to March 28, 2022"
                                                    data-navlink
                                                    tabIndex={0}
                                                  >
                                                    28
                                                  </a>
                                                </div>
                                                <div className="fc-daygrid-day-events">
                                                  <div
                                                    className="fc-daygrid-day-bottom"
                                                    style={{ marginTop: "0px" }}
                                                  />
                                                </div>
                                                <div className="fc-daygrid-day-bg" />
                                              </div>
                                            </td>
                                            <td
                                              role="gridcell"
                                              className="fc-daygrid-day fc-day fc-day-tue fc-day-past fc-day-other"
                                              data-date="2022-03-29"
                                              aria-labelledby="fc-dom-6"
                                            >
                                              <div className="fc-daygrid-day-frame fc-scrollgrid-sync-inner">
                                                <div className="fc-daygrid-day-top">
                                                  <a
                                                    id="fc-dom-6"
                                                    className="fc-daygrid-day-number"
                                                    title="Go to March 29, 2022"
                                                    data-navlink
                                                    tabIndex={0}
                                                  >
                                                    29
                                                  </a>
                                                </div>
                                                <div className="fc-daygrid-day-events">
                                                  <div
                                                    className="fc-daygrid-day-bottom"
                                                    style={{ marginTop: "0px" }}
                                                  />
                                                </div>
                                                <div className="fc-daygrid-day-bg" />
                                              </div>
                                            </td>
                                            <td
                                              role="gridcell"
                                              className="fc-daygrid-day fc-day fc-day-wed fc-day-past fc-day-other"
                                              data-date="2022-03-30"
                                              aria-labelledby="fc-dom-8"
                                            >
                                              <div className="fc-daygrid-day-frame fc-scrollgrid-sync-inner">
                                                <div className="fc-daygrid-day-top">
                                                  <a
                                                    id="fc-dom-8"
                                                    className="fc-daygrid-day-number"
                                                    title="Go to March 30, 2022"
                                                    data-navlink
                                                    tabIndex={0}
                                                  >
                                                    30
                                                  </a>
                                                </div>
                                                <div className="fc-daygrid-day-events">
                                                  <div
                                                    className="fc-daygrid-day-bottom"
                                                    style={{ marginTop: "0px" }}
                                                  />
                                                </div>
                                                <div className="fc-daygrid-day-bg" />
                                              </div>
                                            </td>
                                            <td
                                              role="gridcell"
                                              className="fc-daygrid-day fc-day fc-day-thu fc-day-past fc-day-other"
                                              data-date="2022-03-31"
                                              aria-labelledby="fc-dom-10"
                                            >
                                              <div className="fc-daygrid-day-frame fc-scrollgrid-sync-inner">
                                                <div className="fc-daygrid-day-top">
                                                  <a
                                                    id="fc-dom-10"
                                                    className="fc-daygrid-day-number"
                                                    title="Go to March 31, 2022"
                                                    data-navlink
                                                    tabIndex={0}
                                                  >
                                                    31
                                                  </a>
                                                </div>
                                                <div className="fc-daygrid-day-events">
                                                  <div
                                                    className="fc-daygrid-event-harness fc-daygrid-event-harness-abs"
                                                    style={{
                                                      top: "0px",
                                                      left: "0px",
                                                      right: "-171.281px",
                                                    }}
                                                  >
                                                    <a className="fc-daygrid-event fc-daygrid-block-event fc-h-event fc-event fc-event-draggable fc-event-resizable fc-event-start fc-event-end fc-event-primary">
                                                      <div className="fc-event-main">
                                                        <div className="fc-event-main-frame">
                                                          <div className="fc-event-title-container">
                                                            <div className="fc-event-title fc-sticky">
                                                              Conference
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                      <div className="fc-event-resizer fc-event-resizer-end" />
                                                    </a>
                                                  </div>
                                                  <div
                                                    className="fc-daygrid-day-bottom"
                                                    style={{
                                                      marginTop: "30px",
                                                    }}
                                                  />
                                                </div>
                                                <div className="fc-daygrid-day-bg" />
                                              </div>
                                            </td>
                                            <td
                                              role="gridcell"
                                              className="fc-daygrid-day fc-day fc-day-fri fc-day-today "
                                              data-date="2022-04-01"
                                              aria-labelledby="fc-dom-12"
                                            >
                                              <div className="fc-daygrid-day-frame fc-scrollgrid-sync-inner">
                                                <div className="fc-daygrid-day-top">
                                                  <a
                                                    id="fc-dom-12"
                                                    className="fc-daygrid-day-number"
                                                    title="Go to April 1, 2022"
                                                    data-navlink
                                                    tabIndex={0}
                                                  >
                                                    1
                                                  </a>
                                                </div>
                                                <div className="fc-daygrid-day-events">
                                                  <div
                                                    className="fc-daygrid-event-harness fc-daygrid-event-harness-abs"
                                                    style={{
                                                      visibility: "hidden",
                                                      top: "0px",
                                                      left: "0px",
                                                      right: "0px",
                                                    }}
                                                  >
                                                    <a className="fc-daygrid-event fc-daygrid-block-event fc-h-event fc-event fc-event-draggable fc-event-resizable fc-event-start fc-event-end fc-event-today fc-event-danger fc-event-solid-warning">
                                                      <div className="fc-event-main">
                                                        <div className="fc-event-main-frame">
                                                          <div className="fc-event-title-container">
                                                            <div className="fc-event-title fc-sticky">
                                                              All Day Event
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                      <div className="fc-event-resizer fc-event-resizer-end" />
                                                    </a>
                                                  </div>
                                                  <div
                                                    className="fc-daygrid-event-harness fc-daygrid-event-harness-abs"
                                                    style={{
                                                      visibility: "hidden",
                                                      top: "0px",
                                                      left: "0px",
                                                      right: "0px",
                                                    }}
                                                  >
                                                    <a className="fc-daygrid-event fc-daygrid-dot-event fc-event fc-event-draggable fc-event-resizable fc-event-start fc-event-end fc-event-today">
                                                      <div className="fc-daygrid-event-dot" />
                                                      <div className="fc-event-time">
                                                        10:30a
                                                      </div>
                                                      <div className="fc-event-title">
                                                        Meeting
                                                      </div>
                                                    </a>
                                                  </div>
                                                  <div
                                                    className="fc-daygrid-event-harness fc-daygrid-event-harness-abs"
                                                    style={{
                                                      visibility: "hidden",
                                                      top: "0px",
                                                      left: "0px",
                                                      right: "0px",
                                                    }}
                                                  >
                                                    <a className="fc-daygrid-event fc-daygrid-dot-event fc-event fc-event-draggable fc-event-resizable fc-event-start fc-event-end fc-event-today fc-event-info">
                                                      <div className="fc-daygrid-event-dot" />
                                                      <div className="fc-event-time">
                                                        12p
                                                      </div>
                                                      <div className="fc-event-title">
                                                        Lunch
                                                      </div>
                                                    </a>
                                                  </div>
                                                  <div
                                                    className="fc-daygrid-event-harness fc-daygrid-event-harness-abs"
                                                    style={{
                                                      visibility: "hidden",
                                                      top: "0px",
                                                      left: "0px",
                                                      right: "0px",
                                                    }}
                                                  >
                                                    <a className="fc-daygrid-event fc-daygrid-dot-event fc-event fc-event-draggable fc-event-resizable fc-event-start fc-event-end fc-event-today fc-event-warning">
                                                      <div className="fc-daygrid-event-dot" />
                                                      <div className="fc-event-time">
                                                        2:30p
                                                      </div>
                                                      <div className="fc-event-title">
                                                        Meeting
                                                      </div>
                                                    </a>
                                                  </div>
                                                  <div
                                                    className="fc-daygrid-event-harness fc-daygrid-event-harness-abs"
                                                    style={{
                                                      visibility: "hidden",
                                                      top: "0px",
                                                      left: "0px",
                                                      right: "0px",
                                                    }}
                                                  >
                                                    <a className="fc-daygrid-event fc-daygrid-dot-event fc-event fc-event-draggable fc-event-resizable fc-event-start fc-event-end fc-event-today fc-event-info">
                                                      <div className="fc-daygrid-event-dot" />
                                                      <div className="fc-event-time">
                                                        5:30p
                                                      </div>
                                                      <div className="fc-event-title">
                                                        Happy Hour
                                                      </div>
                                                    </a>
                                                  </div>
                                                  <div
                                                    className="fc-daygrid-day-bottom"
                                                    style={{
                                                      marginTop: "30px",
                                                    }}
                                                  >
                                                    <a
                                                      className="fc-daygrid-more-link fc-more-link"
                                                      title="Show 5 more events"
                                                      aria-expanded="false"
                                                      aria-controls
                                                      tabIndex={0}
                                                    >
                                                      +5 more
                                                    </a>
                                                  </div>
                                                </div>
                                                <div className="fc-daygrid-day-bg" />
                                              </div>
                                            </td>
                                            <td
                                              role="gridcell"
                                              className="fc-daygrid-day fc-day fc-day-sat fc-day-future"
                                              data-date="2022-04-02"
                                              aria-labelledby="fc-dom-14"
                                            >
                                              <div className="fc-daygrid-day-frame fc-scrollgrid-sync-inner">
                                                <div className="fc-daygrid-day-top">
                                                  <a
                                                    id="fc-dom-14"
                                                    className="fc-daygrid-day-number"
                                                    title="Go to April 2, 2022"
                                                    data-navlink
                                                    tabIndex={0}
                                                  >
                                                    2
                                                  </a>
                                                </div>
                                                <div className="fc-daygrid-day-events">
                                                  <div
                                                    className="fc-daygrid-event-harness"
                                                    style={{ marginTop: "0px" }}
                                                  >
                                                    <a className="fc-daygrid-event fc-daygrid-block-event fc-h-event fc-event fc-event-draggable fc-event-resizable fc-event-start fc-event-end fc-event-future fc-event-primary">
                                                      <div className="fc-event-main">
                                                        <div className="fc-event-main-frame">
                                                          <div className="fc-event-title-container">
                                                            <div className="fc-event-title fc-sticky">
                                                              Company Trip
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                      <div className="fc-event-resizer fc-event-resizer-end" />
                                                    </a>
                                                  </div>
                                                  <div
                                                    className="fc-daygrid-event-harness fc-daygrid-event-harness-abs"
                                                    style={{
                                                      visibility: "hidden",
                                                      top: "0px",
                                                      left: "0px",
                                                      right: "0px",
                                                    }}
                                                  >
                                                    <a className="fc-daygrid-event fc-daygrid-dot-event fc-event fc-event-draggable fc-event-resizable fc-event-start fc-event-end fc-event-future fc-event-solid-danger fc-event-light">
                                                      <div className="fc-daygrid-event-dot" />
                                                      <div className="fc-event-time">
                                                        5a
                                                      </div>
                                                      <div className="fc-event-title">
                                                        Dinner
                                                      </div>
                                                    </a>
                                                  </div>
                                                  <div
                                                    className="fc-daygrid-event-harness fc-daygrid-event-harness-abs"
                                                    style={{
                                                      visibility: "hidden",
                                                      top: "0px",
                                                      left: "0px",
                                                      right: "0px",
                                                    }}
                                                  >
                                                    <a className="fc-daygrid-event fc-daygrid-dot-event fc-event fc-event-draggable fc-event-resizable fc-event-start fc-event-end fc-event-future fc-event-primary">
                                                      <div className="fc-daygrid-event-dot" />
                                                      <div className="fc-event-time">
                                                        7a
                                                      </div>
                                                      <div className="fc-event-title">
                                                        Birthday Party
                                                      </div>
                                                    </a>
                                                  </div>
                                                  <div
                                                    className="fc-daygrid-day-bottom"
                                                    style={{ marginTop: "0px" }}
                                                  >
                                                    <a
                                                      className="fc-daygrid-more-link fc-more-link"
                                                      title="Show 2 more events"
                                                      aria-expanded="false"
                                                      aria-controls
                                                      tabIndex={0}
                                                    >
                                                      +2 more
                                                    </a>
                                                  </div>
                                                </div>
                                                <div className="fc-daygrid-day-bg" />
                                              </div>
                                            </td>
                                          </tr>
                                          <tr role="row">
                                            <td
                                              role="gridcell"
                                              className="fc-daygrid-day fc-day fc-day-sun fc-day-future"
                                              data-date="2022-04-03"
                                              aria-labelledby="fc-dom-16"
                                            >
                                              <div className="fc-daygrid-day-frame fc-scrollgrid-sync-inner">
                                                <div className="fc-daygrid-day-top">
                                                  <a
                                                    id="fc-dom-16"
                                                    className="fc-daygrid-day-number"
                                                    title="Go to April 3, 2022"
                                                    data-navlink
                                                    tabIndex={0}
                                                  >
                                                    3
                                                  </a>
                                                </div>
                                                <div className="fc-daygrid-day-events">
                                                  <div
                                                    className="fc-daygrid-event-harness fc-daygrid-event-harness-abs"
                                                    style={{
                                                      top: "0px",
                                                      left: "0px",
                                                      right: "-171.281px",
                                                    }}
                                                  >
                                                    <a className="fc-daygrid-event fc-daygrid-block-event fc-h-event fc-event fc-event-draggable fc-event-resizable fc-event-start fc-event-end fc-event-future fc-event-light fc-event-solid-primary">
                                                      <div className="fc-event-main">
                                                        <div className="fc-event-main-frame">
                                                          <div className="fc-event-title-container">
                                                            <div className="fc-event-title fc-sticky">
                                                              ICT Expo 2017 -
                                                              Product Release
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                      <div className="fc-event-resizer fc-event-resizer-end" />
                                                    </a>
                                                  </div>
                                                  <div
                                                    className="fc-daygrid-day-bottom"
                                                    style={{
                                                      marginTop: "30px",
                                                    }}
                                                  />
                                                </div>
                                                <div className="fc-daygrid-day-bg" />
                                              </div>
                                            </td>
                                            <td
                                              role="gridcell"
                                              className="fc-daygrid-day fc-day fc-day-mon fc-day-future"
                                              data-date="2022-04-04"
                                              aria-labelledby="fc-dom-18"
                                            >
                                              <div className="fc-daygrid-day-frame fc-scrollgrid-sync-inner">
                                                <div className="fc-daygrid-day-top">
                                                  <a
                                                    id="fc-dom-18"
                                                    className="fc-daygrid-day-number"
                                                    title="Go to April 4, 2022"
                                                    data-navlink
                                                    tabIndex={0}
                                                  >
                                                    4
                                                  </a>
                                                </div>
                                                <div className="fc-daygrid-day-events">
                                                  <div
                                                    className="fc-daygrid-day-bottom"
                                                    style={{
                                                      marginTop: "30px",
                                                    }}
                                                  />
                                                </div>
                                                <div className="fc-daygrid-day-bg" />
                                              </div>
                                            </td>
                                            <td
                                              role="gridcell"
                                              className="fc-daygrid-day fc-day fc-day-tue fc-day-future"
                                              data-date="2022-04-05"
                                              aria-labelledby="fc-dom-20"
                                            >
                                              <div className="fc-daygrid-day-frame fc-scrollgrid-sync-inner">
                                                <div className="fc-daygrid-day-top">
                                                  <a
                                                    id="fc-dom-20"
                                                    className="fc-daygrid-day-number"
                                                    title="Go to April 5, 2022"
                                                    data-navlink
                                                    tabIndex={0}
                                                  >
                                                    5
                                                  </a>
                                                </div>
                                                <div className="fc-daygrid-day-events">
                                                  <div
                                                    className="fc-daygrid-day-bottom"
                                                    style={{ marginTop: "0px" }}
                                                  />
                                                </div>
                                                <div className="fc-daygrid-day-bg" />
                                              </div>
                                            </td>
                                            <td
                                              role="gridcell"
                                              className="fc-daygrid-day fc-day fc-day-wed fc-day-future"
                                              data-date="2022-04-06"
                                              aria-labelledby="fc-dom-22"
                                            >
                                              <div className="fc-daygrid-day-frame fc-scrollgrid-sync-inner">
                                                <div className="fc-daygrid-day-top">
                                                  <a
                                                    id="fc-dom-22"
                                                    className="fc-daygrid-day-number"
                                                    title="Go to April 6, 2022"
                                                    data-navlink
                                                    tabIndex={0}
                                                  >
                                                    6
                                                  </a>
                                                </div>
                                                <div className="fc-daygrid-day-events">
                                                  <div
                                                    className="fc-daygrid-day-bottom"
                                                    style={{ marginTop: "0px" }}
                                                  />
                                                </div>
                                                <div className="fc-daygrid-day-bg" />
                                              </div>
                                            </td>
                                            <td
                                              role="gridcell"
                                              className="fc-daygrid-day fc-day fc-day-thu fc-day-future"
                                              data-date="2022-04-07"
                                              aria-labelledby="fc-dom-24"
                                            >
                                              <div className="fc-daygrid-day-frame fc-scrollgrid-sync-inner">
                                                <div className="fc-daygrid-day-top">
                                                  <a
                                                    id="fc-dom-24"
                                                    className="fc-daygrid-day-number"
                                                    title="Go to April 7, 2022"
                                                    data-navlink
                                                    tabIndex={0}
                                                  >
                                                    7
                                                  </a>
                                                </div>
                                                <div className="fc-daygrid-day-events">
                                                  <div
                                                    className="fc-daygrid-day-bottom"
                                                    style={{ marginTop: "0px" }}
                                                  />
                                                </div>
                                                <div className="fc-daygrid-day-bg" />
                                              </div>
                                            </td>
                                            <td
                                              role="gridcell"
                                              className="fc-daygrid-day fc-day fc-day-fri fc-day-future"
                                              data-date="2022-04-08"
                                              aria-labelledby="fc-dom-26"
                                            >
                                              <div className="fc-daygrid-day-frame fc-scrollgrid-sync-inner">
                                                <div className="fc-daygrid-day-top">
                                                  <a
                                                    id="fc-dom-26"
                                                    className="fc-daygrid-day-number"
                                                    title="Go to April 8, 2022"
                                                    data-navlink
                                                    tabIndex={0}
                                                  >
                                                    8
                                                  </a>
                                                </div>
                                                <div className="fc-daygrid-day-events">
                                                  <div
                                                    className="fc-daygrid-day-bottom"
                                                    style={{ marginTop: "0px" }}
                                                  />
                                                </div>
                                                <div className="fc-daygrid-day-bg" />
                                              </div>
                                            </td>
                                            <td
                                              role="gridcell"
                                              className="fc-daygrid-day fc-day fc-day-sat fc-day-future"
                                              data-date="2022-04-09"
                                              aria-labelledby="fc-dom-28"
                                            >
                                              <div className="fc-daygrid-day-frame fc-scrollgrid-sync-inner">
                                                <div className="fc-daygrid-day-top">
                                                  <a
                                                    id="fc-dom-28"
                                                    className="fc-daygrid-day-number"
                                                    title="Go to April 9, 2022"
                                                    data-navlink
                                                    tabIndex={0}
                                                  >
                                                    9
                                                  </a>
                                                </div>
                                                <div className="fc-daygrid-day-events">
                                                  <div
                                                    className="fc-daygrid-event-harness"
                                                    style={{ marginTop: "0px" }}
                                                  >
                                                    <a className="fc-daygrid-event fc-daygrid-dot-event fc-event fc-event-draggable fc-event-resizable fc-event-start fc-event-end fc-event-future fc-event-danger">
                                                      <div className="fc-daygrid-event-dot" />
                                                      <div className="fc-event-time">
                                                        4p
                                                      </div>
                                                      <div className="fc-event-title">
                                                        Repeating Event
                                                      </div>
                                                    </a>
                                                  </div>
                                                  <div
                                                    className="fc-daygrid-day-bottom"
                                                    style={{ marginTop: "0px" }}
                                                  />
                                                </div>
                                                <div className="fc-daygrid-day-bg" />
                                              </div>
                                            </td>
                                          </tr>
                                          <tr role="row">
                                            <td
                                              role="gridcell"
                                              className="fc-daygrid-day fc-day fc-day-sun fc-day-future"
                                              data-date="2022-04-10"
                                              aria-labelledby="fc-dom-30"
                                            >
                                              <div className="fc-daygrid-day-frame fc-scrollgrid-sync-inner">
                                                <div className="fc-daygrid-day-top">
                                                  <a
                                                    id="fc-dom-30"
                                                    className="fc-daygrid-day-number"
                                                    title="Go to April 10, 2022"
                                                    data-navlink
                                                    tabIndex={0}
                                                  >
                                                    10
                                                  </a>
                                                </div>
                                                <div className="fc-daygrid-day-events">
                                                  <div
                                                    className="fc-daygrid-day-bottom"
                                                    style={{ marginTop: "0px" }}
                                                  />
                                                </div>
                                                <div className="fc-daygrid-day-bg" />
                                              </div>
                                            </td>
                                            <td
                                              role="gridcell"
                                              className="fc-daygrid-day fc-day fc-day-mon fc-day-future"
                                              data-date="2022-04-11"
                                              aria-labelledby="fc-dom-32"
                                            >
                                              <div className="fc-daygrid-day-frame fc-scrollgrid-sync-inner">
                                                <div className="fc-daygrid-day-top">
                                                  <a
                                                    id="fc-dom-32"
                                                    className="fc-daygrid-day-number"
                                                    title="Go to April 11, 2022"
                                                    data-navlink
                                                    tabIndex={0}
                                                  >
                                                    11
                                                  </a>
                                                </div>
                                                <div className="fc-daygrid-day-events">
                                                  <div
                                                    className="fc-daygrid-day-bottom"
                                                    style={{ marginTop: "0px" }}
                                                  />
                                                </div>
                                                <div className="fc-daygrid-day-bg" />
                                              </div>
                                            </td>
                                            <td
                                              role="gridcell"
                                              className="fc-daygrid-day fc-day fc-day-tue fc-day-future"
                                              data-date="2022-04-12"
                                              aria-labelledby="fc-dom-34"
                                            >
                                              <div className="fc-daygrid-day-frame fc-scrollgrid-sync-inner">
                                                <div className="fc-daygrid-day-top">
                                                  <a
                                                    id="fc-dom-34"
                                                    className="fc-daygrid-day-number"
                                                    title="Go to April 12, 2022"
                                                    data-navlink
                                                    tabIndex={0}
                                                  >
                                                    12
                                                  </a>
                                                </div>
                                                <div className="fc-daygrid-day-events">
                                                  <div
                                                    className="fc-daygrid-event-harness"
                                                    style={{ marginTop: "0px" }}
                                                  >
                                                    <a className="fc-daygrid-event fc-daygrid-block-event fc-h-event fc-event fc-event-draggable fc-event-resizable fc-event-start fc-event-end fc-event-future">
                                                      <div className="fc-event-main">
                                                        <div className="fc-event-main-frame">
                                                          <div className="fc-event-title-container">
                                                            <div className="fc-event-title fc-sticky">
                                                              Dinner
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                      <div className="fc-event-resizer fc-event-resizer-end" />
                                                    </a>
                                                  </div>
                                                  <div
                                                    className="fc-daygrid-day-bottom"
                                                    style={{ marginTop: "0px" }}
                                                  />
                                                </div>
                                                <div className="fc-daygrid-day-bg" />
                                              </div>
                                            </td>
                                            <td
                                              role="gridcell"
                                              className="fc-daygrid-day fc-day fc-day-wed fc-day-future"
                                              data-date="2022-04-13"
                                              aria-labelledby="fc-dom-36"
                                            >
                                              <div className="fc-daygrid-day-frame fc-scrollgrid-sync-inner">
                                                <div className="fc-daygrid-day-top">
                                                  <a
                                                    id="fc-dom-36"
                                                    className="fc-daygrid-day-number"
                                                    title="Go to April 13, 2022"
                                                    data-navlink
                                                    tabIndex={0}
                                                  >
                                                    13
                                                  </a>
                                                </div>
                                                <div className="fc-daygrid-day-events">
                                                  <div
                                                    className="fc-daygrid-day-bottom"
                                                    style={{ marginTop: "0px" }}
                                                  />
                                                </div>
                                                <div className="fc-daygrid-day-bg" />
                                              </div>
                                            </td>
                                            <td
                                              role="gridcell"
                                              className="fc-daygrid-day fc-day fc-day-thu fc-day-future"
                                              data-date="2022-04-14"
                                              aria-labelledby="fc-dom-38"
                                            >
                                              <div className="fc-daygrid-day-frame fc-scrollgrid-sync-inner">
                                                <div className="fc-daygrid-day-top">
                                                  <a
                                                    id="fc-dom-38"
                                                    className="fc-daygrid-day-number"
                                                    title="Go to April 14, 2022"
                                                    data-navlink
                                                    tabIndex={0}
                                                  >
                                                    14
                                                  </a>
                                                </div>
                                                <div className="fc-daygrid-day-events">
                                                  <div
                                                    className="fc-daygrid-event-harness"
                                                    style={{ marginTop: "0px" }}
                                                  >
                                                    <a className="fc-daygrid-event fc-daygrid-dot-event fc-event fc-event-draggable fc-event-resizable fc-event-start fc-event-end fc-event-future fc-event-success">
                                                      <div className="fc-daygrid-event-dot" />
                                                      <div className="fc-event-time">
                                                        1:30p
                                                      </div>
                                                      <div className="fc-event-title">
                                                        Reporting
                                                      </div>
                                                    </a>
                                                  </div>
                                                  <div
                                                    className="fc-daygrid-day-bottom"
                                                    style={{ marginTop: "0px" }}
                                                  />
                                                </div>
                                                <div className="fc-daygrid-day-bg" />
                                              </div>
                                            </td>
                                            <td
                                              role="gridcell"
                                              className="fc-daygrid-day fc-day fc-day-fri fc-day-future"
                                              data-date="2022-04-15"
                                              aria-labelledby="fc-dom-40"
                                            >
                                              <div className="fc-daygrid-day-frame fc-scrollgrid-sync-inner">
                                                <div className="fc-daygrid-day-top">
                                                  <a
                                                    id="fc-dom-40"
                                                    className="fc-daygrid-day-number"
                                                    title="Go to April 15, 2022"
                                                    data-navlink
                                                    tabIndex={0}
                                                  >
                                                    15
                                                  </a>
                                                </div>
                                                <div className="fc-daygrid-day-events">
                                                  <div
                                                    className="fc-daygrid-day-bottom"
                                                    style={{ marginTop: "0px" }}
                                                  />
                                                </div>
                                                <div className="fc-daygrid-day-bg" />
                                              </div>
                                            </td>
                                            <td
                                              role="gridcell"
                                              className="fc-daygrid-day fc-day fc-day-sat fc-day-future"
                                              data-date="2022-04-16"
                                              aria-labelledby="fc-dom-42"
                                            >
                                              <div className="fc-daygrid-day-frame fc-scrollgrid-sync-inner">
                                                <div className="fc-daygrid-day-top">
                                                  <a
                                                    id="fc-dom-42"
                                                    className="fc-daygrid-day-number"
                                                    title="Go to April 16, 2022"
                                                    data-navlink
                                                    tabIndex={0}
                                                  >
                                                    16
                                                  </a>
                                                </div>
                                                <div className="fc-daygrid-day-events">
                                                  <div
                                                    className="fc-daygrid-event-harness"
                                                    style={{ marginTop: "0px" }}
                                                  >
                                                    <a className="fc-daygrid-event fc-daygrid-dot-event fc-event fc-event-draggable fc-event-resizable fc-event-start fc-event-end fc-event-future">
                                                      <div className="fc-daygrid-event-dot" />
                                                      <div className="fc-event-time">
                                                        4p
                                                      </div>
                                                      <div className="fc-event-title">
                                                        Repeating Event
                                                      </div>
                                                    </a>
                                                  </div>
                                                  <div
                                                    className="fc-daygrid-day-bottom"
                                                    style={{ marginTop: "0px" }}
                                                  />
                                                </div>
                                                <div className="fc-daygrid-day-bg" />
                                              </div>
                                            </td>
                                          </tr>
                                          <tr role="row">
                                            <td
                                              role="gridcell"
                                              className="fc-daygrid-day fc-day fc-day-sun fc-day-future"
                                              data-date="2022-04-17"
                                              aria-labelledby="fc-dom-44"
                                            >
                                              <div className="fc-daygrid-day-frame fc-scrollgrid-sync-inner">
                                                <div className="fc-daygrid-day-top">
                                                  <a
                                                    id="fc-dom-44"
                                                    className="fc-daygrid-day-number"
                                                    title="Go to April 17, 2022"
                                                    data-navlink
                                                    tabIndex={0}
                                                  >
                                                    17
                                                  </a>
                                                </div>
                                                <div className="fc-daygrid-day-events">
                                                  <div
                                                    className="fc-daygrid-day-bottom"
                                                    style={{ marginTop: "0px" }}
                                                  />
                                                </div>
                                                <div className="fc-daygrid-day-bg" />
                                              </div>
                                            </td>
                                            <td
                                              role="gridcell"
                                              className="fc-daygrid-day fc-day fc-day-mon fc-day-future"
                                              data-date="2022-04-18"
                                              aria-labelledby="fc-dom-46"
                                            >
                                              <div className="fc-daygrid-day-frame fc-scrollgrid-sync-inner">
                                                <div className="fc-daygrid-day-top">
                                                  <a
                                                    id="fc-dom-46"
                                                    className="fc-daygrid-day-number"
                                                    title="Go to April 18, 2022"
                                                    data-navlink
                                                    tabIndex={0}
                                                  >
                                                    18
                                                  </a>
                                                </div>
                                                <div className="fc-daygrid-day-events">
                                                  <div
                                                    className="fc-daygrid-day-bottom"
                                                    style={{ marginTop: "0px" }}
                                                  />
                                                </div>
                                                <div className="fc-daygrid-day-bg" />
                                              </div>
                                            </td>
                                            <td
                                              role="gridcell"
                                              className="fc-daygrid-day fc-day fc-day-tue fc-day-future"
                                              data-date="2022-04-19"
                                              aria-labelledby="fc-dom-48"
                                            >
                                              <div className="fc-daygrid-day-frame fc-scrollgrid-sync-inner">
                                                <div className="fc-daygrid-day-top">
                                                  <a
                                                    id="fc-dom-48"
                                                    className="fc-daygrid-day-number"
                                                    title="Go to April 19, 2022"
                                                    data-navlink
                                                    tabIndex={0}
                                                  >
                                                    19
                                                  </a>
                                                </div>
                                                <div className="fc-daygrid-day-events">
                                                  <div
                                                    className="fc-daygrid-day-bottom"
                                                    style={{ marginTop: "0px" }}
                                                  />
                                                </div>
                                                <div className="fc-daygrid-day-bg" />
                                              </div>
                                            </td>
                                            <td
                                              role="gridcell"
                                              className="fc-daygrid-day fc-day fc-day-wed fc-day-future"
                                              data-date="2022-04-20"
                                              aria-labelledby="fc-dom-50"
                                            >
                                              <div className="fc-daygrid-day-frame fc-scrollgrid-sync-inner">
                                                <div className="fc-daygrid-day-top">
                                                  <a
                                                    id="fc-dom-50"
                                                    className="fc-daygrid-day-number"
                                                    title="Go to April 20, 2022"
                                                    data-navlink
                                                    tabIndex={0}
                                                  >
                                                    20
                                                  </a>
                                                </div>
                                                <div className="fc-daygrid-day-events">
                                                  <div
                                                    className="fc-daygrid-day-bottom"
                                                    style={{ marginTop: "0px" }}
                                                  />
                                                </div>
                                                <div className="fc-daygrid-day-bg" />
                                              </div>
                                            </td>
                                            <td
                                              role="gridcell"
                                              className="fc-daygrid-day fc-day fc-day-thu fc-day-future"
                                              data-date="2022-04-21"
                                              aria-labelledby="fc-dom-52"
                                            >
                                              <div className="fc-daygrid-day-frame fc-scrollgrid-sync-inner">
                                                <div className="fc-daygrid-day-top">
                                                  <a
                                                    id="fc-dom-52"
                                                    className="fc-daygrid-day-number"
                                                    title="Go to April 21, 2022"
                                                    data-navlink
                                                    tabIndex={0}
                                                  >
                                                    21
                                                  </a>
                                                </div>
                                                <div className="fc-daygrid-day-events">
                                                  <div
                                                    className="fc-daygrid-day-bottom"
                                                    style={{ marginTop: "0px" }}
                                                  />
                                                </div>
                                                <div className="fc-daygrid-day-bg" />
                                              </div>
                                            </td>
                                            <td
                                              role="gridcell"
                                              className="fc-daygrid-day fc-day fc-day-fri fc-day-future"
                                              data-date="2022-04-22"
                                              aria-labelledby="fc-dom-54"
                                            >
                                              <div className="fc-daygrid-day-frame fc-scrollgrid-sync-inner">
                                                <div className="fc-daygrid-day-top">
                                                  <a
                                                    id="fc-dom-54"
                                                    className="fc-daygrid-day-number"
                                                    title="Go to April 22, 2022"
                                                    data-navlink
                                                    tabIndex={0}
                                                  >
                                                    22
                                                  </a>
                                                </div>
                                                <div className="fc-daygrid-day-events">
                                                  <div
                                                    className="fc-daygrid-day-bottom"
                                                    style={{ marginTop: "0px" }}
                                                  />
                                                </div>
                                                <div className="fc-daygrid-day-bg" />
                                              </div>
                                            </td>
                                            <td
                                              role="gridcell"
                                              className="fc-daygrid-day fc-day fc-day-sat fc-day-future"
                                              data-date="2022-04-23"
                                              aria-labelledby="fc-dom-56"
                                            >
                                              <div className="fc-daygrid-day-frame fc-scrollgrid-sync-inner">
                                                <div className="fc-daygrid-day-top">
                                                  <a
                                                    id="fc-dom-56"
                                                    className="fc-daygrid-day-number"
                                                    title="Go to April 23, 2022"
                                                    data-navlink
                                                    tabIndex={0}
                                                  >
                                                    23
                                                  </a>
                                                </div>
                                                <div className="fc-daygrid-day-events">
                                                  <div
                                                    className="fc-daygrid-day-bottom"
                                                    style={{ marginTop: "0px" }}
                                                  />
                                                </div>
                                                <div className="fc-daygrid-day-bg" />
                                              </div>
                                            </td>
                                          </tr>
                                          <tr role="row">
                                            <td
                                              role="gridcell"
                                              className="fc-daygrid-day fc-day fc-day-sun fc-day-future"
                                              data-date="2022-04-24"
                                              aria-labelledby="fc-dom-58"
                                            >
                                              <div className="fc-daygrid-day-frame fc-scrollgrid-sync-inner">
                                                <div className="fc-daygrid-day-top">
                                                  <a
                                                    id="fc-dom-58"
                                                    className="fc-daygrid-day-number"
                                                    title="Go to April 24, 2022"
                                                    data-navlink
                                                    tabIndex={0}
                                                  >
                                                    24
                                                  </a>
                                                </div>
                                                <div className="fc-daygrid-day-events">
                                                  <div
                                                    className="fc-daygrid-day-bottom"
                                                    style={{ marginTop: "0px" }}
                                                  />
                                                </div>
                                                <div className="fc-daygrid-day-bg" />
                                              </div>
                                            </td>
                                            <td
                                              role="gridcell"
                                              className="fc-daygrid-day fc-day fc-day-mon fc-day-future"
                                              data-date="2022-04-25"
                                              aria-labelledby="fc-dom-60"
                                            >
                                              <div className="fc-daygrid-day-frame fc-scrollgrid-sync-inner">
                                                <div className="fc-daygrid-day-top">
                                                  <a
                                                    id="fc-dom-60"
                                                    className="fc-daygrid-day-number"
                                                    title="Go to April 25, 2022"
                                                    data-navlink
                                                    tabIndex={0}
                                                  >
                                                    25
                                                  </a>
                                                </div>
                                                <div className="fc-daygrid-day-events">
                                                  <div
                                                    className="fc-daygrid-day-bottom"
                                                    style={{ marginTop: "0px" }}
                                                  />
                                                </div>
                                                <div className="fc-daygrid-day-bg" />
                                              </div>
                                            </td>
                                            <td
                                              role="gridcell"
                                              className="fc-daygrid-day fc-day fc-day-tue fc-day-future"
                                              data-date="2022-04-26"
                                              aria-labelledby="fc-dom-62"
                                            >
                                              <div className="fc-daygrid-day-frame fc-scrollgrid-sync-inner">
                                                <div className="fc-daygrid-day-top">
                                                  <a
                                                    id="fc-dom-62"
                                                    className="fc-daygrid-day-number"
                                                    title="Go to April 26, 2022"
                                                    data-navlink
                                                    tabIndex={0}
                                                  >
                                                    26
                                                  </a>
                                                </div>
                                                <div className="fc-daygrid-day-events">
                                                  <div
                                                    className="fc-daygrid-day-bottom"
                                                    style={{ marginTop: "0px" }}
                                                  />
                                                </div>
                                                <div className="fc-daygrid-day-bg" />
                                              </div>
                                            </td>
                                            <td
                                              role="gridcell"
                                              className="fc-daygrid-day fc-day fc-day-wed fc-day-future"
                                              data-date="2022-04-27"
                                              aria-labelledby="fc-dom-64"
                                            >
                                              <div className="fc-daygrid-day-frame fc-scrollgrid-sync-inner">
                                                <div className="fc-daygrid-day-top">
                                                  <a
                                                    id="fc-dom-64"
                                                    className="fc-daygrid-day-number"
                                                    title="Go to April 27, 2022"
                                                    data-navlink
                                                    tabIndex={0}
                                                  >
                                                    27
                                                  </a>
                                                </div>
                                                <div className="fc-daygrid-day-events">
                                                  <div
                                                    className="fc-daygrid-day-bottom"
                                                    style={{ marginTop: "0px" }}
                                                  />
                                                </div>
                                                <div className="fc-daygrid-day-bg" />
                                              </div>
                                            </td>
                                            <td
                                              role="gridcell"
                                              className="fc-daygrid-day fc-day fc-day-thu fc-day-future"
                                              data-date="2022-04-28"
                                              aria-labelledby="fc-dom-66"
                                            >
                                              <div className="fc-daygrid-day-frame fc-scrollgrid-sync-inner">
                                                <div className="fc-daygrid-day-top">
                                                  <a
                                                    id="fc-dom-66"
                                                    className="fc-daygrid-day-number"
                                                    title="Go to April 28, 2022"
                                                    data-navlink
                                                    tabIndex={0}
                                                  >
                                                    28
                                                  </a>
                                                </div>
                                                <div className="fc-daygrid-day-events">
                                                  <div
                                                    className="fc-daygrid-event-harness"
                                                    style={{ marginTop: "0px" }}
                                                  >
                                                    <a
                                                      className="fc-daygrid-event fc-daygrid-block-event fc-h-event fc-event fc-event-draggable fc-event-resizable fc-event-start fc-event-end fc-event-future fc-event-solid-info fc-event-light"
                                                      href="http://google.com/"
                                                    >
                                                      <div className="fc-event-main">
                                                        <div className="fc-event-main-frame">
                                                          <div className="fc-event-title-container">
                                                            <div className="fc-event-title fc-sticky">
                                                              Click for Google
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                      <div className="fc-event-resizer fc-event-resizer-end" />
                                                    </a>
                                                  </div>
                                                  <div
                                                    className="fc-daygrid-day-bottom"
                                                    style={{ marginTop: "0px" }}
                                                  />
                                                </div>
                                                <div className="fc-daygrid-day-bg" />
                                              </div>
                                            </td>
                                            <td
                                              role="gridcell"
                                              className="fc-daygrid-day fc-day fc-day-fri fc-day-future"
                                              data-date="2022-04-29"
                                              aria-labelledby="fc-dom-68"
                                            >
                                              <div className="fc-daygrid-day-frame fc-scrollgrid-sync-inner">
                                                <div className="fc-daygrid-day-top">
                                                  <a
                                                    id="fc-dom-68"
                                                    className="fc-daygrid-day-number"
                                                    title="Go to April 29, 2022"
                                                    data-navlink
                                                    tabIndex={0}
                                                  >
                                                    29
                                                  </a>
                                                </div>
                                                <div className="fc-daygrid-day-events">
                                                  <div
                                                    className="fc-daygrid-day-bottom"
                                                    style={{ marginTop: "0px" }}
                                                  />
                                                </div>
                                                <div className="fc-daygrid-day-bg" />
                                              </div>
                                            </td>
                                            <td
                                              role="gridcell"
                                              className="fc-daygrid-day fc-day fc-day-sat fc-day-future"
                                              data-date="2022-04-30"
                                              aria-labelledby="fc-dom-70"
                                            >
                                              <div className="fc-daygrid-day-frame fc-scrollgrid-sync-inner">
                                                <div className="fc-daygrid-day-top">
                                                  <a
                                                    id="fc-dom-70"
                                                    className="fc-daygrid-day-number"
                                                    title="Go to April 30, 2022"
                                                    data-navlink
                                                    tabIndex={0}
                                                  >
                                                    30
                                                  </a>
                                                </div>
                                                <div className="fc-daygrid-day-events">
                                                  <div
                                                    className="fc-daygrid-day-bottom"
                                                    style={{ marginTop: "0px" }}
                                                  />
                                                </div>
                                                <div className="fc-daygrid-day-bg" />
                                              </div>
                                            </td>
                                          </tr>
                                          <tr role="row">
                                            <td
                                              role="gridcell"
                                              className="fc-daygrid-day fc-day fc-day-sun fc-day-future fc-day-other"
                                              data-date="2022-05-01"
                                              aria-labelledby="fc-dom-72"
                                            >
                                              <div className="fc-daygrid-day-frame fc-scrollgrid-sync-inner">
                                                <div className="fc-daygrid-day-top">
                                                  <a
                                                    id="fc-dom-72"
                                                    className="fc-daygrid-day-number"
                                                    title="Go to May 1, 2022"
                                                    data-navlink
                                                    tabIndex={0}
                                                  >
                                                    1
                                                  </a>
                                                </div>
                                                <div className="fc-daygrid-day-events">
                                                  <div
                                                    className="fc-daygrid-day-bottom"
                                                    style={{ marginTop: "0px" }}
                                                  />
                                                </div>
                                                <div className="fc-daygrid-day-bg" />
                                              </div>
                                            </td>
                                            <td
                                              role="gridcell"
                                              className="fc-daygrid-day fc-day fc-day-mon fc-day-future fc-day-other"
                                              data-date="2022-05-02"
                                              aria-labelledby="fc-dom-74"
                                            >
                                              <div className="fc-daygrid-day-frame fc-scrollgrid-sync-inner">
                                                <div className="fc-daygrid-day-top">
                                                  <a
                                                    id="fc-dom-74"
                                                    className="fc-daygrid-day-number"
                                                    title="Go to May 2, 2022"
                                                    data-navlink
                                                    tabIndex={0}
                                                  >
                                                    2
                                                  </a>
                                                </div>
                                                <div className="fc-daygrid-day-events">
                                                  <div
                                                    className="fc-daygrid-day-bottom"
                                                    style={{ marginTop: "0px" }}
                                                  />
                                                </div>
                                                <div className="fc-daygrid-day-bg" />
                                              </div>
                                            </td>
                                            <td
                                              role="gridcell"
                                              className="fc-daygrid-day fc-day fc-day-tue fc-day-future fc-day-other"
                                              data-date="2022-05-03"
                                              aria-labelledby="fc-dom-76"
                                            >
                                              <div className="fc-daygrid-day-frame fc-scrollgrid-sync-inner">
                                                <div className="fc-daygrid-day-top">
                                                  <a
                                                    id="fc-dom-76"
                                                    className="fc-daygrid-day-number"
                                                    title="Go to May 3, 2022"
                                                    data-navlink
                                                    tabIndex={0}
                                                  >
                                                    3
                                                  </a>
                                                </div>
                                                <div className="fc-daygrid-day-events">
                                                  <div
                                                    className="fc-daygrid-day-bottom"
                                                    style={{ marginTop: "0px" }}
                                                  />
                                                </div>
                                                <div className="fc-daygrid-day-bg" />
                                              </div>
                                            </td>
                                            <td
                                              role="gridcell"
                                              className="fc-daygrid-day fc-day fc-day-wed fc-day-future fc-day-other"
                                              data-date="2022-05-04"
                                              aria-labelledby="fc-dom-78"
                                            >
                                              <div className="fc-daygrid-day-frame fc-scrollgrid-sync-inner">
                                                <div className="fc-daygrid-day-top">
                                                  <a
                                                    id="fc-dom-78"
                                                    className="fc-daygrid-day-number"
                                                    title="Go to May 4, 2022"
                                                    data-navlink
                                                    tabIndex={0}
                                                  >
                                                    4
                                                  </a>
                                                </div>
                                                <div className="fc-daygrid-day-events">
                                                  <div
                                                    className="fc-daygrid-day-bottom"
                                                    style={{ marginTop: "0px" }}
                                                  />
                                                </div>
                                                <div className="fc-daygrid-day-bg" />
                                              </div>
                                            </td>
                                            <td
                                              role="gridcell"
                                              className="fc-daygrid-day fc-day fc-day-thu fc-day-future fc-day-other"
                                              data-date="2022-05-05"
                                              aria-labelledby="fc-dom-80"
                                            >
                                              <div className="fc-daygrid-day-frame fc-scrollgrid-sync-inner">
                                                <div className="fc-daygrid-day-top">
                                                  <a
                                                    id="fc-dom-80"
                                                    className="fc-daygrid-day-number"
                                                    title="Go to May 5, 2022"
                                                    data-navlink
                                                    tabIndex={0}
                                                  >
                                                    5
                                                  </a>
                                                </div>
                                                <div className="fc-daygrid-day-events">
                                                  <div
                                                    className="fc-daygrid-day-bottom"
                                                    style={{ marginTop: "0px" }}
                                                  />
                                                </div>
                                                <div className="fc-daygrid-day-bg" />
                                              </div>
                                            </td>
                                            <td
                                              role="gridcell"
                                              className="fc-daygrid-day fc-day fc-day-fri fc-day-future fc-day-other"
                                              data-date="2022-05-06"
                                              aria-labelledby="fc-dom-82"
                                            >
                                              <div className="fc-daygrid-day-frame fc-scrollgrid-sync-inner">
                                                <div className="fc-daygrid-day-top">
                                                  <a
                                                    id="fc-dom-82"
                                                    className="fc-daygrid-day-number"
                                                    title="Go to May 6, 2022"
                                                    data-navlink
                                                    tabIndex={0}
                                                  >
                                                    6
                                                  </a>
                                                </div>
                                                <div className="fc-daygrid-day-events">
                                                  <div
                                                    className="fc-daygrid-day-bottom"
                                                    style={{ marginTop: "0px" }}
                                                  />
                                                </div>
                                                <div className="fc-daygrid-day-bg" />
                                              </div>
                                            </td>
                                            <td
                                              role="gridcell"
                                              className="fc-daygrid-day fc-day fc-day-sat fc-day-future fc-day-other"
                                              data-date="2022-05-07"
                                              aria-labelledby="fc-dom-84"
                                            >
                                              <div className="fc-daygrid-day-frame fc-scrollgrid-sync-inner">
                                                <div className="fc-daygrid-day-top">
                                                  <a
                                                    id="fc-dom-84"
                                                    className="fc-daygrid-day-number"
                                                    title="Go to May 7, 2022"
                                                    data-navlink
                                                    tabIndex={0}
                                                  >
                                                    7
                                                  </a>
                                                </div>
                                                <div className="fc-daygrid-day-events">
                                                  <div
                                                    className="fc-daygrid-day-bottom"
                                                    style={{ marginTop: "0px" }}
                                                  />
                                                </div>
                                                <div className="fc-daygrid-day-bg" />
                                              </div>
                                            </td>
                                          </tr>
                                        </tbody>
                                      </table>
                                    </div>
                                  </div>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                  {/*end::Calendar*/}
                </div>
                {/*end::Card body*/}
              </div>
              {/*end::Calendar Widget 1*/}
              {/*begin::Modals*/}
              {/*begin::Modal - New Product*/}
              <div
                className="modal fade"
                id="kt_modal_add_event"
                tabIndex={-1}
                aria-hidden="true"
              >
                {/*begin::Modal dialog*/}
                <div className="modal-dialog modal-dialog-centered mw-650px">
                  {/*begin::Modal content*/}
                  <div className="modal-content">
                    {/*begin::Form*/}
                    <form
                      className="form"
                      action="#"
                      id="kt_modal_add_event_form"
                    >
                      {/*begin::Modal header*/}
                      <div className="modal-header">
                        {/*begin::Modal title*/}
                        <h2 className="fw-bolder" data-kt-calendar="title">
                          Add Event
                        </h2>
                        {/*end::Modal title*/}
                        {/*begin::Close*/}
                        <div
                          className="btn btn-icon btn-sm btn-active-icon-primary"
                          id="kt_modal_add_event_close"
                        >
                          {/*begin::Svg Icon | path: icons/duotune/arrows/arr061.svg*/}
                          <span className="svg-icon svg-icon-1">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width={24}
                              height={24}
                              viewBox="0 0 24 24"
                              fill="none"
                            >
                              <rect
                                opacity="0.5"
                                x={6}
                                y="17.3137"
                                width={16}
                                height={2}
                                rx={1}
                                transform="rotate(-45 6 17.3137)"
                                fill="currentColor"
                              />
                              <rect
                                x="7.41422"
                                y={6}
                                width={16}
                                height={2}
                                rx={1}
                                transform="rotate(45 7.41422 6)"
                                fill="currentColor"
                              />
                            </svg>
                          </span>
                          {/*end::Svg Icon*/}
                        </div>
                        {/*end::Close*/}
                      </div>
                      {/*end::Modal header*/}
                      {/*begin::Modal body*/}
                      <div className="modal-body py-10 px-lg-17">
                        {/*begin::Input group*/}
                        <div className="fv-row mb-9">
                          {/*begin::Label*/}
                          <label className="fs-6 fw-bold required mb-2">
                            Event Name
                          </label>
                          {/*end::Label*/}
                          {/*begin::Input*/}
                          <input
                            type="text"
                            className="form-control form-control-solid"
                            placeholder
                            name="calendar_event_name"
                          />
                          {/*end::Input*/}
                        </div>
                        {/*end::Input group*/}
                        {/*begin::Input group*/}
                        <div className="fv-row mb-9">
                          {/*begin::Label*/}
                          <label className="fs-6 fw-bold mb-2">
                            Event Description
                          </label>
                          {/*end::Label*/}
                          {/*begin::Input*/}
                          <input
                            type="text"
                            className="form-control form-control-solid"
                            placeholder
                            name="calendar_event_description"
                          />
                          {/*end::Input*/}
                        </div>
                        {/*end::Input group*/}
                        {/*begin::Input group*/}
                        <div className="fv-row mb-9">
                          {/*begin::Label*/}
                          <label className="fs-6 fw-bold mb-2">
                            Event Location
                          </label>
                          {/*end::Label*/}
                          {/*begin::Input*/}
                          <input
                            type="text"
                            className="form-control form-control-solid"
                            placeholder
                            name="calendar_event_location"
                          />
                          {/*end::Input*/}
                        </div>
                        {/*end::Input group*/}
                        {/*begin::Input group*/}
                        <div className="fv-row mb-9">
                          {/*begin::Checkbox*/}
                          <label className="form-check form-check-custom form-check-solid">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              defaultValue
                              id="kt_calendar_datepicker_allday"
                            />
                            <span
                              className="form-check-label fw-bold"
                              htmlFor="kt_calendar_datepicker_allday"
                            >
                              All Day
                            </span>
                          </label>
                          {/*end::Checkbox*/}
                        </div>
                        {/*end::Input group*/}
                        {/*begin::Input group*/}
                        <div className="row row-cols-lg-2 g-10">
                          <div className="col">
                            <div className="fv-row mb-9">
                              {/*begin::Label*/}
                              <label className="fs-6 fw-bold mb-2 required">
                                Event Start Date
                              </label>
                              {/*end::Label*/}
                              {/*begin::Input*/}
                              <input
                                className="form-control form-control-solid"
                                name="calendar_event_start_date"
                                placeholder="Pick a start date"
                                id="kt_calendar_datepicker_start_date"
                              />
                              {/*end::Input*/}
                            </div>
                          </div>
                          <div className="col" data-kt-calendar="datepicker">
                            <div className="fv-row mb-9">
                              {/*begin::Label*/}
                              <label className="fs-6 fw-bold mb-2">
                                Event Start Time
                              </label>
                              {/*end::Label*/}
                              {/*begin::Input*/}
                              <input
                                className="form-control form-control-solid"
                                name="calendar_event_start_time"
                                placeholder="Pick a start time"
                                id="kt_calendar_datepicker_start_time"
                              />
                              {/*end::Input*/}
                            </div>
                          </div>
                        </div>
                        {/*end::Input group*/}
                        {/*begin::Input group*/}
                        <div className="row row-cols-lg-2 g-10">
                          <div className="col">
                            <div className="fv-row mb-9">
                              {/*begin::Label*/}
                              <label className="fs-6 fw-bold mb-2 required">
                                Event End Date
                              </label>
                              {/*end::Label*/}
                              {/*begin::Input*/}
                              <input
                                className="form-control form-control-solid"
                                name="calendar_event_end_date"
                                placeholder="Pick a end date"
                                id="kt_calendar_datepicker_end_date"
                              />
                              {/*end::Input*/}
                            </div>
                          </div>
                          <div className="col" data-kt-calendar="datepicker">
                            <div className="fv-row mb-9">
                              {/*begin::Label*/}
                              <label className="fs-6 fw-bold mb-2">
                                Event End Time
                              </label>
                              {/*end::Label*/}
                              {/*begin::Input*/}
                              <input
                                className="form-control form-control-solid"
                                name="calendar_event_end_time"
                                placeholder="Pick a end time"
                                id="kt_calendar_datepicker_end_time"
                              />
                              {/*end::Input*/}
                            </div>
                          </div>
                        </div>
                        {/*end::Input group*/}
                      </div>
                      {/*end::Modal body*/}
                      {/*begin::Modal footer*/}
                      <div className="modal-footer flex-center">
                        {/*begin::Button*/}
                        <button
                          type="reset"
                          id="kt_modal_add_event_cancel"
                          className="btn btn-light me-3"
                        >
                          Cancel
                        </button>
                        {/*end::Button*/}
                        {/*begin::Button*/}
                        <button
                          type="button"
                          id="kt_modal_add_event_submit"
                          className="btn btn-primary"
                        >
                          <span className="indicator-label">Submit</span>
                          <span className="indicator-progress">
                            Please wait...
                            <span className="spinner-border spinner-border-sm align-middle ms-2" />
                          </span>
                        </button>
                        {/*end::Button*/}
                      </div>
                      {/*end::Modal footer*/}
                    </form>
                    {/*end::Form*/}
                  </div>
                </div>
              </div>
              {/*end::Modal - New Product*/}
              {/*begin::Modal - New Product*/}
              <div
                className="modal fade"
                id="kt_modal_view_event"
                tabIndex={-1}
                aria-hidden="true"
              >
                {/*begin::Modal dialog*/}
                <div className="modal-dialog modal-dialog-centered mw-650px">
                  {/*begin::Modal content*/}
                  <div className="modal-content">
                    {/*begin::Modal header*/}
                    <div className="modal-header border-0 justify-content-end">
                      {/*begin::Edit*/}
                      <div
                        className="btn btn-icon btn-sm btn-color-gray-400 btn-active-icon-primary me-2"
                        data-bs-toggle="tooltip"
                        data-bs-dismiss="click"
                        title
                        id="kt_modal_view_event_edit"
                        data-bs-original-title="Edit Event"
                      >
                        {/*begin::Svg Icon | path: icons/duotune/art/art005.svg*/}
                        <span className="svg-icon svg-icon-2">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width={24}
                            height={24}
                            viewBox="0 0 24 24"
                            fill="none"
                          >
                            <path
                              opacity="0.3"
                              d="M21.4 8.35303L19.241 10.511L13.485 4.755L15.643 2.59595C16.0248 2.21423 16.5426 1.99988 17.0825 1.99988C17.6224 1.99988 18.1402 2.21423 18.522 2.59595L21.4 5.474C21.7817 5.85581 21.9962 6.37355 21.9962 6.91345C21.9962 7.45335 21.7817 7.97122 21.4 8.35303ZM3.68699 21.932L9.88699 19.865L4.13099 14.109L2.06399 20.309C1.98815 20.5354 1.97703 20.7787 2.03189 21.0111C2.08674 21.2436 2.2054 21.4561 2.37449 21.6248C2.54359 21.7934 2.75641 21.9115 2.989 21.9658C3.22158 22.0201 3.4647 22.0084 3.69099 21.932H3.68699Z"
                              fill="currentColor"
                            />
                            <path
                              d="M5.574 21.3L3.692 21.928C3.46591 22.0032 3.22334 22.0141 2.99144 21.9594C2.75954 21.9046 2.54744 21.7864 2.3789 21.6179C2.21036 21.4495 2.09202 21.2375 2.03711 21.0056C1.9822 20.7737 1.99289 20.5312 2.06799 20.3051L2.696 18.422L5.574 21.3ZM4.13499 14.105L9.891 19.861L19.245 10.507L13.489 4.75098L4.13499 14.105Z"
                              fill="currentColor"
                            />
                          </svg>
                        </span>
                        {/*end::Svg Icon*/}
                      </div>
                      {/*end::Edit*/}
                      {/*begin::Edit*/}
                      <div
                        className="btn btn-icon btn-sm btn-color-gray-400 btn-active-icon-danger me-2"
                        data-bs-toggle="tooltip"
                        data-bs-dismiss="click"
                        title
                        id="kt_modal_view_event_delete"
                        data-bs-original-title="Delete Event"
                      >
                        {/*begin::Svg Icon | path: icons/duotune/general/gen027.svg*/}
                        <span className="svg-icon svg-icon-2">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width={24}
                            height={24}
                            viewBox="0 0 24 24"
                            fill="none"
                          >
                            <path
                              d="M5 9C5 8.44772 5.44772 8 6 8H18C18.5523 8 19 8.44772 19 9V18C19 19.6569 17.6569 21 16 21H8C6.34315 21 5 19.6569 5 18V9Z"
                              fill="currentColor"
                            />
                            <path
                              opacity="0.5"
                              d="M5 5C5 4.44772 5.44772 4 6 4H18C18.5523 4 19 4.44772 19 5V5C19 5.55228 18.5523 6 18 6H6C5.44772 6 5 5.55228 5 5V5Z"
                              fill="currentColor"
                            />
                            <path
                              opacity="0.5"
                              d="M9 4C9 3.44772 9.44772 3 10 3H14C14.5523 3 15 3.44772 15 4V4H9V4Z"
                              fill="currentColor"
                            />
                          </svg>
                        </span>
                        {/*end::Svg Icon*/}
                      </div>
                      {/*end::Edit*/}
                      {/*begin::Close*/}
                      <div
                        className="btn btn-icon btn-sm btn-color-gray-500 btn-active-icon-primary"
                        data-bs-toggle="tooltip"
                        title
                        data-bs-dismiss="modal"
                        data-bs-original-title="Hide Event"
                      >
                        {/*begin::Svg Icon | path: icons/duotune/arrows/arr061.svg*/}
                        <span className="svg-icon svg-icon-1">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width={24}
                            height={24}
                            viewBox="0 0 24 24"
                            fill="none"
                          >
                            <rect
                              opacity="0.5"
                              x={6}
                              y="17.3137"
                              width={16}
                              height={2}
                              rx={1}
                              transform="rotate(-45 6 17.3137)"
                              fill="currentColor"
                            />
                            <rect
                              x="7.41422"
                              y={6}
                              width={16}
                              height={2}
                              rx={1}
                              transform="rotate(45 7.41422 6)"
                              fill="currentColor"
                            />
                          </svg>
                        </span>
                        {/*end::Svg Icon*/}
                      </div>
                      {/*end::Close*/}
                    </div>
                    {/*end::Modal header*/}
                    {/*begin::Modal body*/}
                    <div className="modal-body pt-0 pb-20 px-lg-17">
                      {/*begin::Row*/}
                      <div className="d-flex">
                        {/*begin::Icon*/}
                        {/*begin::Svg Icon | path: icons/duotune/general/gen014.svg*/}
                        <span className="svg-icon svg-icon-1 svg-icon-muted me-5">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width={24}
                            height={24}
                            viewBox="0 0 24 24"
                            fill="none"
                          >
                            <path
                              opacity="0.3"
                              d="M21 22H3C2.4 22 2 21.6 2 21V5C2 4.4 2.4 4 3 4H21C21.6 4 22 4.4 22 5V21C22 21.6 21.6 22 21 22Z"
                              fill="currentColor"
                            />
                            <path
                              d="M6 6C5.4 6 5 5.6 5 5V3C5 2.4 5.4 2 6 2C6.6 2 7 2.4 7 3V5C7 5.6 6.6 6 6 6ZM11 5V3C11 2.4 10.6 2 10 2C9.4 2 9 2.4 9 3V5C9 5.6 9.4 6 10 6C10.6 6 11 5.6 11 5ZM15 5V3C15 2.4 14.6 2 14 2C13.4 2 13 2.4 13 3V5C13 5.6 13.4 6 14 6C14.6 6 15 5.6 15 5ZM19 5V3C19 2.4 18.6 2 18 2C17.4 2 17 2.4 17 3V5C17 5.6 17.4 6 18 6C18.6 6 19 5.6 19 5Z"
                              fill="currentColor"
                            />
                            <path
                              d="M8.8 13.1C9.2 13.1 9.5 13 9.7 12.8C9.9 12.6 10.1 12.3 10.1 11.9C10.1 11.6 10 11.3 9.8 11.1C9.6 10.9 9.3 10.8 9 10.8C8.8 10.8 8.59999 10.8 8.39999 10.9C8.19999 11 8.1 11.1 8 11.2C7.9 11.3 7.8 11.4 7.7 11.6C7.6 11.8 7.5 11.9 7.5 12.1C7.5 12.2 7.4 12.2 7.3 12.3C7.2 12.4 7.09999 12.4 6.89999 12.4C6.69999 12.4 6.6 12.3 6.5 12.2C6.4 12.1 6.3 11.9 6.3 11.7C6.3 11.5 6.4 11.3 6.5 11.1C6.6 10.9 6.8 10.7 7 10.5C7.2 10.3 7.49999 10.1 7.89999 10C8.29999 9.90003 8.60001 9.80003 9.10001 9.80003C9.50001 9.80003 9.80001 9.90003 10.1 10C10.4 10.1 10.7 10.3 10.9 10.4C11.1 10.5 11.3 10.8 11.4 11.1C11.5 11.4 11.6 11.6 11.6 11.9C11.6 12.3 11.5 12.6 11.3 12.9C11.1 13.2 10.9 13.5 10.6 13.7C10.9 13.9 11.2 14.1 11.4 14.3C11.6 14.5 11.8 14.7 11.9 15C12 15.3 12.1 15.5 12.1 15.8C12.1 16.2 12 16.5 11.9 16.8C11.8 17.1 11.5 17.4 11.3 17.7C11.1 18 10.7 18.2 10.3 18.3C9.9 18.4 9.5 18.5 9 18.5C8.5 18.5 8.1 18.4 7.7 18.2C7.3 18 7 17.8 6.8 17.6C6.6 17.4 6.4 17.1 6.3 16.8C6.2 16.5 6.10001 16.3 6.10001 16.1C6.10001 15.9 6.2 15.7 6.3 15.6C6.4 15.5 6.6 15.4 6.8 15.4C6.9 15.4 7.00001 15.4 7.10001 15.5C7.20001 15.6 7.3 15.6 7.3 15.7C7.5 16.2 7.7 16.6 8 16.9C8.3 17.2 8.6 17.3 9 17.3C9.2 17.3 9.5 17.2 9.7 17.1C9.9 17 10.1 16.8 10.3 16.6C10.5 16.4 10.5 16.1 10.5 15.8C10.5 15.3 10.4 15 10.1 14.7C9.80001 14.4 9.50001 14.3 9.10001 14.3C9.00001 14.3 8.9 14.3 8.7 14.3C8.5 14.3 8.39999 14.3 8.39999 14.3C8.19999 14.3 7.99999 14.2 7.89999 14.1C7.79999 14 7.7 13.8 7.7 13.7C7.7 13.5 7.79999 13.4 7.89999 13.2C7.99999 13 8.2 13 8.5 13H8.8V13.1ZM15.3 17.5V12.2C14.3 13 13.6 13.3 13.3 13.3C13.1 13.3 13 13.2 12.9 13.1C12.8 13 12.7 12.8 12.7 12.6C12.7 12.4 12.8 12.3 12.9 12.2C13 12.1 13.2 12 13.6 11.8C14.1 11.6 14.5 11.3 14.7 11.1C14.9 10.9 15.2 10.6 15.5 10.3C15.8 10 15.9 9.80003 15.9 9.70003C15.9 9.60003 16.1 9.60004 16.3 9.60004C16.5 9.60004 16.7 9.70003 16.8 9.80003C16.9 9.90003 17 10.2 17 10.5V17.2C17 18 16.7 18.4 16.2 18.4C16 18.4 15.8 18.3 15.6 18.2C15.4 18.1 15.3 17.8 15.3 17.5Z"
                              fill="currentColor"
                            />
                          </svg>
                        </span>
                        {/*end::Svg Icon*/}
                        {/*end::Icon*/}
                        <div className="mb-9">
                          {/*begin::Event name*/}
                          <div className="d-flex align-items-center mb-2">
                            <span
                              className="fs-3 fw-bolder me-3"
                              data-kt-calendar="event_name"
                            />
                            <span
                              className="badge badge-light-success"
                              data-kt-calendar="all_day"
                            />
                          </div>
                          {/*end::Event name*/}
                          {/*begin::Event description*/}
                          <div
                            className="fs-6"
                            data-kt-calendar="event_description"
                          />
                          {/*end::Event description*/}
                        </div>
                      </div>
                      {/*end::Row*/}
                      {/*begin::Row*/}
                      <div className="d-flex align-items-center mb-2">
                        {/*begin::Icon*/}
                        {/*begin::Svg Icon | path: icons/duotune/abstract/abs050.svg*/}
                        <span className="svg-icon svg-icon-1 svg-icon-success me-5">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24px"
                            height="24px"
                            viewBox="0 0 24 24"
                            version="1.1"
                          >
                            <circle fill="currentColor" cx={12} cy={12} r={8} />
                          </svg>
                        </span>
                        {/*end::Svg Icon*/}
                        {/*end::Icon*/}
                        {/*begin::Event start date/time*/}
                        <div className="fs-6">
                          <span className="fw-bolder">Starts</span>
                          <span data-kt-calendar="event_start_date" />
                        </div>
                        {/*end::Event start date/time*/}
                      </div>
                      {/*end::Row*/}
                      {/*begin::Row*/}
                      <div className="d-flex align-items-center mb-9">
                        {/*begin::Icon*/}
                        {/*begin::Svg Icon | path: icons/duotune/abstract/abs050.svg*/}
                        <span className="svg-icon svg-icon-1 svg-icon-danger me-5">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24px"
                            height="24px"
                            viewBox="0 0 24 24"
                            version="1.1"
                          >
                            <circle fill="currentColor" cx={12} cy={12} r={8} />
                          </svg>
                        </span>
                        {/*end::Svg Icon*/}
                        {/*end::Icon*/}
                        {/*begin::Event end date/time*/}
                        <div className="fs-6">
                          <span className="fw-bolder">Ends</span>
                          <span data-kt-calendar="event_end_date" />
                        </div>
                        {/*end::Event end date/time*/}
                      </div>
                      {/*end::Row*/}
                      {/*begin::Row*/}
                      <div className="d-flex align-items-center">
                        {/*begin::Icon*/}
                        {/*begin::Svg Icon | path: icons/duotune/general/gen018.svg*/}
                        <span className="svg-icon svg-icon-1 svg-icon-muted me-5">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width={24}
                            height={24}
                            viewBox="0 0 24 24"
                            fill="none"
                          >
                            <path
                              opacity="0.3"
                              d="M18.0624 15.3453L13.1624 20.7453C12.5624 21.4453 11.5624 21.4453 10.9624 20.7453L6.06242 15.3453C4.56242 13.6453 3.76242 11.4453 4.06242 8.94534C4.56242 5.34534 7.46242 2.44534 11.0624 2.04534C15.8624 1.54534 19.9624 5.24534 19.9624 9.94534C20.0624 12.0453 19.2624 13.9453 18.0624 15.3453Z"
                              fill="currentColor"
                            />
                            <path
                              d="M12.0624 13.0453C13.7193 13.0453 15.0624 11.7022 15.0624 10.0453C15.0624 8.38849 13.7193 7.04535 12.0624 7.04535C10.4056 7.04535 9.06241 8.38849 9.06241 10.0453C9.06241 11.7022 10.4056 13.0453 12.0624 13.0453Z"
                              fill="currentColor"
                            />
                          </svg>
                        </span>
                        {/*end::Svg Icon*/}
                        {/*end::Icon*/}
                        {/*begin::Event location*/}
                        <div
                          className="fs-6"
                          data-kt-calendar="event_location"
                        />
                        {/*end::Event location*/}
                      </div>
                      {/*end::Row*/}
                    </div>
                    {/*end::Modal body*/}
                  </div>
                </div>
              </div>
              {/*end::Modal - New Product*/}
              {/*end::Modals*/}
            </div>
            {/*end::Container*/}
          </div>
          {/*end::Post*/}
        </div>
        {/*end::Content*/}
        {/*begin::Footer*/}
        <div className="footer py-4 d-flex flex-lg-column" id="kt_footer">
          {/*begin::Container*/}
          <div className="container-fluid d-flex flex-column flex-md-row align-items-center justify-content-between">
            {/*begin::Copyright*/}
            <div className="text-dark order-2 order-md-1">
              <span className="text-muted fw-bold me-1">2022©</span>
              <a
                href="https://keenthemes.com"
                target="_blank"
                className="text-gray-800 text-hover-primary"
              >
                Keenthemes
              </a>
            </div>
            {/*end::Copyright*/}
            {/*begin::Menu*/}
            <ul className="menu menu-gray-600 menu-hover-primary fw-bold order-1">
              <li className="menu-item">
                <a
                  href="https://keenthemes.com"
                  target="_blank"
                  className="menu-link px-2"
                >
                  About
                </a>
              </li>
              <li className="menu-item">
                <a
                  href="https://devs.keenthemes.com"
                  target="_blank"
                  className="menu-link px-2"
                >
                  Support
                </a>
              </li>
              <li className="menu-item">
                <a
                  href="https://1.envato.market/EA4JP"
                  target="_blank"
                  className="menu-link px-2"
                >
                  Purchase
                </a>
              </li>
            </ul>
            {/*end::Menu*/}
          </div>
          {/*end::Container*/}
        </div>
        {/*end::Footer*/}
      </div>
    </div>
  );
}

export default CreatePhrase;
